/* Reconstructed from tenant.zip:public/build/assets/stores-CB9UySvc.js
 * Original SHA-256: 124975b09a9fd9c3a419edc9836252fea0039b3b190104a3b24a54343ed09fcf
 * Surviving compiled logic, formatted and relinked. Original templates/comments/names are not recovered.
 */
const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "assets/View-BxA4B2HN.js",
      "assets/app-CWh9yNuH.js",
      "assets/chunk-CMxvf4Kt.js",
      "assets/dist-B86vIM39.js",
      "assets/vue.esm-bundler-B5vgcGJL.js",
      "assets/vuex.esm-bundler-DJRHx7fM.js",
      "assets/array-FrBPf9mT.js",
      "assets/utils-DEEYWRUN.js",
      "assets/app-BIMZT0MW.css",
      "assets/Index-D5Sd1Kz7.js",
      "assets/ShowImages-DFDtXXq3.js",
      "assets/fslightbox-vue-CXjuDJWg.js",
      "assets/View-Bs_VHuiH.js",
      "assets/Vacancy-CRz9mKRa.js",
      "assets/VacancyDetail-C-bLe6TV.js",
      "assets/Application-Bosak8y5.js",
      "assets/Index-nEhEFMfh.js",
      "assets/Index-B3KepcZ_.js",
      "assets/Verify-hhslX_wh.js",
      "assets/Form-DSrem45f.js",
      "assets/useCustomFields-BMALWRI-.js",
      "assets/Billplz-PsfOJPzs.js",
      "assets/inline-ChpernJQ.js",
      "assets/Index-Ci5NOqd4.js",
      "assets/currency-LBLQ7lBU.js",
      "assets/OnlinePaymentForm-C_IKv6wj.js",
      "assets/Anonymous-ZYfTs1XM.js",
      "assets/Index-B5_DwDyo.js",
      "assets/Index-DOaV72Tv.js",
      "assets/Index--_-fcxrR.js",
      "assets/Form-DMhbhr4z.js",
      "assets/Form-C3xXgUwi.css",
      "assets/Index-D6wMeA9r.js",
      "assets/dist-D-xxZeUb.js",
      "assets/EditRequestInfo-CePRUoVN.js",
      "assets/Index-B16R6dYh.js",
      "assets/Index-BGxdh5ZM2.js",
      "assets/Action-DSOUcYmD.js",
      "assets/Show-C4j9m3qg.js",
      "assets/Index-DN4zjwpv.js",
      "assets/Action-BffJ_JVE.js",
      "assets/Index-BcTjeJdB2.js",
      "assets/User-DgI3jL9H.js",
      "assets/Index-D3MkF6Jb2.js",
      "assets/Index-BYTNM6PW2.js",
      "assets/table-BHc19LGZ.js",
      "assets/Action-CcvtozJ4.js",
      "assets/Show-p-fd9E1N.js",
      "assets/Index-cVXpPwqm.js",
      "assets/Index-2sO4GdVM.js",
      "assets/Index-D7ZPOiEA2.js",
      "assets/Action-CvD0d0NJ.js",
      "assets/Show-CRYA_915.js",
      "assets/FailedLoginAttempt-BrWNtx0D.js",
      "assets/ForceChangePassword-DEcB3IcX.js",
      "assets/User-CFem7hHk.js",
      "assets/Index-BVXAYx2w.js",
      "assets/Account-sqbiRVP3.js",
      "assets/Avatar-CU7aRuwF.js",
      "assets/Preference-BzWRINwG.js",
      "assets/Security-DWQSXjjF.js",
      "assets/Password-DBX2SA7Z.js",
      "assets/Index-DIzWmYUZ2.js",
      "assets/vuedraggable.umd-8VUyNr_X.js",
      "assets/Action-DyyAbjlQ.js",
      "assets/Index-Dg5wHGlA.js",
      "assets/UserInfo-i7qItORc.js",
      "assets/Message-BpHl-CzX.js",
      "assets/Message-aBJFhgvb.css",
      "assets/GroupConfig-DPaCRLTy.js",
      "assets/Index-CK5YpvpX.js",
      "assets/useColumnVisibility-C0iM10-6.js",
      "assets/Action-fkIsM55i.js",
      "assets/Show-kuVnx34W.js",
      "assets/Index-BvIPGj18.js",
      "assets/Action-DZg67gPi.js",
      "assets/Show-BYPZhmaa.js",
      "assets/Index-Bcbwew-x.js",
      "assets/Index-BU29o15V2.js",
      "assets/General-wUyCMin5.js",
      "assets/Index-CCUoA4xx.js",
      "assets/Action-BOHnp5AR.js",
      "assets/Show-CgFL6-dx.js",
      "assets/Index-DihQrUzc2.js",
      "assets/Action-CHnLz4Wa2.js",
      "assets/Index-BJb383A92.js",
      "assets/Action-B-e5AVVH2.js",
      "assets/Index-B3D3ea98.js",
      "assets/Action-90IGg6n4.js",
      "assets/Index-mc1oVWwk.js",
      "assets/Index-BrbUt_LA2.js",
      "assets/Index-BVbnmTif.js",
      "assets/Index-Bb4ufkjy.js",
      "assets/Index-Dm3F-s3P2.js",
      "assets/Index-D27lvSqu2.js",
      "assets/Index-BgVlyScW.js",
      "assets/Index-rqDf6b5J2.js",
      "assets/Index-K1zF6nVE.js",
      "assets/Index-BDrSLVnX.js",
      "assets/Index-7Oxg59yh.js",
      "assets/Index-C4-BIY2S.js",
      "assets/Index-CY4PPmJm2.js",
      "assets/Index-CHdkVLgD.js",
      "assets/Action-mTwADSk9.js",
      "assets/Show-CLfv_hvl.js",
      "assets/Action-C7YucQx7.js",
      "assets/Index-DUq4XYg3.js",
      "assets/Index-DwSLiode.js",
      "assets/Index-D1nn6bks.js",
      "assets/Action-BLpz58S-.js",
      "assets/Wizard-gvSBkq1s.js",
      "assets/Show-C6yZQV6j.js",
      "assets/Index-BxyrBY8i.js",
      "assets/Action-B94DuAVO.js",
      "assets/Show--mGrcor3.js",
      "assets/Index-JJDo174l.js",
      "assets/Action-6cz31mqA.js",
      "assets/Show-PWGdbf_9.js",
      "assets/Index-DMoBroKS.js",
      "assets/Action-CuW2BpWh.js",
      "assets/Show-BLKbcBJu.js",
      "assets/Index-CbKnzICX.js",
      "assets/Action-BO5QBQSj.js",
      "assets/Show-DkZRzEhq.js",
      "assets/Index-CUyDSuSJ.js",
      "assets/Action-BL5dNEzX.js",
      "assets/Show-Dtc7Y4L_.js",
      "assets/Index-DyPFvWsX.js",
      "assets/Show-BkEbSSKO.js",
      "assets/Index-Dj98js23.js",
      "assets/General-DV4tytIZ.js",
      "assets/Index-BF0V90Vo.js",
      "assets/Action-CVrGxPSJ.js",
      "assets/Show-DuSDn7y2.js",
      "assets/Index-5YPmMXol.js",
      "assets/Assign-MhGQtv-3.js",
      "assets/Action-ChlrgE1Y.js",
      "assets/Show-Bf_Rcsk7.js",
      "assets/Index--qng7USr.js",
      "assets/Action-DgIVvUat.js",
      "assets/Form-DjfyLwan.js",
      "assets/Show-DB1Bkhcq.js",
      "assets/Index-OLUbmwpY.js",
      "assets/Action-HKRhrs9X.js",
      "assets/Show-k-unERP7.js",
      "assets/Index-BAqcLO7o.js",
      "assets/Assign-BwHM7Vzv.js",
      "assets/Action-Ru-yWLjN.js",
      "assets/Show-DH4_yioo.js",
      "assets/Index-VrUn8Lae.js",
      "assets/Action-qbatzIht.js",
      "assets/Show-BGyTALvd.js",
      "assets/Index-BX7aEgyy.js",
      "assets/Action-RTeUd1PV.js",
      "assets/Show-DlQ15ttn.js",
      "assets/Index-CwF1659U2.js",
      "assets/Action-CXiJjbyX2.js",
      "assets/Show-B1uKMdIt2.js",
      "assets/Index-D5oDMuTk.js",
      "assets/Assign-DCSTeqR7.js",
      "assets/Action-B5PavFoL2.js",
      "assets/Show-DHmmWJoO.js",
      "assets/Index-B9ZiP_9V.js",
      "assets/Action-CeQJr94b.js",
      "assets/Show-DWTkOY3e.js",
      "assets/Index-DigLs2bz.js",
      "assets/Assign-BdPj3hpJ.js",
      "assets/Action-CilriZ8-.js",
      "assets/Show-tq5ybvOY.js",
      "assets/Index-Cppd7YzS.js",
      "assets/Action-BelYQ8Za.js",
      "assets/Show-Cuth4VPB.js",
      "assets/Index-CIjWbM8T.js",
      "assets/Action-BWs7N6EW.js",
      "assets/Show-COYlyyo9.js",
      "assets/Index-DVXQ-BoT.js",
      "assets/Assign-DGEgVdGT.js",
      "assets/Action-v4lEoNdL.js",
      "assets/Show-DiTJ2Mdx.js",
      "assets/Index-CQydGomv.js",
      "assets/Action-aC78Z-8t.js",
      "assets/Show-LVtMemLs.js",
      "assets/Index-Cd94unGU.js",
      "assets/Assign-qW5GxDYh.js",
      "assets/Action-YYfo5P0J.js",
      "assets/Show-B3e1EQ52.js",
      "assets/Index-BBESvliQ.js",
      "assets/Action-BDhsglGn.js",
      "assets/Show-CNgxIP24.js",
      "assets/Index-BCrWizNk.js",
      "assets/Action-BpXtzX2j.js",
      "assets/Allocation-CFstBxT-.js",
      "assets/Show-3lPHAcy-.js",
      "assets/Index-BtsvtqAL.js",
      "assets/Action-DyANR2Tj.js",
      "assets/Show-C8Tj63BD.js",
      "assets/Index-BsW3Ey7Y.js",
      "assets/Index-pehOzzUd.js",
      "assets/Action-DVfMemq4.js",
      "assets/Show-Ble0sZQU.js",
      "assets/Index-DahmEupW.js",
      "assets/Action-C0zxtb_5.js",
      "assets/Show-aXV57I-e.js",
      "assets/Index-B7kLtMWU.js",
      "assets/Action-o5rPryj_.js",
      "assets/Summary-D1s5_cnG.js",
      "assets/Show-DizZ0WaT.js",
      "assets/Index-Bd_ziWQA.js",
      "assets/Action-B2DtGOeH.js",
      "assets/Show-DtQUYg_H.js",
      "assets/Print-CQLUvsfs.js",
      "assets/Index-BM5D8lxk.js",
      "assets/General-YrKGrK1g.js",
      "assets/Timetable-xq6tfNIX.js",
      "assets/Index-DA_8nSsa2.js",
      "assets/Action-VNa05ADM.js",
      "assets/Wizard-DzH-ndYV.js",
      "assets/Show-j6EHKVoK.js",
      "assets/BulkEdit-okKiP_1c.js",
      "assets/Index-CNaZT5gs.js",
      "assets/Index-BJU3pFOd.js",
      "assets/Index-DENsay2E.js",
      "assets/Action-Cem_cuK9.js",
      "assets/Batch-zQ7iLNEJ.js",
      "assets/Show-BHg6mSN3.js",
      "assets/Index-Bpz6fPwF.js",
      "assets/Show-ife44lxq.js",
      "assets/Index-BWb_Hnta.js",
      "assets/Action-Blbm4D09.js",
      "assets/Show--iVIx7G9.js",
      "assets/Index-CcIFXQ3t.js",
      "assets/Action-noM02r86.js",
      "assets/Show-BCcSzkLH.js",
      "assets/Index-O-boGy2L.js",
      "assets/Action-E_kroH1q.js",
      "assets/Show-px-stl70.js",
      "assets/Index-BXGGgz1e.js",
      "assets/GeneralFilter-8J1jP3y1.js",
      "assets/Index-DfN3EpxI.js",
      "assets/Action-CvowdXfq.js",
      "assets/Show-Cj1HW8w0.js",
      "assets/Index-DQTwzXmN.js",
      "assets/Index-Bm3RsxS2.js",
      "assets/Index-s1C2BRZj.js",
      "assets/Index-CwjNUZoK.js",
      "assets/Index-BsnWW6oQ.js",
      "assets/Index-_3RcBVhT2.js",
      "assets/Index-BYy1KH-6.js",
      "assets/ModuleDropdown-DIsR02tt.js",
      "assets/Action-BihuQDCv.js",
      "assets/Show-C4P77HCu.js",
      "assets/Index-CSJC7SAP.js",
      "assets/Action-B-FrNO5m.js",
      "assets/Show-CV_VkJw1.js",
      "assets/Index-DF9EKQQm.js",
      "assets/Action-BEj_xMcY.js",
      "assets/Show-B4zmXZIA.js",
      "assets/Index-bodVdP-Q.js",
      "assets/Action-BOkiKXJr.js",
      "assets/Show-D-QV-XY_.js",
      "assets/Index-Bth8wrAD2.js",
      "assets/Action-CcX08abX2.js",
      "assets/Show-DopFexHU2.js",
      "assets/Index-B_GGtoMI.js",
      "assets/Action-CEk3n_Zs.js",
      "assets/Show-Di2eICLD.js",
      "assets/Index-DdTEC70p.js",
      "assets/ParentDetail-Bq8MmlaA.js",
      "assets/Action-Dn3y_dMn.js",
      "assets/Index-CK_lchm_.js",
      "assets/Index-B1rvo76o.js",
      "assets/New-4xRzM7D_.js",
      "assets/Show-CAJZhfgD.js",
      "assets/Index-XkdNHe64.js",
      "assets/Action-CClp5FBl.js",
      "assets/Show-D0PdbZcV.js",
      "assets/Index-CnT_-hPL.js",
      "assets/Action-Tc3d0wg5.js",
      "assets/Show-C-8VRcx5.js",
      "assets/Index-CS0nKKA-.js",
      "assets/Action-COk4E9or.js",
      "assets/Show-DH1lJSCm.js",
      "assets/Index-Cm6DOsmA.js",
      "assets/Index-CwIr32VV.css",
      "assets/Index-D4mwvric2.js",
      "assets/Action-_lx5hoZW2.js",
      "assets/Show-DwKDboWg2.js",
      "assets/Index-CFWBRBo-.js",
      "assets/Action-BKH-HFzg.js",
      "assets/Show-CAP-5Mi1.js",
      "assets/Index-CFAD_7YK.js",
      "assets/Action-DdHGR8YW.js",
      "assets/Show-CmKm6xzO.js",
      "assets/Index-D4nMQV64.js",
      "assets/Action-B8tIotUt.js",
      "assets/Show-CICb35d3.js",
      "assets/Index-CjQdBles.js",
      "assets/General-C8SMIR9l.js",
      "assets/Index-O35Wj4WV.js",
      "assets/Index-DbFAJ4oO.js",
      "assets/Index-DoI_3dnp.js",
      "assets/Index-odwinRuA.js",
      "assets/Index-DCXNzbAw2.js",
      "assets/Absentee-63IrPzl5.js",
      "assets/Index-NJQfgq93.js",
      "assets/Index-rTII1tRj.js",
      "assets/Index-Cm2XN4NA2.js",
      "assets/Index-BdTTfMjG.js",
      "assets/MigrateAttendance-npwnaply.js",
      "assets/Show-BtDOZbYk.js",
      "assets/Profile-DbTxiPKM.js",
      "assets/TagList-BiOc9BQC.js",
      "assets/Basic-BDdnEWD5.js",
      "assets/EditBasic-CdWPswV0.js",
      "assets/EditPhoto-CE6TXrUl.js",
      "assets/Contact-sg9RdNFL.js",
      "assets/EditContact-DXHHtVtY.js",
      "assets/Login-Bg9BnhwC.js",
      "assets/EditLogin-DUKWxLwj.js",
      "assets/ChangeRecord-m0fPBn26.js",
      "assets/Index-CK3TQLTT.js",
      "assets/Index-3l3DCdOh.js",
      "assets/Set-kog4zxeL.js",
      "assets/Edit-AcrCT57k.js",
      "assets/OptionalFee-z-pMFpIB.js",
      "assets/Attendance-BweyzroF.js",
      "assets/ExamReport-BzKS0qOe.js",
      "assets/Subject-gE8ocalw.js",
      "assets/Index-BIg3OcwE.js",
      "assets/Action-DWLCIi8V.js",
      "assets/Show-BLvsxBmJ.js",
      "assets/Index-D4scgIlr.js",
      "assets/Action-Dkam4Y1Y.js",
      "assets/Show-CPsLBI8o.js",
      "assets/Index-DU0ZQrtP.js",
      "assets/Action-dbSP-_iH.js",
      "assets/Show-BYSSWRJm.js",
      "assets/Index-C4xjE7xM.js",
      "assets/Action-D8QbkMo-.js",
      "assets/Show-DHhfzLLs.js",
      "assets/Index-B5eK02Ay.js",
      "assets/Action-ti8AkuXp.js",
      "assets/Show-DQD2-XX7.js",
      "assets/Index-CTXT5UvP.js",
      "assets/Index-DzzdqpdW.js",
      "assets/Action-CHZOojvX.js",
      "assets/Show-C72znPmQ.js",
      "assets/Index-BNaarNsf.js",
      "assets/Action-CvackvEq.js",
      "assets/Show-BMKXcfbd.js",
      "assets/Index-CG_9xIu9.js",
      "assets/Action-CWr8XGzX.js",
      "assets/Show-BVPFtYSY.js",
      "assets/Index-CBc5NO92.js",
      "assets/Action-gA9gUdk3.js",
      "assets/Show-SYxH3nRX.js",
      "assets/Index-CVh1U9wr.js",
      "assets/Action-CCn5_4AV.js",
      "assets/Show-LPQMIf3c.js",
      "assets/Index-D_OBRUXS.js",
      "assets/Action-CMecdxqr.js",
      "assets/Show-e6kRCpB7.js",
      "assets/Index-AZEpPWOB.js",
      "assets/Action-bzTSs9xW.js",
      "assets/Show-hFv5jyM5.js",
      "assets/Index-Bbc5yYJW.js",
      "assets/Action-B5Gz1l_O.js",
      "assets/Show-FAVKew8y.js",
      "assets/Index-BrxSb2Ch.js",
      "assets/Index-DXlSut45.js",
      "assets/Index-Dsfp0gXX2.js",
      "assets/Index-BuNg5Rg82.js",
      "assets/Index-D4dmC-ic2.js",
      "assets/Index-w5NzmG46.js",
      "assets/Index-2czoGnMN.js",
      "assets/Index-ZE2m4Y1g.js",
      "assets/Index-smOFkSAF2.js",
      "assets/Index-BeD4D15m.js",
      "assets/Index-CCZ06snA.js",
      "assets/Index-tro7Fqwb2.js",
      "assets/Index-BkKyo3y4.js",
      "assets/Index-anMTp8Xh.js",
      "assets/Index-DKzyna4N.js",
      "assets/Index-BZZDTgVF.js",
      "assets/General-BBqAx_t4.js",
      "assets/PaymentGateway-Bwb1RPDW.js",
      "assets/Index-Du-3a5PE.js",
      "assets/Action-4b4bHt90.js",
      "assets/Show-WtZvRZCB.js",
      "assets/Index-C7q7Fdww.js",
      "assets/Action-Crw3BF7y.js",
      "assets/Show-CTCggVhr.js",
      "assets/Index-R4sUbvPp.js",
      "assets/Action-HgGZ5-e9.js",
      "assets/Show-DqIj2KIP.js",
      "assets/Index-DP29yFmg2.js",
      "assets/Action-DHL_Sh5A2.js",
      "assets/Show-ChLFMtwj.js",
      "assets/Index-Bdhva_4Z.js",
      "assets/Action-BkAZU3ID.js",
      "assets/Show-DJBoijq_.js",
      "assets/Index-D73yrb4c.js",
      "assets/Action-D0YmwJcB2.js",
      "assets/Show-DudbOxfF.js",
      "assets/FormSubmission-BkQyysZl.js",
      "assets/Index-CVVSXOK1.js",
      "assets/Show-Cm6JCaXS.js",
      "assets/Index-FgfL9Wmk2.js",
      "assets/Index-CcLQhANz.js",
      "assets/Index-Dj7__LVM2.js",
      "assets/Action-C5wX3alE.js",
      "assets/Submit-DBgMO1te.js",
      "assets/Submission-DuyOX6dv.js",
      "assets/Show-uvpFWkVA.js",
      "assets/General-TZyWAsuX.js",
      "assets/Index-DAGi1Gev2.js",
      "assets/Index-CjWA7en8.js",
      "assets/Index-D1id2U7C2.js",
      "assets/Index-Cg-nQcvd.js",
      "assets/Index-4taB0r0-.js",
      "assets/General-D_EKd5Yf.js",
      "assets/Index-BVTYSIUA.js",
      "assets/Index-Uf4v9lvb.js",
      "assets/ExamRecordForm-Dh1X2FGJ.js",
      "assets/ModuleDropdown-KHw159GF.js",
      "assets/Index-UzCEx4OC.js",
      "assets/Index-DRgSvDOw2.js",
      "assets/Index-BL3l2i4e.js",
      "assets/Index-BlihHis6.js",
      "assets/Index-CUbM2vtG.js",
      "assets/Index-BNoD3F8V.js",
      "assets/Index-DHvzgHVy2.js",
      "assets/Index-B25xLBy1.js",
      "assets/Index-BXsaNyNb.js",
      "assets/Action-B5Cm-TcT.js",
      "assets/Show-Bnc8eei-.js",
      "assets/Index-D1JAJ0qN.js",
      "assets/Action-DnHBYIW0.js",
      "assets/Show-DCapJOd4.js",
      "assets/Index-eG7NunmF.js",
      "assets/Hierarchy-B2F9iPG0.js",
      "assets/Action-CEX9Kt6O.js",
      "assets/Show-DAKl22SG.js",
      "assets/BulkEdit-D12r9n-c.js",
      "assets/Index-9fH75o_S.js",
      "assets/Index-BnmALi4N.js",
      "assets/Action-BwIRzuNO.js",
      "assets/Show-C3eKn1Jd.js",
      "assets/Index-QM3klWm5.js",
      "assets/Action-CDRyCUNe.js",
      "assets/Show-CpcEwDYd.js",
      "assets/Index-rmX5WDVJ.js",
      "assets/Index-By6WwaU9.js",
      "assets/Action-nUmc71iB.js",
      "assets/Show-Co4YpXqm.js",
      "assets/Index-C408b6GN.js",
      "assets/Action-BMsEw9vR.js",
      "assets/Show-C_vB0X4d.js",
      "assets/Index-0PRKM72j.js",
      "assets/Action-C-SI8RWx.js",
      "assets/Show-NMZydW34.js",
      "assets/Index-DjXVfxI_.js",
      "assets/Index-B00281Jy.css",
      "assets/Index-zz2frQQA.js",
      "assets/Action-CfTvY67N.js",
      "assets/Show-DbFO2Kz3.js",
      "assets/Index-5L3-w_PL.js",
      "assets/Action-Ct3g2gE4.js",
      "assets/Show-CfICB8N6.js",
      "assets/Index-BH9ZXttj.js",
      "assets/Action-BLVHLirJ.js",
      "assets/Show-NPiJd715.js",
      "assets/Index-DdyI-ZQv2.js",
      "assets/Action-Dt0ezFRo.js",
      "assets/Show-qvWWT1py.js",
      "assets/Index-D8CfEoNu.js",
      "assets/ModuleDropdown-DvrMmdgy.js",
      "assets/Index-V_02OO2b2.js",
      "assets/General-kOXv9Qig2.js",
      "assets/Action-DXiloJ2Q.js",
      "assets/Show-DQcRojar.js",
      "assets/Basic-Bb5sjfrx.js",
      "assets/EditRequestInfo-B36B0oSL.js",
      "assets/EditBasic-Dv-WYjFu.js",
      "assets/EditPhoto-Bs_g5llu.js",
      "assets/Contact-tQJKS0s2.js",
      "assets/EditContact-CnUu_9un.js",
      "assets/Login-F0o7rjcu.js",
      "assets/EditLogin-CXhOPJN0.js",
      "assets/Index-CWlBFozV2.js",
      "assets/ModuleDropdown-BQifTnl1.js",
      "assets/Action-BYuplCgR2.js",
      "assets/Show-BmefkNgP2.js",
      "assets/Report-BYQ_RF4a.js",
      "assets/Filter-ChABKUm3.js",
      "assets/Index-DySbXryh.js",
      "assets/Index-D5gXnu__.js",
      "assets/Action-B8FThCdx.js",
      "assets/Show-D8yEqGCd.js",
      "assets/Index-D933SFzd.js",
      "assets/Action-oVc0uehu.js",
      "assets/Show-CmeqgTJT.js",
      "assets/Index-CcWOf0wr2.js",
      "assets/Filter-BQ-j8N37.js",
      "assets/Mark-CqkG9q0T.js",
      "assets/MarkProduction-BRlwrQt7.js",
      "assets/Index-2NiY2hKJ.js",
      "assets/General-CvPDhSlG.js",
      "assets/Index-DJm6SH20.js",
      "assets/Action-BjkeHA76.js",
      "assets/Show-BX3ibI6w.js",
      "assets/Index-C9yGOPOK.js",
      "assets/Action-DQcH99rw.js",
      "assets/Show-DWZQqja1.js",
      "assets/Index-BioB1CE7.js",
      "assets/Action-B8TcFG1b.js",
      "assets/Show-BbSf0Q-0.js",
      "assets/Index-FngSMzrN.js",
      "assets/Action-Fo30syl6.js",
      "assets/Show-C8dwxtRK.js",
      "assets/Index-BHhkS9pY.js",
      "assets/ModuleDropdown-BfospoXh.js",
      "assets/Action-DGDNi96r.js",
      "assets/Show-CKfSqoUU.js",
      "assets/Index-Chr-xraH.js",
      "assets/Action-KdIGx-7z.js",
      "assets/Show-CCwzy3sG.js",
      "assets/Index-UPO48uSL.js",
      "assets/Action-Z5zmUQyE.js",
      "assets/Show-BiECFcWC.js",
      "assets/Index-CaX5atOm.js",
      "assets/General-MvMybtyj.js",
      "assets/Index-B7kgQXfU2.js",
      "assets/General-BDAeCq2L.js",
      "assets/Index-DVlw7G8W.js",
      "assets/ModuleDropdown-DSoD743I.js",
      "assets/Index-C-a201Rr2.js",
      "assets/Action-DkrxBMNI.js",
      "assets/Show-CYLSA0lK.js",
      "assets/Index-B1uIsPZ3.js",
      "assets/Action-BmfD5oQH2.js",
      "assets/Show-07UcMsKU.js",
      "assets/Index-C6nAgFhG.js",
      "assets/Action-CIHTvJwx.js",
      "assets/Show-BzHTTi-4.js",
      "assets/Action-mTYaN1tg.js",
      "assets/Process-_96UFxJZ.js",
      "assets/Show-DbvxdYjZ2.js",
      "assets/Index-C4BpGm0z.js",
      "assets/Show-BnlxAlJM.js",
      "assets/Assistant-1Nf-yyml.js",
      "assets/QrCode-cIVQdbs2.js",
      "assets/Index-BZMNfP992.js",
      "assets/Action-CXsCRFdm.js",
      "assets/Preview-cAd1CZo5.js",
      "assets/Show-DUmRao4e.js",
      "assets/Index-C6cVIHLJ.js",
      "assets/Action-C9qE4rqe.js",
      "assets/Show-B7g18rDz.js",
      "assets/Index-B3WG68z_.js",
      "assets/Action-Dhcs192O.js",
      "assets/Show-BQLpmz1K.js",
      "assets/Index-CYsfkS3H.js",
      "assets/Action-CbuIQbv8.js",
      "assets/Show--WAHJ7JV.js",
      "assets/Index-CblVq2JD.js",
      "assets/Action-DGHS33jq.js",
      "assets/Show-B_o6kBwL.js",
      "assets/Index-S_r8rSUv.js",
      "assets/Action-Db-K13Dt.js",
      "assets/Show-B4zJBy5V.js",
      "assets/Index-CAYC3piT.js",
      "assets/Action-DkjPxFKH.js",
      "assets/Show-CqIvnx68.js",
      "assets/Index-DF-ZBHDO.js",
      "assets/Index-DlHglo45.js",
      "assets/Index-Dbjij84T.js",
      "assets/Index-Cp-quLt4.js",
      "assets/Index-DjQ-F201.js",
      "assets/General-Cq9RK7MF.js",
      "assets/Index-BTY_t7PO.js",
      "assets/Index-BcB1IMwo.js",
      "assets/Action-__M4O9b6.js",
      "assets/Show-CIUPoqRb.js",
      "assets/Index-C6eXRGmY.js",
      "assets/Action-9cepS-eC.js",
      "assets/Show-CpM9Tmpr.js",
      "assets/Index-MO7OuQ6M.js",
      "assets/Action-CyvZKcjt.js",
      "assets/Show-CJQVoq_a.js",
      "assets/Index-DQISvVZ9.js",
      "assets/Action-mfABihgZ.js",
      "assets/Show-BnY5tqaG.js",
      "assets/Index-BaCHQl6D.js",
      "assets/Action-DQx0vYaj.js",
      "assets/Show-D-Rtc6ZV.js",
      "assets/Index-DPDB88WR.js",
      "assets/Action-B8nSep8t.js",
      "assets/Show-BVRLq8uT.js",
      "assets/Index-DF0vBvfJ.js",
      "assets/Action-DWpQR1tm.js",
      "assets/Show-DiWdT4g9.js",
      "assets/Index-CDMwgLne.js",
      "assets/ModuleDropdown-DpAJzmjl.js",
      "assets/Action-BuOItJhv.js",
      "assets/Show-Dv6F-Ext.js",
      "assets/Index-D_kRw4262.js",
      "assets/Action-BgMNNmrW.js",
      "assets/Show-B3GAQTtN.js",
      "assets/Index-DwkPo23v.js",
      "assets/Action-Byo5wmtw.js",
      "assets/Show-BJZqWDeo.js",
      "assets/Index-DKU38aRF2.js",
      "assets/Action-BXYXsBgv2.js",
      "assets/Show-Bbo5ZVR82.js",
      "assets/Index-DMW0UcGm.js",
      "assets/Action-Dl9oouF2.js",
      "assets/Show-DhMQ7vnp.js",
      "assets/Index-BvdqSCyS.js",
      "assets/Action-zliUnY74.js",
      "assets/Show-BIhGdEHH.js",
      "assets/Index-DlZx0Rl0.js",
      "assets/Index-BRgwfvBm.js",
      "assets/Index-BQ4NFvf4.js",
      "assets/Index-2Cd24gYt.js",
      "assets/Index-DarjDAJN.js",
      "assets/Index-DCyOsflD.js",
      "assets/Index-DY_vFx7a.js",
      "assets/Index-Bgz13Rr_.js",
      "assets/General-BWgzDDgx.js",
      "assets/Index-BClaggDj.js",
      "assets/Action-CMCFsfyY.js",
      "assets/Show-CH-wrMjY.js",
      "assets/General-BHHQDyb5.js",
      "assets/Index-DUWcGa7J.js",
      "assets/Index-Do8K-pte2.js",
      "assets/Index-CAxP5mZ32.js",
      "assets/Index-DSOi_h8k.js",
      "assets/General-DHZHdQNR.js",
      "assets/Index-BHI7sNbP.js",
      "assets/Action-5WThQ6mA.js",
      "assets/Show-C3Ylc0H0.js",
      "assets/Index-Qv8C051R.js",
      "assets/Index-DffmVEyD.js",
      "assets/Action-DwlBlQS_.js",
      "assets/Show-Cq9Xmp_y.js",
      "assets/Index-Css8kK4U.js",
      "assets/General-BX0TFbif.js",
      "assets/Index-DAUoqRzU.js",
      "assets/Action-CQOABZpl.js",
      "assets/Show-cvG6uEKH.js",
      "assets/Index-DolVyJH6.js",
      "assets/Action-Qog_iAZb.js",
      "assets/Show-Cc_MlZMw.js",
      "assets/Statement-Bn6uDcPt.js",
      "assets/Index-DNa7FZeZ2.js",
      "assets/Action-CB4zcgEh2.js",
      "assets/Show-CkOyJSPK.js",
      "assets/Index-Bq4PC6LS.js",
      "assets/Action-C2f3NKik.js",
      "assets/Show-BjQekBsu.js",
      "assets/Index-DwqP1bQl.js",
      "assets/Print-D25ufBjb.js",
      "assets/Index-CBLLw-q22.js",
      "assets/Action-BIXeLEev2.js",
      "assets/Show-DNbNY62z2.js",
      "assets/Index-DNDMFtZX.js",
      "assets/Action-BWYaOJBh.js",
      "assets/VendorForm-B-igvSNk.js",
      "assets/Show-BaL8uAl0.js",
      "assets/Index-BT1pFEZm.js",
      "assets/Action-60KbU1fg.js",
      "assets/Show-8fmbrRtd.js",
      "assets/Index-CHJn4aCS.js",
      "assets/Action-Cnxv2SPH.js",
      "assets/Show-u3-kfVEo.js",
      "assets/Index-BddIgYWP.js",
      "assets/Action-BNOjwyus.js",
      "assets/Show-_yoxviTH.js",
      "assets/Index-CiES8pS82.js",
      "assets/Action-ubDTUX5q2.js",
      "assets/Show-0SXxAu-_2.js",
      "assets/Index-D0_xOMb6.js",
      "assets/Index-ST7KBw1c2.js",
      "assets/Index-Cy1MKk4L.js",
      "assets/Action-D0AEfM18.js",
      "assets/Show-CbZUf7kM2.js",
      "assets/Index-CPxC2bVf.js",
      "assets/General-D-L8H0B2.js",
      "assets/Index-D9yEFiYl.js",
      "assets/General-CL4CvvYf.js",
      "assets/Index-BuBgarJH.js",
      "assets/Action-DB-eYYkF.js",
      "assets/Show-D7IXHQE5.js",
      "assets/Index-lNbj0ACJ.js",
      "assets/Action-B1baIWco.js",
      "assets/Show-BBjzI0R9.js",
      "assets/Index-Di2X58ej.js",
      "assets/Action-B9fAdodv.js",
      "assets/Show-xIUd78-3.js",
      "assets/Index-DHWLlwGn.js",
      "assets/Action-CQ8CdENR.js",
      "assets/Show-Blth7ko6.js",
      "assets/Index-kY0uWfxO.js",
      "assets/Action-BLy6nuYc.js",
      "assets/Show-F_SXtkjf.js",
      "assets/Index-DXB1fU9N.js",
      "assets/Action-JxwHRd96.js",
      "assets/Show-C2Z_UXU1.js",
      "assets/Index-B1iVaN6a.js",
      "assets/General-fu1oXfUP.js",
      "assets/Index-Bf-ANOXq.js",
      "assets/Action-DhBMOE3v.js",
      "assets/Show-lKpdfeXI.js",
      "assets/Index-CTEVv3NX.js",
      "assets/Print-CYEl-Q6k.js",
      "assets/Index-Dlf8UQiG.js",
      "assets/Action-DLpY2hGa.js",
      "assets/Show-Cbw6RK6H.js",
      "assets/Index-BR7p2o49.js",
      "assets/Action-BTsll5Pz.js",
      "assets/Show-DOi9qr5R.js",
      "assets/Index-dIVO1Xek.js",
      "assets/Index-BMj6Y-GP.js",
      "assets/Index-CXGetunU.js",
      "assets/Index-Z5L68pIa.js",
      "assets/Index-DnqpDXIR.js",
      "assets/General-ooVu1X68.js",
      "assets/Index-Bz_5v6bh.js",
      "assets/Action-B4LLivpM.js",
      "assets/Show-BZOasN7D.js",
      "assets/Index-Vcru_Fwt.js",
      "assets/GeneralFilter-CNDEM4vp.js",
      "assets/Action-BgoNuGZS.js",
      "assets/Show-BO7qLN4-.js",
      "assets/Pending-zZKPozEk.js",
      "assets/Processed-6sy_y5dx.js",
      "assets/Index-CW1i9Ync.js",
      "assets/General-DXuU8BP1.js",
      "assets/Index-Cpc59oqw.js",
      "assets/Index-CiHyLuw1.js",
      "assets/Index-BStzOz0p.js",
      "assets/Index-3VmLqHTc.js",
      "assets/Index-iu24Iiev.js",
      "assets/Index-D9eR-qDx.js",
      "assets/Index-BAVxvRzz.js",
      "assets/General-BJtjWM5U.js",
      "assets/Action-BQnIrAcf.js",
      "assets/Show-HgLiTCKd.js",
      "assets/General-m1Se3Ykg.js",
      "assets/Index-Bk71ugfo.js",
      "assets/Action-CmQLbrkY.js",
      "assets/Show-DsSPO4ER.js",
      "assets/Index-Df3xuR8Z.js",
      "assets/Action-BvQY8gsr.js",
      "assets/Show-vjV0eCi7.js",
      "assets/Index-BL3AUMRX.js",
      "assets/General-BG5nDefC.js",
      "assets/Index-CFKFG1eg.js",
      "assets/General-Dohc3FqA.js",
      "assets/Index-UuNTDF0V.js",
      "assets/Action-DpFqfgh6.js",
      "assets/Show-BeiJCase.js",
      "assets/Index-CNsVXCCP.js",
      "assets/General-7uAMTkvW.js",
      "assets/Index-Co5iW1k8.js",
      "assets/Action-fdbs0pQa.js",
      "assets/Show-DRzMa4__.js",
      "assets/Index-DgQBJzzl.js",
      "assets/Action-aAgGFjQm.js",
      "assets/Show-Bd_PBJJT.js",
      "assets/Index-Dn9zG2kx2.js",
      "assets/Action-Cbs_rmf42.js",
      "assets/Show-5jY1lIdo2.js",
      "assets/Index-St2lpjQd2.js",
      "assets/Action-B6Kvu4Tj2.js",
      "assets/Show-CNWJlCdO2.js",
      "assets/Index--rDCDA9J.js",
      "assets/General-TtT2UqDr.js",
      "assets/Index-CFzPKmdP.js",
      "assets/Index-tLPZAXv7.js",
      "assets/Index-tJvPZDgP.js",
      "assets/Action-D1ZcYiUu.js",
      "assets/Show-BLQ0bCLq.js",
      "assets/General-CMar7b5i.js",
      "assets/Index-BsPxNkbm.js",
      "assets/General-DQTjvTpb.js",
      "assets/Index-B2eDKU3H.js",
      "assets/Action-BO-udOKm.js",
      "assets/Show-DuiSilEa.js",
      "assets/Index-bMLqcabb.js",
      "assets/Action-DygA4dqa.js",
      "assets/Show-DRh4UCdH.js",
      "assets/Index-DkH5XCLz.js",
      "assets/Action-C7f6yPGM.js",
      "assets/Show-DamIQPIO.js",
      "assets/Index-06lDF2WH.js",
      "assets/Action-BE3tPiWD.js",
      "assets/Show-DYLMpWCw.js",
      "assets/Index-DP4pF38E.js",
      "assets/Action-B3hkTlqu.js",
      "assets/Show-TfPUalVk.js",
      "assets/Index-CzfHU8Jt2.js",
      "assets/Action-B8iJhO6k.js",
      "assets/Show-C3bjtDiy.js",
      "assets/Submit-CBIlfg-l.js",
      "assets/Layout-DQpuRlhV.js",
      "assets/Index-DnVDDBaJ.js",
      "assets/Show-B7FRC1_F.js",
      "assets/Index-qirVFfvC.js",
      "assets/General-ConLCjTo.js",
      "assets/Index-Wl7HtGWi.js",
      "assets/Action-RvcFZ1hN.js",
      "assets/Show-ygzCImwX.js",
      "assets/Index-D5lws6Bt2.js",
      "assets/Action-rBYXX4M-.js",
      "assets/Show-JgK8SV5B.js",
      "assets/Index-CRxPXdTr.js",
      "assets/Action-DIaj0qRv.js",
      "assets/Show-D_8T8B17.js",
      "assets/Index-C6x_bTuD.js",
      "assets/Action-Csf-Xf6i.js",
      "assets/Edit--UzgUscn.js",
      "assets/Og-vOjyJEyL.js",
      "assets/Show-CV4mRgHV.js",
      "assets/Index-BAbj1hjh.js",
      "assets/Action-CEwH5RCH.js",
      "assets/Show-CipaJ6uV.js",
      "assets/Index-DM9iFNbT.js",
      "assets/Action-BJ8hvEvW.js",
      "assets/Edit-D3Z6P4UC.js",
      "assets/Asset-CU0Fyw-M.js",
      "assets/Show-Bg8HT4Cq.js",
      "assets/Index-gcK2amtI.js",
      "assets/General-DiZotpsQ.js",
      "assets/Index-c6CAfLTF.js",
      "assets/Index-Cr5dIYx6.js",
      "assets/General-KfEMNoCE.js",
      "assets/Action-Cm91lbaT.js",
      "assets/Edit-BpDg64jj.js",
      "assets/Og-CygLnUa7.js",
      "assets/Show-wXKwHf4T.js",
      "assets/Index-CeAFZkXy.js",
      "assets/Index-Y1TCr6EW2.js",
      "assets/General-Cwgsjivk.js",
      "assets/Action-RfW15vr3.js",
      "assets/Edit-IIEuOBRX.js",
      "assets/Og-D8SdAiih.js",
      "assets/Show-tbvBIU1M.js",
      "assets/Index-BDMH8Djw2.js",
      "assets/Action-w7lEMLCy.js",
      "assets/Show-CkB1KxmO.js",
      "assets/Index-45DTY6Be.js",
      "assets/Action-xG2TvNs4.js",
      "assets/Show-_BN8t4TQ.js",
      "assets/Index-sBJaOFSZ.js",
      "assets/General-XejORiTN.js",
      "assets/Index-B0BIcbLv.js",
      "assets/General-DY7XleHy.js",
      "assets/Index-bnd6u_M5.js",
      "assets/Show-CiFpGARQ.js",
      "assets/Basic-CQzLFUEa.js",
      "assets/EditBasic-wCFyMXi2.js",
      "assets/EditPhoto-BibyGMEk.js",
      "assets/Contact-DO-e3qOo.js",
      "assets/EditContact-CHXdbxqZ.js",
      "assets/Login-DFBGWAJt.js",
      "assets/EditLogin-CHdRus0o.js",
      "assets/Index-DIX2XD99.js",
      "assets/General-DLQ65oJa.js",
      "assets/Index-BzFf5jEE.js",
      "assets/Action-yhbRxYQf.js",
      "assets/Show-ubjoCNT3.js",
      "assets/Index-CNOpSCv-.js",
      "assets/Action-DXYeFV-y.js",
      "assets/Show-crltKOik.js",
      "assets/Basic-DXTA-ofy.js",
      "assets/EditBasic-CQNgwDG6.js",
      "assets/EditPhoto-CxfvbcWm.js",
      "assets/Contact-BM3sNgVE.js",
      "assets/EditContact-fUIXHEXo.js",
      "assets/Login-C33fLY0V.js",
      "assets/EditLogin-BsqMHz2-.js",
      "assets/Index-kLd_vkzU.js",
      "assets/Action-DiwaLfD9.js",
      "assets/Show-Dyc2dWDE.js",
      "assets/Index-CQPv78ox.js",
      "assets/General-ruaveUgT.js",
      "assets/Edit-Cc64FyBK.js",
      "assets/Show-BJq5f0PP.js",
      "assets/Login-DvuJznoy.js",
      "assets/EmailOtp-BEVqKl5_.js",
      "assets/SMSOtp-DRv7b57p.js",
      "assets/TwoFactorSecurity-BIJTVwAs.js",
      "assets/Register-BXEBrj3M.js",
      "assets/EmailRequest-CHS16UOD.js",
      "assets/EmailVerification-Blm6sxlm.js",
      "assets/Password-DdUf74_v.js",
      "assets/Index-DMNQa3U82.js",
      "assets/Selection-CbW3b6dz.js",
      "assets/Index-Db1o_rM_.js",
      "assets/401-Cf1_DWvI.js",
      "assets/403-C7ym3b9s.js",
      "assets/404-YD64XzE0.js",
      "assets/Blank-BlrR44oZ.js",
      "assets/App-CGXxjD-O.js",
      "assets/App-f_xrOSiN.css",
      "assets/Guest-BRI1_UCr.js",
      "assets/Setup-w_MphF9V.js",
      "assets/Empty-w_MphF9V.js",
      "assets/Error-ChJuGYox.js",
    ]),
) => i.map((i) => d[i]);
import { o as e, r as t, t as n } from "./chunk-CMxvf4Kt.js";
import { t as r } from "./utils-DEEYWRUN.js";
import {
  At as i,
  D as a,
  Dt as o,
  E as s,
  H as c,
  J as l,
  K as u,
  N as d,
  P as f,
  S as p,
  T as m,
  Tt as h,
  X as g,
  Z as v,
  a as y,
  at as b,
  b as x,
  h as S,
  i as C,
  j as w,
  kt as T,
  m as ee,
  q as te,
  t as ne,
  w as re,
  x as E,
  xt as ie,
  y as ae,
} from "./vue.esm-bundler-B5vgcGJL.js";
import { t as oe } from "./vuex.esm-bundler-DJRHx7fM.js";
import { t as D } from "./array-FrBPf9mT.js";
var O = n((e, t) => {
    var n = Object.prototype.hasOwnProperty;
    function r(e, t) {
      return e != null && n.call(e, t);
    }
    t.exports = r;
  }),
  k = n((e, t) => {
    t.exports = Array.isArray;
  }),
  se = n((e, t) => {
    t.exports = typeof global == `object` && global && global.Object === Object && global;
  }),
  ce = n((e, t) => {
    var n = se(),
      r = typeof self == `object` && self && self.Object === Object && self;
    t.exports = n || r || Function(`return this`)();
  }),
  le = n((e, t) => {
    t.exports = ce().Symbol;
  }),
  ue = n((e, t) => {
    var n = le(),
      r = Object.prototype,
      i = r.hasOwnProperty,
      a = r.toString,
      o = n ? n.toStringTag : void 0;
    function s(e) {
      var t = i.call(e, o),
        n = e[o];
      try {
        e[o] = void 0;
        var r = !0;
      } catch {}
      var s = a.call(e);
      return (r && (t ? (e[o] = n) : delete e[o]), s);
    }
    t.exports = s;
  }),
  de = n((e, t) => {
    var n = Object.prototype.toString;
    function r(e) {
      return n.call(e);
    }
    t.exports = r;
  }),
  fe = n((e, t) => {
    var n = le(),
      r = ue(),
      i = de(),
      a = `[object Null]`,
      o = `[object Undefined]`,
      s = n ? n.toStringTag : void 0;
    function c(e) {
      return e == null ? (e === void 0 ? o : a) : s && s in Object(e) ? r(e) : i(e);
    }
    t.exports = c;
  }),
  pe = n((e, t) => {
    function n(e) {
      return typeof e == `object` && !!e;
    }
    t.exports = n;
  }),
  me = n((e, t) => {
    var n = fe(),
      r = pe(),
      i = `[object Symbol]`;
    function a(e) {
      return typeof e == `symbol` || (r(e) && n(e) == i);
    }
    t.exports = a;
  }),
  he = n((e, t) => {
    var n = k(),
      r = me(),
      i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      a = /^\w*$/;
    function o(e, t) {
      if (n(e)) return !1;
      var o = typeof e;
      return o == `number` || o == `symbol` || o == `boolean` || e == null || r(e)
        ? !0
        : a.test(e) || !i.test(e) || (t != null && e in Object(t));
    }
    t.exports = o;
  }),
  ge = n((e, t) => {
    function n(e) {
      var t = typeof e;
      return e != null && (t == `object` || t == `function`);
    }
    t.exports = n;
  }),
  _e = n((e, t) => {
    var n = fe(),
      r = ge(),
      i = `[object AsyncFunction]`,
      a = `[object Function]`,
      o = `[object GeneratorFunction]`,
      s = `[object Proxy]`;
    function c(e) {
      if (!r(e)) return !1;
      var t = n(e);
      return t == a || t == o || t == i || t == s;
    }
    t.exports = c;
  }),
  ve = n((e, t) => {
    t.exports = ce()[`__core-js_shared__`];
  }),
  ye = n((e, t) => {
    var n = ve(),
      r = (function () {
        var e = /[^.]+$/.exec((n && n.keys && n.keys.IE_PROTO) || ``);
        return e ? `Symbol(src)_1.` + e : ``;
      })();
    function i(e) {
      return !!r && r in e;
    }
    t.exports = i;
  }),
  be = n((e, t) => {
    var n = Function.prototype.toString;
    function r(e) {
      if (e != null) {
        try {
          return n.call(e);
        } catch {}
        try {
          return e + ``;
        } catch {}
      }
      return ``;
    }
    t.exports = r;
  }),
  xe = n((e, t) => {
    var n = _e(),
      r = ye(),
      i = ge(),
      a = be(),
      o = /[\\^$.*+?()[\]{}|]/g,
      s = /^\[object .+?Constructor\]$/,
      c = Function.prototype,
      l = Object.prototype,
      u = c.toString,
      d = l.hasOwnProperty,
      f = RegExp(
        `^` +
          u
            .call(d)
            .replace(o, `\\$&`)
            .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, `$1.*?`) +
          `$`,
      );
    function p(e) {
      return !i(e) || r(e) ? !1 : (n(e) ? f : s).test(a(e));
    }
    t.exports = p;
  }),
  Se = n((e, t) => {
    function n(e, t) {
      return e?.[t];
    }
    t.exports = n;
  }),
  Ce = n((e, t) => {
    var n = xe(),
      r = Se();
    function i(e, t) {
      var i = r(e, t);
      return n(i) ? i : void 0;
    }
    t.exports = i;
  }),
  we = n((e, t) => {
    t.exports = Ce()(Object, `create`);
  }),
  Te = n((e, t) => {
    var n = we();
    function r() {
      ((this.__data__ = n ? n(null) : {}), (this.size = 0));
    }
    t.exports = r;
  }),
  A = n((e, t) => {
    function n(e) {
      var t = this.has(e) && delete this.__data__[e];
      return ((this.size -= +!!t), t);
    }
    t.exports = n;
  }),
  Ee = n((e, t) => {
    var n = we(),
      r = `__lodash_hash_undefined__`,
      i = Object.prototype.hasOwnProperty;
    function a(e) {
      var t = this.__data__;
      if (n) {
        var a = t[e];
        return a === r ? void 0 : a;
      }
      return i.call(t, e) ? t[e] : void 0;
    }
    t.exports = a;
  }),
  De = n((e, t) => {
    var n = we(),
      r = Object.prototype.hasOwnProperty;
    function i(e) {
      var t = this.__data__;
      return n ? t[e] !== void 0 : r.call(t, e);
    }
    t.exports = i;
  }),
  Oe = n((e, t) => {
    var n = we(),
      r = `__lodash_hash_undefined__`;
    function i(e, t) {
      var i = this.__data__;
      return ((this.size += +!this.has(e)), (i[e] = n && t === void 0 ? r : t), this);
    }
    t.exports = i;
  }),
  ke = n((e, t) => {
    var n = Te(),
      r = A(),
      i = Ee(),
      a = De(),
      o = Oe();
    function s(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    ((s.prototype.clear = n),
      (s.prototype.delete = r),
      (s.prototype.get = i),
      (s.prototype.has = a),
      (s.prototype.set = o),
      (t.exports = s));
  }),
  Ae = n((e, t) => {
    function n() {
      ((this.__data__ = []), (this.size = 0));
    }
    t.exports = n;
  }),
  je = n((e, t) => {
    function n(e, t) {
      return e === t || (e !== e && t !== t);
    }
    t.exports = n;
  }),
  Me = n((e, t) => {
    var n = je();
    function r(e, t) {
      for (var r = e.length; r--;) if (n(e[r][0], t)) return r;
      return -1;
    }
    t.exports = r;
  }),
  Ne = n((e, t) => {
    var n = Me(),
      r = Array.prototype.splice;
    function i(e) {
      var t = this.__data__,
        i = n(t, e);
      return i < 0 ? !1 : (i == t.length - 1 ? t.pop() : r.call(t, i, 1), --this.size, !0);
    }
    t.exports = i;
  }),
  Pe = n((e, t) => {
    var n = Me();
    function r(e) {
      var t = this.__data__,
        r = n(t, e);
      return r < 0 ? void 0 : t[r][1];
    }
    t.exports = r;
  }),
  Fe = n((e, t) => {
    var n = Me();
    function r(e) {
      return n(this.__data__, e) > -1;
    }
    t.exports = r;
  }),
  Ie = n((e, t) => {
    var n = Me();
    function r(e, t) {
      var r = this.__data__,
        i = n(r, e);
      return (i < 0 ? (++this.size, r.push([e, t])) : (r[i][1] = t), this);
    }
    t.exports = r;
  }),
  Le = n((e, t) => {
    var n = Ae(),
      r = Ne(),
      i = Pe(),
      a = Fe(),
      o = Ie();
    function s(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    ((s.prototype.clear = n),
      (s.prototype.delete = r),
      (s.prototype.get = i),
      (s.prototype.has = a),
      (s.prototype.set = o),
      (t.exports = s));
  }),
  Re = n((e, t) => {
    t.exports = Ce()(ce(), `Map`);
  }),
  ze = n((e, t) => {
    var n = ke(),
      r = Le(),
      i = Re();
    function a() {
      ((this.size = 0),
        (this.__data__ = {
          hash: new n(),
          map: new (i || r)(),
          string: new n(),
        }));
    }
    t.exports = a;
  }),
  Be = n((e, t) => {
    function n(e) {
      var t = typeof e;
      return t == `string` || t == `number` || t == `symbol` || t == `boolean`
        ? e !== `__proto__`
        : e === null;
    }
    t.exports = n;
  }),
  Ve = n((e, t) => {
    var n = Be();
    function r(e, t) {
      var r = e.__data__;
      return n(t) ? r[typeof t == `string` ? `string` : `hash`] : r.map;
    }
    t.exports = r;
  }),
  He = n((e, t) => {
    var n = Ve();
    function r(e) {
      var t = n(this, e).delete(e);
      return ((this.size -= +!!t), t);
    }
    t.exports = r;
  }),
  Ue = n((e, t) => {
    var n = Ve();
    function r(e) {
      return n(this, e).get(e);
    }
    t.exports = r;
  }),
  We = n((e, t) => {
    var n = Ve();
    function r(e) {
      return n(this, e).has(e);
    }
    t.exports = r;
  }),
  Ge = n((e, t) => {
    var n = Ve();
    function r(e, t) {
      var r = n(this, e),
        i = r.size;
      return (r.set(e, t), (this.size += r.size == i ? 0 : 1), this);
    }
    t.exports = r;
  }),
  Ke = n((e, t) => {
    var n = ze(),
      r = He(),
      i = Ue(),
      a = We(),
      o = Ge();
    function s(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    ((s.prototype.clear = n),
      (s.prototype.delete = r),
      (s.prototype.get = i),
      (s.prototype.has = a),
      (s.prototype.set = o),
      (t.exports = s));
  }),
  qe = n((e, t) => {
    var n = Ke(),
      r = `Expected a function`;
    function i(e, t) {
      if (typeof e != `function` || (t != null && typeof t != `function`)) throw TypeError(r);
      var a = function () {
        var n = arguments,
          r = t ? t.apply(this, n) : n[0],
          i = a.cache;
        if (i.has(r)) return i.get(r);
        var o = e.apply(this, n);
        return ((a.cache = i.set(r, o) || i), o);
      };
      return ((a.cache = new (i.Cache || n)()), a);
    }
    ((i.Cache = n), (t.exports = i));
  }),
  Je = n((e, t) => {
    var n = qe(),
      r = 500;
    function i(e) {
      var t = n(e, function (e) {
          return (i.size === r && i.clear(), e);
        }),
        i = t.cache;
      return t;
    }
    t.exports = i;
  }),
  Ye = n((e, t) => {
    var n = Je(),
      r =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      i = /\\(\\)?/g;
    t.exports = n(function (e) {
      var t = [];
      return (
        e.charCodeAt(0) === 46 && t.push(``),
        e.replace(r, function (e, n, r, a) {
          t.push(r ? a.replace(i, `$1`) : n || e);
        }),
        t
      );
    });
  }),
  Xe = n((e, t) => {
    function n(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
      return i;
    }
    t.exports = n;
  }),
  Ze = n((e, t) => {
    var n = le(),
      r = Xe(),
      i = k(),
      a = me(),
      o = 1 / 0,
      s = n ? n.prototype : void 0,
      c = s ? s.toString : void 0;
    function l(e) {
      if (typeof e == `string`) return e;
      if (i(e)) return r(e, l) + ``;
      if (a(e)) return c ? c.call(e) : ``;
      var t = e + ``;
      return t == `0` && 1 / e == -o ? `-0` : t;
    }
    t.exports = l;
  }),
  Qe = n((e, t) => {
    var n = Ze();
    function r(e) {
      return e == null ? `` : n(e);
    }
    t.exports = r;
  }),
  $e = n((e, t) => {
    var n = k(),
      r = he(),
      i = Ye(),
      a = Qe();
    function o(e, t) {
      return n(e) ? e : r(e, t) ? [e] : i(a(e));
    }
    t.exports = o;
  }),
  et = n((e, t) => {
    var n = fe(),
      r = pe(),
      i = `[object Arguments]`;
    function a(e) {
      return r(e) && n(e) == i;
    }
    t.exports = a;
  }),
  tt = n((e, t) => {
    var n = et(),
      r = pe(),
      i = Object.prototype,
      a = i.hasOwnProperty,
      o = i.propertyIsEnumerable;
    t.exports = n(
      (function () {
        return arguments;
      })(),
    )
      ? n
      : function (e) {
          return r(e) && a.call(e, `callee`) && !o.call(e, `callee`);
        };
  }),
  nt = n((e, t) => {
    var n = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;
    function i(e, t) {
      var i = typeof e;
      return (
        (t ??= n),
        !!t && (i == `number` || (i != `symbol` && r.test(e))) && e > -1 && e % 1 == 0 && e < t
      );
    }
    t.exports = i;
  }),
  rt = n((e, t) => {
    var n = 9007199254740991;
    function r(e) {
      return typeof e == `number` && e > -1 && e % 1 == 0 && e <= n;
    }
    t.exports = r;
  }),
  it = n((e, t) => {
    var n = me(),
      r = 1 / 0;
    function i(e) {
      if (typeof e == `string` || n(e)) return e;
      var t = e + ``;
      return t == `0` && 1 / e == -r ? `-0` : t;
    }
    t.exports = i;
  }),
  at = n((e, t) => {
    var n = $e(),
      r = tt(),
      i = k(),
      a = nt(),
      o = rt(),
      s = it();
    function c(e, t, c) {
      t = n(t, e);
      for (var l = -1, u = t.length, d = !1; ++l < u;) {
        var f = s(t[l]);
        if (!(d = e != null && c(e, f))) break;
        e = e[f];
      }
      return d || ++l != u
        ? d
        : ((u = e == null ? 0 : e.length), !!u && o(u) && a(f, u) && (i(e) || r(e)));
    }
    t.exports = c;
  }),
  ot = n((e, t) => {
    var n = O(),
      r = at();
    function i(e, t) {
      return e != null && r(e, t, n);
    }
    t.exports = i;
  }),
  st = n((e, t) => {
    var n = $e(),
      r = it();
    function i(e, t) {
      t = n(t, e);
      for (var i = 0, a = t.length; e != null && i < a;) e = e[r(t[i++])];
      return i && i == a ? e : void 0;
    }
    t.exports = i;
  }),
  ct = n((e, t) => {
    var n = st();
    function r(e, t, r) {
      var i = e == null ? void 0 : n(e, t);
      return i === void 0 ? r : i;
    }
    t.exports = r;
  }),
  lt = n((e, t) => {
    var n = Le();
    function r() {
      ((this.__data__ = new n()), (this.size = 0));
    }
    t.exports = r;
  }),
  ut = n((e, t) => {
    function n(e) {
      var t = this.__data__,
        n = t.delete(e);
      return ((this.size = t.size), n);
    }
    t.exports = n;
  }),
  dt = n((e, t) => {
    function n(e) {
      return this.__data__.get(e);
    }
    t.exports = n;
  }),
  ft = n((e, t) => {
    function n(e) {
      return this.__data__.has(e);
    }
    t.exports = n;
  }),
  pt = n((e, t) => {
    var n = Le(),
      r = Re(),
      i = Ke(),
      a = 200;
    function o(e, t) {
      var o = this.__data__;
      if (o instanceof n) {
        var s = o.__data__;
        if (!r || s.length < a - 1) return (s.push([e, t]), (this.size = ++o.size), this);
        o = this.__data__ = new i(s);
      }
      return (o.set(e, t), (this.size = o.size), this);
    }
    t.exports = o;
  }),
  mt = n((e, t) => {
    var n = Le(),
      r = lt(),
      i = ut(),
      a = dt(),
      o = ft(),
      s = pt();
    function c(e) {
      var t = (this.__data__ = new n(e));
      this.size = t.size;
    }
    ((c.prototype.clear = r),
      (c.prototype.delete = i),
      (c.prototype.get = a),
      (c.prototype.has = o),
      (c.prototype.set = s),
      (t.exports = c));
  }),
  ht = n((e, t) => {
    function n(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
      return e;
    }
    t.exports = n;
  }),
  gt = n((e, t) => {
    var n = Ce();
    t.exports = (function () {
      try {
        var e = n(Object, `defineProperty`);
        return (e({}, ``, {}), e);
      } catch {}
    })();
  }),
  _t = n((e, t) => {
    var n = gt();
    function r(e, t, r) {
      t == `__proto__` && n
        ? n(e, t, {
            configurable: !0,
            enumerable: !0,
            value: r,
            writable: !0,
          })
        : (e[t] = r);
    }
    t.exports = r;
  }),
  vt = n((e, t) => {
    var n = _t(),
      r = je(),
      i = Object.prototype.hasOwnProperty;
    function a(e, t, a) {
      var o = e[t];
      (!(i.call(e, t) && r(o, a)) || (a === void 0 && !(t in e))) && n(e, t, a);
    }
    t.exports = a;
  }),
  yt = n((e, t) => {
    var n = vt(),
      r = _t();
    function i(e, t, i, a) {
      var o = !i;
      i ||= {};
      for (var s = -1, c = t.length; ++s < c;) {
        var l = t[s],
          u = a ? a(i[l], e[l], l, i, e) : void 0;
        (u === void 0 && (u = e[l]), o ? r(i, l, u) : n(i, l, u));
      }
      return i;
    }
    t.exports = i;
  }),
  bt = n((e, t) => {
    function n(e, t) {
      for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
      return r;
    }
    t.exports = n;
  }),
  xt = n((e, t) => {
    function n() {
      return !1;
    }
    t.exports = n;
  }),
  St = n((e, t) => {
    var n = ce(),
      r = xt(),
      i = typeof e == `object` && e && !e.nodeType && e,
      a = i && typeof t == `object` && t && !t.nodeType && t,
      o = a && a.exports === i ? n.Buffer : void 0;
    t.exports = (o ? o.isBuffer : void 0) || r;
  }),
  Ct = n((e, t) => {
    var n = fe(),
      r = rt(),
      i = pe(),
      a = `[object Arguments]`,
      o = `[object Array]`,
      s = `[object Boolean]`,
      c = `[object Date]`,
      l = `[object Error]`,
      u = `[object Function]`,
      d = `[object Map]`,
      f = `[object Number]`,
      p = `[object Object]`,
      m = `[object RegExp]`,
      h = `[object Set]`,
      g = `[object String]`,
      v = `[object WeakMap]`,
      y = `[object ArrayBuffer]`,
      b = `[object DataView]`,
      x = `[object Float32Array]`,
      S = `[object Float64Array]`,
      C = `[object Int8Array]`,
      w = `[object Int16Array]`,
      T = `[object Int32Array]`,
      ee = `[object Uint8Array]`,
      te = `[object Uint8ClampedArray]`,
      ne = `[object Uint16Array]`,
      re = `[object Uint32Array]`,
      E = {};
    ((E[x] = E[S] = E[C] = E[w] = E[T] = E[ee] = E[te] = E[ne] = E[re] = !0),
      (E[a] =
        E[o] =
        E[y] =
        E[s] =
        E[b] =
        E[c] =
        E[l] =
        E[u] =
        E[d] =
        E[f] =
        E[p] =
        E[m] =
        E[h] =
        E[g] =
        E[v] =
          !1));
    function ie(e) {
      return i(e) && r(e.length) && !!E[n(e)];
    }
    t.exports = ie;
  }),
  wt = n((e, t) => {
    function n(e) {
      return function (t) {
        return e(t);
      };
    }
    t.exports = n;
  }),
  Tt = n((e, t) => {
    var n = se(),
      r = typeof e == `object` && e && !e.nodeType && e,
      i = r && typeof t == `object` && t && !t.nodeType && t,
      a = i && i.exports === r && n.process;
    t.exports = (function () {
      try {
        return (i && i.require && i.require(`util`).types) || (a && a.binding && a.binding(`util`));
      } catch {}
    })();
  }),
  Et = n((e, t) => {
    var n = Ct(),
      r = wt(),
      i = Tt(),
      a = i && i.isTypedArray;
    t.exports = a ? r(a) : n;
  }),
  j = n((e, t) => {
    var n = bt(),
      r = tt(),
      i = k(),
      a = St(),
      o = nt(),
      s = Et(),
      c = Object.prototype.hasOwnProperty;
    function l(e, t) {
      var l = i(e),
        u = !l && r(e),
        d = !l && !u && a(e),
        f = !l && !u && !d && s(e),
        p = l || u || d || f,
        m = p ? n(e.length, String) : [],
        h = m.length;
      for (var g in e)
        (t || c.call(e, g)) &&
          !(
            p &&
            (g == `length` ||
              (d && (g == `offset` || g == `parent`)) ||
              (f && (g == `buffer` || g == `byteLength` || g == `byteOffset`)) ||
              o(g, h))
          ) &&
          m.push(g);
      return m;
    }
    t.exports = l;
  }),
  Dt = n((e, t) => {
    var n = Object.prototype;
    function r(e) {
      var t = e && e.constructor;
      return e === ((typeof t == `function` && t.prototype) || n);
    }
    t.exports = r;
  }),
  Ot = n((e, t) => {
    function n(e, t) {
      return function (n) {
        return e(t(n));
      };
    }
    t.exports = n;
  }),
  kt = n((e, t) => {
    t.exports = Ot()(Object.keys, Object);
  }),
  At = n((e, t) => {
    var n = Dt(),
      r = kt(),
      i = Object.prototype.hasOwnProperty;
    function a(e) {
      if (!n(e)) return r(e);
      var t = [];
      for (var a in Object(e)) i.call(e, a) && a != `constructor` && t.push(a);
      return t;
    }
    t.exports = a;
  }),
  jt = n((e, t) => {
    var n = _e(),
      r = rt();
    function i(e) {
      return e != null && r(e.length) && !n(e);
    }
    t.exports = i;
  }),
  Mt = n((e, t) => {
    var n = j(),
      r = At(),
      i = jt();
    function a(e) {
      return i(e) ? n(e) : r(e);
    }
    t.exports = a;
  }),
  Nt = n((e, t) => {
    var n = yt(),
      r = Mt();
    function i(e, t) {
      return e && n(t, r(t), e);
    }
    t.exports = i;
  }),
  Pt = n((e, t) => {
    function n(e) {
      var t = [];
      if (e != null) for (var n in Object(e)) t.push(n);
      return t;
    }
    t.exports = n;
  }),
  M = n((e, t) => {
    var n = ge(),
      r = Dt(),
      i = Pt(),
      a = Object.prototype.hasOwnProperty;
    function o(e) {
      if (!n(e)) return i(e);
      var t = r(e),
        o = [];
      for (var s in e) (s == `constructor` && (t || !a.call(e, s))) || o.push(s);
      return o;
    }
    t.exports = o;
  }),
  Ft = n((e, t) => {
    var n = j(),
      r = M(),
      i = jt();
    function a(e) {
      return i(e) ? n(e, !0) : r(e);
    }
    t.exports = a;
  }),
  It = n((e, t) => {
    var n = yt(),
      r = Ft();
    function i(e, t) {
      return e && n(t, r(t), e);
    }
    t.exports = i;
  }),
  Lt = n((e, t) => {
    var n = ce(),
      r = typeof e == `object` && e && !e.nodeType && e,
      i = r && typeof t == `object` && t && !t.nodeType && t,
      a = i && i.exports === r ? n.Buffer : void 0,
      o = a ? a.allocUnsafe : void 0;
    function s(e, t) {
      if (t) return e.slice();
      var n = e.length,
        r = o ? o(n) : new e.constructor(n);
      return (e.copy(r), r);
    }
    t.exports = s;
  }),
  Rt = n((e, t) => {
    function n(e, t) {
      var n = -1,
        r = e.length;
      for (t ||= Array(r); ++n < r;) t[n] = e[n];
      return t;
    }
    t.exports = n;
  }),
  zt = n((e, t) => {
    function n(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
        var o = e[n];
        t(o, n, e) && (a[i++] = o);
      }
      return a;
    }
    t.exports = n;
  }),
  Bt = n((e, t) => {
    function n() {
      return [];
    }
    t.exports = n;
  }),
  Vt = n((e, t) => {
    var n = zt(),
      r = Bt(),
      i = Object.prototype.propertyIsEnumerable,
      a = Object.getOwnPropertySymbols;
    t.exports = a
      ? function (e) {
          return e == null
            ? []
            : ((e = Object(e)),
              n(a(e), function (t) {
                return i.call(e, t);
              }));
        }
      : r;
  }),
  Ht = n((e, t) => {
    var n = yt(),
      r = Vt();
    function i(e, t) {
      return n(e, r(e), t);
    }
    t.exports = i;
  }),
  Ut = n((e, t) => {
    function n(e, t) {
      for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
      return e;
    }
    t.exports = n;
  }),
  Wt = n((e, t) => {
    t.exports = Ot()(Object.getPrototypeOf, Object);
  }),
  Gt = n((e, t) => {
    var n = Ut(),
      r = Wt(),
      i = Vt(),
      a = Bt();
    t.exports = Object.getOwnPropertySymbols
      ? function (e) {
          for (var t = []; e;) (n(t, i(e)), (e = r(e)));
          return t;
        }
      : a;
  }),
  Kt = n((e, t) => {
    var n = yt(),
      r = Gt();
    function i(e, t) {
      return n(e, r(e), t);
    }
    t.exports = i;
  }),
  qt = n((e, t) => {
    var n = Ut(),
      r = k();
    function i(e, t, i) {
      var a = t(e);
      return r(e) ? a : n(a, i(e));
    }
    t.exports = i;
  }),
  Jt = n((e, t) => {
    var n = qt(),
      r = Vt(),
      i = Mt();
    function a(e) {
      return n(e, i, r);
    }
    t.exports = a;
  }),
  Yt = n((e, t) => {
    var n = qt(),
      r = Gt(),
      i = Ft();
    function a(e) {
      return n(e, i, r);
    }
    t.exports = a;
  }),
  Xt = n((e, t) => {
    t.exports = Ce()(ce(), `DataView`);
  }),
  Zt = n((e, t) => {
    t.exports = Ce()(ce(), `Promise`);
  }),
  Qt = n((e, t) => {
    t.exports = Ce()(ce(), `Set`);
  }),
  $t = n((e, t) => {
    t.exports = Ce()(ce(), `WeakMap`);
  }),
  en = n((e, t) => {
    var n = Xt(),
      r = Re(),
      i = Zt(),
      a = Qt(),
      o = $t(),
      s = fe(),
      c = be(),
      l = `[object Map]`,
      u = `[object Object]`,
      d = `[object Promise]`,
      f = `[object Set]`,
      p = `[object WeakMap]`,
      m = `[object DataView]`,
      h = c(n),
      g = c(r),
      v = c(i),
      y = c(a),
      b = c(o),
      x = s;
    (((n && x(new n(new ArrayBuffer(1))) != m) ||
      (r && x(new r()) != l) ||
      (i && x(i.resolve()) != d) ||
      (a && x(new a()) != f) ||
      (o && x(new o()) != p)) &&
      (x = function (e) {
        var t = s(e),
          n = t == u ? e.constructor : void 0,
          r = n ? c(n) : ``;
        if (r)
          switch (r) {
            case h:
              return m;
            case g:
              return l;
            case v:
              return d;
            case y:
              return f;
            case b:
              return p;
          }
        return t;
      }),
      (t.exports = x));
  }),
  tn = n((e, t) => {
    var n = Object.prototype.hasOwnProperty;
    function r(e) {
      var t = e.length,
        r = new e.constructor(t);
      return (
        t &&
          typeof e[0] == `string` &&
          n.call(e, `index`) &&
          ((r.index = e.index), (r.input = e.input)),
        r
      );
    }
    t.exports = r;
  }),
  nn = n((e, t) => {
    t.exports = ce().Uint8Array;
  }),
  rn = n((e, t) => {
    var n = nn();
    function r(e) {
      var t = new e.constructor(e.byteLength);
      return (new n(t).set(new n(e)), t);
    }
    t.exports = r;
  }),
  an = n((e, t) => {
    var n = rn();
    function r(e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.byteLength);
    }
    t.exports = r;
  }),
  on = n((e, t) => {
    var n = /\w*$/;
    function r(e) {
      var t = new e.constructor(e.source, n.exec(e));
      return ((t.lastIndex = e.lastIndex), t);
    }
    t.exports = r;
  }),
  sn = n((e, t) => {
    var n = le(),
      r = n ? n.prototype : void 0,
      i = r ? r.valueOf : void 0;
    function a(e) {
      return i ? Object(i.call(e)) : {};
    }
    t.exports = a;
  }),
  cn = n((e, t) => {
    var n = rn();
    function r(e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.length);
    }
    t.exports = r;
  }),
  ln = n((e, t) => {
    var n = rn(),
      r = an(),
      i = on(),
      a = sn(),
      o = cn(),
      s = `[object Boolean]`,
      c = `[object Date]`,
      l = `[object Map]`,
      u = `[object Number]`,
      d = `[object RegExp]`,
      f = `[object Set]`,
      p = `[object String]`,
      m = `[object Symbol]`,
      h = `[object ArrayBuffer]`,
      g = `[object DataView]`,
      v = `[object Float32Array]`,
      y = `[object Float64Array]`,
      b = `[object Int8Array]`,
      x = `[object Int16Array]`,
      S = `[object Int32Array]`,
      C = `[object Uint8Array]`,
      w = `[object Uint8ClampedArray]`,
      T = `[object Uint16Array]`,
      ee = `[object Uint32Array]`;
    function te(e, t, te) {
      var ne = e.constructor;
      switch (t) {
        case h:
          return n(e);
        case s:
        case c:
          return new ne(+e);
        case g:
          return r(e, te);
        case v:
        case y:
        case b:
        case x:
        case S:
        case C:
        case w:
        case T:
        case ee:
          return o(e, te);
        case l:
          return new ne();
        case u:
        case p:
          return new ne(e);
        case d:
          return i(e);
        case f:
          return new ne();
        case m:
          return a(e);
      }
    }
    t.exports = te;
  }),
  un = n((e, t) => {
    var n = ge(),
      r = Object.create;
    t.exports = (function () {
      function e() {}
      return function (t) {
        if (!n(t)) return {};
        if (r) return r(t);
        e.prototype = t;
        var i = new e();
        return ((e.prototype = void 0), i);
      };
    })();
  }),
  dn = n((e, t) => {
    var n = un(),
      r = Wt(),
      i = Dt();
    function a(e) {
      return typeof e.constructor == `function` && !i(e) ? n(r(e)) : {};
    }
    t.exports = a;
  }),
  fn = n((e, t) => {
    var n = en(),
      r = pe(),
      i = `[object Map]`;
    function a(e) {
      return r(e) && n(e) == i;
    }
    t.exports = a;
  }),
  pn = n((e, t) => {
    var n = fn(),
      r = wt(),
      i = Tt(),
      a = i && i.isMap;
    t.exports = a ? r(a) : n;
  }),
  mn = n((e, t) => {
    var n = en(),
      r = pe(),
      i = `[object Set]`;
    function a(e) {
      return r(e) && n(e) == i;
    }
    t.exports = a;
  }),
  hn = n((e, t) => {
    var n = mn(),
      r = wt(),
      i = Tt(),
      a = i && i.isSet;
    t.exports = a ? r(a) : n;
  }),
  gn = n((e, t) => {
    var n = mt(),
      r = ht(),
      i = vt(),
      a = Nt(),
      o = It(),
      s = Lt(),
      c = Rt(),
      l = Ht(),
      u = Kt(),
      d = Jt(),
      f = Yt(),
      p = en(),
      m = tn(),
      h = ln(),
      g = dn(),
      v = k(),
      y = St(),
      b = pn(),
      x = ge(),
      S = hn(),
      C = Mt(),
      w = Ft(),
      T = 1,
      ee = 2,
      te = 4,
      ne = `[object Arguments]`,
      re = `[object Array]`,
      E = `[object Boolean]`,
      ie = `[object Date]`,
      ae = `[object Error]`,
      oe = `[object Function]`,
      D = `[object GeneratorFunction]`,
      O = `[object Map]`,
      se = `[object Number]`,
      ce = `[object Object]`,
      le = `[object RegExp]`,
      ue = `[object Set]`,
      de = `[object String]`,
      fe = `[object Symbol]`,
      pe = `[object WeakMap]`,
      me = `[object ArrayBuffer]`,
      he = `[object DataView]`,
      _e = `[object Float32Array]`,
      ve = `[object Float64Array]`,
      ye = `[object Int8Array]`,
      be = `[object Int16Array]`,
      xe = `[object Int32Array]`,
      Se = `[object Uint8Array]`,
      Ce = `[object Uint8ClampedArray]`,
      we = `[object Uint16Array]`,
      Te = `[object Uint32Array]`,
      A = {};
    ((A[ne] =
      A[re] =
      A[me] =
      A[he] =
      A[E] =
      A[ie] =
      A[_e] =
      A[ve] =
      A[ye] =
      A[be] =
      A[xe] =
      A[O] =
      A[se] =
      A[ce] =
      A[le] =
      A[ue] =
      A[de] =
      A[fe] =
      A[Se] =
      A[Ce] =
      A[we] =
      A[Te] =
        !0),
      (A[ae] = A[oe] = A[pe] = !1));
    function Ee(e, t, re, E, ie, ae) {
      var O,
        k = t & T,
        se = t & ee,
        le = t & te;
      if ((re && (O = ie ? re(e, E, ie, ae) : re(e)), O !== void 0)) return O;
      if (!x(e)) return e;
      var ue = v(e);
      if (ue) {
        if (((O = m(e)), !k)) return c(e, O);
      } else {
        var de = p(e),
          fe = de == oe || de == D;
        if (y(e)) return s(e, k);
        if (de == ce || de == ne || (fe && !ie)) {
          if (((O = se || fe ? {} : g(e)), !k)) return se ? u(e, o(O, e)) : l(e, a(O, e));
        } else {
          if (!A[de]) return ie ? e : {};
          O = h(e, de, k);
        }
      }
      ae ||= new n();
      var pe = ae.get(e);
      if (pe) return pe;
      (ae.set(e, O),
        S(e)
          ? e.forEach(function (n) {
              O.add(Ee(n, t, re, n, e, ae));
            })
          : b(e) &&
            e.forEach(function (n, r) {
              O.set(r, Ee(n, t, re, r, e, ae));
            }));
      var me = ue ? void 0 : (le ? (se ? f : d) : se ? w : C)(e);
      return (
        r(me || e, function (n, r) {
          (me && ((r = n), (n = e[r])), i(O, r, Ee(n, t, re, r, e, ae)));
        }),
        O
      );
    }
    t.exports = Ee;
  }),
  _n = n((e, t) => {
    function n(e) {
      var t = e == null ? 0 : e.length;
      return t ? e[t - 1] : void 0;
    }
    t.exports = n;
  }),
  vn = n((e, t) => {
    function n(e, t, n) {
      var r = -1,
        i = e.length;
      (t < 0 && (t = -t > i ? 0 : i + t),
        (n = n > i ? i : n),
        n < 0 && (n += i),
        (i = t > n ? 0 : (n - t) >>> 0),
        (t >>>= 0));
      for (var a = Array(i); ++r < i;) a[r] = e[r + t];
      return a;
    }
    t.exports = n;
  }),
  yn = n((e, t) => {
    var n = st(),
      r = vn();
    function i(e, t) {
      return t.length < 2 ? e : n(e, r(t, 0, -1));
    }
    t.exports = i;
  }),
  bn = n((e, t) => {
    var n = $e(),
      r = _n(),
      i = yn(),
      a = it(),
      o = Object.prototype.hasOwnProperty;
    function s(e, t) {
      t = n(t, e);
      var s = -1,
        c = t.length;
      if (!c) return !0;
      for (; ++s < c;) {
        var l = a(t[s]);
        if (
          (l === `__proto__` && !o.call(e, `__proto__`)) ||
          ((l === `constructor` || l === `prototype`) && s < c - 1)
        )
          return !1;
      }
      var u = i(e, t);
      return u == null || delete u[a(r(t))];
    }
    t.exports = s;
  }),
  xn = n((e, t) => {
    var n = fe(),
      r = Wt(),
      i = pe(),
      a = `[object Object]`,
      o = Function.prototype,
      s = Object.prototype,
      c = o.toString,
      l = s.hasOwnProperty,
      u = c.call(Object);
    function d(e) {
      if (!i(e) || n(e) != a) return !1;
      var t = r(e);
      if (t === null) return !0;
      var o = l.call(t, `constructor`) && t.constructor;
      return typeof o == `function` && o instanceof o && c.call(o) == u;
    }
    t.exports = d;
  }),
  Sn = n((e, t) => {
    var n = xn();
    function r(e) {
      return n(e) ? void 0 : e;
    }
    t.exports = r;
  }),
  Cn = n((e, t) => {
    var n = le(),
      r = tt(),
      i = k(),
      a = n ? n.isConcatSpreadable : void 0;
    function o(e) {
      return i(e) || r(e) || !!(a && e && e[a]);
    }
    t.exports = o;
  }),
  wn = n((e, t) => {
    var n = Ut(),
      r = Cn();
    function i(e, t, a, o, s) {
      var c = -1,
        l = e.length;
      for (a ||= r, s ||= []; ++c < l;) {
        var u = e[c];
        t > 0 && a(u) ? (t > 1 ? i(u, t - 1, a, o, s) : n(s, u)) : o || (s[s.length] = u);
      }
      return s;
    }
    t.exports = i;
  }),
  Tn = n((e, t) => {
    var n = wn();
    function r(e) {
      return e != null && e.length ? n(e, 1) : [];
    }
    t.exports = r;
  }),
  En = n((e, t) => {
    function n(e, t, n) {
      switch (n.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, n[0]);
        case 2:
          return e.call(t, n[0], n[1]);
        case 3:
          return e.call(t, n[0], n[1], n[2]);
      }
      return e.apply(t, n);
    }
    t.exports = n;
  }),
  Dn = n((e, t) => {
    var n = En(),
      r = Math.max;
    function i(e, t, i) {
      return (
        (t = r(t === void 0 ? e.length - 1 : t, 0)),
        function () {
          for (var a = arguments, o = -1, s = r(a.length - t, 0), c = Array(s); ++o < s;)
            c[o] = a[t + o];
          o = -1;
          for (var l = Array(t + 1); ++o < t;) l[o] = a[o];
          return ((l[t] = i(c)), n(e, this, l));
        }
      );
    }
    t.exports = i;
  }),
  On = n((e, t) => {
    function n(e) {
      return function () {
        return e;
      };
    }
    t.exports = n;
  }),
  kn = n((e, t) => {
    function n(e) {
      return e;
    }
    t.exports = n;
  }),
  An = n((e, t) => {
    var n = On(),
      r = gt(),
      i = kn();
    t.exports = r
      ? function (e, t) {
          return r(e, `toString`, {
            configurable: !0,
            enumerable: !1,
            value: n(t),
            writable: !0,
          });
        }
      : i;
  }),
  jn = n((e, t) => {
    var n = 800,
      r = 16,
      i = Date.now;
    function a(e) {
      var t = 0,
        a = 0;
      return function () {
        var o = i(),
          s = r - (o - a);
        if (((a = o), s > 0)) {
          if (++t >= n) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    }
    t.exports = a;
  }),
  Mn = n((e, t) => {
    var n = An();
    t.exports = jn()(n);
  }),
  Nn = n((e, t) => {
    var n = Tn(),
      r = Dn(),
      i = Mn();
    function a(e) {
      return i(r(e, void 0, n), e + ``);
    }
    t.exports = a;
  }),
  Pn = n((e, t) => {
    var n = Xe(),
      r = gn(),
      i = bn(),
      a = $e(),
      o = yt(),
      s = Sn(),
      c = Nn(),
      l = Yt(),
      u = 1,
      d = 2,
      f = 4;
    t.exports = c(function (e, t) {
      var c = {};
      if (e == null) return c;
      var p = !1;
      ((t = n(t, function (t) {
        return ((t = a(t, e)), (p ||= t.length > 1), t);
      })),
        o(e, l(e), c),
        p && (c = r(c, u | d | f, s)));
      for (var m = t.length; m--;) i(c, t[m]);
      return c;
    });
  }),
  Fn = n((e, t) => {
    var n = Qe();
    function r() {
      var e = arguments,
        t = n(e[0]);
      return e.length < 3 ? t : t.replace(e[1], e[2]);
    }
    t.exports = r;
  }),
  In = n((e, t) => {
    function n(e) {
      return function (t, n, r) {
        for (var i = -1, a = Object(t), o = r(t), s = o.length; s--;) {
          var c = o[e ? s : ++i];
          if (n(a[c], c, a) === !1) break;
        }
        return t;
      };
    }
    t.exports = n;
  }),
  Ln = n((e, t) => {
    t.exports = In()();
  }),
  Rn = n((e, t) => {
    var n = Ln(),
      r = Mt();
    function i(e, t) {
      return e && n(e, t, r);
    }
    t.exports = i;
  }),
  zn = n((e, t) => {
    var n = jt();
    function r(e, t) {
      return function (r, i) {
        if (r == null) return r;
        if (!n(r)) return e(r, i);
        for (
          var a = r.length, o = t ? a : -1, s = Object(r);
          (t ? o-- : ++o < a) && i(s[o], o, s) !== !1;
        );
        return r;
      };
    }
    t.exports = r;
  }),
  Bn = n((e, t) => {
    var n = Rn();
    t.exports = zn()(n);
  }),
  Vn = n((e, t) => {
    var n = kn();
    function r(e) {
      return typeof e == `function` ? e : n;
    }
    t.exports = r;
  }),
  Hn = n((e, t) => {
    var n = ht(),
      r = Bn(),
      i = Vn(),
      a = k();
    function o(e, t) {
      return (a(e) ? n : r)(e, i(t));
    }
    t.exports = o;
  }),
  Un = n((e, t) => {
    function n(e, t, n, r) {
      for (var i = -1, a = e == null ? 0 : e.length; ++i < a;) {
        var o = e[i];
        t(r, o, n(o), e);
      }
      return r;
    }
    t.exports = n;
  }),
  Wn = n((e, t) => {
    var n = Bn();
    function r(e, t, r, i) {
      return (
        n(e, function (e, n, a) {
          t(i, e, r(e), a);
        }),
        i
      );
    }
    t.exports = r;
  }),
  Gn = n((e, t) => {
    var n = `__lodash_hash_undefined__`;
    function r(e) {
      return (this.__data__.set(e, n), this);
    }
    t.exports = r;
  }),
  Kn = n((e, t) => {
    function n(e) {
      return this.__data__.has(e);
    }
    t.exports = n;
  }),
  qn = n((e, t) => {
    var n = Ke(),
      r = Gn(),
      i = Kn();
    function a(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.__data__ = new n(); ++t < r;) this.add(e[t]);
    }
    ((a.prototype.add = a.prototype.push = r), (a.prototype.has = i), (t.exports = a));
  }),
  Jn = n((e, t) => {
    function n(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
      return !1;
    }
    t.exports = n;
  }),
  Yn = n((e, t) => {
    function n(e, t) {
      return e.has(t);
    }
    t.exports = n;
  }),
  Xn = n((e, t) => {
    var n = qn(),
      r = Jn(),
      i = Yn(),
      a = 1,
      o = 2;
    function s(e, t, s, c, l, u) {
      var d = s & a,
        f = e.length,
        p = t.length;
      if (f != p && !(d && p > f)) return !1;
      var m = u.get(e),
        h = u.get(t);
      if (m && h) return m == t && h == e;
      var g = -1,
        v = !0,
        y = s & o ? new n() : void 0;
      for (u.set(e, t), u.set(t, e); ++g < f;) {
        var b = e[g],
          x = t[g];
        if (c) var S = d ? c(x, b, g, t, e, u) : c(b, x, g, e, t, u);
        if (S !== void 0) {
          if (S) continue;
          v = !1;
          break;
        }
        if (y) {
          if (
            !r(t, function (e, t) {
              if (!i(y, t) && (b === e || l(b, e, s, c, u))) return y.push(t);
            })
          ) {
            v = !1;
            break;
          }
        } else if (!(b === x || l(b, x, s, c, u))) {
          v = !1;
          break;
        }
      }
      return (u.delete(e), u.delete(t), v);
    }
    t.exports = s;
  }),
  Zn = n((e, t) => {
    function n(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (e, r) {
          n[++t] = [r, e];
        }),
        n
      );
    }
    t.exports = n;
  }),
  Qn = n((e, t) => {
    function n(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (e) {
          n[++t] = e;
        }),
        n
      );
    }
    t.exports = n;
  }),
  $n = n((e, t) => {
    var n = le(),
      r = nn(),
      i = je(),
      a = Xn(),
      o = Zn(),
      s = Qn(),
      c = 1,
      l = 2,
      u = `[object Boolean]`,
      d = `[object Date]`,
      f = `[object Error]`,
      p = `[object Map]`,
      m = `[object Number]`,
      h = `[object RegExp]`,
      g = `[object Set]`,
      v = `[object String]`,
      y = `[object Symbol]`,
      b = `[object ArrayBuffer]`,
      x = `[object DataView]`,
      S = n ? n.prototype : void 0,
      C = S ? S.valueOf : void 0;
    function w(e, t, n, S, w, T, ee) {
      switch (n) {
        case x:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          ((e = e.buffer), (t = t.buffer));
        case b:
          return !(e.byteLength != t.byteLength || !T(new r(e), new r(t)));
        case u:
        case d:
        case m:
          return i(+e, +t);
        case f:
          return e.name == t.name && e.message == t.message;
        case h:
        case v:
          return e == t + ``;
        case p:
          var te = o;
        case g:
          var ne = S & c;
          if (((te ||= s), e.size != t.size && !ne)) return !1;
          var re = ee.get(e);
          if (re) return re == t;
          ((S |= l), ee.set(e, t));
          var E = a(te(e), te(t), S, w, T, ee);
          return (ee.delete(e), E);
        case y:
          if (C) return C.call(e) == C.call(t);
      }
      return !1;
    }
    t.exports = w;
  }),
  er = n((e, t) => {
    var n = Jt(),
      r = 1,
      i = Object.prototype.hasOwnProperty;
    function a(e, t, a, o, s, c) {
      var l = a & r,
        u = n(e),
        d = u.length;
      if (d != n(t).length && !l) return !1;
      for (var f = d; f--;) {
        var p = u[f];
        if (!(l ? p in t : i.call(t, p))) return !1;
      }
      var m = c.get(e),
        h = c.get(t);
      if (m && h) return m == t && h == e;
      var g = !0;
      (c.set(e, t), c.set(t, e));
      for (var v = l; ++f < d;) {
        p = u[f];
        var y = e[p],
          b = t[p];
        if (o) var x = l ? o(b, y, p, t, e, c) : o(y, b, p, e, t, c);
        if (!(x === void 0 ? y === b || s(y, b, a, o, c) : x)) {
          g = !1;
          break;
        }
        v ||= p == `constructor`;
      }
      if (g && !v) {
        var S = e.constructor,
          C = t.constructor;
        S != C &&
          `constructor` in e &&
          `constructor` in t &&
          !(typeof S == `function` && S instanceof S && typeof C == `function` && C instanceof C) &&
          (g = !1);
      }
      return (c.delete(e), c.delete(t), g);
    }
    t.exports = a;
  }),
  tr = n((e, t) => {
    var n = mt(),
      r = Xn(),
      i = $n(),
      a = er(),
      o = en(),
      s = k(),
      c = St(),
      l = Et(),
      u = 1,
      d = `[object Arguments]`,
      f = `[object Array]`,
      p = `[object Object]`,
      m = Object.prototype.hasOwnProperty;
    function h(e, t, h, g, v, y) {
      var b = s(e),
        x = s(t),
        S = b ? f : o(e),
        C = x ? f : o(t);
      ((S = S == d ? p : S), (C = C == d ? p : C));
      var w = S == p,
        T = C == p,
        ee = S == C;
      if (ee && c(e)) {
        if (!c(t)) return !1;
        ((b = !0), (w = !1));
      }
      if (ee && !w)
        return ((y ||= new n()), b || l(e) ? r(e, t, h, g, v, y) : i(e, t, S, h, g, v, y));
      if (!(h & u)) {
        var te = w && m.call(e, `__wrapped__`),
          ne = T && m.call(t, `__wrapped__`);
        if (te || ne) {
          var re = te ? e.value() : e,
            E = ne ? t.value() : t;
          return ((y ||= new n()), v(re, E, h, g, y));
        }
      }
      return ee ? ((y ||= new n()), a(e, t, h, g, v, y)) : !1;
    }
    t.exports = h;
  }),
  nr = n((e, t) => {
    var n = tr(),
      r = pe();
    function i(e, t, a, o, s) {
      return e === t
        ? !0
        : e == null || t == null || (!r(e) && !r(t))
          ? e !== e && t !== t
          : n(e, t, a, o, i, s);
    }
    t.exports = i;
  }),
  rr = n((e, t) => {
    var n = mt(),
      r = nr(),
      i = 1,
      a = 2;
    function o(e, t, o, s) {
      var c = o.length,
        l = c,
        u = !s;
      if (e == null) return !l;
      for (e = Object(e); c--;) {
        var d = o[c];
        if (u && d[2] ? d[1] !== e[d[0]] : !(d[0] in e)) return !1;
      }
      for (; ++c < l;) {
        d = o[c];
        var f = d[0],
          p = e[f],
          m = d[1];
        if (u && d[2]) {
          if (p === void 0 && !(f in e)) return !1;
        } else {
          var h = new n();
          if (s) var g = s(p, m, f, e, t, h);
          if (!(g === void 0 ? r(m, p, i | a, s, h) : g)) return !1;
        }
      }
      return !0;
    }
    t.exports = o;
  }),
  ir = n((e, t) => {
    var n = ge();
    function r(e) {
      return e === e && !n(e);
    }
    t.exports = r;
  }),
  ar = n((e, t) => {
    var n = ir(),
      r = Mt();
    function i(e) {
      for (var t = r(e), i = t.length; i--;) {
        var a = t[i],
          o = e[a];
        t[i] = [a, o, n(o)];
      }
      return t;
    }
    t.exports = i;
  }),
  or = n((e, t) => {
    function n(e, t) {
      return function (n) {
        return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
      };
    }
    t.exports = n;
  }),
  sr = n((e, t) => {
    var n = rr(),
      r = ar(),
      i = or();
    function a(e) {
      var t = r(e);
      return t.length == 1 && t[0][2]
        ? i(t[0][0], t[0][1])
        : function (r) {
            return r === e || n(r, e, t);
          };
    }
    t.exports = a;
  }),
  cr = n((e, t) => {
    function n(e, t) {
      return e != null && t in Object(e);
    }
    t.exports = n;
  }),
  lr = n((e, t) => {
    var n = cr(),
      r = at();
    function i(e, t) {
      return e != null && r(e, t, n);
    }
    t.exports = i;
  }),
  ur = n((e, t) => {
    var n = nr(),
      r = ct(),
      i = lr(),
      a = he(),
      o = ir(),
      s = or(),
      c = it(),
      l = 1,
      u = 2;
    function d(e, t) {
      return a(e) && o(t)
        ? s(c(e), t)
        : function (a) {
            var o = r(a, e);
            return o === void 0 && o === t ? i(a, e) : n(t, o, l | u);
          };
    }
    t.exports = d;
  }),
  dr = n((e, t) => {
    function n(e) {
      return function (t) {
        return t?.[e];
      };
    }
    t.exports = n;
  }),
  fr = n((e, t) => {
    var n = st();
    function r(e) {
      return function (t) {
        return n(t, e);
      };
    }
    t.exports = r;
  }),
  pr = n((e, t) => {
    var n = dr(),
      r = fr(),
      i = he(),
      a = it();
    function o(e) {
      return i(e) ? n(a(e)) : r(e);
    }
    t.exports = o;
  }),
  mr = n((e, t) => {
    var n = sr(),
      r = ur(),
      i = kn(),
      a = k(),
      o = pr();
    function s(e) {
      return typeof e == `function`
        ? e
        : e == null
          ? i
          : typeof e == `object`
            ? a(e)
              ? r(e[0], e[1])
              : n(e)
            : o(e);
    }
    t.exports = s;
  }),
  hr = n((e, t) => {
    var n = Un(),
      r = Wn(),
      i = mr(),
      a = k();
    function o(e, t) {
      return function (o, s) {
        var c = a(o) ? n : r,
          l = t ? t() : {};
        return c(o, e, i(s, 2), l);
      };
    }
    t.exports = o;
  }),
  gr = n((e, t) => {
    var n = _t(),
      r = hr(),
      i = Object.prototype.hasOwnProperty;
    t.exports = r(function (e, t, r) {
      i.call(e, r) ? e[r].push(t) : n(e, r, [t]);
    });
  }),
  _r = n((e, t) => {
    var n = nr();
    function r(e, t) {
      return n(e, t);
    }
    t.exports = r;
  }),
  vr = n((e, t) => {
    var n = At(),
      r = en(),
      i = tt(),
      a = k(),
      o = jt(),
      s = St(),
      c = Dt(),
      l = Et(),
      u = `[object Map]`,
      d = `[object Set]`,
      f = Object.prototype.hasOwnProperty;
    function p(e) {
      if (e == null) return !0;
      if (
        o(e) &&
        (a(e) || typeof e == `string` || typeof e.splice == `function` || s(e) || l(e) || i(e))
      )
        return !e.length;
      var t = r(e);
      if (t == u || t == d) return !e.size;
      if (c(e)) return !n(e).length;
      for (var p in e) if (f.call(e, p)) return !1;
      return !0;
    }
    t.exports = p;
  }),
  yr = n((e, t) => {
    function n(e, t, n, r) {
      for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) if (t(e[a], a, e)) return a;
      return -1;
    }
    t.exports = n;
  }),
  br = n((e, t) => {
    function n(e) {
      return e !== e;
    }
    t.exports = n;
  }),
  xr = n((e, t) => {
    function n(e, t, n) {
      for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
      return -1;
    }
    t.exports = n;
  }),
  Sr = n((e, t) => {
    var n = yr(),
      r = br(),
      i = xr();
    function a(e, t, a) {
      return t === t ? i(e, t, a) : n(e, r, a);
    }
    t.exports = a;
  }),
  Cr = n((e, t) => {
    var n = fe(),
      r = k(),
      i = pe(),
      a = `[object String]`;
    function o(e) {
      return typeof e == `string` || (!r(e) && i(e) && n(e) == a);
    }
    t.exports = o;
  }),
  wr = n((e, t) => {
    var n = /\s/;
    function r(e) {
      for (var t = e.length; t-- && n.test(e.charAt(t)););
      return t;
    }
    t.exports = r;
  }),
  Tr = n((e, t) => {
    var n = wr(),
      r = /^\s+/;
    function i(e) {
      return e && e.slice(0, n(e) + 1).replace(r, ``);
    }
    t.exports = i;
  }),
  Er = n((e, t) => {
    var n = Tr(),
      r = ge(),
      i = me(),
      a = NaN,
      o = /^[-+]0x[0-9a-f]+$/i,
      s = /^0b[01]+$/i,
      c = /^0o[0-7]+$/i,
      l = parseInt;
    function u(e) {
      if (typeof e == `number`) return e;
      if (i(e)) return a;
      if (r(e)) {
        var t = typeof e.valueOf == `function` ? e.valueOf() : e;
        e = r(t) ? t + `` : t;
      }
      if (typeof e != `string`) return e === 0 ? e : +e;
      e = n(e);
      var u = s.test(e);
      return u || c.test(e) ? l(e.slice(2), u ? 2 : 8) : o.test(e) ? a : +e;
    }
    t.exports = u;
  }),
  Dr = n((e, t) => {
    var n = Er(),
      r = 1 / 0,
      i = 17976931348623157e292;
    function a(e) {
      return e
        ? ((e = n(e)), e === r || e === -r ? (e < 0 ? -1 : 1) * i : e === e ? e : 0)
        : e === 0
          ? e
          : 0;
    }
    t.exports = a;
  }),
  Or = n((e, t) => {
    var n = Dr();
    function r(e) {
      var t = n(e),
        r = t % 1;
      return t === t ? (r ? t - r : t) : 0;
    }
    t.exports = r;
  }),
  kr = n((e, t) => {
    var n = Xe();
    function r(e, t) {
      return n(t, function (t) {
        return e[t];
      });
    }
    t.exports = r;
  }),
  Ar = n((e, t) => {
    var n = kr(),
      r = Mt();
    function i(e) {
      return e == null ? [] : n(e, r(e));
    }
    t.exports = i;
  }),
  jr = n((e, t) => {
    var n = Sr(),
      r = jt(),
      i = Cr(),
      a = Or(),
      o = Ar(),
      s = Math.max;
    function c(e, t, c, l) {
      ((e = r(e) ? e : o(e)), (c = c && !l ? a(c) : 0));
      var u = e.length;
      return (
        c < 0 && (c = s(u + c, 0)),
        i(e) ? c <= u && e.indexOf(t, c) > -1 : !!u && n(e, t, c) > -1
      );
    }
    t.exports = c;
  }),
  Mr = n((e, t) => {
    var n = ce();
    t.exports = function () {
      return n.Date.now();
    };
  }),
  Nr = n((e, t) => {
    var n = ge(),
      r = Mr(),
      i = Er(),
      a = `Expected a function`,
      o = Math.max,
      s = Math.min;
    function c(e, t, c) {
      var l,
        u,
        d,
        f,
        p,
        m,
        h = 0,
        g = !1,
        v = !1,
        y = !0;
      if (typeof e != `function`) throw TypeError(a);
      ((t = i(t) || 0),
        n(c) &&
          ((g = !!c.leading),
          (v = `maxWait` in c),
          (d = v ? o(i(c.maxWait) || 0, t) : d),
          (y = `trailing` in c ? !!c.trailing : y)));
      function b(t) {
        var n = l,
          r = u;
        return ((l = u = void 0), (h = t), (f = e.apply(r, n)), f);
      }
      function x(e) {
        return ((h = e), (p = setTimeout(w, t)), g ? b(e) : f);
      }
      function S(e) {
        var n = e - m,
          r = e - h,
          i = t - n;
        return v ? s(i, d - r) : i;
      }
      function C(e) {
        var n = e - m,
          r = e - h;
        return m === void 0 || n >= t || n < 0 || (v && r >= d);
      }
      function w() {
        var e = r();
        if (C(e)) return T(e);
        p = setTimeout(w, S(e));
      }
      function T(e) {
        return ((p = void 0), y && l ? b(e) : ((l = u = void 0), f));
      }
      function ee() {
        (p !== void 0 && clearTimeout(p), (h = 0), (l = m = u = p = void 0));
      }
      function te() {
        return p === void 0 ? f : T(r());
      }
      function ne() {
        var e = r(),
          n = C(e);
        if (((l = arguments), (u = this), (m = e), n)) {
          if (p === void 0) return x(m);
          if (v) return (clearTimeout(p), (p = setTimeout(w, t)), b(m));
        }
        return (p === void 0 && (p = setTimeout(w, t)), f);
      }
      return ((ne.cancel = ee), (ne.flush = te), ne);
    }
    t.exports = c;
  }),
  Pr = n((e, t) => {
    var n = Nr(),
      r = ge(),
      i = `Expected a function`;
    function a(e, t, a) {
      var o = !0,
        s = !0;
      if (typeof e != `function`) throw TypeError(i);
      return (
        r(a) && ((o = `leading` in a ? !!a.leading : o), (s = `trailing` in a ? !!a.trailing : s)),
        n(e, t, {
          leading: o,
          maxWait: t,
          trailing: s,
        })
      );
    }
    t.exports = a;
  }),
  Fr = n((e, t) => {
    function n(e, t) {
      for (var n = e == null ? 0 : e.length; n-- && t(e[n], n, e) !== !1;);
      return e;
    }
    t.exports = n;
  }),
  Ir = n((e, t) => {
    t.exports = In()(!0);
  }),
  Lr = n((e, t) => {
    var n = Ir(),
      r = Mt();
    function i(e, t) {
      return e && n(e, t, r);
    }
    t.exports = i;
  }),
  Rr = n((e, t) => {
    var n = Lr();
    t.exports = zn()(n, !0);
  }),
  zr = n((e, t) => {
    var n = Fr(),
      r = Rr(),
      i = Vn(),
      a = k();
    function o(e, t) {
      return (a(e) ? n : r)(e, i(t));
    }
    t.exports = o;
  }),
  Br = n((e, t) => {
    t.exports = zr();
  }),
  Vr = n((e, t) => {
    function n(e, t, n, r) {
      var i = -1,
        a = e == null ? 0 : e.length;
      for (r && a && (n = e[++i]); ++i < a;) n = t(n, e[i], i, e);
      return n;
    }
    t.exports = n;
  }),
  Hr = n((e, t) => {
    function n(e) {
      return function (t) {
        return e?.[t];
      };
    }
    t.exports = n;
  }),
  Ur = n((e, t) => {
    t.exports = Hr()({
      À: `A`,
      Á: `A`,
      Â: `A`,
      Ã: `A`,
      Ä: `A`,
      Å: `A`,
      à: `a`,
      á: `a`,
      â: `a`,
      ã: `a`,
      ä: `a`,
      å: `a`,
      Ç: `C`,
      ç: `c`,
      Ð: `D`,
      ð: `d`,
      È: `E`,
      É: `E`,
      Ê: `E`,
      Ë: `E`,
      è: `e`,
      é: `e`,
      ê: `e`,
      ë: `e`,
      Ì: `I`,
      Í: `I`,
      Î: `I`,
      Ï: `I`,
      ì: `i`,
      í: `i`,
      î: `i`,
      ï: `i`,
      Ñ: `N`,
      ñ: `n`,
      Ò: `O`,
      Ó: `O`,
      Ô: `O`,
      Õ: `O`,
      Ö: `O`,
      Ø: `O`,
      ò: `o`,
      ó: `o`,
      ô: `o`,
      õ: `o`,
      ö: `o`,
      ø: `o`,
      Ù: `U`,
      Ú: `U`,
      Û: `U`,
      Ü: `U`,
      ù: `u`,
      ú: `u`,
      û: `u`,
      ü: `u`,
      Ý: `Y`,
      ý: `y`,
      ÿ: `y`,
      Æ: `Ae`,
      æ: `ae`,
      Þ: `Th`,
      þ: `th`,
      ß: `ss`,
      Ā: `A`,
      Ă: `A`,
      Ą: `A`,
      ā: `a`,
      ă: `a`,
      ą: `a`,
      Ć: `C`,
      Ĉ: `C`,
      Ċ: `C`,
      Č: `C`,
      ć: `c`,
      ĉ: `c`,
      ċ: `c`,
      č: `c`,
      Ď: `D`,
      Đ: `D`,
      ď: `d`,
      đ: `d`,
      Ē: `E`,
      Ĕ: `E`,
      Ė: `E`,
      Ę: `E`,
      Ě: `E`,
      ē: `e`,
      ĕ: `e`,
      ė: `e`,
      ę: `e`,
      ě: `e`,
      Ĝ: `G`,
      Ğ: `G`,
      Ġ: `G`,
      Ģ: `G`,
      ĝ: `g`,
      ğ: `g`,
      ġ: `g`,
      ģ: `g`,
      Ĥ: `H`,
      Ħ: `H`,
      ĥ: `h`,
      ħ: `h`,
      Ĩ: `I`,
      Ī: `I`,
      Ĭ: `I`,
      Į: `I`,
      İ: `I`,
      ĩ: `i`,
      ī: `i`,
      ĭ: `i`,
      į: `i`,
      ı: `i`,
      Ĵ: `J`,
      ĵ: `j`,
      Ķ: `K`,
      ķ: `k`,
      ĸ: `k`,
      Ĺ: `L`,
      Ļ: `L`,
      Ľ: `L`,
      Ŀ: `L`,
      Ł: `L`,
      ĺ: `l`,
      ļ: `l`,
      ľ: `l`,
      ŀ: `l`,
      ł: `l`,
      Ń: `N`,
      Ņ: `N`,
      Ň: `N`,
      Ŋ: `N`,
      ń: `n`,
      ņ: `n`,
      ň: `n`,
      ŋ: `n`,
      Ō: `O`,
      Ŏ: `O`,
      Ő: `O`,
      ō: `o`,
      ŏ: `o`,
      ő: `o`,
      Ŕ: `R`,
      Ŗ: `R`,
      Ř: `R`,
      ŕ: `r`,
      ŗ: `r`,
      ř: `r`,
      Ś: `S`,
      Ŝ: `S`,
      Ş: `S`,
      Š: `S`,
      ś: `s`,
      ŝ: `s`,
      ş: `s`,
      š: `s`,
      Ţ: `T`,
      Ť: `T`,
      Ŧ: `T`,
      ţ: `t`,
      ť: `t`,
      ŧ: `t`,
      Ũ: `U`,
      Ū: `U`,
      Ŭ: `U`,
      Ů: `U`,
      Ű: `U`,
      Ų: `U`,
      ũ: `u`,
      ū: `u`,
      ŭ: `u`,
      ů: `u`,
      ű: `u`,
      ų: `u`,
      Ŵ: `W`,
      ŵ: `w`,
      Ŷ: `Y`,
      ŷ: `y`,
      Ÿ: `Y`,
      Ź: `Z`,
      Ż: `Z`,
      Ž: `Z`,
      ź: `z`,
      ż: `z`,
      ž: `z`,
      Ĳ: `IJ`,
      ĳ: `ij`,
      Œ: `Oe`,
      œ: `oe`,
      ŉ: `'n`,
      ſ: `s`,
    });
  }),
  Wr = n((e, t) => {
    var n = Ur(),
      r = Qe(),
      i = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
      a = RegExp(`[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]`, `g`);
    function o(e) {
      return ((e = r(e)), e && e.replace(i, n).replace(a, ``));
    }
    t.exports = o;
  }),
  Gr = n((e, t) => {
    var n = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    function r(e) {
      return e.match(n) || [];
    }
    t.exports = r;
  }),
  N = n((e, t) => {
    var n = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    function r(e) {
      return n.test(e);
    }
    t.exports = r;
  }),
  Kr = n((e, t) => {
    var n = `\\ud800-\\udfff`,
      r = `\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff`,
      i = `\\u2700-\\u27bf`,
      a = `a-z\\xdf-\\xf6\\xf8-\\xff`,
      o = `\\xac\\xb1\\xd7\\xf7`,
      s = `\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf`,
      c = `\\u2000-\\u206f`,
      l = ` \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000`,
      u = `A-Z\\xc0-\\xd6\\xd8-\\xde`,
      d = `\\ufe0e\\ufe0f`,
      f = o + s + c + l,
      p = `['’]`,
      m = `[` + f + `]`,
      h = `[` + r + `]`,
      g = `\\d+`,
      v = `[` + i + `]`,
      y = `[` + a + `]`,
      b = `[^` + n + f + g + i + a + u + `]`,
      x = `(?:` + h + `|\\ud83c[\\udffb-\\udfff])`,
      S = `[^` + n + `]`,
      C = `(?:\\ud83c[\\udde6-\\uddff]){2}`,
      w = `[\\ud800-\\udbff][\\udc00-\\udfff]`,
      T = `[` + u + `]`,
      ee = `\\u200d`,
      te = `(?:` + y + `|` + b + `)`,
      ne = `(?:` + T + `|` + b + `)`,
      re = `(?:` + p + `(?:d|ll|m|re|s|t|ve))?`,
      E = `(?:` + p + `(?:D|LL|M|RE|S|T|VE))?`,
      ie = x + `?`,
      ae = `[` + d + `]?`,
      oe = `(?:` + ee + `(?:` + [S, C, w].join(`|`) + `)` + ae + ie + `)*`,
      D = `\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])`,
      O = `\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])`,
      k = ae + ie + oe,
      se = `(?:` + [v, C, w].join(`|`) + `)` + k,
      ce = RegExp(
        [
          T + `?` + y + `+` + re + `(?=` + [m, T, `$`].join(`|`) + `)`,
          ne + `+` + E + `(?=` + [m, T + te, `$`].join(`|`) + `)`,
          T + `?` + te + `+` + re,
          T + `+` + E,
          O,
          D,
          g,
          se,
        ].join(`|`),
        `g`,
      );
    function le(e) {
      return e.match(ce) || [];
    }
    t.exports = le;
  }),
  qr = n((e, t) => {
    var n = Gr(),
      r = N(),
      i = Qe(),
      a = Kr();
    function o(e, t, o) {
      return (
        (e = i(e)),
        (t = o ? void 0 : t),
        t === void 0 ? (r(e) ? a(e) : n(e)) : e.match(t) || []
      );
    }
    t.exports = o;
  }),
  Jr = n((e, t) => {
    var n = Vr(),
      r = Wr(),
      i = qr(),
      a = RegExp(`['’]`, `g`);
    function o(e) {
      return function (t) {
        return n(i(r(t).replace(a, ``)), e, ``);
      };
    }
    t.exports = o;
  }),
  P = n((e, t) => {
    var n = vn();
    function r(e, t, r) {
      var i = e.length;
      return ((r = r === void 0 ? i : r), !t && r >= i ? e : n(e, t, r));
    }
    t.exports = r;
  }),
  Yr = n((e, t) => {
    var n = RegExp(
      `[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]`,
    );
    function r(e) {
      return n.test(e);
    }
    t.exports = r;
  }),
  Xr = n((e, t) => {
    function n(e) {
      return e.split(``);
    }
    t.exports = n;
  }),
  Zr = n((e, t) => {
    var n = `\\ud800-\\udfff`,
      r = `\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff`,
      i = `\\ufe0e\\ufe0f`,
      a = `[` + n + `]`,
      o = `[` + r + `]`,
      s = `\\ud83c[\\udffb-\\udfff]`,
      c = `(?:` + o + `|` + s + `)`,
      l = `[^` + n + `]`,
      u = `(?:\\ud83c[\\udde6-\\uddff]){2}`,
      d = `[\\ud800-\\udbff][\\udc00-\\udfff]`,
      f = `\\u200d`,
      p = c + `?`,
      m = `[` + i + `]?`,
      h = `(?:` + f + `(?:` + [l, u, d].join(`|`) + `)` + m + p + `)*`,
      g = m + p + h,
      v = `(?:` + [l + o + `?`, o, u, d, a].join(`|`) + `)`,
      y = RegExp(s + `(?=` + s + `)|` + v + g, `g`);
    function b(e) {
      return e.match(y) || [];
    }
    t.exports = b;
  }),
  Qr = n((e, t) => {
    var n = Xr(),
      r = Yr(),
      i = Zr();
    function a(e) {
      return r(e) ? i(e) : n(e);
    }
    t.exports = a;
  }),
  $r = n((e, t) => {
    var n = P(),
      r = Yr(),
      i = Qr(),
      a = Qe();
    function o(e) {
      return function (t) {
        t = a(t);
        var o = r(t) ? i(t) : void 0,
          s = o ? o[0] : t.charAt(0),
          c = o ? n(o, 1).join(``) : t.slice(1);
        return s[e]() + c;
      };
    }
    t.exports = o;
  }),
  ei = n((e, t) => {
    t.exports = $r()(`toUpperCase`);
  }),
  ti = n((e, t) => {
    var n = Jr(),
      r = ei();
    t.exports = n(function (e, t, n) {
      return e + (n ? ` ` : ``) + r(t);
    });
  }),
  ni = n((e, t) => {
    var n = gn(),
      r = 1,
      i = 4;
    function a(e) {
      return n(e, r | i);
    }
    t.exports = a;
  }),
  ri = n((e, t) => {
    var n = _t(),
      r = Rn(),
      i = mr();
    function a(e, t) {
      var a = {};
      return (
        (t = i(t, 3)),
        r(e, function (e, r, i) {
          n(a, r, t(e, r, i));
        }),
        a
      );
    }
    t.exports = a;
  }),
  ii = n((e, t) => {
    t.exports = Jr()(function (e, t, n) {
      return e + (n ? `_` : ``) + t.toLowerCase();
    });
  }),
  ai = n((e, t) => {
    var n = Qe(),
      r = ei();
    function i(e) {
      return r(n(e).toLowerCase());
    }
    t.exports = i;
  }),
  oi = n((e, t) => {
    var n = ai();
    t.exports = Jr()(function (e, t, r) {
      return ((t = t.toLowerCase()), e + (r ? n(t) : t));
    });
  }),
  si = e(ot(), 1),
  ci = e(ct(), 1),
  li = e(Pn(), 1),
  ui = e(Fn(), 1),
  di = e(k(), 1),
  fi = e(Hn(), 1),
  pi = e(gr(), 1),
  mi = e(_r(), 1),
  hi = e(vr(), 1),
  gi = e(jr(), 1),
  _i = e(Pr(), 1),
  vi = e(Nr(), 1),
  yi = e(Br(), 1),
  bi = e(ti(), 1),
  xi = e(ni(), 1),
  Si = e(ri(), 1),
  Ci = e(ii(), 1),
  wi = e(oi(), 1),
  Ti = e(xn(), 1);
window._ = {
  has: si.default,
  get: ci.default,
  omit: li.default,
  replace: ui.default,
  isEqual: mi.default,
  isEmpty: hi.default,
  forEach: fi.default,
  isArray: di.default,
  groupBy: pi.default,
  includes: gi.default,
  throttle: _i.default,
  debounce: vi.default,
  eachRight: yi.default,
  camelCase: wi.default,
  snakeCase: Ci.default,
  mapValues: Si.default,
  startCase: bi.default,
  cloneDeep: xi.default,
  isPlainObject: Ti.default,
};
var Ei = n((e, t) => {
  (function (n, r) {
    typeof define == `function` && define.amd
      ? define(r)
      : typeof e == `object`
        ? (t.exports = r())
        : (n.NProgress = r());
  })(e, function () {
    var e = {};
    e.version = `0.2.0`;
    var t = (e.settings = {
      minimum: 0.08,
      easing: `ease`,
      positionUsing: ``,
      speed: 200,
      trickle: !0,
      trickleRate: 0.02,
      trickleSpeed: 800,
      showSpinner: !0,
      barSelector: `[role="bar"]`,
      spinnerSelector: `[role="spinner"]`,
      parent: `body`,
      template: `<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>`,
    });
    ((e.configure = function (e) {
      var n, r;
      for (n in e) ((r = e[n]), r !== void 0 && e.hasOwnProperty(n) && (t[n] = r));
      return this;
    }),
      (e.status = null),
      (e.set = function (r) {
        var s = e.isStarted();
        ((r = n(r, t.minimum, 1)), (e.status = r === 1 ? null : r));
        var c = e.render(!s),
          l = c.querySelector(t.barSelector),
          u = t.speed,
          d = t.easing;
        return (
          c.offsetWidth,
          a(function (n) {
            (t.positionUsing === `` && (t.positionUsing = e.getPositioningCSS()),
              o(l, i(r, u, d)),
              r === 1
                ? (o(c, {
                    transition: `none`,
                    opacity: 1,
                  }),
                  c.offsetWidth,
                  setTimeout(function () {
                    (o(c, {
                      transition: `all ` + u + `ms linear`,
                      opacity: 0,
                    }),
                      setTimeout(function () {
                        (e.remove(), n());
                      }, u));
                  }, u))
                : setTimeout(n, u));
          }),
          this
        );
      }),
      (e.isStarted = function () {
        return typeof e.status == `number`;
      }),
      (e.start = function () {
        e.status || e.set(0);
        var n = function () {
          setTimeout(function () {
            e.status && (e.trickle(), n());
          }, t.trickleSpeed);
        };
        return (t.trickle && n(), this);
      }),
      (e.done = function (t) {
        return !t && !e.status ? this : e.inc(0.3 + 0.5 * Math.random()).set(1);
      }),
      (e.inc = function (t) {
        var r = e.status;
        return r
          ? (typeof t != `number` && (t = (1 - r) * n(Math.random() * r, 0.1, 0.95)),
            (r = n(r + t, 0, 0.994)),
            e.set(r))
          : e.start();
      }),
      (e.trickle = function () {
        return e.inc(Math.random() * t.trickleRate);
      }),
      (function () {
        var t = 0,
          n = 0;
        e.promise = function (r) {
          return !r || r.state() === `resolved`
            ? this
            : (n === 0 && e.start(),
              t++,
              n++,
              r.always(function () {
                (n--, n === 0 ? ((t = 0), e.done()) : e.set((t - n) / t));
              }),
              this);
        };
      })(),
      (e.render = function (n) {
        if (e.isRendered()) return document.getElementById(`nprogress`);
        c(document.documentElement, `nprogress-busy`);
        var i = document.createElement(`div`);
        ((i.id = `nprogress`), (i.innerHTML = t.template));
        var a = i.querySelector(t.barSelector),
          s = n ? `-100` : r(e.status || 0),
          l = document.querySelector(t.parent),
          u;
        return (
          o(a, {
            transition: `all 0 linear`,
            transform: `translate3d(` + s + `%,0,0)`,
          }),
          t.showSpinner || ((u = i.querySelector(t.spinnerSelector)), u && d(u)),
          l != document.body && c(l, `nprogress-custom-parent`),
          l.appendChild(i),
          i
        );
      }),
      (e.remove = function () {
        (l(document.documentElement, `nprogress-busy`),
          l(document.querySelector(t.parent), `nprogress-custom-parent`));
        var e = document.getElementById(`nprogress`);
        e && d(e);
      }),
      (e.isRendered = function () {
        return !!document.getElementById(`nprogress`);
      }),
      (e.getPositioningCSS = function () {
        var e = document.body.style,
          t =
            `WebkitTransform` in e
              ? `Webkit`
              : `MozTransform` in e
                ? `Moz`
                : `msTransform` in e
                  ? `ms`
                  : `OTransform` in e
                    ? `O`
                    : ``;
        return t + `Perspective` in e
          ? `translate3d`
          : t + `Transform` in e
            ? `translate`
            : `margin`;
      }));
    function n(e, t, n) {
      return e < t ? t : e > n ? n : e;
    }
    function r(e) {
      return (-1 + e) * 100;
    }
    function i(e, n, i) {
      var a =
        t.positionUsing === `translate3d`
          ? {
              transform: `translate3d(` + r(e) + `%,0,0)`,
            }
          : t.positionUsing === `translate`
            ? {
                transform: `translate(` + r(e) + `%,0)`,
              }
            : {
                "margin-left": r(e) + `%`,
              };
      return ((a.transition = `all ` + n + `ms ` + i), a);
    }
    var a = (function () {
        var e = [];
        function t() {
          var n = e.shift();
          n && n(t);
        }
        return function (n) {
          (e.push(n), e.length == 1 && t());
        };
      })(),
      o = (function () {
        var e = [`Webkit`, `O`, `Moz`, `ms`],
          t = {};
        function n(e) {
          return e.replace(/^-ms-/, `ms-`).replace(/-([\da-z])/gi, function (e, t) {
            return t.toUpperCase();
          });
        }
        function r(t) {
          var n = document.body.style;
          if (t in n) return t;
          for (var r = e.length, i = t.charAt(0).toUpperCase() + t.slice(1), a; r--;)
            if (((a = e[r] + i), a in n)) return a;
          return t;
        }
        function i(e) {
          return ((e = n(e)), t[e] || (t[e] = r(e)));
        }
        function a(e, t, n) {
          ((t = i(t)), (e.style[t] = n));
        }
        return function (e, t) {
          var n = arguments,
            r,
            i;
          if (n.length == 2)
            for (r in t) ((i = t[r]), i !== void 0 && t.hasOwnProperty(r) && a(e, r, i));
          else a(e, n[1], n[2]);
        };
      })();
    function s(e, t) {
      return (typeof e == `string` ? e : u(e)).indexOf(` ` + t + ` `) >= 0;
    }
    function c(e, t) {
      var n = u(e),
        r = n + t;
      s(n, t) || (e.className = r.substring(1));
    }
    function l(e, t) {
      var n = u(e),
        r;
      s(e, t) &&
        ((r = n.replace(` ` + t + ` `, ` `)), (e.className = r.substring(1, r.length - 1)));
    }
    function u(e) {
      return (` ` + (e.className || ``) + ` `).replace(/\s+/gi, ` `);
    }
    function d(e) {
      e && e.parentNode && e.parentNode.removeChild(e);
    }
    return e;
  });
});
function Di(e, t) {
  return function () {
    return e.apply(t, arguments);
  };
}
var { toString: Oi } = Object.prototype,
  { getPrototypeOf: ki } = Object,
  { iterator: Ai, toStringTag: ji } = Symbol,
  Mi = ((e) => (t) => {
    let n = Oi.call(t);
    return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
  })(Object.create(null)),
  Ni = (e) => ((e = e.toLowerCase()), (t) => Mi(t) === e),
  Pi = (e) => (t) => typeof t === e,
  { isArray: Fi } = Array,
  Ii = Pi(`undefined`);
function Li(e) {
  return (
    e !== null &&
    !Ii(e) &&
    e.constructor !== null &&
    !Ii(e.constructor) &&
    Vi(e.constructor.isBuffer) &&
    e.constructor.isBuffer(e)
  );
}
var Ri = Ni(`ArrayBuffer`);
function zi(e) {
  let t;
  return (
    (t =
      typeof ArrayBuffer < `u` && ArrayBuffer.isView
        ? ArrayBuffer.isView(e)
        : e && e.buffer && Ri(e.buffer)),
    t
  );
}
var Bi = Pi(`string`),
  Vi = Pi(`function`),
  Hi = Pi(`number`),
  Ui = (e) => typeof e == `object` && !!e,
  Wi = (e) => e === !0 || e === !1,
  Gi = (e) => {
    if (Mi(e) !== `object`) return !1;
    let t = ki(e);
    return (
      (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) &&
      !(ji in e) &&
      !(Ai in e)
    );
  },
  Ki = (e) => {
    if (!Ui(e) || Li(e)) return !1;
    try {
      return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
    } catch {
      return !1;
    }
  },
  qi = Ni(`Date`),
  Ji = Ni(`File`),
  Yi = (e) => !!(e && e.uri !== void 0),
  Xi = (e) => e && e.getParts !== void 0,
  Zi = Ni(`Blob`),
  Qi = Ni(`FileList`),
  $i = (e) => Ui(e) && Vi(e.pipe);
function ea() {
  return typeof globalThis < `u`
    ? globalThis
    : typeof self < `u`
      ? self
      : typeof window < `u`
        ? window
        : typeof global < `u`
          ? global
          : {};
}
var ta = ea(),
  na = ta.FormData === void 0 ? void 0 : ta.FormData,
  ra = (e) => {
    if (!e) return !1;
    if (na && e instanceof na) return !0;
    let t = ki(e);
    if (!t || t === Object.prototype || !Vi(e.append)) return !1;
    let n = Mi(e);
    return (
      n === `formdata` || (n === `object` && Vi(e.toString) && e.toString() === `[object FormData]`)
    );
  },
  ia = Ni(`URLSearchParams`),
  [aa, oa, sa, ca] = [`ReadableStream`, `Request`, `Response`, `Headers`].map(Ni),
  la = (e) => (e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ``));
function ua(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e == null) return;
  let r, i;
  if ((typeof e != `object` && (e = [e]), Fi(e)))
    for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
  else {
    if (Li(e)) return;
    let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e),
      a = i.length,
      o;
    for (r = 0; r < a; r++) ((o = i[r]), t.call(null, e[o], o, e));
  }
}
function da(e, t) {
  if (Li(e)) return null;
  t = t.toLowerCase();
  let n = Object.keys(e),
    r = n.length,
    i;
  for (; r-- > 0;) if (((i = n[r]), t === i.toLowerCase())) return i;
  return null;
}
var fa =
    typeof globalThis < `u`
      ? globalThis
      : typeof self < `u`
        ? self
        : typeof window < `u`
          ? window
          : global,
  pa = (e) => !Ii(e) && e !== fa;
function ma(...e) {
  let { caseless: t, skipUndefined: n } = (pa(this) && this) || {},
    r = {},
    i = (e, i) => {
      if (i === `__proto__` || i === `constructor` || i === `prototype`) return;
      let a = (t && typeof i == `string` && da(r, i)) || i,
        o = Ea(r, a) ? r[a] : void 0;
      Gi(o) && Gi(e)
        ? (r[a] = ma(o, e))
        : Gi(e)
          ? (r[a] = ma({}, e))
          : Fi(e)
            ? (r[a] = e.slice())
            : (!n || !Ii(e)) && (r[a] = e);
    };
  for (let t = 0, n = e.length; t < n; t++) {
    let n = e[t];
    if (!n || Li(n) || (ua(n, i), typeof n != `object` || Fi(n))) continue;
    let r = Object.getOwnPropertySymbols(n);
    for (let e = 0; e < r.length; e++) {
      let t = r[e];
      Da.call(n, t) && i(n[t], t);
    }
  }
  return r;
}
var ha = (e, t, n, { allOwnKeys: r } = {}) => (
    ua(
      t,
      (t, r) => {
        n && Vi(t)
          ? Object.defineProperty(e, r, {
              __proto__: null,
              value: Di(t, n),
              writable: !0,
              enumerable: !0,
              configurable: !0,
            })
          : Object.defineProperty(e, r, {
              __proto__: null,
              value: t,
              writable: !0,
              enumerable: !0,
              configurable: !0,
            });
      },
      {
        allOwnKeys: r,
      },
    ),
    e
  ),
  ga = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e),
  _a = (e, t, n, r) => {
    ((e.prototype = Object.create(t.prototype, r)),
      Object.defineProperty(e.prototype, "constructor", {
        __proto__: null,
        value: e,
        writable: !0,
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(e, "super", {
        __proto__: null,
        value: t.prototype,
      }),
      n && Object.assign(e.prototype, n));
  },
  va = (e, t, n, r) => {
    let i,
      a,
      o,
      s = {};
    if (((t ||= {}), e == null)) return t;
    do {
      for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0;)
        ((o = i[a]), (!r || r(o, e, t)) && !s[o] && ((t[o] = e[o]), (s[o] = !0)));
      e = n !== !1 && ki(e);
    } while (e && (!n || n(e, t)) && e !== Object.prototype);
    return t;
  },
  ya = (e, t, n) => {
    ((e = String(e)), (n === void 0 || n > e.length) && (n = e.length), (n -= t.length));
    let r = e.indexOf(t, n);
    return r !== -1 && r === n;
  },
  ba = (e) => {
    if (!e) return null;
    if (Fi(e)) return e;
    let t = e.length;
    if (!Hi(t)) return null;
    let n = Array(t);
    for (; t-- > 0;) n[t] = e[t];
    return n;
  },
  xa = (
    (e) => (t) =>
      e && t instanceof e
  )(typeof Uint8Array < `u` && ki(Uint8Array)),
  Sa = (e, t) => {
    let n = (e && e[Ai]).call(e),
      r;
    for (; (r = n.next()) && !r.done;) {
      let n = r.value;
      t.call(e, n[0], n[1]);
    }
  },
  Ca = (e, t) => {
    let n,
      r = [];
    for (; (n = e.exec(t)) !== null;) r.push(n);
    return r;
  },
  wa = Ni(`HTMLFormElement`),
  Ta = (e) =>
    e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (e, t, n) {
      return t.toUpperCase() + n;
    }),
  Ea = (
    ({ hasOwnProperty: e }) =>
    (t, n) =>
      e.call(t, n)
  )(Object.prototype),
  { propertyIsEnumerable: Da } = Object.prototype,
  Oa = Ni(`RegExp`),
  ka = (e, t) => {
    let n = Object.getOwnPropertyDescriptors(e),
      r = {};
    (ua(n, (n, i) => {
      let a;
      (a = t(n, i, e)) !== !1 && (r[i] = a || n);
    }),
      Object.defineProperties(e, r));
  },
  Aa = (e) => {
    ka(e, (t, n) => {
      if (Vi(e) && [`arguments`, `caller`, `callee`].includes(n)) return !1;
      let r = e[n];
      if (Vi(r)) {
        if (((t.enumerable = !1), `writable` in t)) {
          t.writable = !1;
          return;
        }
        t.set ||= () => {
          throw Error(`Can not rewrite read-only method '` + n + `'`);
        };
      }
    });
  },
  ja = (e, t) => {
    let n = {},
      r = (e) => {
        e.forEach((e) => {
          n[e] = !0;
        });
      };
    return (Fi(e) ? r(e) : r(String(e).split(t)), n);
  },
  Ma = () => {},
  Na = (e, t) => (e != null && Number.isFinite((e = +e)) ? e : t);
function Pa(e) {
  return !!(e && Vi(e.append) && e[ji] === `FormData` && e[Ai]);
}
var Fa = (e) => {
    let t = new WeakSet(),
      n = (e) => {
        if (Ui(e)) {
          if (t.has(e)) return;
          if (Li(e)) return e;
          if (!(`toJSON` in e)) {
            t.add(e);
            let r = Fi(e) ? [] : {};
            return (
              ua(e, (e, t) => {
                let i = n(e);
                !Ii(i) && (r[t] = i);
              }),
              t.delete(e),
              r
            );
          }
        }
        return e;
      };
    return n(e);
  },
  Ia = Ni(`AsyncFunction`),
  La = (e) => e && (Ui(e) || Vi(e)) && Vi(e.then) && Vi(e.catch),
  Ra = ((e, t) =>
    e
      ? setImmediate
      : t
        ? ((e, t) => (
            fa.addEventListener(
              `message`,
              ({ source: n, data: r }) => {
                n === fa && r === e && t.length && t.shift()();
              },
              !1,
            ),
            (n) => {
              (t.push(n), fa.postMessage(e, `*`));
            }
          ))(`axios@${Math.random()}`, [])
        : (e) => setTimeout(e))(typeof setImmediate == `function`, Vi(fa.postMessage)),
  F = {
    isArray: Fi,
    isArrayBuffer: Ri,
    isBuffer: Li,
    isFormData: ra,
    isArrayBufferView: zi,
    isString: Bi,
    isNumber: Hi,
    isBoolean: Wi,
    isObject: Ui,
    isPlainObject: Gi,
    isEmptyObject: Ki,
    isReadableStream: aa,
    isRequest: oa,
    isResponse: sa,
    isHeaders: ca,
    isUndefined: Ii,
    isDate: qi,
    isFile: Ji,
    isReactNativeBlob: Yi,
    isReactNative: Xi,
    isBlob: Zi,
    isRegExp: Oa,
    isFunction: Vi,
    isStream: $i,
    isURLSearchParams: ia,
    isTypedArray: xa,
    isFileList: Qi,
    forEach: ua,
    merge: ma,
    extend: ha,
    trim: la,
    stripBOM: ga,
    inherits: _a,
    toFlatObject: va,
    kindOf: Mi,
    kindOfTest: Ni,
    endsWith: ya,
    toArray: ba,
    forEachEntry: Sa,
    matchAll: Ca,
    isHTMLForm: wa,
    hasOwnProperty: Ea,
    hasOwnProp: Ea,
    reduceDescriptors: ka,
    freezeMethods: Aa,
    toObjectSet: ja,
    toCamelCase: Ta,
    noop: Ma,
    toFiniteNumber: Na,
    findKey: da,
    global: fa,
    isContextDefined: pa,
    isSpecCompliantForm: Pa,
    toJSONObject: Fa,
    isAsyncFn: Ia,
    isThenable: La,
    setImmediate: Ra,
    asap:
      typeof queueMicrotask < `u`
        ? queueMicrotask.bind(fa)
        : (typeof process < `u` && process.nextTick) || Ra,
    isIterable: (e) => e != null && Vi(e[Ai]),
  },
  za = F.toObjectSet([
    `age`,
    `authorization`,
    `content-length`,
    `content-type`,
    `etag`,
    `expires`,
    `from`,
    `host`,
    `if-modified-since`,
    `if-unmodified-since`,
    `last-modified`,
    `location`,
    `max-forwards`,
    `proxy-authorization`,
    `referer`,
    `retry-after`,
    `user-agent`,
  ]),
  I = (e) => {
    let t = {},
      n,
      r,
      i;
    return (
      e &&
        e
          .split(
            `
`,
          )
          .forEach(function (e) {
            ((i = e.indexOf(`:`)),
              (n = e.substring(0, i).trim().toLowerCase()),
              (r = e.substring(i + 1).trim()),
              !(!n || (t[n] && za[n])) &&
                (n === `set-cookie`
                  ? t[n]
                    ? t[n].push(r)
                    : (t[n] = [r])
                  : (t[n] = t[n] ? t[n] + `, ` + r : r)));
          }),
      t
    );
  };
function Ba(e) {
  let t = 0,
    n = e.length;
  for (; t < n;) {
    let n = e.charCodeAt(t);
    if (n !== 9 && n !== 32) break;
    t += 1;
  }
  for (; n > t;) {
    let t = e.charCodeAt(n - 1);
    if (t !== 9 && t !== 32) break;
    --n;
  }
  return t === 0 && n === e.length ? e : e.slice(t, n);
}
var Va = RegExp(`[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+`, `g`),
  Ha = RegExp(`[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+`, `g`);
function Ua(e, t) {
  return F.isArray(e) ? e.map((e) => Ua(e, t)) : Ba(String(e).replace(t, ``));
}
var Wa = (e) => Ua(e, Va),
  Ga = (e) => Ua(e, Ha);
function Ka(e) {
  let t = Object.create(null);
  return (
    F.forEach(e.toJSON(), (e, n) => {
      t[n] = Ga(e);
    }),
    t
  );
}
var qa = Symbol(`internals`);
function Ja(e) {
  return e && String(e).trim().toLowerCase();
}
function Ya(e) {
  return e === !1 || e == null ? e : F.isArray(e) ? e.map(Ya) : Wa(String(e));
}
function Xa(e) {
  let t = Object.create(null),
    n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g,
    r;
  for (; (r = n.exec(e));) t[r[1]] = r[2];
  return t;
}
var Za = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Qa(e, t, n, r, i) {
  if (F.isFunction(r)) return r.call(this, t, n);
  if ((i && (t = n), F.isString(t))) {
    if (F.isString(r)) return t.indexOf(r) !== -1;
    if (F.isRegExp(r)) return r.test(t);
  }
}
function $a(e) {
  return e
    .trim()
    .toLowerCase()
    .replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function eo(e, t) {
  let n = F.toCamelCase(` ` + t);
  [`get`, `set`, `has`].forEach((r) => {
    Object.defineProperty(e, r + n, {
      __proto__: null,
      value: function (e, n, i) {
        return this[r].call(this, t, e, n, i);
      },
      configurable: !0,
    });
  });
}
var to = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    let r = this;
    function i(e, t, n) {
      let i = Ja(t);
      if (!i) return;
      let a = F.findKey(r, i);
      (!a || r[a] === void 0 || n === !0 || (n === void 0 && r[a] !== !1)) && (r[a || t] = Ya(e));
    }
    let a = (e, t) => F.forEach(e, (e, n) => i(e, n, t));
    if (F.isPlainObject(e) || e instanceof this.constructor) a(e, t);
    else if (F.isString(e) && (e = e.trim()) && !Za(e)) a(I(e), t);
    else if (F.isObject(e) && F.isIterable(e)) {
      let n = {},
        r,
        i;
      for (let t of e) {
        if (!F.isArray(t)) throw TypeError(`Object iterator must return a key-value pair`);
        n[(i = t[0])] = (r = n[i]) ? (F.isArray(r) ? [...r, t[1]] : [r, t[1]]) : t[1];
      }
      a(n, t);
    } else e != null && i(t, e, n);
    return this;
  }
  get(e, t) {
    if (((e = Ja(e)), e)) {
      let n = F.findKey(this, e);
      if (n) {
        let e = this[n];
        if (!t) return e;
        if (t === !0) return Xa(e);
        if (F.isFunction(t)) return t.call(this, e, n);
        if (F.isRegExp(t)) return t.exec(e);
        throw TypeError(`parser must be boolean|regexp|function`);
      }
    }
  }
  has(e, t) {
    if (((e = Ja(e)), e)) {
      let n = F.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || Qa(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    let n = this,
      r = !1;
    function i(e) {
      if (((e = Ja(e)), e)) {
        let i = F.findKey(n, e);
        i && (!t || Qa(n, n[i], i, t)) && (delete n[i], (r = !0));
      }
    }
    return (F.isArray(e) ? e.forEach(i) : i(e), r);
  }
  clear(e) {
    let t = Object.keys(this),
      n = t.length,
      r = !1;
    for (; n--;) {
      let i = t[n];
      (!e || Qa(this, this[i], i, e, !0)) && (delete this[i], (r = !0));
    }
    return r;
  }
  normalize(e) {
    let t = this,
      n = {};
    return (
      F.forEach(this, (r, i) => {
        let a = F.findKey(n, i);
        if (a) {
          ((t[a] = Ya(r)), delete t[i]);
          return;
        }
        let o = e ? $a(i) : String(i).trim();
        (o !== i && delete t[i], (t[o] = Ya(r)), (n[o] = !0));
      }),
      this
    );
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    let t = Object.create(null);
    return (
      F.forEach(this, (n, r) => {
        n != null && n !== !1 && (t[r] = e && F.isArray(n) ? n.join(`, `) : n);
      }),
      t
    );
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + `: ` + t).join(`
`);
  }
  getSetCookie() {
    return this.get(`set-cookie`) || [];
  }
  get [Symbol.toStringTag]() {
    return `AxiosHeaders`;
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    let n = new this(e);
    return (t.forEach((e) => n.set(e)), n);
  }
  static accessor(e) {
    let t = (this[qa] = this[qa] =
        {
          accessors: {},
        }).accessors,
      n = this.prototype;
    function r(e) {
      let r = Ja(e);
      t[r] || (eo(n, e), (t[r] = !0));
    }
    return (F.isArray(e) ? e.forEach(r) : r(e), this);
  }
};
(to.accessor([
  `Content-Type`,
  `Content-Length`,
  `Accept`,
  `Accept-Encoding`,
  `User-Agent`,
  `Authorization`,
]),
  F.reduceDescriptors(to.prototype, ({ value: e }, t) => {
    let n = t[0].toUpperCase() + t.slice(1);
    return {
      get: () => e,
      set(e) {
        this[n] = e;
      },
    };
  }),
  F.freezeMethods(to));
var no = `[REDACTED ****]`;
function ro(e) {
  if (F.hasOwnProp(e, `toJSON`)) return !0;
  let t = Object.getPrototypeOf(e);
  for (; t && t !== Object.prototype;) {
    if (F.hasOwnProp(t, `toJSON`)) return !0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}
function io(e, t) {
  let n = new Set(t.map((e) => String(e).toLowerCase())),
    r = [],
    i = (e) => {
      if (typeof e != `object` || !e || F.isBuffer(e)) return e;
      if (r.indexOf(e) !== -1) return;
      (e instanceof to && (e = e.toJSON()), r.push(e));
      let t;
      if (F.isArray(e))
        ((t = []),
          e.forEach((e, n) => {
            let r = i(e);
            F.isUndefined(r) || (t[n] = r);
          }));
      else {
        if (!F.isPlainObject(e) && ro(e)) return (r.pop(), e);
        t = Object.create(null);
        for (let [r, a] of Object.entries(e)) {
          let e = n.has(r.toLowerCase()) ? no : i(a);
          F.isUndefined(e) || (t[r] = e);
        }
      }
      return (r.pop(), t);
    };
  return i(e);
}
var L = class e extends Error {
  static from(t, n, r, i, a, o) {
    let s = new e(t.message, n || t.code, r, i, a);
    return (
      (s.cause = t),
      (s.name = t.name),
      t.status != null && s.status == null && (s.status = t.status),
      o && Object.assign(s, o),
      s
    );
  }
  constructor(e, t, n, r, i) {
    (super(e),
      Object.defineProperty(this, "message", {
        __proto__: null,
        value: e,
        enumerable: !0,
        writable: !0,
        configurable: !0,
      }),
      (this.name = `AxiosError`),
      (this.isAxiosError = !0),
      t && (this.code = t),
      n && (this.config = n),
      r && (this.request = r),
      i && ((this.response = i), (this.status = i.status)));
  }
  toJSON() {
    let e = this.config,
      t = e && F.hasOwnProp(e, `redact`) ? e.redact : void 0,
      n = F.isArray(t) && t.length > 0 ? io(e, t) : F.toJSONObject(e);
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: n,
      code: this.code,
      status: this.status,
    };
  }
};
((L.ERR_BAD_OPTION_VALUE = `ERR_BAD_OPTION_VALUE`),
  (L.ERR_BAD_OPTION = `ERR_BAD_OPTION`),
  (L.ECONNABORTED = `ECONNABORTED`),
  (L.ETIMEDOUT = `ETIMEDOUT`),
  (L.ECONNREFUSED = `ECONNREFUSED`),
  (L.ERR_NETWORK = `ERR_NETWORK`),
  (L.ERR_FR_TOO_MANY_REDIRECTS = `ERR_FR_TOO_MANY_REDIRECTS`),
  (L.ERR_DEPRECATED = `ERR_DEPRECATED`),
  (L.ERR_BAD_RESPONSE = `ERR_BAD_RESPONSE`),
  (L.ERR_BAD_REQUEST = `ERR_BAD_REQUEST`),
  (L.ERR_CANCELED = `ERR_CANCELED`),
  (L.ERR_NOT_SUPPORT = `ERR_NOT_SUPPORT`),
  (L.ERR_INVALID_URL = `ERR_INVALID_URL`),
  (L.ERR_FORM_DATA_DEPTH_EXCEEDED = `ERR_FORM_DATA_DEPTH_EXCEEDED`));
function ao(e) {
  return F.isPlainObject(e) || F.isArray(e);
}
function oo(e) {
  return F.endsWith(e, `[]`) ? e.slice(0, -2) : e;
}
function so(e, t, n) {
  return e
    ? e
        .concat(t)
        .map(function (e, t) {
          return ((e = oo(e)), !n && t ? `[` + e + `]` : e);
        })
        .join(n ? `.` : ``)
    : t;
}
function co(e) {
  return F.isArray(e) && !e.some(ao);
}
var lo = F.toFlatObject(F, {}, null, function (e) {
  return /^is[A-Z]/.test(e);
});
function uo(e, t, n) {
  if (!F.isObject(e)) throw TypeError(`target must be an object`);
  ((t ||= new FormData()),
    (n = F.toFlatObject(
      n,
      {
        metaTokens: !0,
        dots: !1,
        indexes: !1,
      },
      !1,
      function (e, t) {
        return !F.isUndefined(t[e]);
      },
    )));
  let r = n.metaTokens,
    i = n.visitor || d,
    a = n.dots,
    o = n.indexes,
    s = n.Blob || (typeof Blob < `u` && Blob),
    c = n.maxDepth === void 0 ? 100 : n.maxDepth,
    l = s && F.isSpecCompliantForm(t);
  if (!F.isFunction(i)) throw TypeError(`visitor must be a function`);
  function u(e) {
    if (e === null) return ``;
    if (F.isDate(e)) return e.toISOString();
    if (F.isBoolean(e)) return e.toString();
    if (!l && F.isBlob(e)) throw new L(`Blob is not supported. Use a Buffer instead.`);
    return F.isArrayBuffer(e) || F.isTypedArray(e)
      ? l && typeof Blob == `function`
        ? new Blob([e])
        : Buffer.from(e)
      : e;
  }
  function d(e, n, i) {
    let s = e;
    if (F.isReactNative(t) && F.isReactNativeBlob(e)) return (t.append(so(i, n, a), u(e)), !1);
    if (e && !i && typeof e == `object`) {
      if (F.endsWith(n, `{}`)) ((n = r ? n : n.slice(0, -2)), (e = JSON.stringify(e)));
      else if (
        (F.isArray(e) && co(e)) ||
        ((F.isFileList(e) || F.endsWith(n, `[]`)) && (s = F.toArray(e)))
      )
        return (
          (n = oo(n)),
          s.forEach(function (e, r) {
            !(F.isUndefined(e) || e === null) &&
              t.append(o === !0 ? so([n], r, a) : o === null ? n : n + `[]`, u(e));
          }),
          !1
        );
    }
    return ao(e) ? !0 : (t.append(so(i, n, a), u(e)), !1);
  }
  let f = [],
    p = Object.assign(lo, {
      defaultVisitor: d,
      convertValue: u,
      isVisitable: ao,
    });
  function m(e, n, r = 0) {
    if (!F.isUndefined(e)) {
      if (r > c)
        throw new L(
          `Object is too deeply nested (` + r + ` levels). Max depth: ` + c,
          L.ERR_FORM_DATA_DEPTH_EXCEEDED,
        );
      if (f.indexOf(e) !== -1) throw Error(`Circular reference detected in ` + n.join(`.`));
      (f.push(e),
        F.forEach(e, function (e, a) {
          (!(F.isUndefined(e) || e === null) &&
            i.call(t, e, F.isString(a) ? a.trim() : a, n, p)) === !0 &&
            m(e, n ? n.concat(a) : [a], r + 1);
        }),
        f.pop());
    }
  }
  if (!F.isObject(e)) throw TypeError(`data must be an object`);
  return (m(e), t);
}
function fo(e) {
  let t = {
    "!": `%21`,
    "'": `%27`,
    "(": `%28`,
    ")": `%29`,
    "~": `%7E`,
    "%20": `+`,
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function (e) {
    return t[e];
  });
}
function po(e, t) {
  ((this._pairs = []), e && uo(e, this, t));
}
var mo = po.prototype;
((mo.append = function (e, t) {
  this._pairs.push([e, t]);
}),
  (mo.toString = function (e) {
    let t = e
      ? function (t) {
          return e.call(this, t, fo);
        }
      : fo;
    return this._pairs
      .map(function (e) {
        return t(e[0]) + `=` + t(e[1]);
      }, ``)
      .join(`&`);
  }));
function ho(e) {
  return encodeURIComponent(e)
    .replace(/%3A/gi, `:`)
    .replace(/%24/g, `$`)
    .replace(/%2C/gi, `,`)
    .replace(/%20/g, `+`);
}
function go(e, t, n) {
  if (!t) return e;
  let r = (n && n.encode) || ho,
    i = F.isFunction(n)
      ? {
          serialize: n,
        }
      : n,
    a = i && i.serialize,
    o;
  if (((o = a ? a(t, i) : F.isURLSearchParams(t) ? t.toString() : new po(t, i).toString(r)), o)) {
    let t = e.indexOf(`#`);
    (t !== -1 && (e = e.slice(0, t)), (e += (e.indexOf(`?`) === -1 ? `?` : `&`) + o));
  }
  return e;
}
var _o = class {
    constructor() {
      this.handlers = [];
    }
    use(e, t, n) {
      return (
        this.handlers.push({
          fulfilled: e,
          rejected: t,
          synchronous: n ? n.synchronous : !1,
          runWhen: n ? n.runWhen : null,
        }),
        this.handlers.length - 1
      );
    }
    eject(e) {
      this.handlers[e] && (this.handlers[e] = null);
    }
    clear() {
      this.handlers &&= [];
    }
    forEach(e) {
      F.forEach(this.handlers, function (t) {
        t !== null && e(t);
      });
    }
  },
  vo = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1,
    legacyInterceptorReqResOrdering: !0,
    advertiseZstdAcceptEncoding: !1,
  },
  yo = {
    isBrowser: !0,
    classes: {
      URLSearchParams: typeof URLSearchParams < `u` ? URLSearchParams : po,
      FormData: typeof FormData < `u` ? FormData : null,
      Blob: typeof Blob < `u` ? Blob : null,
    },
    protocols: [`http`, `https`, `file`, `blob`, `url`, `data`],
  },
  bo = t({
    hasBrowserEnv: () => xo,
    hasStandardBrowserEnv: () => Co,
    hasStandardBrowserWebWorkerEnv: () => wo,
    navigator: () => So,
    origin: () => To,
  }),
  xo = typeof window < `u` && typeof document < `u`,
  So = (typeof navigator == `object` && navigator) || void 0,
  Co = xo && (!So || [`ReactNative`, `NativeScript`, `NS`].indexOf(So.product) < 0),
  wo =
    typeof WorkerGlobalScope < `u` &&
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts == `function`,
  To = (xo && window.location.href) || `http://localhost`,
  Eo = {
    ...bo,
    ...yo,
  };
function Do(e, t) {
  return uo(e, new Eo.classes.URLSearchParams(), {
    visitor: function (e, t, n, r) {
      return Eo.isNode && F.isBuffer(e)
        ? (this.append(t, e.toString(`base64`)), !1)
        : r.defaultVisitor.apply(this, arguments);
    },
    ...t,
  });
}
function Oo(e) {
  return F.matchAll(/\w+|\[(\w*)]/g, e).map((e) => (e[0] === `[]` ? `` : e[1] || e[0]));
}
function ko(e) {
  let t = {},
    n = Object.keys(e),
    r,
    i = n.length,
    a;
  for (r = 0; r < i; r++) ((a = n[r]), (t[a] = e[a]));
  return t;
}
function Ao(e) {
  function t(e, n, r, i) {
    let a = e[i++];
    if (a === `__proto__`) return !0;
    let o = Number.isFinite(+a),
      s = i >= e.length;
    return (
      (a = !a && F.isArray(r) ? r.length : a),
      s
        ? (F.hasOwnProp(r, a) ? (r[a] = F.isArray(r[a]) ? r[a].concat(n) : [r[a], n]) : (r[a] = n),
          !o)
        : ((!F.hasOwnProp(r, a) || !F.isObject(r[a])) && (r[a] = []),
          t(e, n, r[a], i) && F.isArray(r[a]) && (r[a] = ko(r[a])),
          !o)
    );
  }
  if (F.isFormData(e) && F.isFunction(e.entries)) {
    let n = {};
    return (
      F.forEachEntry(e, (e, r) => {
        t(Oo(e), r, n, 0);
      }),
      n
    );
  }
  return null;
}
var jo = (e, t) => (e != null && F.hasOwnProp(e, t) ? e[t] : void 0);
function Mo(e, t, n) {
  if (F.isString(e))
    try {
      return ((t || JSON.parse)(e), F.trim(e));
    } catch (e) {
      if (e.name !== `SyntaxError`) throw e;
    }
  return (n || JSON.stringify)(e);
}
var No = {
  transitional: vo,
  adapter: [`xhr`, `http`, `fetch`],
  transformRequest: [
    function (e, t) {
      let n = t.getContentType() || ``,
        r = n.indexOf(`application/json`) > -1,
        i = F.isObject(e);
      if ((i && F.isHTMLForm(e) && (e = new FormData(e)), F.isFormData(e)))
        return r ? JSON.stringify(Ao(e)) : e;
      if (
        F.isArrayBuffer(e) ||
        F.isBuffer(e) ||
        F.isStream(e) ||
        F.isFile(e) ||
        F.isBlob(e) ||
        F.isReadableStream(e)
      )
        return e;
      if (F.isArrayBufferView(e)) return e.buffer;
      if (F.isURLSearchParams(e))
        return (
          t.setContentType(`application/x-www-form-urlencoded;charset=utf-8`, !1),
          e.toString()
        );
      let a;
      if (i) {
        let t = jo(this, `formSerializer`);
        if (n.indexOf(`application/x-www-form-urlencoded`) > -1) return Do(e, t).toString();
        if ((a = F.isFileList(e)) || n.indexOf(`multipart/form-data`) > -1) {
          let n = jo(this, `env`),
            r = n && n.FormData;
          return uo(
            a
              ? {
                  "files[]": e,
                }
              : e,
            r && new r(),
            t,
          );
        }
      }
      return i || r ? (t.setContentType(`application/json`, !1), Mo(e)) : e;
    },
  ],
  transformResponse: [
    function (e) {
      let t = jo(this, `transitional`) || No.transitional,
        n = t && t.forcedJSONParsing,
        r = jo(this, `responseType`),
        i = r === `json`;
      if (F.isResponse(e) || F.isReadableStream(e)) return e;
      if (e && F.isString(e) && ((n && !r) || i)) {
        let n = !(t && t.silentJSONParsing) && i;
        try {
          return JSON.parse(e, jo(this, `parseReviver`));
        } catch (e) {
          if (n)
            throw e.name === `SyntaxError`
              ? L.from(e, L.ERR_BAD_RESPONSE, this, null, jo(this, `response`))
              : e;
        }
      }
      return e;
    },
  ],
  timeout: 0,
  xsrfCookieName: `XSRF-TOKEN`,
  xsrfHeaderName: `X-XSRF-TOKEN`,
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Eo.classes.FormData,
    Blob: Eo.classes.Blob,
  },
  validateStatus: function (e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: `application/json, text/plain, */*`,
      "Content-Type": void 0,
    },
  },
};
F.forEach([`delete`, `get`, `head`, `post`, `put`, `patch`, `query`], (e) => {
  No.headers[e] = {};
});
function Po(e, t) {
  let n = this || No,
    r = t || n,
    i = to.from(r.headers),
    a = r.data;
  return (
    F.forEach(e, function (e) {
      a = e.call(n, a, i.normalize(), t ? t.status : void 0);
    }),
    i.normalize(),
    a
  );
}
function Fo(e) {
  return !!(e && e.__CANCEL__);
}
var Io = class extends L {
  constructor(e, t, n) {
    (super(e ?? `canceled`, L.ERR_CANCELED, t, n),
      (this.name = `CanceledError`),
      (this.__CANCEL__ = !0));
  }
};
function Lo(e, t, n) {
  let r = n.config.validateStatus;
  !n.status || !r || r(n.status)
    ? e(n)
    : t(
        new L(
          `Request failed with status code ` + n.status,
          n.status >= 400 && n.status < 500 ? L.ERR_BAD_REQUEST : L.ERR_BAD_RESPONSE,
          n.config,
          n.request,
          n,
        ),
      );
}
function Ro(e) {
  let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return (t && t[1]) || ``;
}
function zo(e, t) {
  e ||= 10;
  let n = Array(e),
    r = Array(e),
    i = 0,
    a = 0,
    o;
  return (
    (t = t === void 0 ? 1e3 : t),
    function (s) {
      let c = Date.now(),
        l = r[a];
      ((o ||= c), (n[i] = s), (r[i] = c));
      let u = a,
        d = 0;
      for (; u !== i;) ((d += n[u++]), (u %= e));
      if (((i = (i + 1) % e), i === a && (a = (a + 1) % e), c - o < t)) return;
      let f = l && c - l;
      return f ? Math.round((d * 1e3) / f) : void 0;
    }
  );
}
function Bo(e, t) {
  let n = 0,
    r = 1e3 / t,
    i,
    a,
    o = (t, r = Date.now()) => {
      ((n = r), (i = null), (a &&= (clearTimeout(a), null)), e(...t));
    };
  return [
    (...e) => {
      let t = Date.now(),
        s = t - n;
      s >= r
        ? o(e, t)
        : ((i = e),
          (a ||= setTimeout(() => {
            ((a = null), o(i));
          }, r - s)));
    },
    () => i && o(i),
  ];
}
var Vo = (e, t, n = 3) => {
    let r = 0,
      i = zo(50, 250);
    return Bo((n) => {
      if (!n || typeof n.loaded != `number`) return;
      let a = n.loaded,
        o = n.lengthComputable ? n.total : void 0,
        s = o == null ? a : Math.min(a, o),
        c = Math.max(0, s - r),
        l = i(c);
      ((r = Math.max(r, s)),
        e({
          loaded: s,
          total: o,
          progress: o ? s / o : void 0,
          bytes: c,
          rate: l || void 0,
          estimated: l && o ? (o - s) / l : void 0,
          event: n,
          lengthComputable: o != null,
          [t ? `download` : `upload`]: !0,
        }));
    }, n);
  },
  Ho = (e, t) => {
    let n = e != null;
    return [
      (r) =>
        t[0]({
          lengthComputable: n,
          total: e,
          loaded: r,
        }),
      t[1],
    ];
  },
  Uo =
    (e) =>
    (...t) =>
      F.asap(() => e(...t)),
  Wo = Eo.hasStandardBrowserEnv
    ? ((e, t) => (n) => (
        (n = new URL(n, Eo.origin)),
        e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)
      ))(new URL(Eo.origin), Eo.navigator && /(msie|trident)/i.test(Eo.navigator.userAgent))
    : () => !0,
  Go = Eo.hasStandardBrowserEnv
    ? {
        write(e, t, n, r, i, a, o) {
          if (typeof document > `u`) return;
          let s = [`${e}=${encodeURIComponent(t)}`];
          (F.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`),
            F.isString(r) && s.push(`path=${r}`),
            F.isString(i) && s.push(`domain=${i}`),
            a === !0 && s.push(`secure`),
            F.isString(o) && s.push(`SameSite=${o}`),
            (document.cookie = s.join(`; `)));
        },
        read(e) {
          if (typeof document > `u`) return null;
          let t = document.cookie.split(`;`);
          for (let n = 0; n < t.length; n++) {
            let r = t[n].replace(/^\s+/, ``),
              i = r.indexOf(`=`);
            if (i !== -1 && r.slice(0, i) === e) return decodeURIComponent(r.slice(i + 1));
          }
          return null;
        },
        remove(e) {
          this.write(e, ``, Date.now() - 864e5, `/`);
        },
      }
    : {
        write() {},
        read() {
          return null;
        },
        remove() {},
      };
function Ko(e) {
  return typeof e == `string` ? /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e) : !1;
}
function qo(e, t) {
  return t ? e.replace(/\/?\/$/, ``) + `/` + t.replace(/^\/+/, ``) : e;
}
function Jo(e, t, n) {
  let r = !Ko(t);
  return e && (r || n === !1) ? qo(e, t) : t;
}
var Yo = (e) =>
  e instanceof to
    ? {
        ...e,
      }
    : e;
function Xo(e, t) {
  t ||= {};
  let n = Object.create(null);
  Object.defineProperty(n, "hasOwnProperty", {
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0,
  });
  function r(e, t, n, r) {
    return F.isPlainObject(e) && F.isPlainObject(t)
      ? F.merge.call(
          {
            caseless: r,
          },
          e,
          t,
        )
      : F.isPlainObject(t)
        ? F.merge({}, t)
        : F.isArray(t)
          ? t.slice()
          : t;
  }
  function i(e, t, n, i) {
    if (!F.isUndefined(t)) return r(e, t, n, i);
    if (!F.isUndefined(e)) return r(void 0, e, n, i);
  }
  function a(e, t) {
    if (!F.isUndefined(t)) return r(void 0, t);
  }
  function o(e, t) {
    if (!F.isUndefined(t)) return r(void 0, t);
    if (!F.isUndefined(e)) return r(void 0, e);
  }
  function s(n, i, a) {
    if (F.hasOwnProp(t, a)) return r(n, i);
    if (F.hasOwnProp(e, a)) return r(void 0, n);
  }
  let c = {
    url: a,
    method: a,
    data: a,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    allowedSocketPaths: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (e, t, n) => i(Yo(e), Yo(t), n, !0),
  };
  return (
    F.forEach(
      Object.keys({
        ...e,
        ...t,
      }),
      function (r) {
        if (r === `__proto__` || r === `constructor` || r === `prototype`) return;
        let a = F.hasOwnProp(c, r) ? c[r] : i,
          o = a(F.hasOwnProp(e, r) ? e[r] : void 0, F.hasOwnProp(t, r) ? t[r] : void 0, r);
        (F.isUndefined(o) && a !== s) || (n[r] = o);
      },
    ),
    n
  );
}
var Zo = [`content-type`, `content-length`];
function Qo(e, t, n) {
  if (n !== `content-only`) {
    e.set(t);
    return;
  }
  Object.entries(t).forEach(([t, n]) => {
    Zo.includes(t.toLowerCase()) && e.set(t, n);
  });
}
var $o = (e) =>
  encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16)));
function es(e) {
  let t = Xo({}, e),
    n = (e) => (F.hasOwnProp(t, e) ? t[e] : void 0),
    r = n(`data`),
    i = n(`withXSRFToken`),
    a = n(`xsrfHeaderName`),
    o = n(`xsrfCookieName`),
    s = n(`headers`),
    c = n(`auth`),
    l = n(`baseURL`),
    u = n(`allowAbsoluteUrls`),
    d = n(`url`);
  if (
    ((t.headers = s = to.from(s)),
    (t.url = go(Jo(l, d, u), n(`params`), n(`paramsSerializer`))),
    c &&
      s.set(
        `Authorization`,
        `Basic ` + btoa((c.username || ``) + `:` + (c.password ? $o(c.password) : ``)),
      ),
    F.isFormData(r) &&
      (Eo.hasStandardBrowserEnv || Eo.hasStandardBrowserWebWorkerEnv || F.isReactNative(r)
        ? s.setContentType(void 0)
        : F.isFunction(r.getHeaders) && Qo(s, r.getHeaders(), n(`formDataHeaderPolicy`))),
    Eo.hasStandardBrowserEnv &&
      (F.isFunction(i) && (i = i(t)), i === !0 || (i == null && Wo(t.url))))
  ) {
    let e = a && o && Go.read(o);
    e && s.set(a, e);
  }
  return t;
}
var ts =
    typeof XMLHttpRequest < `u` &&
    function (e) {
      return new Promise(function (t, n) {
        let r = es(e),
          i = r.data,
          a = to.from(r.headers).normalize(),
          { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r,
          l,
          u,
          d,
          f,
          p;
        function m() {
          (f && f(),
            p && p(),
            r.cancelToken && r.cancelToken.unsubscribe(l),
            r.signal && r.signal.removeEventListener(`abort`, l));
        }
        let h = new XMLHttpRequest();
        (h.open(r.method.toUpperCase(), r.url, !0), (h.timeout = r.timeout));
        function g() {
          if (!h) return;
          let r = to.from(`getAllResponseHeaders` in h && h.getAllResponseHeaders());
          (Lo(
            function (e) {
              (t(e), m());
            },
            function (e) {
              (n(e), m());
            },
            {
              data: !o || o === `text` || o === `json` ? h.responseText : h.response,
              status: h.status,
              statusText: h.statusText,
              headers: r,
              config: e,
              request: h,
            },
          ),
            (h = null));
        }
        (`onloadend` in h
          ? (h.onloadend = g)
          : (h.onreadystatechange = function () {
              !h ||
                h.readyState !== 4 ||
                (h.status === 0 && !(h.responseURL && h.responseURL.startsWith(`file:`))) ||
                setTimeout(g);
            }),
          (h.onabort = function () {
            h &&= (n(new L(`Request aborted`, L.ECONNABORTED, e, h)), m(), null);
          }),
          (h.onerror = function (t) {
            let r = new L(t && t.message ? t.message : `Network Error`, L.ERR_NETWORK, e, h);
            ((r.event = t || null), n(r), m(), (h = null));
          }),
          (h.ontimeout = function () {
            let t = r.timeout ? `timeout of ` + r.timeout + `ms exceeded` : `timeout exceeded`,
              i = r.transitional || vo;
            (r.timeoutErrorMessage && (t = r.timeoutErrorMessage),
              n(new L(t, i.clarifyTimeoutError ? L.ETIMEDOUT : L.ECONNABORTED, e, h)),
              m(),
              (h = null));
          }),
          i === void 0 && a.setContentType(null),
          `setRequestHeader` in h &&
            F.forEach(Ka(a), function (e, t) {
              h.setRequestHeader(t, e);
            }),
          F.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials),
          o && o !== `json` && (h.responseType = r.responseType),
          c && (([d, p] = Vo(c, !0)), h.addEventListener(`progress`, d)),
          s &&
            h.upload &&
            (([u, f] = Vo(s)),
            h.upload.addEventListener(`progress`, u),
            h.upload.addEventListener(`loadend`, f)),
          (r.cancelToken || r.signal) &&
            ((l = (t) => {
              h &&= (n(!t || t.type ? new Io(null, e, h) : t), h.abort(), m(), null);
            }),
            r.cancelToken && r.cancelToken.subscribe(l),
            r.signal && (r.signal.aborted ? l() : r.signal.addEventListener(`abort`, l))));
        let v = Ro(r.url);
        if (v && !Eo.protocols.includes(v)) {
          n(new L(`Unsupported protocol ` + v + `:`, L.ERR_BAD_REQUEST, e));
          return;
        }
        h.send(i || null);
      });
    },
  ns = (e, t) => {
    if (((e = e ? e.filter(Boolean) : []), !t && !e.length)) return;
    let n = new AbortController(),
      r = !1,
      i = function (e) {
        if (!r) {
          ((r = !0), o());
          let t = e instanceof Error ? e : this.reason;
          n.abort(t instanceof L ? t : new Io(t instanceof Error ? t.message : t));
        }
      },
      a =
        t &&
        setTimeout(() => {
          ((a = null), i(new L(`timeout of ${t}ms exceeded`, L.ETIMEDOUT)));
        }, t),
      o = () => {
        e &&=
          (a && clearTimeout(a),
          (a = null),
          e.forEach((e) => {
            e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener(`abort`, i);
          }),
          null);
      };
    e.forEach((e) => e.addEventListener(`abort`, i));
    let { signal: s } = n;
    return ((s.unsubscribe = () => F.asap(o)), s);
  },
  rs = function* (e, t) {
    let n = e.byteLength;
    if (!t || n < t) {
      yield e;
      return;
    }
    let r = 0,
      i;
    for (; r < n;) ((i = r + t), yield e.slice(r, i), (r = i));
  },
  is = async function* (e, t) {
    for await (let n of as(e)) yield* rs(n, t);
  },
  as = async function* (e) {
    if (e[Symbol.asyncIterator]) {
      yield* e;
      return;
    }
    let t = e.getReader();
    try {
      for (;;) {
        let { done: e, value: n } = await t.read();
        if (e) break;
        yield n;
      }
    } finally {
      await t.cancel();
    }
  },
  os = (e, t, n, r) => {
    let i = is(e, t),
      a = 0,
      o,
      s = (e) => {
        o || ((o = !0), r && r(e));
      };
    return new ReadableStream(
      {
        async pull(e) {
          try {
            let { done: t, value: r } = await i.next();
            if (t) {
              (s(), e.close());
              return;
            }
            let o = r.byteLength;
            (n && n((a += o)), e.enqueue(new Uint8Array(r)));
          } catch (e) {
            throw (s(e), e);
          }
        },
        cancel(e) {
          return (s(e), i.return());
        },
      },
      {
        highWaterMark: 2,
      },
    );
  };
function ss(e) {
  if (!e || typeof e != `string` || !e.startsWith(`data:`)) return 0;
  let t = e.indexOf(`,`);
  if (t < 0) return 0;
  let n = e.slice(5, t),
    r = e.slice(t + 1);
  if (/;base64/i.test(n)) {
    let e = r.length,
      t = r.length;
    for (let n = 0; n < t; n++)
      if (r.charCodeAt(n) === 37 && n + 2 < t) {
        let t = r.charCodeAt(n + 1),
          i = r.charCodeAt(n + 2);
        ((t >= 48 && t <= 57) || (t >= 65 && t <= 70) || (t >= 97 && t <= 102)) &&
          ((i >= 48 && i <= 57) || (i >= 65 && i <= 70) || (i >= 97 && i <= 102)) &&
          ((e -= 2), (n += 2));
      }
    let n = 0,
      i = t - 1,
      a = (e) =>
        e >= 2 &&
        r.charCodeAt(e - 2) === 37 &&
        r.charCodeAt(e - 1) === 51 &&
        (r.charCodeAt(e) === 68 || r.charCodeAt(e) === 100);
    (i >= 0 && (r.charCodeAt(i) === 61 ? (n++, i--) : a(i) && (n++, (i -= 3))),
      n === 1 && i >= 0 && (r.charCodeAt(i) === 61 || a(i)) && n++);
    let o = Math.floor(e / 4) * 3 - (n || 0);
    return o > 0 ? o : 0;
  }
  if (typeof Buffer < `u` && typeof Buffer.byteLength == `function`)
    return Buffer.byteLength(r, `utf8`);
  let i = 0;
  for (let e = 0, t = r.length; e < t; e++) {
    let n = r.charCodeAt(e);
    if (n < 128) i += 1;
    else if (n < 2048) i += 2;
    else if (n >= 55296 && n <= 56319 && e + 1 < t) {
      let t = r.charCodeAt(e + 1);
      t >= 56320 && t <= 57343 ? ((i += 4), e++) : (i += 3);
    } else i += 3;
  }
  return i;
}
var R = `1.17.0`,
  cs = 64 * 1024,
  { isFunction: ls } = F,
  us = (e) =>
    encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) =>
      String.fromCharCode(parseInt(t, 16)),
    ),
  ds = (e) => {
    if (!F.isString(e)) return e;
    try {
      return decodeURIComponent(e);
    } catch {
      return e;
    }
  },
  fs = (e, ...t) => {
    try {
      return !!e(...t);
    } catch {
      return !1;
    }
  },
  ps = (e) => {
    let t = e.indexOf(`://`),
      n = e;
    return (t !== -1 && (n = n.slice(t + 3)), n.includes(`@`) || n.includes(`:`));
  },
  ms = (e) => {
    let t = F.global !== void 0 && F.global !== null ? F.global : globalThis,
      { ReadableStream: n, TextEncoder: r } = t;
    e = F.merge.call(
      {
        skipUndefined: !0,
      },
      {
        Request: t.Request,
        Response: t.Response,
      },
      e,
    );
    let { fetch: i, Request: a, Response: o } = e,
      s = i ? ls(i) : typeof fetch == `function`,
      c = ls(a),
      l = ls(o);
    if (!s) return !1;
    let u = s && ls(n),
      d =
        s &&
        (typeof r == `function`
          ? (
              (e) => (t) =>
                e.encode(t)
            )(new r())
          : async (e) => new Uint8Array(await new a(e).arrayBuffer())),
      f =
        c &&
        u &&
        fs(() => {
          let e = !1,
            t = new a(Eo.origin, {
              body: new n(),
              method: `POST`,
              get duplex() {
                return ((e = !0), `half`);
              },
            }),
            r = t.headers.has(`Content-Type`);
          return (t.body != null && t.body.cancel(), e && !r);
        }),
      p = l && u && fs(() => F.isReadableStream(new o(``).body)),
      m = {
        stream: p && ((e) => e.body),
      };
    s &&
      [`text`, `arrayBuffer`, `blob`, `formData`, `stream`].forEach((e) => {
        !m[e] &&
          (m[e] = (t, n) => {
            let r = t && t[e];
            if (r) return r.call(t);
            throw new L(`Response type '${e}' is not supported`, L.ERR_NOT_SUPPORT, n);
          });
      });
    let h = async (e) => {
        if (e == null) return 0;
        if (F.isBlob(e)) return e.size;
        if (F.isSpecCompliantForm(e))
          return (
            await new a(Eo.origin, {
              method: `POST`,
              body: e,
            }).arrayBuffer()
          ).byteLength;
        if (F.isArrayBufferView(e) || F.isArrayBuffer(e)) return e.byteLength;
        if ((F.isURLSearchParams(e) && (e += ``), F.isString(e))) return (await d(e)).byteLength;
      },
      g = async (e, t) => F.toFiniteNumber(e.getContentLength()) ?? h(t);
    return async (e) => {
      let {
          url: t,
          method: n,
          data: s,
          signal: l,
          cancelToken: u,
          timeout: d,
          onDownloadProgress: h,
          onUploadProgress: v,
          responseType: y,
          headers: b,
          withCredentials: x = `same-origin`,
          fetchOptions: S,
          maxContentLength: C,
          maxBodyLength: w,
        } = es(e),
        T = F.isNumber(C) && C > -1,
        ee = F.isNumber(w) && w > -1,
        te = (t) => (F.hasOwnProp(e, t) ? e[t] : void 0),
        ne = i || fetch;
      y = y ? (y + ``).toLowerCase() : `text`;
      let re = ns([l, u && u.toAbortSignal()], d),
        E = null,
        ie =
          re &&
          re.unsubscribe &&
          (() => {
            re.unsubscribe();
          }),
        ae;
      try {
        let i,
          l = te(`auth`);
        if (
          (l &&
            (i = {
              username: l.username || ``,
              password: l.password || ``,
            }),
          ps(t))
        ) {
          let e = new URL(t, Eo.origin);
          (!i &&
            (e.username || e.password) &&
            (i = {
              username: ds(e.username),
              password: ds(e.password),
            }),
            (e.username || e.password) && ((e.username = ``), (e.password = ``), (t = e.href)));
        }
        if (
          (i &&
            (b.delete(`authorization`),
            b.set(
              `Authorization`,
              `Basic ` + btoa(us((i.username || ``) + `:` + (i.password || ``))),
            )),
          T && typeof t == `string` && t.startsWith(`data:`) && ss(t) > C)
        )
          throw new L(`maxContentLength size of ` + C + ` exceeded`, L.ERR_BAD_RESPONSE, e, E);
        if (ee && n !== `get` && n !== `head`) {
          let t = await g(b, s);
          if (typeof t == `number` && isFinite(t) && t > w)
            throw new L(`Request body larger than maxBodyLength limit`, L.ERR_BAD_REQUEST, e, E);
        }
        if (v && f && n !== `get` && n !== `head` && (ae = await g(b, s)) !== 0) {
          let e = new a(t, {
              method: `POST`,
              body: s,
              duplex: `half`,
            }),
            n;
          if (
            (F.isFormData(s) && (n = e.headers.get(`content-type`)) && b.setContentType(n), e.body)
          ) {
            let [t, n] = Ho(ae, Vo(Uo(v)));
            s = os(e.body, cs, t, n);
          }
        }
        F.isString(x) || (x = x ? `include` : `omit`);
        let u = c && `credentials` in a.prototype;
        if (F.isFormData(s)) {
          let e = b.getContentType();
          e &&
            /^multipart\/form-data/i.test(e) &&
            !/boundary=/i.test(e) &&
            b.delete(`content-type`);
        }
        b.set(`User-Agent`, `axios/` + R, !1);
        let d = {
          ...S,
          signal: re,
          method: n.toUpperCase(),
          headers: Ka(b.normalize()),
          body: s,
          duplex: `half`,
          credentials: u ? x : void 0,
        };
        E = c && new a(t, d);
        let oe = await (c ? ne(E, S) : ne(t, d));
        if (T) {
          let t = F.toFiniteNumber(oe.headers.get(`content-length`));
          if (t != null && t > C)
            throw new L(`maxContentLength size of ` + C + ` exceeded`, L.ERR_BAD_RESPONSE, e, E);
        }
        let D = p && (y === `stream` || y === `response`);
        if (p && oe.body && (h || T || (D && ie))) {
          let t = {};
          [`status`, `statusText`, `headers`].forEach((e) => {
            t[e] = oe[e];
          });
          let n = F.toFiniteNumber(oe.headers.get(`content-length`)),
            [r, i] = (h && Ho(n, Vo(Uo(h), !0))) || [],
            a = 0;
          oe = new o(
            os(
              oe.body,
              cs,
              (t) => {
                if (T && ((a = t), a > C))
                  throw new L(
                    `maxContentLength size of ` + C + ` exceeded`,
                    L.ERR_BAD_RESPONSE,
                    e,
                    E,
                  );
                r && r(t);
              },
              () => {
                (i && i(), ie && ie());
              },
            ),
            t,
          );
        }
        y ||= `text`;
        let O = await m[F.findKey(m, y) || `text`](oe, e);
        if (T && !p && !D) {
          let t;
          if (
            (O != null &&
              (typeof O.byteLength == `number`
                ? (t = O.byteLength)
                : typeof O.size == `number`
                  ? (t = O.size)
                  : typeof O == `string` &&
                    (t = typeof r == `function` ? new r().encode(O).byteLength : O.length)),
            typeof t == `number` && t > C)
          )
            throw new L(`maxContentLength size of ` + C + ` exceeded`, L.ERR_BAD_RESPONSE, e, E);
        }
        return (
          !D && ie && ie(),
          await new Promise((t, n) => {
            Lo(t, n, {
              data: O,
              headers: to.from(oe.headers),
              status: oe.status,
              statusText: oe.statusText,
              config: e,
              request: E,
            });
          })
        );
      } catch (t) {
        if ((ie && ie(), re && re.aborted && re.reason instanceof L)) {
          let n = re.reason;
          throw ((n.config = e), E && (n.request = E), t !== n && (n.cause = t), n);
        }
        throw t && t.name === `TypeError` && /Load failed|fetch/i.test(t.message)
          ? Object.assign(new L(`Network Error`, L.ERR_NETWORK, e, E, t && t.response), {
              cause: t.cause || t,
            })
          : L.from(t, t && t.code, e, E, t && t.response);
      }
    };
  },
  hs = new Map(),
  gs = (e) => {
    let t = (e && e.env) || {},
      { fetch: n, Request: r, Response: i } = t,
      a = [r, i, n],
      o = a.length,
      s,
      c,
      l = hs;
    for (; o--;)
      ((s = a[o]), (c = l.get(s)), c === void 0 && l.set(s, (c = o ? new Map() : ms(t))), (l = c));
    return c;
  };
gs();
var _s = {
  http: null,
  xhr: ts,
  fetch: {
    get: gs,
  },
};
F.forEach(_s, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", {
        __proto__: null,
        value: t,
      });
    } catch {}
    Object.defineProperty(e, "adapterName", {
      __proto__: null,
      value: t,
    });
  }
});
var vs = (e) => `- ${e}`,
  ys = (e) => F.isFunction(e) || e === null || e === !1;
function bs(e, t) {
  e = F.isArray(e) ? e : [e];
  let { length: n } = e,
    r,
    i,
    a = {};
  for (let o = 0; o < n; o++) {
    r = e[o];
    let n;
    if (((i = r), !ys(r) && ((i = _s[(n = String(r)).toLowerCase()]), i === void 0)))
      throw new L(`Unknown adapter '${n}'`);
    if (i && (F.isFunction(i) || (i = i.get(t)))) break;
    a[n || `#` + o] = i;
  }
  if (!i) {
    let e = Object.entries(a).map(
      ([e, t]) =>
        `adapter ${e} ` +
        (t === !1 ? `is not supported by the environment` : `is not available in the build`),
    );
    throw new L(
      `There is no suitable adapter to dispatch the request ` +
        (n
          ? e.length > 1
            ? `since :
` +
              e.map(vs).join(`
`)
            : ` ` + vs(e[0])
          : `as no adapter specified`),
      `ERR_NOT_SUPPORT`,
    );
  }
  return i;
}
var xs = {
  getAdapter: bs,
  adapters: _s,
};
function Ss(e) {
  if ((e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted))
    throw new Io(null, e);
}
function Cs(e) {
  return (
    Ss(e),
    (e.headers = to.from(e.headers)),
    (e.data = Po.call(e, e.transformRequest)),
    [`post`, `put`, `patch`].indexOf(e.method) !== -1 &&
      e.headers.setContentType(`application/x-www-form-urlencoded`, !1),
    xs
      .getAdapter(
        e.adapter || No.adapter,
        e,
      )(e)
      .then(
        function (t) {
          (Ss(e), (e.response = t));
          try {
            t.data = Po.call(e, e.transformResponse, t);
          } finally {
            delete e.response;
          }
          return ((t.headers = to.from(t.headers)), t);
        },
        function (t) {
          if (!Fo(t) && (Ss(e), t && t.response)) {
            e.response = t.response;
            try {
              t.response.data = Po.call(e, e.transformResponse, t.response);
            } finally {
              delete e.response;
            }
            t.response.headers = to.from(t.response.headers);
          }
          return Promise.reject(t);
        },
      )
  );
}
var ws = {};
[`object`, `boolean`, `number`, `function`, `string`, `symbol`].forEach((e, t) => {
  ws[e] = function (n) {
    return typeof n === e || `a` + (t < 1 ? `n ` : ` `) + e;
  };
});
var Ts = {};
((ws.transitional = function (e, t, n) {
  function r(e, t) {
    return `[Axios v` + R + `] Transitional option '` + e + `'` + t + (n ? `. ` + n : ``);
  }
  return (n, i, a) => {
    if (e === !1) throw new L(r(i, ` has been removed` + (t ? ` in ` + t : ``)), L.ERR_DEPRECATED);
    return (
      t &&
        !Ts[i] &&
        ((Ts[i] = !0),
        console.warn(
          r(i, ` has been deprecated since v` + t + ` and will be removed in the near future`),
        )),
      e ? e(n, i, a) : !0
    );
  };
}),
  (ws.spelling = function (e) {
    return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
  }));
function Es(e, t, n) {
  if (typeof e != `object`) throw new L(`options must be an object`, L.ERR_BAD_OPTION_VALUE);
  let r = Object.keys(e),
    i = r.length;
  for (; i-- > 0;) {
    let a = r[i],
      o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
    if (o) {
      let t = e[a],
        n = t === void 0 || o(t, a, e);
      if (n !== !0) throw new L(`option ` + a + ` must be ` + n, L.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0) throw new L(`Unknown option ` + a, L.ERR_BAD_OPTION);
  }
}
var Ds = {
    assertOptions: Es,
    validators: ws,
  },
  Os = Ds.validators,
  ks = class {
    constructor(e) {
      ((this.defaults = e || {}),
        (this.interceptors = {
          request: new _o(),
          response: new _o(),
        }));
    }
    async request(e, t) {
      try {
        return await this._request(e, t);
      } catch (e) {
        if (e instanceof Error) {
          let t = {};
          Error.captureStackTrace ? Error.captureStackTrace(t) : (t = Error());
          let n = (() => {
            if (!t.stack) return ``;
            let e = t.stack.indexOf(`
`);
            return e === -1 ? `` : t.stack.slice(e + 1);
          })();
          try {
            if (!e.stack) e.stack = n;
            else if (n) {
              let t = n.indexOf(`
`),
                r =
                  t === -1
                    ? -1
                    : n.indexOf(
                        `
`,
                        t + 1,
                      ),
                i = r === -1 ? `` : n.slice(r + 1);
              String(e.stack).endsWith(i) ||
                (e.stack +=
                  `
` + n);
            }
          } catch {}
        }
        throw e;
      }
    }
    _request(e, t) {
      (typeof e == `string` ? ((t ||= {}), (t.url = e)) : (t = e || {}),
        (t = Xo(this.defaults, t)));
      let { transitional: n, paramsSerializer: r, headers: i } = t;
      (n !== void 0 &&
        Ds.assertOptions(
          n,
          {
            silentJSONParsing: Os.transitional(Os.boolean),
            forcedJSONParsing: Os.transitional(Os.boolean),
            clarifyTimeoutError: Os.transitional(Os.boolean),
            legacyInterceptorReqResOrdering: Os.transitional(Os.boolean),
            advertiseZstdAcceptEncoding: Os.transitional(Os.boolean),
          },
          !1,
        ),
        r != null &&
          (F.isFunction(r)
            ? (t.paramsSerializer = {
                serialize: r,
              })
            : Ds.assertOptions(
                r,
                {
                  encode: Os.function,
                  serialize: Os.function,
                },
                !0,
              )),
        t.allowAbsoluteUrls !== void 0 ||
          (this.defaults.allowAbsoluteUrls === void 0
            ? (t.allowAbsoluteUrls = !0)
            : (t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls)),
        Ds.assertOptions(
          t,
          {
            baseUrl: Os.spelling(`baseURL`),
            withXsrfToken: Os.spelling(`withXSRFToken`),
          },
          !0,
        ),
        (t.method = (t.method || this.defaults.method || `get`).toLowerCase()));
      let a = i && F.merge(i.common, i[t.method]);
      (i &&
        F.forEach([`delete`, `get`, `head`, `post`, `put`, `patch`, `query`, `common`], (e) => {
          delete i[e];
        }),
        (t.headers = to.concat(a, i)));
      let o = [],
        s = !0;
      this.interceptors.request.forEach(function (e) {
        if (typeof e.runWhen == `function` && e.runWhen(t) === !1) return;
        s &&= e.synchronous;
        let n = t.transitional || vo;
        n && n.legacyInterceptorReqResOrdering
          ? o.unshift(e.fulfilled, e.rejected)
          : o.push(e.fulfilled, e.rejected);
      });
      let c = [];
      this.interceptors.response.forEach(function (e) {
        c.push(e.fulfilled, e.rejected);
      });
      let l,
        u = 0,
        d;
      if (!s) {
        let e = [Cs.bind(this), void 0];
        for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;)
          l = l.then(e[u++], e[u++]);
        return l;
      }
      d = o.length;
      let f = t;
      for (; u < d;) {
        let e = o[u++],
          t = o[u++];
        try {
          f = e(f);
        } catch (e) {
          t.call(this, e);
          break;
        }
      }
      try {
        l = Cs.call(this, f);
      } catch (e) {
        return Promise.reject(e);
      }
      for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
      return l;
    }
    getUri(e) {
      return (
        (e = Xo(this.defaults, e)),
        go(Jo(e.baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer)
      );
    }
  };
(F.forEach([`delete`, `get`, `head`, `options`], function (e) {
  ks.prototype[e] = function (t, n) {
    return this.request(
      Xo(n || {}, {
        method: e,
        url: t,
        data: (n || {}).data,
      }),
    );
  };
}),
  F.forEach([`post`, `put`, `patch`, `query`], function (e) {
    function t(t) {
      return function (n, r, i) {
        return this.request(
          Xo(i || {}, {
            method: e,
            headers: t
              ? {
                  "Content-Type": `multipart/form-data`,
                }
              : {},
            url: n,
            data: r,
          }),
        );
      };
    }
    ((ks.prototype[e] = t()), e !== `query` && (ks.prototype[e + `Form`] = t(!0)));
  }));
var As = class e {
  constructor(e) {
    if (typeof e != `function`) throw TypeError(`executor must be a function.`);
    let t;
    this.promise = new Promise(function (e) {
      t = e;
    });
    let n = this;
    (this.promise.then((e) => {
      if (!n._listeners) return;
      let t = n._listeners.length;
      for (; t-- > 0;) n._listeners[t](e);
      n._listeners = null;
    }),
      (this.promise.then = (e) => {
        let t,
          r = new Promise((e) => {
            (n.subscribe(e), (t = e));
          }).then(e);
        return (
          (r.cancel = function () {
            n.unsubscribe(t);
          }),
          r
        );
      }),
      e(function (e, r, i) {
        n.reason || ((n.reason = new Io(e, r, i)), t(n.reason));
      }));
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : (this._listeners = [e]);
  }
  unsubscribe(e) {
    if (!this._listeners) return;
    let t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    let e = new AbortController(),
      t = (t) => {
        e.abort(t);
      };
    return (this.subscribe(t), (e.signal.unsubscribe = () => this.unsubscribe(t)), e.signal);
  }
  static source() {
    let t;
    return {
      token: new e(function (e) {
        t = e;
      }),
      cancel: t,
    };
  }
};
function js(e) {
  return function (t) {
    return e.apply(null, t);
  };
}
function Ms(e) {
  return F.isObject(e) && e.isAxiosError === !0;
}
var Ns = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526,
};
Object.entries(Ns).forEach(([e, t]) => {
  Ns[t] = e;
});
function Ps(e) {
  let t = new ks(e),
    n = Di(ks.prototype.request, t);
  return (
    F.extend(n, ks.prototype, t, {
      allOwnKeys: !0,
    }),
    F.extend(n, t, null, {
      allOwnKeys: !0,
    }),
    (n.create = function (t) {
      return Ps(Xo(e, t));
    }),
    n
  );
}
var Fs = Ps(No);
((Fs.Axios = ks),
  (Fs.CanceledError = Io),
  (Fs.CancelToken = As),
  (Fs.isCancel = Fo),
  (Fs.VERSION = R),
  (Fs.toFormData = uo),
  (Fs.AxiosError = L),
  (Fs.Cancel = Fs.CanceledError),
  (Fs.all = function (e) {
    return Promise.all(e);
  }),
  (Fs.spread = js),
  (Fs.isAxiosError = Ms),
  (Fs.mergeConfig = Xo),
  (Fs.AxiosHeaders = to),
  (Fs.formToJSON = (e) => Ao(F.isHTMLForm(e) ? new FormData(e) : e)),
  (Fs.getAdapter = xs.getAdapter),
  (Fs.HttpStatusCode = Ns),
  (Fs.default = Fs));
var Is = (e) =>
  e.replace(/([-_][a-z])/gi, (e) => e.toUpperCase().replace(`-`, ``).replace(`_`, ``));
function Ls(e) {
  return e.then && typeof e.then == `function`;
}
var Rs = function (e) {
    return Array.isArray(e);
  },
  zs = function (e) {
    return e === Object(e) && !Rs(e) && typeof e != `function`;
  };
function Bs(e) {
  return Vs(r(e));
}
var Vs = function (e) {
  if (zs(e)) {
    let t = {};
    return (
      Object.keys(e).forEach((n) => {
        t[Is(n)] = Vs(e[n]);
      }),
      t
    );
  } else if (Rs(e)) return e.map((e) => Vs(e));
  return e;
};
function Hs(e) {
  return Us(r(e));
}
var Us = function (e) {
    if (typeof e != `object`) return e;
    for (var t in e) {
      let n = t.replace(/([A-Z])/g, function (e) {
        return `_` + e.toLowerCase();
      });
      (n != t && e.hasOwnProperty(t) && ((e[n] = e[t]), delete e[t]),
        typeof e[n] == `object` && (e[n] = Us(e[n])));
    }
    return e;
  },
  Ws = e(Ei(), 1),
  Gs = (e, t) => Math.floor(e * 1) / t,
  Ks = Fs.create({
    baseURL: `/api/v1`,
    withCredentials: !0,
  });
((Ks.defaults.onDownloadProgress = (e) => {
  let t = Gs(e.loaded, e.total);
  Ws.default.set(t);
}),
  Ks.interceptors.request.use(
    (e) => (
      (e.headers[`X-Requested-With`] = `XMLHttpRequest`),
      e.upload &&
        (e.headers[`Content-Type`] =
          `multipart/form-data; charset=utf-8; boundary=` + Math.random().toString().substr(2)),
      (e.params &&= Hs(e.params)),
      !e.upload && e.data && (e.data = Hs(e.data)),
      e
    ),
    (e) => (Ws.default.done(!0), Promise.reject(e)),
  ),
  Ks.interceptors.response.use(
    (e) => {
      Ws.default.done(!0);
      let t = e.data;
      return ((typeof t == `object` || t.isArray) && t !== null && (t = Bs(t)), Promise.resolve(t));
    },
    (e) => {
      Ws.default.done(!0);
      let t = e.response?.data,
        n = e.response?.status;
      return (
        (typeof t == `object` || t?.isArray) &&
          t !== null &&
          ((t = Bs(t)), (t.response_status = n)),
        Promise.reject(t)
      );
    },
  ));
var qs = t({
  custom: () => z,
  destroy: () => Qs,
  get: () => Xs,
  list: () => Js,
  store: () => Ys,
  update: () => Zs,
});
function Js(e, t = {}) {
  return Ks({
    url: D(e, t),
    method: `get`,
  });
}
function Ys(e, t, n = {}) {
  return Ks({
    url: D(e, n),
    method: `post`,
    data: t,
  });
}
function Xs(e, t, n = {}) {
  return Ks({
    url: D(`${e}/${t}`, n),
    method: `get`,
  });
}
function Zs(e, t, n, r = {}) {
  return Ks({
    url: D(`${e}/${t}`, r),
    method: `patch`,
    data: n,
  });
}
function Qs(e, t, n = {}) {
  return Ks({
    url: D(`${e}/${t}`, n),
    method: `delete`,
  });
}
function z(e) {
  return Ks(e);
}
ne();
var $s = Object.defineProperty,
  ec = Object.getOwnPropertySymbols,
  tc = Object.prototype.hasOwnProperty,
  nc = Object.prototype.propertyIsEnumerable,
  rc = (e, t, n) =>
    t in e
      ? $s(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: n,
        })
      : (e[t] = n),
  ic = (e, t) => {
    for (var n in (t ||= {})) tc.call(t, n) && rc(e, n, t[n]);
    if (ec) for (var n of ec(t)) nc.call(t, n) && rc(e, n, t[n]);
    return e;
  },
  ac = (e) => typeof e == `function`,
  oc = (e) => typeof e == `string`,
  sc = (e) => oc(e) && e.trim().length > 0,
  cc = (e) => typeof e == `number`,
  lc = (e) => e === void 0,
  uc = (e) => typeof e == `object` && !!e,
  dc = (e) => _c(e, `tag`) && sc(e.tag),
  fc = (e) => window.TouchEvent && e instanceof TouchEvent,
  pc = (e) => _c(e, `component`) && hc(e.component),
  mc = (e) => ac(e) || uc(e),
  hc = (e) => !lc(e) && (oc(e) || mc(e) || pc(e)),
  gc = (e) => uc(e) && [`height`, `width`, `right`, `left`, `top`, `bottom`].every((t) => cc(e[t])),
  _c = (e, t) => (uc(e) || ac(e)) && t in e,
  vc = (
    (e) => () =>
      e++
  )(0);
function yc(e) {
  return fc(e) ? e.targetTouches[0].clientX : e.clientX;
}
function bc(e) {
  return fc(e) ? e.targetTouches[0].clientY : e.clientY;
}
var xc = (e) => {
    lc(e.remove) ? e.parentNode && e.parentNode.removeChild(e) : e.remove();
  },
  Sc = (e) =>
    pc(e)
      ? Sc(e.component)
      : dc(e)
        ? s({
            render() {
              return e;
            },
          })
        : typeof e == `string`
          ? e
          : ie(h(e)),
  Cc = (e) => {
    if (typeof e == `string`) return e;
    let t = _c(e, `props`) && uc(e.props) ? e.props : {},
      n = _c(e, `listeners`) && uc(e.listeners) ? e.listeners : {};
    return {
      component: Sc(e),
      props: t,
      listeners: n,
    };
  },
  wc = () => typeof window < `u`,
  Tc = class {
    constructor() {
      this.allHandlers = {};
    }
    getHandlers(e) {
      return this.allHandlers[e] || [];
    }
    on(e, t) {
      let n = this.getHandlers(e);
      (n.push(t), (this.allHandlers[e] = n));
    }
    off(e, t) {
      let n = this.getHandlers(e);
      n.splice(n.indexOf(t) >>> 0, 1);
    }
    emit(e, t) {
      this.getHandlers(e).forEach((e) => e(t));
    }
  },
  Ec = (e) => [`on`, `off`, `emit`].every((t) => _c(e, t) && ac(e[t])),
  Dc;
(function (e) {
  ((e.SUCCESS = `success`),
    (e.ERROR = `error`),
    (e.WARNING = `warning`),
    (e.INFO = `info`),
    (e.DEFAULT = `default`));
})((Dc ||= {}));
var Oc;
(function (e) {
  ((e.TOP_LEFT = `top-left`),
    (e.TOP_CENTER = `top-center`),
    (e.TOP_RIGHT = `top-right`),
    (e.BOTTOM_LEFT = `bottom-left`),
    (e.BOTTOM_CENTER = `bottom-center`),
    (e.BOTTOM_RIGHT = `bottom-right`));
})((Oc ||= {}));
var kc;
(function (e) {
  ((e.ADD = `add`),
    (e.DISMISS = `dismiss`),
    (e.UPDATE = `update`),
    (e.CLEAR = `clear`),
    (e.UPDATE_DEFAULTS = `update_defaults`));
})((kc ||= {}));
var Ac = `Vue-Toastification`,
  jc = {
    type: {
      type: String,
      default: Dc.DEFAULT,
    },
    classNames: {
      type: [String, Array],
      default: () => [],
    },
    trueBoolean: {
      type: Boolean,
      default: !0,
    },
  },
  Mc = {
    type: jc.type,
    customIcon: {
      type: [String, Boolean, Object, Function],
      default: !0,
    },
  },
  Nc = {
    component: {
      type: [String, Object, Function, Boolean],
      default: `button`,
    },
    classNames: jc.classNames,
    showOnHover: {
      type: Boolean,
      default: !1,
    },
    ariaLabel: {
      type: String,
      default: `close`,
    },
  },
  Pc = {
    timeout: {
      type: [Number, Boolean],
      default: 5e3,
    },
    hideProgressBar: {
      type: Boolean,
      default: !1,
    },
    isRunning: {
      type: Boolean,
      default: !1,
    },
  },
  Fc = {
    transition: {
      type: [Object, String],
      default: `${Ac}__bounce`,
    },
  },
  Ic = {
    CORE_TOAST: {
      position: {
        type: String,
        default: Oc.TOP_RIGHT,
      },
      draggable: jc.trueBoolean,
      draggablePercent: {
        type: Number,
        default: 0.6,
      },
      pauseOnFocusLoss: jc.trueBoolean,
      pauseOnHover: jc.trueBoolean,
      closeOnClick: jc.trueBoolean,
      timeout: Pc.timeout,
      hideProgressBar: Pc.hideProgressBar,
      toastClassName: jc.classNames,
      bodyClassName: jc.classNames,
      icon: Mc.customIcon,
      closeButton: Nc.component,
      closeButtonClassName: Nc.classNames,
      showCloseButtonOnHover: Nc.showOnHover,
      accessibility: {
        type: Object,
        default: () => ({
          toastRole: `alert`,
          closeButtonLabel: `close`,
        }),
      },
      rtl: {
        type: Boolean,
        default: !1,
      },
      eventBus: {
        type: Object,
        required: !1,
        default: () => new Tc(),
      },
    },
    TOAST: {
      id: {
        type: [String, Number],
        required: !0,
        default: 0,
      },
      type: jc.type,
      content: {
        type: [String, Object, Function],
        required: !0,
        default: ``,
      },
      onClick: {
        type: Function,
        default: void 0,
      },
      onClose: {
        type: Function,
        default: void 0,
      },
    },
    CONTAINER: {
      container: {
        type: [Object, Function],
        default: () => document.body,
      },
      newestOnTop: jc.trueBoolean,
      maxToasts: {
        type: Number,
        default: 20,
      },
      transition: Fc.transition,
      toastDefaults: Object,
      filterBeforeCreate: {
        type: Function,
        default: (e) => e,
      },
      filterToasts: {
        type: Function,
        default: (e) => e,
      },
      containerClassName: jc.classNames,
      onMounted: Function,
      shareAppContext: [Boolean, Object],
    },
    PROGRESS_BAR: Pc,
    ICON: Mc,
    TRANSITION: Fc,
    CLOSE_BUTTON: Nc,
  },
  Lc = s({
    name: `VtProgressBar`,
    props: Ic.PROGRESS_BAR,
    data() {
      return {
        hasClass: !0,
      };
    },
    computed: {
      style() {
        return {
          animationDuration: `${this.timeout}ms`,
          animationPlayState: this.isRunning ? `running` : `paused`,
          opacity: +!this.hideProgressBar,
        };
      },
      cpClass() {
        return this.hasClass ? `${Ac}__progress-bar` : ``;
      },
    },
    watch: {
      timeout() {
        ((this.hasClass = !1), this.$nextTick(() => (this.hasClass = !0)));
      },
    },
    mounted() {
      this.$el.addEventListener(`animationend`, this.animationEnded);
    },
    beforeUnmount() {
      this.$el.removeEventListener(`animationend`, this.animationEnded);
    },
    methods: {
      animationEnded() {
        this.$emit(`close-toast`);
      },
    },
  });
function Rc(e, t) {
  return (
    c(),
    p(
      `div`,
      {
        style: T(e.style),
        class: o(e.cpClass),
      },
      null,
      6,
    )
  );
}
Lc.render = Rc;
var zc = Lc,
  Bc = s({
    name: `VtCloseButton`,
    props: Ic.CLOSE_BUTTON,
    computed: {
      buttonComponent() {
        return this.component === !1 ? `button` : Sc(this.component);
      },
      classes() {
        let e = [`${Ac}__close-button`];
        return (this.showOnHover && e.push(`show-on-hover`), e.concat(this.classNames));
      },
    },
  }),
  Vc = re(` × `);
function Hc(e, t) {
  return (
    c(),
    x(
      g(e.buttonComponent),
      d(
        {
          "aria-label": e.ariaLabel,
          class: e.classes,
        },
        e.$attrs,
      ),
      {
        default: b(() => [Vc]),
        _: 1,
      },
      16,
      [`aria-label`, `class`],
    )
  );
}
Bc.render = Hc;
var Uc = Bc,
  Wc = {},
  Gc = {
    "aria-hidden": `true`,
    focusable: `false`,
    "data-prefix": `fas`,
    "data-icon": `check-circle`,
    class: `svg-inline--fa fa-check-circle fa-w-16`,
    role: `img`,
    xmlns: `http://www.w3.org/2000/svg`,
    viewBox: `0 0 512 512`,
  },
  Kc = [
    ae(
      `path`,
      {
        fill: `currentColor`,
        d: `M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z`,
      },
      null,
      -1,
    ),
  ];
function qc(e, t) {
  return (c(), p(`svg`, Gc, Kc));
}
Wc.render = qc;
var Jc = Wc,
  Yc = {},
  Xc = {
    "aria-hidden": `true`,
    focusable: `false`,
    "data-prefix": `fas`,
    "data-icon": `info-circle`,
    class: `svg-inline--fa fa-info-circle fa-w-16`,
    role: `img`,
    xmlns: `http://www.w3.org/2000/svg`,
    viewBox: `0 0 512 512`,
  },
  Zc = [
    ae(
      `path`,
      {
        fill: `currentColor`,
        d: `M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z`,
      },
      null,
      -1,
    ),
  ];
function Qc(e, t) {
  return (c(), p(`svg`, Xc, Zc));
}
Yc.render = Qc;
var $c = Yc,
  el = {},
  tl = {
    "aria-hidden": `true`,
    focusable: `false`,
    "data-prefix": `fas`,
    "data-icon": `exclamation-circle`,
    class: `svg-inline--fa fa-exclamation-circle fa-w-16`,
    role: `img`,
    xmlns: `http://www.w3.org/2000/svg`,
    viewBox: `0 0 512 512`,
  },
  nl = [
    ae(
      `path`,
      {
        fill: `currentColor`,
        d: `M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z`,
      },
      null,
      -1,
    ),
  ];
function rl(e, t) {
  return (c(), p(`svg`, tl, nl));
}
el.render = rl;
var il = el,
  al = {},
  ol = {
    "aria-hidden": `true`,
    focusable: `false`,
    "data-prefix": `fas`,
    "data-icon": `exclamation-triangle`,
    class: `svg-inline--fa fa-exclamation-triangle fa-w-18`,
    role: `img`,
    xmlns: `http://www.w3.org/2000/svg`,
    viewBox: `0 0 576 512`,
  },
  sl = [
    ae(
      `path`,
      {
        fill: `currentColor`,
        d: `M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z`,
      },
      null,
      -1,
    ),
  ];
function cl(e, t) {
  return (c(), p(`svg`, ol, sl));
}
al.render = cl;
var ll = al,
  ul = s({
    name: `VtIcon`,
    props: Ic.ICON,
    computed: {
      customIconChildren() {
        return _c(this.customIcon, `iconChildren`)
          ? this.trimValue(this.customIcon.iconChildren)
          : ``;
      },
      customIconClass() {
        return oc(this.customIcon)
          ? this.trimValue(this.customIcon)
          : _c(this.customIcon, `iconClass`)
            ? this.trimValue(this.customIcon.iconClass)
            : ``;
      },
      customIconTag() {
        return _c(this.customIcon, `iconTag`) ? this.trimValue(this.customIcon.iconTag, `i`) : `i`;
      },
      hasCustomIcon() {
        return this.customIconClass.length > 0;
      },
      component() {
        return this.hasCustomIcon
          ? this.customIconTag
          : hc(this.customIcon)
            ? Sc(this.customIcon)
            : this.iconTypeComponent;
      },
      iconTypeComponent() {
        return {
          [Dc.DEFAULT]: $c,
          [Dc.INFO]: $c,
          [Dc.SUCCESS]: Jc,
          [Dc.ERROR]: ll,
          [Dc.WARNING]: il,
        }[this.type];
      },
      iconClasses() {
        let e = [`${Ac}__icon`];
        return this.hasCustomIcon ? e.concat(this.customIconClass) : e;
      },
    },
    methods: {
      trimValue(e, t = ``) {
        return sc(e) ? e.trim() : t;
      },
    },
  });
function dl(e, t) {
  return (
    c(),
    x(
      g(e.component),
      {
        class: o(e.iconClasses),
      },
      {
        default: b(() => [re(i(e.customIconChildren), 1)]),
        _: 1,
      },
      8,
      [`class`],
    )
  );
}
ul.render = dl;
var fl = s({
    name: `VtToast`,
    components: {
      ProgressBar: zc,
      CloseButton: Uc,
      Icon: ul,
    },
    inheritAttrs: !1,
    props: Object.assign({}, Ic.CORE_TOAST, Ic.TOAST),
    data() {
      return {
        isRunning: !0,
        disableTransitions: !1,
        beingDragged: !1,
        dragStart: 0,
        dragPos: {
          x: 0,
          y: 0,
        },
        dragRect: {},
      };
    },
    computed: {
      classes() {
        let e = [`${Ac}__toast`, `${Ac}__toast--${this.type}`, `${this.position}`].concat(
          this.toastClassName,
        );
        return (
          this.disableTransitions && e.push(`disable-transition`),
          this.rtl && e.push(`${Ac}__toast--rtl`),
          e
        );
      },
      bodyClasses() {
        return [`${Ac}__toast-${oc(this.content) ? `body` : `component-body`}`].concat(
          this.bodyClassName,
        );
      },
      draggableStyle() {
        return this.dragStart === this.dragPos.x
          ? {}
          : this.beingDragged
            ? {
                transform: `translateX(${this.dragDelta}px)`,
                opacity: 1 - Math.abs(this.dragDelta / this.removalDistance),
              }
            : {
                transition: `transform 0.2s, opacity 0.2s`,
                transform: `translateX(0)`,
                opacity: 1,
              };
      },
      dragDelta() {
        return this.beingDragged ? this.dragPos.x - this.dragStart : 0;
      },
      removalDistance() {
        return gc(this.dragRect)
          ? (this.dragRect.right - this.dragRect.left) * this.draggablePercent
          : 0;
      },
    },
    mounted() {
      (this.draggable && this.draggableSetup(), this.pauseOnFocusLoss && this.focusSetup());
    },
    beforeUnmount() {
      (this.draggable && this.draggableCleanup(), this.pauseOnFocusLoss && this.focusCleanup());
    },
    methods: {
      hasProp: _c,
      getVueComponentFromObj: Sc,
      closeToast() {
        this.eventBus.emit(kc.DISMISS, this.id);
      },
      clickHandler() {
        (this.onClick && this.onClick(this.closeToast),
          this.closeOnClick &&
            (!this.beingDragged || this.dragStart === this.dragPos.x) &&
            this.closeToast());
      },
      timeoutHandler() {
        this.closeToast();
      },
      hoverPause() {
        this.pauseOnHover && (this.isRunning = !1);
      },
      hoverPlay() {
        this.pauseOnHover && (this.isRunning = !0);
      },
      focusPause() {
        this.isRunning = !1;
      },
      focusPlay() {
        this.isRunning = !0;
      },
      focusSetup() {
        (addEventListener(`blur`, this.focusPause), addEventListener(`focus`, this.focusPlay));
      },
      focusCleanup() {
        (removeEventListener(`blur`, this.focusPause),
          removeEventListener(`focus`, this.focusPlay));
      },
      draggableSetup() {
        let e = this.$el;
        (e.addEventListener(`touchstart`, this.onDragStart, {
          passive: !0,
        }),
          e.addEventListener(`mousedown`, this.onDragStart),
          addEventListener(`touchmove`, this.onDragMove, {
            passive: !1,
          }),
          addEventListener(`mousemove`, this.onDragMove),
          addEventListener(`touchend`, this.onDragEnd),
          addEventListener(`mouseup`, this.onDragEnd));
      },
      draggableCleanup() {
        let e = this.$el;
        (e.removeEventListener(`touchstart`, this.onDragStart),
          e.removeEventListener(`mousedown`, this.onDragStart),
          removeEventListener(`touchmove`, this.onDragMove),
          removeEventListener(`mousemove`, this.onDragMove),
          removeEventListener(`touchend`, this.onDragEnd),
          removeEventListener(`mouseup`, this.onDragEnd));
      },
      onDragStart(e) {
        ((this.beingDragged = !0),
          (this.dragPos = {
            x: yc(e),
            y: bc(e),
          }),
          (this.dragStart = yc(e)),
          (this.dragRect = this.$el.getBoundingClientRect()));
      },
      onDragMove(e) {
        this.beingDragged &&
          (e.preventDefault(),
          (this.isRunning &&= !1),
          (this.dragPos = {
            x: yc(e),
            y: bc(e),
          }));
      },
      onDragEnd() {
        this.beingDragged &&
          (Math.abs(this.dragDelta) >= this.removalDistance
            ? ((this.disableTransitions = !0), this.$nextTick(() => this.closeToast()))
            : setTimeout(() => {
                ((this.beingDragged = !1),
                  gc(this.dragRect) &&
                  this.pauseOnHover &&
                  this.dragRect.bottom >= this.dragPos.y &&
                  this.dragPos.y >= this.dragRect.top &&
                  this.dragRect.left <= this.dragPos.x &&
                  this.dragPos.x <= this.dragRect.right
                    ? (this.isRunning = !1)
                    : (this.isRunning = !0));
              }));
      },
    },
  }),
  pl = [`role`];
function ml(e, t) {
  let n = l(`Icon`),
    r = l(`CloseButton`),
    a = l(`ProgressBar`);
  return (
    c(),
    p(
      `div`,
      {
        class: o(e.classes),
        style: T(e.draggableStyle),
        onClick: (t[0] ||= (...t) => e.clickHandler && e.clickHandler(...t)),
        onMouseenter: (t[1] ||= (...t) => e.hoverPause && e.hoverPause(...t)),
        onMouseleave: (t[2] ||= (...t) => e.hoverPlay && e.hoverPlay(...t)),
      },
      [
        e.icon
          ? (c(),
            x(
              n,
              {
                key: 0,
                "custom-icon": e.icon,
                type: e.type,
              },
              null,
              8,
              [`custom-icon`, `type`],
            ))
          : E(`v-if`, !0),
        ae(
          `div`,
          {
            role: e.accessibility.toastRole || `alert`,
            class: o(e.bodyClasses),
          },
          [
            typeof e.content == `string`
              ? (c(),
                p(
                  S,
                  {
                    key: 0,
                  },
                  [re(i(e.content), 1)],
                  2112,
                ))
              : (c(),
                x(
                  g(e.getVueComponentFromObj(e.content)),
                  d(
                    {
                      key: 1,
                      "toast-id": e.id,
                    },
                    e.hasProp(e.content, `props`) ? e.content.props : {},
                    v(e.hasProp(e.content, `listeners`) ? e.content.listeners : {}),
                    {
                      onCloseToast: e.closeToast,
                    },
                  ),
                  null,
                  16,
                  [`toast-id`, `onCloseToast`],
                )),
          ],
          10,
          pl,
        ),
        e.closeButton
          ? (c(),
            x(
              r,
              {
                key: 1,
                component: e.closeButton,
                "class-names": e.closeButtonClassName,
                "show-on-hover": e.showCloseButtonOnHover,
                "aria-label": e.accessibility.closeButtonLabel,
                onClick: ee(e.closeToast, [`stop`]),
              },
              null,
              8,
              [`component`, `class-names`, `show-on-hover`, `aria-label`, `onClick`],
            ))
          : E(`v-if`, !0),
        e.timeout
          ? (c(),
            x(
              a,
              {
                key: 2,
                "is-running": e.isRunning,
                "hide-progress-bar": e.hideProgressBar,
                timeout: e.timeout,
                onCloseToast: e.timeoutHandler,
              },
              null,
              8,
              [`is-running`, `hide-progress-bar`, `timeout`, `onCloseToast`],
            ))
          : E(`v-if`, !0),
      ],
      38,
    )
  );
}
fl.render = ml;
var hl = fl,
  gl = s({
    name: `VtTransition`,
    props: Ic.TRANSITION,
    emits: [`leave`],
    methods: {
      hasProp: _c,
      leave(e) {
        e instanceof HTMLElement &&
          ((e.style.left = e.offsetLeft + `px`),
          (e.style.top = e.offsetTop + `px`),
          (e.style.width = getComputedStyle(e).width),
          (e.style.position = `absolute`));
      },
    },
  });
function _l(e, t) {
  return (
    c(),
    x(
      C,
      {
        tag: `div`,
        "enter-active-class": e.transition.enter
          ? e.transition.enter
          : `${e.transition}-enter-active`,
        "move-class": e.transition.move ? e.transition.move : `${e.transition}-move`,
        "leave-active-class": e.transition.leave
          ? e.transition.leave
          : `${e.transition}-leave-active`,
        onLeave: e.leave,
      },
      {
        default: b(() => [te(e.$slots, `default`)]),
        _: 3,
      },
      8,
      [`enter-active-class`, `move-class`, `leave-active-class`, `onLeave`],
    )
  );
}
gl.render = _l;
var vl = s({
  name: `VueToastification`,
  devtools: {
    hide: !0,
  },
  components: {
    Toast: hl,
    VtTransition: gl,
  },
  props: Object.assign({}, Ic.CORE_TOAST, Ic.CONTAINER, Ic.TRANSITION),
  data() {
    return {
      count: 0,
      positions: Object.values(Oc),
      toasts: {},
      defaults: {},
    };
  },
  computed: {
    toastArray() {
      return Object.values(this.toasts);
    },
    filteredToasts() {
      return this.defaults.filterToasts(this.toastArray);
    },
  },
  beforeMount() {
    let e = this.eventBus;
    (e.on(kc.ADD, this.addToast),
      e.on(kc.CLEAR, this.clearToasts),
      e.on(kc.DISMISS, this.dismissToast),
      e.on(kc.UPDATE, this.updateToast),
      e.on(kc.UPDATE_DEFAULTS, this.updateDefaults),
      (this.defaults = this.$props));
  },
  mounted() {
    this.setup(this.container);
  },
  methods: {
    async setup(e) {
      (ac(e) && (e = await e()), xc(this.$el), e.appendChild(this.$el));
    },
    setToast(e) {
      lc(e.id) || (this.toasts[e.id] = e);
    },
    addToast(e) {
      e.content = Cc(e.content);
      let t = Object.assign(
          {},
          this.defaults,
          e.type && this.defaults.toastDefaults && this.defaults.toastDefaults[e.type],
          e,
        ),
        n = this.defaults.filterBeforeCreate(t, this.toastArray);
      n && this.setToast(n);
    },
    dismissToast(e) {
      let t = this.toasts[e];
      (!lc(t) && !lc(t.onClose) && t.onClose(), delete this.toasts[e]);
    },
    clearToasts() {
      Object.keys(this.toasts).forEach((e) => {
        this.dismissToast(e);
      });
    },
    getPositionToasts(e) {
      let t = this.filteredToasts.filter((t) => t.position === e).slice(0, this.defaults.maxToasts);
      return this.defaults.newestOnTop ? t.reverse() : t;
    },
    updateDefaults(e) {
      (lc(e.container) || this.setup(e.container),
        (this.defaults = Object.assign({}, this.defaults, e)));
    },
    updateToast({ id: e, options: t, create: n }) {
      this.toasts[e]
        ? (t.timeout && t.timeout === this.toasts[e].timeout && t.timeout++,
          this.setToast(Object.assign({}, this.toasts[e], t)))
        : n &&
          this.addToast(
            Object.assign(
              {},
              {
                id: e,
              },
              t,
            ),
          );
    },
    getClasses(e) {
      return [`${Ac}__container`, e].concat(this.defaults.containerClassName);
    },
  },
});
function yl(e, t) {
  let n = l(`Toast`),
    r = l(`VtTransition`);
  return (
    c(),
    p(`div`, null, [
      (c(!0),
      p(
        S,
        null,
        u(
          e.positions,
          (t) => (
            c(),
            p(
              `div`,
              {
                key: t,
              },
              [
                m(
                  r,
                  {
                    transition: e.defaults.transition,
                    class: o(e.getClasses(t)),
                  },
                  {
                    default: b(() => [
                      (c(!0),
                      p(
                        S,
                        null,
                        u(
                          e.getPositionToasts(t),
                          (e) => (
                            c(),
                            x(
                              n,
                              d(
                                {
                                  key: e.id,
                                },
                                e,
                              ),
                              null,
                              16,
                            )
                          ),
                        ),
                        128,
                      )),
                    ]),
                    _: 2,
                  },
                  1032,
                  [`transition`, `class`],
                ),
              ],
            )
          ),
        ),
        128,
      )),
    ])
  );
}
vl.render = yl;
var bl = vl,
  xl = (e = {}, t = !0) => {
    let n = (e.eventBus = e.eventBus || new Tc());
    t &&
      f(() => {
        let t = y(bl, ic({}, e)),
          n = t.mount(document.createElement(`div`)),
          r = e.onMounted;
        if ((lc(r) || r(n, t), e.shareAppContext)) {
          let n = e.shareAppContext;
          n === !0
            ? console.warn(`[${Ac}] App to share context with was not provided.`)
            : ((t._context.components = n._context.components),
              (t._context.directives = n._context.directives),
              (t._context.mixins = n._context.mixins),
              (t._context.provides = n._context.provides),
              (t.config.globalProperties = n.config.globalProperties));
        }
      });
    let r = (e, t) => {
      let r = Object.assign(
        {},
        {
          id: vc(),
          type: Dc.DEFAULT,
        },
        t,
        {
          content: e,
        },
      );
      return (n.emit(kc.ADD, r), r.id);
    };
    ((r.clear = () => n.emit(kc.CLEAR, void 0)),
      (r.updateDefaults = (e) => {
        n.emit(kc.UPDATE_DEFAULTS, e);
      }),
      (r.dismiss = (e) => {
        n.emit(kc.DISMISS, e);
      }));
    function i(e, { content: t, options: r }, i = !1) {
      let a = Object.assign({}, r, {
        content: t,
      });
      n.emit(kc.UPDATE, {
        id: e,
        options: a,
        create: i,
      });
    }
    return (
      (r.update = i),
      (r.success = (e, t) =>
        r(
          e,
          Object.assign({}, t, {
            type: Dc.SUCCESS,
          }),
        )),
      (r.info = (e, t) =>
        r(
          e,
          Object.assign({}, t, {
            type: Dc.INFO,
          }),
        )),
      (r.error = (e, t) =>
        r(
          e,
          Object.assign({}, t, {
            type: Dc.ERROR,
          }),
        )),
      (r.warning = (e, t) =>
        r(
          e,
          Object.assign({}, t, {
            type: Dc.WARNING,
          }),
        )),
      r
    );
  },
  Sl = () => {
    let e = () => console.warn(`[${Ac}] This plugin does not support SSR!`);
    return new Proxy(e, {
      get() {
        return e;
      },
    });
  };
function Cl(e) {
  return wc()
    ? Ec(e)
      ? xl(
          {
            eventBus: e,
          },
          !1,
        )
      : xl(e, !0)
    : Sl();
}
var wl = Symbol(`VueToastification`),
  Tl = new Tc(),
  El = (e, t) => {
    t?.shareAppContext === !0 && (t.shareAppContext = e);
    let n = Cl(
      ic(
        {
          eventBus: Tl,
        },
        t,
      ),
    );
    e.provide(wl, n);
  },
  B = (e) => (e ? Cl(e) : (a() ? w(wl, void 0) : void 0) || Cl(Tl)),
  Dl = El,
  Ol = t({
    assignErrors: () => Al,
    getErrors: () => V,
    handleErrors: () => jl,
    hideLoader: () => Ml,
  }),
  kl = B();
function Al(e) {
  return _.mapValues(e, (e) => (Array.isArray(e) ? e.join(` `) : e));
}
function jl(e) {
  let t = e.errors ? Bs(Al(e.errors)) : {};
  return (
    e.hasOwnProperty(`response_status`) &&
      (e.response_status, e.hasOwnProperty(`reload`) && e.reload === !0 && location.reload()),
    e.message && kl.error(e.message),
    Object.keys(t).length && t.message,
    t
  );
}
function V(e) {
  return Object.assign({}, jl(e));
}
function Ml(e) {
  e && e.loader && e.loader.hide();
}
var Nl = B(),
  Pl = () => ({}),
  H = {
    SET_FORM_ERRORS: (e, t = {}) => {
      e.formErrors = t;
    },
    RESET_STATE: (e) => {
      e = Pl;
    },
  },
  U = {
    resetFormErrors({ commit: e }) {
      e(`SET_FORM_ERRORS`);
    },
    preRequisite({ state: e, commit: t }, n) {
      let r = ``,
        i = {};
      Array.isArray(n.data)
        ? (r = n.data.join(`,`))
        : typeof n.data == `object`
          ? (i = n.data)
          : (r = n.data);
      let a = e.initURL + `/pre-requisite`;
      return (
        r && (a += `?type=` + r),
        i && (a = D(a, i)),
        z({
          url: a,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          })
      );
    },
    list({ state: e, commit: t }, n) {
      return Js(e.initURL, n.params)
        .then((e) => e)
        .catch((e) => {
          throw (V(e), e);
        });
    },
    async get({ state: e, commit: t }, n) {
      return await Xs(e.initURL, n.uuid, n.params)
        .then((e) => e)
        .catch((e) => {
          throw (V(e), e);
        });
    },
    async create({ state: e, commit: t }, n) {
      return await Ys(e.initURL, n.form)
        .then((e) => (Nl.success(e.message), e))
        .catch((e) => {
          throw (t(`SET_FORM_ERRORS`, V(e)), e);
        });
    },
    async update({ state: e, commit: t }, n) {
      await Zs(e.initURL, n.uuid, n.form)
        .then((e) => {
          Nl.success(e.message);
        })
        .catch((e) => {
          throw (t(`SET_FORM_ERRORS`, V(e)), e);
        });
    },
    async delete({ state: e, commit: t }, n) {
      await Qs(e.initURL, n.uuid, {
        force: n.force || !1,
      })
        .then((e) => {
          Nl.success(e.message);
        })
        .catch((e) => {
          throw (V(e), e);
        });
    },
    resetState({ commit: e }) {
      e(`RESET_STATE`);
    },
  },
  W = {
    getFormErrors: (e) => e.formErrors,
  };
B();
var Fl = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/setup-wizard`,
      formErrors: {},
    }),
    mutations: {
      ...H,
    },
    actions: {
      getSteps({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            V(e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Il = B(),
  Ll = {
    namespaced: !0,
    modules: {
      install: {
        namespaced: !0,
        state: () => ({
          initURL: `/install`,
          app: {},
          formErrors: {},
        }),
        mutations: {
          ...H,
          SET_PREREQUISITES: (e, t = []) => {
            e.preRequisites = t;
          },
          SET_APP: (e, t = {}) => {
            e.app = t;
          },
        },
        actions: {
          resetFormErrors: U.resetFormErrors,
          preRequisite({ state: e, commit: t }, n) {
            z({
              url: e.initURL + `/pre-requisite`,
              method: `GET`,
            })
              .then((e) => {
                (t(`SET_PREREQUISITES`, e.preRequisites), t(`SET_APP`, e.app));
              })
              .catch((e) => {
                V(e);
              });
          },
          async finish({ state: e, commit: t, dispatch: n }, r) {
            (await z({
              url: e.initURL,
              method: `POST`,
              data: r.form,
            })
              .then((e) => {
                (t(`RESET_STATE`), Il.success(e.message));
              })
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              }),
              await n(`config/get`, !0, {
                root: !0,
              }));
          },
        },
        getters: {
          ...W,
          getPreRequisites: (e) => e.preRequisites,
          getApp: (e) => e.app,
        },
      },
      wizard: Fl,
    },
    state: () => ({}),
    mutations: {},
    actions: {},
    getters: {},
  },
  Rl = `modulepreload`,
  zl = function (e) {
    return `/build/` + e;
  },
  Bl = {},
  G = function (e, t, n) {
    let r = Promise.resolve();
    if (t && t.length > 0) {
      let e = document.getElementsByTagName(`link`),
        i = document.querySelector(`meta[property=csp-nonce]`),
        a = i?.nonce || i?.getAttribute(`nonce`);
      function o(e) {
        return Promise.all(
          e.map((e) =>
            Promise.resolve(e).then(
              (e) => ({
                status: `fulfilled`,
                value: e,
              }),
              (e) => ({
                status: `rejected`,
                reason: e,
              }),
            ),
          ),
        );
      }
      r = o(
        t.map((t) => {
          if (((t = zl(t, n)), t in Bl)) return;
          Bl[t] = !0;
          let r = t.endsWith(`.css`),
            i = r ? `[rel="stylesheet"]` : ``;
          if (n)
            for (let n = e.length - 1; n >= 0; n--) {
              let i = e[n];
              if (i.href === t && (!r || i.rel === `stylesheet`)) return;
            }
          else if (document.querySelector(`link[href="${t}"]${i}`)) return;
          let o = document.createElement(`link`);
          if (
            ((o.rel = r ? `stylesheet` : Rl),
            r || (o.as = `script`),
            (o.crossOrigin = ``),
            (o.href = t),
            a && o.setAttribute(`nonce`, a),
            document.head.appendChild(o),
            r)
          )
            return new Promise((e, n) => {
              (o.addEventListener(`load`, e),
                o.addEventListener(`error`, () => n(Error(`Unable to preload CSS for ${t}`))));
            });
        }),
      );
    }
    function i(e) {
      let t = new Event(`vite:preloadError`, {
        cancelable: !0,
      });
      if (((t.payload = e), window.dispatchEvent(t), !t.defaultPrevented)) throw e;
    }
    return r.then((t) => {
      for (let e of t || []) e.status === `rejected` && i(e.reason);
      return e().catch(i);
    });
  },
  Vl = [
    {
      path: `pages/:slug`,
      name: `SitePageView`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Site/Page/View.vue`),
          __vite__mapDeps([0, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `site/posts`,
      name: `SitePost`,
      meta: {
        hideCard: !0,
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Site/Post/Index.vue`),
          __vite__mapDeps([9, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11]),
        ),
    },
    {
      path: `site/posts/:uuid`,
      name: `SitePostView`,
      meta: {
        hideCard: !0,
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Site/Post/View.vue`),
          __vite__mapDeps([12, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11]),
        ),
    },
    {
      path: `job/vacancies`,
      name: `JobVacancies`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Recruitment/Job/Vacancy.vue`),
          __vite__mapDeps([13, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `job/vacancies/:slug`,
      name: `JobVacancyDetail`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Recruitment/Job/VacancyDetail.vue`),
          __vite__mapDeps([14, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `job/vacancies/:slug/application`,
      name: `JobVacancyApplication`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Recruitment/Job/Application.vue`),
          __vite__mapDeps([15, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `online-enquiry`,
      name: `OnlineEnquiry`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Reception/OnlineEnquiry/Index.vue`),
          __vite__mapDeps([16, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `online-registration`,
      name: `OnlineRegistration`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/OnlineRegistration/Index.vue`),
          __vite__mapDeps([17, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `online-registration/verify`,
      name: `OnlineRegistrationVerify`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/OnlineRegistration/Verify.vue`),
          __vite__mapDeps([18, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `online-registration/form/:number`,
      name: `OnlineRegistrationForm`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/OnlineRegistration/Form.vue`),
          __vite__mapDeps([19, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22]),
        ),
    },
    {
      path: `payment`,
      name: `GuestPayment`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/GuestPayment/Index.vue`),
          __vite__mapDeps([23, 1, 2, 3, 4, 5, 6, 7, 8, 24, 25, 21, 22]),
        ),
    },
    {
      path: `payments/:uuid`,
      name: `AnonymousGuestPayment`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/GuestPayment/Anonymous.vue`),
          __vite__mapDeps([26, 1, 2, 3, 4, 5, 6, 7, 8, 25, 24, 21, 22]),
        ),
    },
    {
      path: `transfer-certificate`,
      name: `TransferCertificate`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/TransferCertificate/Index.vue`),
          __vite__mapDeps([27, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `student/photo`,
      name: `GuestStudentPhoto`,
      meta: {
        showLogo: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/GuestStudentPhoto/Index.vue`),
          __vite__mapDeps([28, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ];
function Hl(e) {
  return kS.getters[`config/config`](e);
}
var Ul = [
    {
      path: `home`,
      name: `Home`,
      meta: {
        isNotNav: !0,
        noPadding: !0,
        label: `home.home`,
        icon: `fas fa-home`,
        permissions: [`post:read`],
        keySearch: !0,
      },
      beforeEnter: (e, t, n) => {
        Hl(`feature.enablePost`) ? n() : n(`/`);
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Post/Index.vue`),
          __vite__mapDeps([29, 1, 2, 3, 4, 5, 6, 7, 8, 30, 31, 10, 11]),
        ),
    },
    {
      path: `dashboard`,
      name: `Dashboard`,
      meta: {
        noPadding: !0,
        label: `dashboard.dashboard`,
        icon: `fas fa-home`,
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Dashboard/Index.vue`),
          __vite__mapDeps([32, 1, 2, 3, 4, 5, 6, 7, 8, 33, 11, 34]),
        ),
    },
    {
      path: `notifications`,
      name: `Notification`,
      meta: {
        isNotNav: !0,
        noPadding: !0,
        label: `notification.notifications`,
        icon: `fas fa-bell`,
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Notification/Index.vue`),
          __vite__mapDeps([35, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Wl = [
    {
      path: `organizations`,
      name: `Organization`,
      redirect: {
        name: `OrganizationList`,
      },
      meta: {
        label: `organization.organization`,
        icon: `fas fa-building`,
        isNotNav: !0,
        hideChildren: !0,
        permissions: [`organization:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `OrganizationList`,
          meta: {
            trans: `global.list`,
            label: `organization.organization`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Organization/Index.vue`),
              __vite__mapDeps([36, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `OrganizationCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `organization.organization`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Organization/Action.vue`),
              __vite__mapDeps([37, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `OrganizationEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `organization.organization`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Organization/Action.vue`),
              __vite__mapDeps([37, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `OrganizationShow`,
          meta: {
            trans: `global.detail`,
            label: `organization.organization`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Organization/Show.vue`),
              __vite__mapDeps([38, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Gl = [
    {
      path: `role`,
      name: `TeamConfigRole`,
      redirect: {
        name: `TeamConfigRoleList`,
      },
      meta: {
        label: `team.config.role.role`,
        icon: `fas fa-user-tag`,
        hideChildren: !0,
        key: `role`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TeamConfigRoleList`,
          meta: {
            trans: `global.list`,
            label: `team.config.role.role`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Config/Role/Index.vue`),
              __vite__mapDeps([39, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `TeamConfigRoleCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `team.config.role.role`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Config/Role/Action.vue`),
              __vite__mapDeps([40, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Kl = [
    {
      path: `permission`,
      name: `TeamConfigPermission`,
      redirect: {
        name: `TeamConfigPermissionAssign`,
      },
      meta: {
        label: `team.config.permission.permission`,
        icon: `fas fa-key`,
        key: `permission`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TeamConfigPermissionAssign`,
          meta: {
            trans: `global.assign`,
            label: `team.config.permission.permission`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Config/Permission/Index.vue`),
              __vite__mapDeps([41, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:module`,
          name: `TeamConfigPermissionAssignModule`,
          meta: {
            trans: `global.assign`,
            label: `team.config.permission.permission`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Config/Permission/Index.vue`),
              __vite__mapDeps([41, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `user-permission`,
      name: `TeamConfigUserPermission`,
      meta: {
        isNotNav: !0,
        label: `team.config.permission.user_permission`,
        icon: `fas fa-key`,
        key: `user-permission`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Team/Config/Permission/User.vue`),
          __vite__mapDeps([42, 1, 2, 3, 4, 5, 6, 7, 8, 43]),
        ),
    },
  ],
  ql = [
    {
      path: `teams`,
      name: `Team`,
      redirect: {
        name: `TeamList`,
      },
      meta: {
        label: `team.team`,
        icon: `fas fa-user-friends`,
        isNotNav: !0,
        hideChildren: !0,
        permissions: [`team:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TeamList`,
          meta: {
            trans: `global.list`,
            label: `team.team`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Index.vue`),
              __vite__mapDeps([44, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `create`,
          name: `TeamCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `team.team`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Action.vue`),
              __vite__mapDeps([46, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TeamEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `team.team`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Action.vue`),
              __vite__mapDeps([46, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TeamShow`,
          meta: {
            trans: `global.detail`,
            label: `team.team`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Show.vue`),
              __vite__mapDeps([47, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/config`,
          name: `TeamConfig`,
          redirect: {
            name: `TeamConfigGeneral`,
          },
          meta: {
            label: `team.team`,
            icon: `fas fa-cog`,
            hideChildren: !0,
            permissions: [`team:manage`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Team/Config/Index.vue`),
              __vite__mapDeps([43, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: `general`,
              name: `TeamConfigGeneral`,
              meta: {
                label: `team.config.general.general`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Team/Config/General/Index.vue`),
                  __vite__mapDeps([48, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `asset`,
              name: `TeamConfigAsset`,
              meta: {
                label: `team.config.asset.asset`,
                icon: `far fa-image`,
                key: `asset`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Team/Config/Asset/Index.vue`),
                  __vite__mapDeps([49, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            ...Gl,
            ...Kl,
          ],
        },
      ],
    },
  ],
  Jl = [
    {
      path: `users`,
      name: `User`,
      redirect: {
        name: `UserList`,
      },
      meta: {
        label: `user.user`,
        icon: `fas fa-users`,
        hideChildren: !0,
        permissions: [`user:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `UserList`,
          meta: {
            trans: `global.list`,
            label: `user.user`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Index.vue`),
              __vite__mapDeps([50, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `UserCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `user.user`,
            permissions: [`user:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Action.vue`),
              __vite__mapDeps([51, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `UserEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `user.user`,
            permissions: [`user:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Action.vue`),
              __vite__mapDeps([51, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `UserShow`,
          meta: {
            trans: `global.detail`,
            label: `user.user`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Show.vue`),
              __vite__mapDeps([52, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `failed-login-attempts`,
      name: `FailedLoginAttempt`,
      meta: {
        roles: [`admin`],
        label: `auth.failed_login_attempt`,
        icon: `fas fa-user-times`,
        isHiddenNav: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/FailedLoginAttempt.vue`),
          __vite__mapDeps([53, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `user/force-change-password`,
      name: `UserForceChangePassword`,
      meta: {
        label: `user.props.force_change_password`,
        icon: `fas fa-user`,
        isNotNav: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/User/ForceChangePassword.vue`),
          __vite__mapDeps([54, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `user`,
      name: `Profile`,
      redirect: {
        name: `UserProfile`,
      },
      meta: {
        label: `user.profile.profile`,
        icon: `fas fa-user`,
        isHiddenNav: !0,
        showOnlyChildren: !0,
        hideChildren: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Layouts/User.vue`),
          __vite__mapDeps([55, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
      children: [
        {
          path: `profile`,
          name: `UserProfile`,
          meta: {
            label: `user.profile.profile`,
            icon: `fas fa-user-circle`,
            isHiddenNav: !1,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Profile/Index.vue`),
              __vite__mapDeps([56, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `account`,
          name: `UserAccount`,
          meta: {
            label: `user.profile.account`,
            icon: `fas fa-user`,
            isHiddenNav: !1,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Profile/Account.vue`),
              __vite__mapDeps([57, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `avatar`,
          name: `UserAvatar`,
          meta: {
            label: `user.avatar`,
            icon: `fas fa-camera`,
            isHiddenNav: !1,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Profile/Avatar.vue`),
              __vite__mapDeps([58, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `preference`,
          name: `UserPreference`,
          meta: {
            label: `user.preference.preference`,
            icon: `fas fa-user-cog`,
            isHiddenNav: !1,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Profile/Preference.vue`),
              __vite__mapDeps([59, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `security`,
          name: `UserSecurity`,
          meta: {
            label: `auth.security.props.code`,
            icon: `fas fa-shield-halved`,
            isHiddenNav: !1,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Profile/Security.vue`),
              __vite__mapDeps([60, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          beforeEnter: (e, t, n) => {
            kS.getters[`config/config`](`auth.enableTwoFactorSecurity`)
              ? n()
              : n({
                  name: `UserProfile`,
                });
          },
        },
        {
          path: `password`,
          name: `UserPassword`,
          meta: {
            label: `auth.password.change_password`,
            icon: `fas fa-key`,
            isHiddenNav: !1,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/User/Profile/Password.vue`),
              __vite__mapDeps([61, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ];
function K(e, t) {
  let n = _.get(window.i18n, e);
  return (
    _.eachRight(t, (e, t) => {
      n = _.replace(n, `:${t}`, e);
    }),
    n
  );
}
function Yl(e, t) {
  let n = _.get(window.i18n, e);
  return (
    _.eachRight(t, (e, t) => {
      n = _.replace(n, `:${t}`, e);
    }),
    n !== void 0
  );
}
var q = (
  e = {
    path: ``,
    prefix: ``,
    label: ``,
    queryType: ``,
    key: ``,
    navs: [],
  },
) => ({
  path: e.path,
  name: `${e.prefix}`,
  redirect: {
    name: `${e.prefix}List`,
  },
  meta: {},
  component: {
    template: `<router-view></router-view>`,
  },
  children: [
    {
      path: ``,
      name: `${e.prefix}List`,
      meta: {
        trans: `global.list`,
        ...e,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Option/Index.vue`),
          __vite__mapDeps([62, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
        ),
    },
    {
      path: `create`,
      name: `${e.prefix}Create`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        ...e,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Option/Action.vue`),
          __vite__mapDeps([64, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:uuid/edit`,
      name: `${e.prefix}Edit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        ...e,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Option/Action.vue`),
          __vite__mapDeps([64, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
});
function Xl(e) {
  return kS.getters[`config/config`](e);
}
var Zl = [
    {
      path: `chat`,
      name: `Chat`,
      meta: {
        isNotNav: !0,
        label: `chat.chat`,
        icon: `fas fa-message`,
        permissions: [`chat:access`],
      },
      beforeEnter: (e, t, n) => {
        Xl(`chat.enableChat`) ? n() : n(`/`);
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Chat/Index.vue`),
          __vite__mapDeps([65, 1, 2, 3, 4, 5, 6, 7, 8, 66]),
        ),
      children: [
        {
          path: `:uuid`,
          name: `ChatMessage`,
          meta: {
            trans: `global.show`,
            label: `chat.chat`,
          },
          component: () =>
            G(
              () => import(`./Message-BpHl-CzX.js`).then((e) => e.t),
              __vite__mapDeps([67, 1, 2, 3, 4, 5, 6, 7, 8, 68]),
            ),
        },
        {
          path: `:uuid/config`,
          name: `ChatConfig`,
          meta: {
            trans: `global.show`,
            label: `chat.chat`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Chat/GroupConfig.vue`),
              __vite__mapDeps([69, 1, 2, 3, 4, 5, 6, 7, 8, 66]),
            ),
        },
      ],
    },
  ],
  Ql = [
    {
      path: `custom-fields`,
      name: `CustomField`,
      redirect: {
        name: `CustomFieldList`,
      },
      meta: {
        moduleName: `customField`,
        label: `custom_field.custom_field`,
        icon: `fas fa-boxes`,
        hideChildren: !0,
        permissions: [`custom-field:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CustomFieldList`,
          meta: {
            trans: `global.list`,
            label: `custom_field.custom_field`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/CustomField/Index.vue`),
              __vite__mapDeps([70, 1, 2, 3, 4, 5, 6, 7, 8, 71]),
            ),
        },
        {
          path: `create`,
          name: `CustomFieldCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `custom_field.custom_field`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/CustomField/Action.vue`),
              __vite__mapDeps([72, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `CustomFieldEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `custom_field.custom_field`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/CustomField/Action.vue`),
              __vite__mapDeps([72, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `CustomFieldDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `custom_field.custom_field`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/CustomField/Action.vue`),
              __vite__mapDeps([72, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `CustomFieldShow`,
          meta: {
            trans: `global.detail`,
            label: `custom_field.custom_field`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/CustomField/Show.vue`),
              __vite__mapDeps([73, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  $l = [
    {
      path: `todos`,
      name: `UtilityTodo`,
      redirect: {
        name: `UtilityTodoList`,
      },
      meta: {
        label: `utility.todo.todo`,
        icon: `far fa-check-square`,
        hideChildren: !0,
        permissions: [`todo:manage`],
        feature: `enableTodo`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `UtilityTodoList`,
          meta: {
            trans: `global.list`,
            label: `utility.todo.todos`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Utility/Todo/Index.vue`),
              __vite__mapDeps([74, 1, 2, 3, 4, 5, 6, 7, 8, 63, 20, 45]),
            ),
        },
        {
          path: `create`,
          name: `UtilityTodoCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `utility.todo.todo`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Utility/Todo/Action.vue`),
              __vite__mapDeps([75, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `UtilityTodoEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `utility.todo.todo`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Utility/Todo/Action.vue`),
              __vite__mapDeps([75, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `UtilityTodoDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `utility.todo.todo`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Utility/Todo/Action.vue`),
              __vite__mapDeps([75, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid`,
          name: `UtilityTodoShow`,
          meta: {
            trans: `global.detail`,
            label: `utility.todo.todo`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Utility/Todo/Show.vue`),
              __vite__mapDeps([76, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  eu = [
    {
      path: `activity-logs`,
      name: `UtilityActivityLog`,
      meta: {
        label: `utility.activity.log`,
        icon: `far fa-file-alt`,
        permissions: [`activity-log:manage`],
        feature: `enableActivityLog`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Utility/ActivityLog/Index.vue`),
          __vite__mapDeps([77, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  tu = [
    {
      path: `utility`,
      name: `Utility`,
      redirect: {
        name: `UtilityTodo`,
      },
      meta: {
        moduleName: `utility`,
        label: `utility.utility`,
        icon: `fas fa-tools`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `UtilityConfig`,
          redirect: {
            name: `UtilityConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`config:store`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Utility/Config/Index.vue`),
              __vite__mapDeps([78, 4, 2]),
            ),
          children: [
            {
              path: ``,
              name: `UtilityConfigIndex`,
              redirect: {
                name: `UtilityConfigGeneral`,
              },
            },
            {
              path: `general`,
              name: `UtilityConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Utility/Config/General.vue`),
                  __vite__mapDeps([79, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `todo-lists`,
              prefix: `UtilityConfigTodoList`,
              queryType: `todo_list`,
              label: `utility.todo.list.list`,
              transKey: `utility.todo.list`,
              navs: [
                {
                  label: K(`utility.todo.todo`),
                  path: `UtilityConfigTodoList`,
                },
                {
                  label: K(`utility.config.config`),
                  path: `UtilityConfig`,
                },
              ],
            }),
          ],
        },
        ...$l,
        ...eu,
      ],
    },
  ],
  nu = [
    {
      path: `mail-template`,
      name: `ConfigMailTemplate`,
      redirect: {
        name: `ConfigMailTemplateList`,
      },
      meta: {
        label: `config.mail.template.template`,
        icon: `fas fa-file-lines`,
        hideChildren: !0,
        key: `mailTemplate`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ConfigMailTemplateList`,
          meta: {
            trans: `global.list`,
            label: `config.mail.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/MailTemplate/Index.vue`),
              __vite__mapDeps([80, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ConfigMailTemplateEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `config.mail.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/MailTemplate/Action.vue`),
              __vite__mapDeps([81, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ConfigMailTemplateShow`,
          meta: {
            trans: `global.detail`,
            label: `config.mail.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/MailTemplate/Show.vue`),
              __vite__mapDeps([82, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ru = [
    {
      path: `sms-template`,
      name: `ConfigSMSTemplate`,
      redirect: {
        name: `ConfigSMSTemplateList`,
      },
      meta: {
        label: `config.sms.template.template`,
        icon: `fas fa-file-lines`,
        hideChildren: !0,
        key: `smsTemplate`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ConfigSMSTemplateList`,
          meta: {
            trans: `global.list`,
            label: `config.sms.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/SMSTemplate/Index.vue`),
              __vite__mapDeps([83, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ConfigSMSTemplateEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `config.sms.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/SMSTemplate/Action.vue`),
              __vite__mapDeps([84, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  iu = [
    {
      path: `whatsapp-template`,
      name: `ConfigWhatsAppTemplate`,
      redirect: {
        name: `ConfigWhatsAppTemplateList`,
      },
      meta: {
        label: `config.whatsapp.template.template`,
        icon: `fas fa-file-lines`,
        hideChildren: !0,
        key: `whatsappTemplate`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ConfigWhatsAppTemplateList`,
          meta: {
            trans: `global.list`,
            label: `config.whatsapp.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/WhatsAppTemplate/Index.vue`),
              __vite__mapDeps([85, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ConfigWhatsAppTemplateEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `config.whatsapp.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/WhatsAppTemplate/Action.vue`),
              __vite__mapDeps([86, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  au = [
    {
      path: `push-notification-template`,
      name: `ConfigPushNotificationTemplate`,
      redirect: {
        name: `ConfigPushNotificationTemplateList`,
      },
      meta: {
        label: `config.push_notification.template.template`,
        icon: `fas fa-file-lines`,
        hideChildren: !0,
        key: `pushNotificationTemplate`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ConfigPushNotificationTemplateList`,
          meta: {
            trans: `global.list`,
            label: `config.push_notification.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/PushNotificationTemplate/Index.vue`),
              __vite__mapDeps([87, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ConfigPushNotificationTemplateEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `config.push_notification.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/PushNotificationTemplate/Action.vue`),
              __vite__mapDeps([88, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ou = [
    {
      path: `module`,
      name: `ConfigModule`,
      meta: {
        label: `config.module.module`,
        icon: `fas fa-boxes-stacked`,
        hideChildren: !0,
        key: `module`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Config/Module/Index.vue`),
          __vite__mapDeps([89, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
        ),
    },
  ],
  su = [
    {
      path: `config`,
      name: `Config`,
      redirect: {
        name: `ConfigGeneral`,
      },
      meta: {
        label: `config.config`,
        icon: `fas fa-cog`,
        permissions: [`config:store`],
        isHiddenNav: !1,
        hideChildren: !1,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `general`,
          name: `ConfigGeneral`,
          meta: {
            label: `config.general.general`,
            icon: `far fa-building`,
            key: `general`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/General/Index.vue`),
              __vite__mapDeps([90, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `asset`,
          name: `ConfigAsset`,
          meta: {
            label: `config.asset.asset`,
            icon: `far fa-images`,
            key: `asset`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/Asset/Index.vue`),
              __vite__mapDeps([91, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `system`,
          name: `ConfigSystem`,
          meta: {
            label: `config.system.system`,
            icon: `fas fa-cogs`,
            key: `system`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/System/Index.vue`),
              __vite__mapDeps([92, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `auth`,
          name: `ConfigAuth`,
          meta: {
            label: `config.auth.auth`,
            icon: `fas fa-sign-in-alt`,
            key: `auth`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/Auth/Index.vue`),
              __vite__mapDeps([93, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `notification`,
          name: `ConfigNotification`,
          meta: {
            label: `config.notification.notification`,
            icon: `fas fa-bell`,
            key: `notification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/Notification/Index.vue`),
              __vite__mapDeps([94, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `mail`,
          name: `ConfigMail`,
          meta: {
            label: `config.mail.mail`,
            icon: `fas fa-envelope`,
            key: `mail`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/Mail/Index.vue`),
              __vite__mapDeps([95, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `sms`,
          name: `ConfigSMS`,
          meta: {
            label: `config.sms.sms`,
            icon: `fas fa-message`,
            key: `sms`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/SMS/Index.vue`),
              __vite__mapDeps([96, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `whatsapp`,
          name: `ConfigWhatsApp`,
          meta: {
            label: `config.whatsapp.whatsapp`,
            icon: `fas fa-message`,
            key: `whatsapp`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/WhatsApp/Index.vue`),
              __vite__mapDeps([97, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        ...nu,
        ...ru,
        ...iu,
        ...au,
        {
          path: `feature`,
          name: `ConfigFeature`,
          meta: {
            label: `config.feature.feature`,
            icon: `fas fa-list`,
            key: `feature`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/Feature/Index.vue`),
              __vite__mapDeps([98, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `chat`,
          name: `ConfigChat`,
          meta: {
            label: `config.chat.chat`,
            icon: `fas fa-comment`,
            key: `chat`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/Chat/Index.vue`),
              __vite__mapDeps([99, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        ...ou,
        {
          path: `social-network`,
          name: `ConfigSocialNetwork`,
          meta: {
            label: `config.social.social`,
            icon: `fas fa-share-alt`,
            key: `social-network`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/SocialNetwork/Index.vue`),
              __vite__mapDeps([100, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `terminology`,
          name: `ConfigTerminology`,
          meta: {
            label: `config.terminology.terminology`,
            icon: `fas fa-language`,
            key: `terminology`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Config/Terminology/Index.vue`),
              __vite__mapDeps([101, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  cu = [
    {
      path: `reminders`,
      name: `Reminder`,
      redirect: {
        name: `ReminderList`,
      },
      meta: {
        isNotNav: !0,
        label: `reminder.reminder`,
        icon: `fas fa-bell`,
        hideChildren: !0,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ReminderList`,
          meta: {
            trans: `global.list`,
            label: `reminder.reminders`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reminder/Index.vue`),
              __vite__mapDeps([102, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ReminderCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `reminder.reminder`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reminder/Action.vue`),
              __vite__mapDeps([103, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ReminderEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `reminder.reminder`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reminder/Action.vue`),
              __vite__mapDeps([103, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ReminderDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `reminder.reminder`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reminder/Action.vue`),
              __vite__mapDeps([103, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ReminderShow`,
          meta: {
            trans: `global.detail`,
            label: `reminder.reminder`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reminder/Show.vue`),
              __vite__mapDeps([104, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  lu = [
    {
      path: `bulk-upload/action`,
      name: `BulkUploadAction`,
      meta: {
        isNotNav: !0,
        label: `bulk_action`,
        icon: `fas fa-upload`,
        roles: [`admin`],
        keySearch: !1,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/General/BulkUpload/Action.vue`),
          __vite__mapDeps([105, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  uu = [
    {
      path: `support`,
      name: `Support`,
      meta: {
        isNotNav: !0,
        label: `general.support`,
        icon: `fas fa-headset`,
        hideChildren: !0,
        superAdmin: !0,
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Support/Index.vue`),
          __vite__mapDeps([106, 4, 2, 5]),
        ),
    },
  ],
  du = [
    {
      path: `subscriptions`,
      name: `Subscription`,
      redirect: {
        name: `SubscriptionList`,
      },
      meta: {
        label: `saas.subscription.subscription`,
        icon: `fas fa-credit-cards`,
        isNotNav: !0,
        hideChildren: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `SubscriptionList`,
          meta: {
            trans: `global.list`,
            label: `saas.subscription.subscription`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Subscription/Index.vue`),
              __vite__mapDeps([107, 1, 2, 3, 4, 5, 6, 7, 8, 22]),
            ),
        },
      ],
    },
  ],
  fu = [
    {
      path: `enquiries`,
      name: `ReceptionEnquiry`,
      redirect: {
        name: `ReceptionEnquiryList`,
      },
      meta: {
        label: `reception.enquiry.enquiry`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`enquiry:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ReceptionEnquiryList`,
          meta: {
            trans: `global.list`,
            label: `reception.enquiry.enquiries`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Enquiry/Index.vue`),
              __vite__mapDeps([108, 1, 2, 3, 4, 5, 6, 7, 8, 71, 20, 45]),
            ),
        },
        {
          path: `create`,
          name: `ReceptionEnquiryCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `reception.enquiry.enquiry`,
            permissions: [`enquiry:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Enquiry/Action.vue`),
              __vite__mapDeps([109, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ReceptionEnquiryEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `reception.enquiry.enquiry`,
            permissions: [`enquiry:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Enquiry/Action.vue`),
              __vite__mapDeps([109, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/wizard`,
          name: `ReceptionEnquiryWizard`,
          meta: {
            type: `wizard`,
            action: `update`,
            trans: `global.edit`,
            label: `reception.enquiry.enquiry`,
            permissions: [`enquiry:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Enquiry/Wizard.vue`),
              __vite__mapDeps([110, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ReceptionEnquiryDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `reception.enquiry.enquiry`,
            permissions: [`enquiry:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Enquiry/Action.vue`),
              __vite__mapDeps([109, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid`,
          name: `ReceptionEnquiryShow`,
          meta: {
            trans: `global.detail`,
            label: `reception.enquiry.enquiry`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Enquiry/Show.vue`),
              __vite__mapDeps([111, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  pu = [
    {
      path: `visitor-logs`,
      name: `ReceptionVisitorLog`,
      redirect: {
        name: `ReceptionVisitorLogList`,
      },
      meta: {
        label: `reception.visitor_log.visitor_log`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`visitor-log:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ReceptionVisitorLogList`,
          meta: {
            trans: `global.list`,
            label: `reception.visitor_log.visitor_logs`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/VisitorLog/Index.vue`),
              __vite__mapDeps([112, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ReceptionVisitorLogCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `reception.visitor_log.visitor_log`,
            permissions: [`visitor-log:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/VisitorLog/Action.vue`),
              __vite__mapDeps([113, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ReceptionVisitorLogEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `reception.visitor_log.visitor_log`,
            permissions: [`visitor-log:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/VisitorLog/Action.vue`),
              __vite__mapDeps([113, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ReceptionVisitorLogDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `reception.visitor_log.visitor_log`,
            permissions: [`visitor-log:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/VisitorLog/Action.vue`),
              __vite__mapDeps([113, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ReceptionVisitorLogShow`,
          meta: {
            trans: `global.detail`,
            label: `reception.visitor_log.visitor_log`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/VisitorLog/Show.vue`),
              __vite__mapDeps([114, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  mu = [
    {
      path: `gate-passes`,
      name: `ReceptionGatePass`,
      redirect: {
        name: `ReceptionGatePassList`,
      },
      meta: {
        label: `reception.gate_pass.gate_pass`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`gate-pass:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ReceptionGatePassList`,
          meta: {
            trans: `global.list`,
            label: `reception.gate_pass.gate_passes`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/GatePass/Index.vue`),
              __vite__mapDeps([115, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ReceptionGatePassCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `reception.gate_pass.gate_pass`,
            permissions: [`gate-pass:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/GatePass/Action.vue`),
              __vite__mapDeps([116, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ReceptionGatePassEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `reception.gate_pass.gate_pass`,
            permissions: [`gate-pass:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/GatePass/Action.vue`),
              __vite__mapDeps([116, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ReceptionGatePassDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `reception.gate_pass.gate_pass`,
            permissions: [`gate-pass:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/GatePass/Action.vue`),
              __vite__mapDeps([116, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ReceptionGatePassShow`,
          meta: {
            trans: `global.detail`,
            label: `reception.gate_pass.gate_pass`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/GatePass/Show.vue`),
              __vite__mapDeps([117, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  hu = [
    {
      path: `complaints`,
      name: `ReceptionComplaint`,
      redirect: {
        name: `ReceptionComplaintList`,
      },
      meta: {
        label: `reception.complaint.complaint`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`complaint:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ReceptionComplaintList`,
          meta: {
            trans: `global.list`,
            label: `reception.complaint.complaints`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Complaint/Index.vue`),
              __vite__mapDeps([118, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ReceptionComplaintCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `reception.complaint.complaint`,
            permissions: [`complaint:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Complaint/Action.vue`),
              __vite__mapDeps([119, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ReceptionComplaintEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `reception.complaint.complaint`,
            permissions: [`complaint:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Complaint/Action.vue`),
              __vite__mapDeps([119, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ReceptionComplaintDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `reception.complaint.complaint`,
            permissions: [`complaint:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Complaint/Action.vue`),
              __vite__mapDeps([119, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ReceptionComplaintShow`,
          meta: {
            trans: `global.detail`,
            label: `reception.complaint.complaint`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Complaint/Show.vue`),
              __vite__mapDeps([120, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  J = [
    {
      path: `call-logs`,
      name: `ReceptionCallLog`,
      redirect: {
        name: `ReceptionCallLogList`,
      },
      meta: {
        label: `reception.call_log.call_log`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`call-log:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ReceptionCallLogList`,
          meta: {
            trans: `global.list`,
            label: `reception.call_log.call_logs`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/CallLog/Index.vue`),
              __vite__mapDeps([121, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ReceptionCallLogCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `reception.call_log.call_log`,
            permissions: [`call-log:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/CallLog/Action.vue`),
              __vite__mapDeps([122, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ReceptionCallLogEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `reception.call_log.call_log`,
            permissions: [`call-log:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/CallLog/Action.vue`),
              __vite__mapDeps([122, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ReceptionCallLogDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `reception.call_log.call_log`,
            permissions: [`call-log:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/CallLog/Action.vue`),
              __vite__mapDeps([122, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ReceptionCallLogShow`,
          meta: {
            trans: `global.detail`,
            label: `reception.call_log.call_log`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/CallLog/Show.vue`),
              __vite__mapDeps([123, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  gu = [
    {
      path: `correspondences`,
      name: `ReceptionCorrespondence`,
      redirect: {
        name: `ReceptionCorrespondenceList`,
      },
      meta: {
        label: `reception.correspondence.correspondence`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`correspondence:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ReceptionCorrespondenceList`,
          meta: {
            trans: `global.list`,
            label: `reception.correspondence.correspondences`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Correspondence/Index.vue`),
              __vite__mapDeps([124, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ReceptionCorrespondenceCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `reception.correspondence.correspondence`,
            permissions: [`correspondence:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Correspondence/Action.vue`),
              __vite__mapDeps([125, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ReceptionCorrespondenceEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `reception.correspondence.correspondence`,
            permissions: [`correspondence:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Correspondence/Action.vue`),
              __vite__mapDeps([125, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ReceptionCorrespondenceDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `reception.correspondence.correspondence`,
            permissions: [`correspondence:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Correspondence/Action.vue`),
              __vite__mapDeps([125, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ReceptionCorrespondenceShow`,
          meta: {
            trans: `global.detail`,
            label: `reception.correspondence.correspondence`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Correspondence/Show.vue`),
              __vite__mapDeps([126, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  _u = [
    {
      path: `queries`,
      name: `ReceptionQuery`,
      redirect: {
        name: `ReceptionQueryList`,
      },
      meta: {
        label: `reception.query.query`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`query:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ReceptionQueryList`,
          meta: {
            trans: `global.list`,
            label: `reception.query.queries`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Query/Index.vue`),
              __vite__mapDeps([127, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ReceptionQueryShow`,
          meta: {
            trans: `global.detail`,
            label: `reception.query.query`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Query/Show.vue`),
              __vite__mapDeps([128, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  vu = [
    {
      path: `reception`,
      name: `Reception`,
      redirect: {
        name: `ReceptionCorrespondence`,
      },
      meta: {
        moduleName: `reception`,
        label: `reception.reception`,
        icon: `fas fa-couch`,
        permissions: [
          `reception:config`,
          `enquiry:read`,
          `visitor-log:read`,
          `gate-pass:read`,
          `complaint:read`,
          `call-log:read`,
          `correspondence:read`,
          `query:read`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `ReceptionConfig`,
          redirect: {
            name: `ReceptionConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`reception:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Reception/Config/Index.vue`),
              __vite__mapDeps([129, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `ReceptionConfigGeneral`,
              meta: {
                label: `reception.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Reception/Config/General.vue`),
                  __vite__mapDeps([130, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `enquiry-stage`,
              prefix: `ReceptionConfigEnquiryStage`,
              queryType: `enquiry_stage`,
              label: `reception.enquiry.stage.stage`,
              transKey: `reception.enquiry.stage`,
              navs: [
                {
                  label: K(`reception.reception`),
                  path: `ReceptionEnquiryList`,
                },
                {
                  label: K(`reception.config.config`),
                  path: `ReceptionConfig`,
                },
              ],
            }),
            q({
              path: `enquiry-type`,
              prefix: `ReceptionConfigEnquiryType`,
              queryType: `enquiry_type`,
              label: `reception.enquiry.type.type`,
              transKey: `reception.enquiry.type`,
              navs: [
                {
                  label: K(`reception.reception`),
                  path: `ReceptionEnquiryList`,
                },
                {
                  label: K(`reception.config.config`),
                  path: `ReceptionConfig`,
                },
              ],
            }),
            q({
              path: `enquiry-source`,
              prefix: `ReceptionConfigEnquirySource`,
              queryType: `enquiry_source`,
              label: `reception.enquiry.source.source`,
              transKey: `reception.enquiry.source`,
              navs: [
                {
                  label: K(`reception.reception`),
                  path: `ReceptionEnquiryList`,
                },
                {
                  label: K(`reception.config.config`),
                  path: `ReceptionConfig`,
                },
              ],
            }),
            q({
              path: `visiting-purpose`,
              prefix: `ReceptionConfigVisitingPurpose`,
              queryType: `visiting_purpose`,
              label: `reception.visitor_log.purpose.purpose`,
              transKey: `reception.visitor_log.purpose`,
              navs: [
                {
                  label: K(`reception.reception`),
                  path: `ReceptionEnquiryList`,
                },
                {
                  label: K(`reception.config.config`),
                  path: `ReceptionConfig`,
                },
              ],
            }),
            q({
              path: `gate-pass-purpose`,
              prefix: `ReceptionConfigGatePassPurpose`,
              queryType: `gate_pass_purpose`,
              label: `reception.gate_pass.purpose.purpose`,
              transKey: `reception.gate_pass.purpose`,
              navs: [
                {
                  label: K(`reception.reception`),
                  path: `ReceptionEnquiryList`,
                },
                {
                  label: K(`reception.config.config`),
                  path: `ReceptionConfig`,
                },
              ],
            }),
            q({
              path: `complaint-type`,
              prefix: `ReceptionConfigComplaintType`,
              queryType: `complaint_type`,
              label: `reception.complaint.type.type`,
              transKey: `reception.complaint.type`,
              navs: [
                {
                  label: K(`reception.reception`),
                  path: `ReceptionComplaintList`,
                },
                {
                  label: K(`reception.config.config`),
                  path: `ReceptionConfig`,
                },
              ],
            }),
            q({
              path: `calling-purpose`,
              prefix: `ReceptionConfigCallingPurpose`,
              queryType: `calling_purpose`,
              label: `reception.call_log.purpose.purpose`,
              transKey: `reception.call_log.purpose`,
              navs: [
                {
                  label: K(`reception.reception`),
                  path: `ReceptionEnquiryList`,
                },
                {
                  label: K(`reception.config.config`),
                  path: `ReceptionConfig`,
                },
              ],
            }),
          ],
        },
        ...fu,
        ...pu,
        ...mu,
        ...hu,
        ...J,
        ...gu,
        ..._u,
      ],
    },
  ],
  yu = [
    {
      path: `departments`,
      name: `AcademicDepartment`,
      redirect: {
        name: `AcademicDepartmentList`,
      },
      meta: {
        label: `academic.department.department`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        keySearchLabel: `academic.department.academic_department`,
        permissions: [`academic-department:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicDepartmentList`,
          meta: {
            trans: `global.list`,
            label: `academic.department.departments`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Department/Index.vue`),
              __vite__mapDeps([131, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `AcademicDepartmentCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.department.department`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Department/Action.vue`),
              __vite__mapDeps([132, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicDepartmentEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.department.department`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Department/Action.vue`),
              __vite__mapDeps([132, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicDepartmentDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.department.department`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Department/Action.vue`),
              __vite__mapDeps([132, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicDepartmentShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.department.department`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Department/Show.vue`),
              __vite__mapDeps([133, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  bu = [
    {
      path: `department-incharges`,
      name: `AcademicDepartmentIncharge`,
      redirect: {
        name: `AcademicDepartmentInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.department_incharge.department_incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`academic-department:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicDepartmentInchargeList`,
          meta: {
            trans: `global.list`,
            label: `academic.department_incharge.department_incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DepartmentIncharge/Index.vue`),
              __vite__mapDeps([134, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `assign`,
          name: `AcademicDepartmentInchargeAssign`,
          meta: {
            trans: `global.assign`,
            label: `academic.department_incharge.department_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DepartmentIncharge/Assign.vue`),
              __vite__mapDeps([135, 4, 2]),
            ),
        },
        {
          path: `create`,
          name: `AcademicDepartmentInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.department_incharge.department_incharge`,
            permissions: [`department-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DepartmentIncharge/Action.vue`),
              __vite__mapDeps([136, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicDepartmentInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.department_incharge.department_incharge`,
            permissions: [`department-incharge:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DepartmentIncharge/Action.vue`),
              __vite__mapDeps([136, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicDepartmentInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.department_incharge.department_incharge`,
            permissions: [`department-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DepartmentIncharge/Action.vue`),
              __vite__mapDeps([136, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicDepartmentInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.department_incharge.department_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DepartmentIncharge/Show.vue`),
              __vite__mapDeps([137, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  xu = [
    {
      path: `program-types`,
      name: `AcademicProgramType`,
      redirect: {
        name: `AcademicProgramTypeList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.program_type.program_type`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`program:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicProgramTypeList`,
          meta: {
            trans: `global.list`,
            label: `academic.program_type.program_types`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramType/Index.vue`),
              __vite__mapDeps([138, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicProgramTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.program_type.program_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramType/Action.vue`),
              __vite__mapDeps([139, 1, 2, 3, 4, 5, 6, 7, 8, 140]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicProgramTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.program_type.program_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramType/Action.vue`),
              __vite__mapDeps([139, 1, 2, 3, 4, 5, 6, 7, 8, 140]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicSessionDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.program_type.program_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramType/Action.vue`),
              __vite__mapDeps([139, 1, 2, 3, 4, 5, 6, 7, 8, 140]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicProgramTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.program_type.program_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramType/Show.vue`),
              __vite__mapDeps([141, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Su = [
    {
      path: `programs`,
      name: `AcademicProgram`,
      redirect: {
        name: `AcademicProgramList`,
      },
      meta: {
        label: `academic.program.program`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`program:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicProgramList`,
          meta: {
            trans: `global.list`,
            label: `academic.program.programs`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Program/Index.vue`),
              __vite__mapDeps([142, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `AcademicProgramCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.program.program`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Program/Action.vue`),
              __vite__mapDeps([143, 1, 2, 3, 4, 5, 6, 7, 8, 140]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicProgramEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.program.program`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Program/Action.vue`),
              __vite__mapDeps([143, 1, 2, 3, 4, 5, 6, 7, 8, 140]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicProgramDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.program.program`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Program/Action.vue`),
              __vite__mapDeps([143, 1, 2, 3, 4, 5, 6, 7, 8, 140]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicProgramShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.program.program`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Program/Show.vue`),
              __vite__mapDeps([144, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Cu = [
    {
      path: `program-incharges`,
      name: `AcademicProgramIncharge`,
      redirect: {
        name: `AcademicProgramInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.program_incharge.program_incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`program:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicProgramInchargeList`,
          meta: {
            trans: `global.list`,
            label: `academic.program_incharge.program_incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramIncharge/Index.vue`),
              __vite__mapDeps([145, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `assign`,
          name: `AcademicProgramInchargeAssign`,
          meta: {
            trans: `global.assign`,
            label: `academic.program_incharge.program_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramIncharge/Assign.vue`),
              __vite__mapDeps([146, 4, 2]),
            ),
        },
        {
          path: `create`,
          name: `AcademicProgramInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.program_incharge.program_incharge`,
            permissions: [`program-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramIncharge/Action.vue`),
              __vite__mapDeps([147, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicProgramInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.program_incharge.program_incharge`,
            permissions: [`program-incharge:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramIncharge/Action.vue`),
              __vite__mapDeps([147, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicProgramInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.program_incharge.program_incharge`,
            permissions: [`program-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramIncharge/Action.vue`),
              __vite__mapDeps([147, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicProgramInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.program_incharge.program_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ProgramIncharge/Show.vue`),
              __vite__mapDeps([148, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  wu = [
    {
      path: `sessions`,
      name: `AcademicSession`,
      redirect: {
        name: `AcademicSessionList`,
      },
      meta: {
        label: `academic.session.session`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`session:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicSessionList`,
          meta: {
            trans: `global.list`,
            label: `academic.session.sessions`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Session/Index.vue`),
              __vite__mapDeps([149, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicSessionCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.session.session`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Session/Action.vue`),
              __vite__mapDeps([150, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicSessionEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.session.session`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Session/Action.vue`),
              __vite__mapDeps([150, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicSessionDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.session.session`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Session/Action.vue`),
              __vite__mapDeps([150, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicSessionShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.session.session`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Session/Show.vue`),
              __vite__mapDeps([151, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Tu = [
    {
      path: `periods`,
      name: `AcademicPeriod`,
      redirect: {
        name: `AcademicPeriodList`,
      },
      meta: {
        label: `academic.period.period`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`period:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicPeriodList`,
          meta: {
            trans: `global.list`,
            label: `academic.period.periods`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Period/Index.vue`),
              __vite__mapDeps([152, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicPeriodCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.period.period`,
            permissions: [`period:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Period/Action.vue`),
              __vite__mapDeps([153, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicPeriodEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.period.period`,
            permissions: [`period:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Period/Action.vue`),
              __vite__mapDeps([153, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicPeriodDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.period.period`,
            permissions: [`period:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Period/Action.vue`),
              __vite__mapDeps([153, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicPeriodShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.period.period`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Period/Show.vue`),
              __vite__mapDeps([154, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Eu = [
    {
      path: `divisions`,
      name: `AcademicDivision`,
      redirect: {
        name: `AcademicDivisionList`,
      },
      meta: {
        label: `academic.division.division`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`division:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicDivisionList`,
          meta: {
            trans: `global.list`,
            label: `academic.division.divisions`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Division/Index.vue`),
              __vite__mapDeps([155, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `AcademicDivisionCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.division.division`,
            permissions: [`division:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Division/Action.vue`),
              __vite__mapDeps([156, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicDivisionEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.division.division`,
            permissions: [`division:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Division/Action.vue`),
              __vite__mapDeps([156, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicDivisionDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.division.division`,
            permissions: [`division:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Division/Action.vue`),
              __vite__mapDeps([156, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicDivisionShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.division.division`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Division/Show.vue`),
              __vite__mapDeps([157, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Du = [
    {
      path: `division-incharges`,
      name: `AcademicDivisionIncharge`,
      redirect: {
        name: `AcademicDivisionInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.division_incharge.division_incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`division-incharge:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicDivisionInchargeList`,
          meta: {
            trans: `global.list`,
            label: `academic.division_incharge.division_incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DivisionIncharge/Index.vue`),
              __vite__mapDeps([158, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `assign`,
          name: `AcademicDivisionInchargeAssign`,
          meta: {
            trans: `global.assign`,
            label: `academic.division_incharge.division_incharge`,
            permissions: [`division-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DivisionIncharge/Assign.vue`),
              __vite__mapDeps([159, 4, 2]),
            ),
        },
        {
          path: `create`,
          name: `AcademicDivisionInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.division_incharge.division_incharge`,
            permissions: [`division-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DivisionIncharge/Action.vue`),
              __vite__mapDeps([160, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicDivisionInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.division_incharge.division_incharge`,
            permissions: [`division-incharge:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DivisionIncharge/Action.vue`),
              __vite__mapDeps([160, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicDivisionInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.division_incharge.division_incharge`,
            permissions: [`division-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DivisionIncharge/Action.vue`),
              __vite__mapDeps([160, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicDivisionInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.division_incharge.division_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/DivisionIncharge/Show.vue`),
              __vite__mapDeps([161, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ou = [
    {
      path: `courses`,
      name: `AcademicCourse`,
      redirect: {
        name: `AcademicCourseList`,
      },
      meta: {
        label: `academic.course.course`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`course:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicCourseList`,
          meta: {
            trans: `global.list`,
            label: `academic.course.courses`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Course/Index.vue`),
              __vite__mapDeps([162, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `AcademicCourseCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.course.course`,
            permissions: [`course:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Course/Action.vue`),
              __vite__mapDeps([163, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicCourseEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.course.course`,
            permissions: [`course:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Course/Action.vue`),
              __vite__mapDeps([163, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicCourseDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.course.course`,
            permissions: [`course:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Course/Action.vue`),
              __vite__mapDeps([163, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicCourseShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.course.course`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Course/Show.vue`),
              __vite__mapDeps([164, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ku = [
    {
      path: `course-incharges`,
      name: `AcademicCourseIncharge`,
      redirect: {
        name: `AcademicCourseInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.course_incharge.course_incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`course-incharge:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicCourseInchargeList`,
          meta: {
            trans: `global.list`,
            label: `academic.course_incharge.course_incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CourseIncharge/Index.vue`),
              __vite__mapDeps([165, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `assign`,
          name: `AcademicCourseInchargeAssign`,
          meta: {
            trans: `global.assign`,
            label: `academic.course_incharge.course_incharge`,
            permissions: [`course-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CourseIncharge/Assign.vue`),
              __vite__mapDeps([166, 4, 2]),
            ),
        },
        {
          path: `create`,
          name: `AcademicCourseInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.course_incharge.course_incharge`,
            permissions: [`course-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CourseIncharge/Action.vue`),
              __vite__mapDeps([167, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicCourseInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.course_incharge.course_incharge`,
            permissions: [`course-incharge:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CourseIncharge/Action.vue`),
              __vite__mapDeps([167, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicCourseInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.course_incharge.course_incharge`,
            permissions: [`course-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CourseIncharge/Action.vue`),
              __vite__mapDeps([167, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicCourseInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.course_incharge.course_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CourseIncharge/Show.vue`),
              __vite__mapDeps([168, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Au = [
    {
      path: `enrollment-seats`,
      name: `AcademicEnrollmentSeat`,
      redirect: {
        name: `AcademicEnrollmentSeatList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.enrollment_seat.enrollment_seat`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`course:read`, `course:create`, `course:edit`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicEnrollmentSeatList`,
          meta: {
            trans: `global.list`,
            label: `academic.enrollment_seat.enrollment_seats`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/EnrollmentSeat/Index.vue`),
              __vite__mapDeps([169, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicEnrollmentSeatCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.enrollment_seat.enrollment_seat`,
            permissions: [`course:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/EnrollmentSeat/Action.vue`),
              __vite__mapDeps([170, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicEnrollmentSeatEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.enrollment_seat.enrollment_seat`,
            permissions: [`course:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/EnrollmentSeat/Action.vue`),
              __vite__mapDeps([170, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicEnrollmentSeatDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.enrollment_seat.enrollment_seat`,
            permissions: [`course:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/EnrollmentSeat/Action.vue`),
              __vite__mapDeps([170, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicEnrollmentSeatShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.enrollment_seat.enrollment_seat`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/EnrollmentSeat/Show.vue`),
              __vite__mapDeps([171, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ju = [
    {
      path: `batches`,
      name: `AcademicBatch`,
      redirect: {
        name: `AcademicBatchList`,
      },
      meta: {
        label: `academic.batch.batch`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`batch:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicBatchList`,
          meta: {
            trans: `global.list`,
            label: `academic.batch.batches`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Batch/Index.vue`),
              __vite__mapDeps([172, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `AcademicBatchCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.batch.batch`,
            permissions: [`batch:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Batch/Action.vue`),
              __vite__mapDeps([173, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicBatchEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.batch.batch`,
            permissions: [`batch:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Batch/Action.vue`),
              __vite__mapDeps([173, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicBatchDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.batch.batch`,
            permissions: [`batch:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Batch/Action.vue`),
              __vite__mapDeps([173, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicBatchShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.batch.batch`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Batch/Show.vue`),
              __vite__mapDeps([174, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Mu = [
    {
      path: `batch-incharges`,
      name: `AcademicBatchIncharge`,
      redirect: {
        name: `AcademicBatchInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.batch_incharge.batch_incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`batch-incharge:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicBatchInchargeList`,
          meta: {
            trans: `global.list`,
            label: `academic.batch_incharge.batch_incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BatchIncharge/Index.vue`),
              __vite__mapDeps([175, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `assign`,
          name: `AcademicBatchInchargeAssign`,
          meta: {
            trans: `global.assign`,
            label: `academic.batch_incharge.batch_incharge`,
            permissions: [`batch-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BatchIncharge/Assign.vue`),
              __vite__mapDeps([176, 4, 2]),
            ),
        },
        {
          path: `create`,
          name: `AcademicBatchInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.batch_incharge.batch_incharge`,
            permissions: [`batch-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BatchIncharge/Action.vue`),
              __vite__mapDeps([177, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicBatchInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.batch_incharge.batch_incharge`,
            permissions: [`batch-incharge:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BatchIncharge/Action.vue`),
              __vite__mapDeps([177, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicBatchInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.batch_incharge.batch_incharge`,
            permissions: [`batch-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BatchIncharge/Action.vue`),
              __vite__mapDeps([177, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicBatchInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.batch_incharge.batch_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BatchIncharge/Show.vue`),
              __vite__mapDeps([178, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Nu = [
    {
      path: `subjects`,
      name: `AcademicSubject`,
      redirect: {
        name: `AcademicSubjectList`,
      },
      meta: {
        label: `academic.subject.subject`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`subject:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicSubjectList`,
          meta: {
            trans: `global.list`,
            label: `academic.subject.subjects`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Subject/Index.vue`),
              __vite__mapDeps([179, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `AcademicSubjectCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.subject.subject`,
            permissions: [`subject:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Subject/Action.vue`),
              __vite__mapDeps([180, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicSubjectEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.subject.subject`,
            permissions: [`subject:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Subject/Action.vue`),
              __vite__mapDeps([180, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicSubjectDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.subject.subject`,
            permissions: [`subject:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Subject/Action.vue`),
              __vite__mapDeps([180, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicSubjectShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.subject.subject`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Subject/Show.vue`),
              __vite__mapDeps([181, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Pu = [
    {
      path: `subject-incharges`,
      name: `AcademicSubjectIncharge`,
      redirect: {
        name: `AcademicSubjectInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.subject_incharge.subject_incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`subject-incharge:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicSubjectInchargeList`,
          meta: {
            trans: `global.list`,
            label: `academic.subject_incharge.subject_incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/SubjectIncharge/Index.vue`),
              __vite__mapDeps([182, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `assign`,
          name: `AcademicSubjectInchargeAssign`,
          meta: {
            trans: `global.assign`,
            label: `academic.subject_incharge.subject_incharge`,
            permissions: [`subject-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/SubjectIncharge/Assign.vue`),
              __vite__mapDeps([183, 4, 2]),
            ),
        },
        {
          path: `create`,
          name: `AcademicSubjectInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.subject_incharge.subject_incharge`,
            permissions: [`subject-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/SubjectIncharge/Action.vue`),
              __vite__mapDeps([184, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicSubjectInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.subject_incharge.subject_incharge`,
            permissions: [`subject-incharge:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/SubjectIncharge/Action.vue`),
              __vite__mapDeps([184, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicSubjectInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.subject_incharge.subject_incharge`,
            permissions: [`subject-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/SubjectIncharge/Action.vue`),
              __vite__mapDeps([184, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicSubjectInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.subject_incharge.subject_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/SubjectIncharge/Show.vue`),
              __vite__mapDeps([185, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Fu = [
    {
      path: `class-timings`,
      name: `AcademicClassTiming`,
      redirect: {
        name: `AcademicClassTimingList`,
      },
      meta: {
        label: `academic.class_timing.class_timing`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`class-timing:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicClassTimingList`,
          meta: {
            trans: `global.list`,
            label: `academic.class_timing.class_timings`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ClassTiming/Index.vue`),
              __vite__mapDeps([186, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicClassTimingCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.class_timing.class_timing`,
            permissions: [`class-timing:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ClassTiming/Action.vue`),
              __vite__mapDeps([187, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicClassTimingEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.class_timing.class_timing`,
            permissions: [`class-timing:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ClassTiming/Action.vue`),
              __vite__mapDeps([187, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicClassTimingDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.class_timing.class_timing`,
            permissions: [`class-timing:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ClassTiming/Action.vue`),
              __vite__mapDeps([187, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicClassTimingShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.class_timing.class_timing`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/ClassTiming/Show.vue`),
              __vite__mapDeps([188, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Iu = [
    {
      path: `timetables`,
      name: `AcademicTimetable`,
      redirect: {
        name: `AcademicTimetableList`,
      },
      meta: {
        label: `academic.timetable.timetable`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`timetable:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicTimetableList`,
          meta: {
            trans: `global.list`,
            label: `academic.timetable.timetables`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Timetable/Index.vue`),
              __vite__mapDeps([189, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `create`,
          name: `AcademicTimetableCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.timetable.timetable`,
            permissions: [`timetable:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Timetable/Action.vue`),
              __vite__mapDeps([190, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicTimetableEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.timetable.timetable`,
            permissions: [`timetable:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Timetable/Action.vue`),
              __vite__mapDeps([190, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicTimetableDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.timetable.timetable`,
            permissions: [`timetable:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Timetable/Action.vue`),
              __vite__mapDeps([190, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/allocation`,
          name: `AcademicTimetableAllocation`,
          meta: {
            permissions: [`timetable:allocate`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Timetable/Allocation.vue`),
              __vite__mapDeps([191, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicTimetableShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.timetable.timetable`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Timetable/Show.vue`),
              __vite__mapDeps([192, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `timetable`,
      name: `AcademicTimetableIndex`,
      redirect: {
        name: `AcademicTimetableGroupList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.timetable.timetable`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`timetable:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `groups`,
          name: `AcademicTimetableGroup`,
          redirect: {
            name: `AcademicTimetableGroupList`,
          },
          meta: {
            label: `academic.timetable.group.group`,
            icon: `fas fa-right-long`,
            hideChildren: !0,
            keySearch: !0,
            permissions: [`timetable:read`],
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `AcademicTimetableGroupList`,
              meta: {
                trans: `global.list`,
                label: `academic.timetable.group.groups`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Academic/Timetable/Group/Index.vue`),
                  __vite__mapDeps([193, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `create`,
              name: `AcademicTimetableGroupCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `academic.timetable.group.group`,
                permissions: [`timetable:create`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Academic/Timetable/Group/Action.vue`),
                  __vite__mapDeps([194, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/edit`,
              name: `AcademicTimetableGroupEdit`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `academic.timetable.group.group`,
                permissions: [`timetable:edit`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Academic/Timetable/Group/Action.vue`),
                  __vite__mapDeps([194, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid`,
              name: `AcademicTimetableGroupShow`,
              meta: {
                trans: `global.detail`,
                label: `academic.timetable.group.group`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Academic/Timetable/Group/Show.vue`),
                  __vite__mapDeps([195, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: `teacher`,
          name: `AcademicTeacherTimetableIndex`,
          meta: {
            trans: `global.list`,
            label: `academic.timetable.teacher_timetable`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Timetable/Teacher/Index.vue`),
              __vite__mapDeps([196, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Lu = [
    {
      path: `book-lists`,
      name: `AcademicBookList`,
      redirect: {
        name: `AcademicBookListList`,
      },
      meta: {
        label: `academic.book_list.book_list`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`book-list:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicBookListList`,
          meta: {
            trans: `global.list`,
            label: `academic.book_list.book_lists`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BookList/Index.vue`),
              __vite__mapDeps([197, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicBookListCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.book_list.book_list`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BookList/Action.vue`),
              __vite__mapDeps([198, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicBookListEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.book_list.book_list`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BookList/Action.vue`),
              __vite__mapDeps([198, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicBookListDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.book_list.book_list`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BookList/Action.vue`),
              __vite__mapDeps([198, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicBookListShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.book_list.book_list`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/BookList/Show.vue`),
              __vite__mapDeps([199, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ru = [
    {
      path: `certificate-templates`,
      name: `AcademicCertificateTemplate`,
      redirect: {
        name: `AcademicCertificateTemplateList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.certificate.template.template`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`certificate-template:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicCertificateTemplateList`,
          meta: {
            trans: `global.list`,
            label: `academic.certificate.template.templates`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CertificateTemplate/Index.vue`),
              __vite__mapDeps([200, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicCertificateTemplateCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.certificate.template.template`,
            permissions: [`certificate-template:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CertificateTemplate/Action.vue`),
              __vite__mapDeps([201, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicCertificateTemplateEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.certificate.template.template`,
            permissions: [`certificate-template:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CertificateTemplate/Action.vue`),
              __vite__mapDeps([201, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicCertificateTemplateDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.certificate.template.template`,
            permissions: [`certificate-template:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CertificateTemplate/Action.vue`),
              __vite__mapDeps([201, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicCertificateTemplateShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.certificate.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/CertificateTemplate/Show.vue`),
              __vite__mapDeps([202, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  zu = [
    {
      path: `certificates`,
      name: `AcademicCertificate`,
      redirect: {
        name: `AcademicCertificateList`,
      },
      meta: {
        label: `academic.certificate.certificate`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`certificate:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicCertificateList`,
          meta: {
            trans: `global.list`,
            label: `academic.certificate.certificates`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Certificate/Index.vue`),
              __vite__mapDeps([203, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicCertificateCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.certificate.certificate`,
            permissions: [`certificate:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Certificate/Action.vue`),
              __vite__mapDeps([204, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicCertificateEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.certificate.certificate`,
            permissions: [`certificate:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Certificate/Action.vue`),
              __vite__mapDeps([204, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicCertificateDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.certificate.certificate`,
            permissions: [`certificate:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Certificate/Action.vue`),
              __vite__mapDeps([204, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicCertificateShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.certificate.certificate`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Certificate/Show.vue`),
              __vite__mapDeps([206, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Bu = [
    {
      path: `id-card-templates`,
      name: `AcademicIdCardTemplate`,
      redirect: {
        name: `AcademicIdCardTemplateList`,
      },
      meta: {
        isNotNav: !0,
        label: `academic.id_card.template.template`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`id-card:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicIdCardTemplateList`,
          meta: {
            trans: `global.list`,
            label: `academic.id_card.template.templates`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/IdCardTemplate/Index.vue`),
              __vite__mapDeps([207, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AcademicIdCardTemplateCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `academic.id_card.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/IdCardTemplate/Action.vue`),
              __vite__mapDeps([208, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AcademicIdCardTemplateEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `academic.id_card.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/IdCardTemplate/Action.vue`),
              __vite__mapDeps([208, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AcademicIdCardTemplateDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `academic.id_card.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/IdCardTemplate/Action.vue`),
              __vite__mapDeps([208, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AcademicIdCardTemplateShow`,
          meta: {
            trans: `global.detail`,
            label: `academic.id_card.template.template`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/IdCardTemplate/Show.vue`),
              __vite__mapDeps([209, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Vu = [
    {
      path: `id-cards`,
      name: `AcademicIdCard`,
      redirect: {
        name: `AcademicIdCardPrint`,
      },
      meta: {
        label: `academic.id_card.id_card`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`id-card:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AcademicIdCardPrint`,
          meta: {
            trans: `global.print`,
            label: `academic.id_card.id_cards`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/IdCard/Print.vue`),
              __vite__mapDeps([210, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Hu = [
    {
      path: `academic`,
      name: `Academic`,
      redirect: {
        name: `AcademicPeriod`,
      },
      meta: {
        moduleName: `academic`,
        label: `academic.academic`,
        icon: `fas fa-building-columns`,
        permissions: [
          `academic-department:manage`,
          `program:manage`,
          `session:manage`,
          `period:read`,
          `division:read`,
          `division-incharge:read`,
          `course:read`,
          `course-incharge:read`,
          `batch:read`,
          `batch-incharge:read`,
          `subject:read`,
          `subject-group:manage`,
          `subject-incharge:read`,
          `book-list:manage`,
          `certificate:read`,
          `id-card:manage`,
          `book-list:manage`,
          `timetable:read`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `AcademicConfig`,
          redirect: {
            name: `AcademicConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`academic:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Academic/Config/Index.vue`),
              __vite__mapDeps([211, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `AcademicConfigGeneral`,
              meta: {
                label: `academic.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Academic/Config/General.vue`),
                  __vite__mapDeps([212, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `subject-type`,
              prefix: `AcademicConfigSubjectType`,
              queryType: `subject_type`,
              label: `academic.subject.type.type`,
              transKey: `academic.subject.type`,
              navs: [
                {
                  label: K(`academic.academic`),
                  path: `AcademicSubjectList`,
                },
                {
                  label: K(`academic.config.config`),
                  path: `AcademicConfig`,
                },
              ],
            }),
            {
              path: `timetable`,
              name: `AcademicConfigTimetable`,
              meta: {
                label: `academic.config.timetable`,
                icon: `far fa-clock`,
                key: `timetable`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Academic/Config/Timetable.vue`),
                  __vite__mapDeps([213, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        ...yu,
        ...bu,
        ...xu,
        ...Su,
        ...Cu,
        ...wu,
        ...Tu,
        ...Eu,
        ...Du,
        ...Ou,
        ...ku,
        ...Au,
        ...ju,
        ...Mu,
        ...Nu,
        ...Pu,
        ...Fu,
        ...Iu,
        ...Lu,
        ...Ru,
        ...zu,
        ...Bu,
        ...Vu,
      ],
    },
  ],
  Uu = [
    {
      path: `registrations`,
      name: `StudentRegistration`,
      redirect: {
        name: `StudentRegistrationList`,
      },
      meta: {
        label: `student.registration.registration`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`registration:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentRegistrationList`,
          meta: {
            trans: `global.list`,
            label: `student.registration.registrations`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Registration/Index.vue`),
              __vite__mapDeps([214, 1, 2, 3, 4, 5, 6, 7, 8, 71, 20, 45]),
            ),
        },
        {
          path: `create`,
          name: `StudentRegistrationCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.registration.registration`,
            permissions: [`registration:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Registration/Action.vue`),
              __vite__mapDeps([215, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentRegistrationEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.registration.registration`,
            permissions: [`registration:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Registration/Action.vue`),
              __vite__mapDeps([215, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/wizard`,
          name: `StudentRegistrationWizard`,
          meta: {
            type: `wizard`,
            action: `update`,
            trans: `global.edit`,
            label: `student.registration.registration`,
            permissions: [`registration:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Registration/Wizard.vue`),
              __vite__mapDeps([216, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentRegistrationDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.registration.registration`,
            permissions: [`registration:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Registration/Action.vue`),
              __vite__mapDeps([215, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentRegistrationShow`,
          meta: {
            trans: `global.detail`,
            label: `student.registration.registration`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Registration/Show.vue`),
              __vite__mapDeps([217, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
      ],
    },
  ],
  Wu = [
    {
      path: `bulk-edit`,
      name: `StudentBulkEdit`,
      meta: {
        isNotNav: !0,
        label: `student.bulk_edit.bulk_edit`,
        icon: `fas fa-right-long`,
        permissions: [`student:edit`, `student-record:manage`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/BulkEdit/index.vue`),
          __vite__mapDeps([218, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `bulk-edit/address`,
      name: `StudentBulkEditAddress`,
      meta: {
        isNotNav: !0,
        label: `student.bulk_edit.edit_address.edit_address`,
        icon: `fas fa-right-long`,
        permissions: [`student:edit`, `student-record:manage`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/BulkEdit/EditAddress/Index.vue`),
          __vite__mapDeps([219, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `bulk-edit/rte`,
      name: `StudentBulkEditRte`,
      meta: {
        isNotNav: !0,
        label: `student.bulk_edit.edit_rte.edit_rte`,
        icon: `fas fa-right-long`,
        permissions: [`student:edit`, `student-record:manage`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/BulkEdit/EditRte/Index.vue`),
          __vite__mapDeps([220, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ];
function Gu(e) {
  return kS.getters[`config/config`](e);
}
var Ku = [
    {
      path: `timesheets`,
      name: `StudentTimesheet`,
      redirect: {
        name: `StudentTimesheetList`,
      },
      meta: {
        isNotNav: !0,
        label: `student.timesheet.timesheet`,
        icon: `fas fa-stopwatch`,
        hideChildren: !0,
        permissions: [`student:manage-timesheet`],
        keySearch: !0,
      },
      beforeEnter: (e, t, n) => {
        Gu(`student.enableTimesheet`) ? n() : n(`/`);
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentTimesheetList`,
          meta: {
            trans: `global.list`,
            label: `student.timesheet.timesheets`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Timesheet/Index.vue`),
              __vite__mapDeps([221, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `StudentTimesheetCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.timesheet.timesheet`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Timesheet/Action.vue`),
              __vite__mapDeps([222, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `batch`,
          name: `StudentTimesheetBatch`,
          meta: {
            type: `update`,
            action: `update`,
            trans: `global.update`,
            label: `student.timesheet.timesheet`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Timesheet/Batch.vue`),
              __vite__mapDeps([223, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentTimesheetEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.timesheet.timesheet`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Timesheet/Action.vue`),
              __vite__mapDeps([222, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentTimesheetDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.timesheet.timesheet`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Timesheet/Action.vue`),
              __vite__mapDeps([222, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentTimesheetShow`,
          meta: {
            trans: `global.detail`,
            label: `student.timesheet.timesheet`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Timesheet/Show.vue`),
              __vite__mapDeps([224, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `timesheet`,
      name: `StudentTimesheetForStudentAndGuardian`,
      meta: {
        isNotNav: !0,
        label: `student.timesheet.timesheet`,
        icon: `fas fa-stopwatch`,
        hideChildren: !0,
        roles: [`student`, `guardian`],
        keySearch: !1,
      },
      beforeEnter: (e, t, n) => {
        Gu(`student.enableTimesheet`) ? n() : n(`/`);
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Timesheet/Index.vue`),
          __vite__mapDeps([221, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  qu = [
    {
      path: `edit-requests`,
      name: `StudentEditRequest`,
      redirect: {
        name: `StudentEditRequestList`,
      },
      meta: {
        label: `student.edit_request.edit_request`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:edit-request-action`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentEditRequestList`,
          meta: {
            trans: `global.list`,
            label: `student.edit_request.edits_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/EditRequest/Index.vue`),
              __vite__mapDeps([225, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentEditRequestShow`,
          meta: {
            trans: `global.detail`,
            label: `student.edit_request.edit_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/EditRequest/Show.vue`),
              __vite__mapDeps([226, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ju = [
    {
      path: `service-requests`,
      name: `StudentServiceRequest`,
      redirect: {
        name: `StudentServiceRequestList`,
      },
      meta: {
        label: `student.service_request.service_request`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:service-request`],
        keySearch: !0,
        keySearchLabel: `student.service_request.student_service_request`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentServiceRequestList`,
          meta: {
            trans: `global.list`,
            label: `student.service_request.services_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/ServiceRequest/Index.vue`),
              __vite__mapDeps([227, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `StudentServiceRequestCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.service_request.service_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/ServiceRequest/Action.vue`),
              __vite__mapDeps([228, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentServiceRequestEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.service_request.service_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/ServiceRequest/Action.vue`),
              __vite__mapDeps([228, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentServiceRequestDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.service_request.service_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/ServiceRequest/Action.vue`),
              __vite__mapDeps([228, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentServiceRequestShow`,
          meta: {
            trans: `global.detail`,
            label: `student.service_request.service_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/ServiceRequest/Show.vue`),
              __vite__mapDeps([229, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Yu = [
    {
      path: `leave-requests`,
      name: `StudentLeaveRequest`,
      redirect: {
        name: `StudentLeaveRequestList`,
      },
      meta: {
        label: `student.leave_request.leave_request`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:leave-request`],
        keySearch: !0,
        keySearchLabel: `student.leave_request.student_leave_request`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentLeaveRequestList`,
          meta: {
            trans: `global.list`,
            label: `student.leave_request.leaves_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/LeaveRequest/Index.vue`),
              __vite__mapDeps([230, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `StudentLeaveRequestCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.leave_request.leave_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/LeaveRequest/Action.vue`),
              __vite__mapDeps([231, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentLeaveRequestEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.leave_request.leave_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/LeaveRequest/Action.vue`),
              __vite__mapDeps([231, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentLeaveRequestDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.leave_request.leave_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/LeaveRequest/Action.vue`),
              __vite__mapDeps([231, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentLeaveRequestShow`,
          meta: {
            trans: `global.detail`,
            label: `student.leave_request.leave_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/LeaveRequest/Show.vue`),
              __vite__mapDeps([232, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Xu = [
    {
      path: `transfer-requests`,
      name: `StudentTransferRequest`,
      redirect: {
        name: `StudentTransferRequestList`,
      },
      meta: {
        label: `student.transfer_request.transfer_request`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:transfer-request`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentTransferRequestList`,
          meta: {
            trans: `global.list`,
            label: `student.transfer_request.transfers_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/TransferRequest/Index.vue`),
              __vite__mapDeps([233, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `StudentTransferRequestCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.transfer_request.transfer_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/TransferRequest/Action.vue`),
              __vite__mapDeps([234, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentTransferRequestEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.transfer_request.transfer_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/TransferRequest/Action.vue`),
              __vite__mapDeps([234, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentTransferRequestDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.transfer_request.transfer_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/TransferRequest/Action.vue`),
              __vite__mapDeps([234, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentTransferRequestShow`,
          meta: {
            trans: `global.detail`,
            label: `student.transfer_request.transfer_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/TransferRequest/Show.vue`),
              __vite__mapDeps([235, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Zu = [
    {
      path: `transfer/approval-requests`,
      name: `StudentTransferApprovalRequestList`,
      meta: {
        isNotNav: !0,
        label: `student.transfer.transfer`,
        icon: `fas fa-right-long`,
        permissions: [`student:transfer`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Transfer/ApprovalRequest/Index.vue`),
          __vite__mapDeps([236, 1, 2, 3, 4, 5, 6, 7, 8, 237]),
        ),
    },
    {
      path: `transfers`,
      name: `StudentTransfer`,
      redirect: {
        name: `StudentTransferList`,
      },
      meta: {
        label: `student.transfer.transfer`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:transfer`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentTransferList`,
          meta: {
            trans: `global.list`,
            label: `student.transfer.transfers`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Transfer/Index.vue`),
              __vite__mapDeps([238, 1, 2, 3, 4, 5, 6, 7, 8, 237]),
            ),
        },
        {
          path: `create`,
          name: `StudentTransferCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.transfer.transfer`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Transfer/Action.vue`),
              __vite__mapDeps([239, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentTransferEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.transfer.transfer`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Transfer/Action.vue`),
              __vite__mapDeps([239, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentTransferDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.transfer.transfer`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Transfer/Action.vue`),
              __vite__mapDeps([239, 1, 2, 3, 4, 5, 6, 7, 8, 205]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentTransferShow`,
          meta: {
            trans: `global.detail`,
            label: `student.transfer.transfer`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Transfer/Show.vue`),
              __vite__mapDeps([240, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Qu = [
    {
      path: `reports`,
      name: `StudentReport`,
      redirect: {
        name: `StudentReportList`,
      },
      meta: {
        label: `general.report`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:report`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentReportList`,
          meta: {
            trans: `global.list`,
            label: `student.report.report`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Report/Index.vue`),
              __vite__mapDeps([241, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `date-wise-attendance`,
          name: `StudentReportDateWiseAttendance`,
          meta: {
            trans: `global.list`,
            label: `student.report.date_wise_attendance.date_wise_attendance`,
            permissions: [`student:list-attendance`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Report/DateWiseAttendance/Index.vue`),
              __vite__mapDeps([242, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `batch-wise-attendance`,
          name: `StudentReportBatchWiseAttendance`,
          meta: {
            trans: `global.list`,
            label: `student.report.batch_wise_attendance.batch_wise_attendance`,
            permissions: [`student:list-attendance`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Report/BatchWiseAttendance/Index.vue`),
              __vite__mapDeps([243, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `subject-wise-attendance`,
          name: `StudentReportSubjectWiseAttendance`,
          meta: {
            trans: `global.list`,
            label: `student.report.subject_wise_attendance.subject_wise_attendance`,
            permissions: [`student:list-attendance`],
            keySearch: !0,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Student/Report/SubjectWiseAttendance/Index.vue`),
              __vite__mapDeps([244, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `subject-wise-student`,
          name: `StudentReportSubjectWiseStudent`,
          meta: {
            trans: `global.list`,
            label: `student.report.subject_wise_student.subject_wise_student`,
            permissions: [`student:report`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Report/SubjectWiseStudent/Index.vue`),
              __vite__mapDeps([245, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `daily-access-report`,
          name: `StudentReportDailyAccessReport`,
          meta: {
            trans: `global.list`,
            label: `student.report.daily_access_report.daily_access_report`,
            permissions: [`student:report`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Report/DailyAccessReport/Index.vue`),
              __vite__mapDeps([246, 1, 2, 3, 4, 5, 6, 7, 8, 33]),
            ),
        },
      ],
    },
  ],
  $u = [
    {
      path: `accounts`,
      name: `StudentAccounts`,
      redirect: {
        name: `StudentAccountsList`,
      },
      meta: {
        isNotNav: !0,
        label: `student.account.accounts`,
        icon: `fas fa-right-long`,
        permissions: [`student:read`],
        keySearch: !0,
        keySearchLabel: `student.account.student_accounts`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentAccountsList`,
          meta: {
            trans: `global.list`,
            label: `student.account.accounts`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Accounts/Index.vue`),
              __vite__mapDeps([247, 1, 2, 3, 4, 5, 6, 7, 8, 248]),
            ),
        },
        {
          path: `create`,
          name: `StudentAccountsCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.account.account`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Accounts/Action.vue`),
              __vite__mapDeps([249, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentAccountsEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.account.account`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Accounts/Action.vue`),
              __vite__mapDeps([249, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentAccountsDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.account.account`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Accounts/Action.vue`),
              __vite__mapDeps([249, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentAccountsShow`,
          meta: {
            trans: `global.detail`,
            label: `student.account.account`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Accounts/Show.vue`),
              __vite__mapDeps([250, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ed = [
    {
      path: `documents`,
      name: `StudentDocuments`,
      redirect: {
        name: `StudentDocumentsList`,
      },
      meta: {
        isNotNav: !0,
        label: `student.document.documents`,
        icon: `fas fa-right-long`,
        permissions: [`student:read`],
        keySearch: !0,
        keySearchLabel: `student.document.student_documents`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentDocumentsList`,
          meta: {
            trans: `global.list`,
            label: `student.document.documents`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Documents/Index.vue`),
              __vite__mapDeps([251, 1, 2, 3, 4, 5, 6, 7, 8, 248]),
            ),
        },
        {
          path: `create`,
          name: `StudentDocumentsCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Documents/Action.vue`),
              __vite__mapDeps([252, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentDocumentsEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Documents/Action.vue`),
              __vite__mapDeps([252, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentDocumentsDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Documents/Action.vue`),
              __vite__mapDeps([252, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentDocumentsShow`,
          meta: {
            trans: `global.detail`,
            label: `student.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Documents/Show.vue`),
              __vite__mapDeps([253, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Y = [
    {
      path: `qualifications`,
      name: `StudentQualifications`,
      redirect: {
        name: `StudentQualificationsList`,
      },
      meta: {
        isNotNav: !0,
        label: `student.qualification.qualifications`,
        icon: `fas fa-right-long`,
        permissions: [`student:read`],
        keySearch: !0,
        keySearchLabel: `student.qualification.student_qualifications`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentQualificationsList`,
          meta: {
            trans: `global.list`,
            label: `student.qualification.qualifications`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Qualifications/Index.vue`),
              __vite__mapDeps([254, 1, 2, 3, 4, 5, 6, 7, 8, 248]),
            ),
        },
        {
          path: `create`,
          name: `StudentQualificationsCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.qualification.qualification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Qualifications/Action.vue`),
              __vite__mapDeps([255, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentQualificationsEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.qualification.qualification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Qualifications/Action.vue`),
              __vite__mapDeps([255, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentQualificationsDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.qualification.qualification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Qualifications/Action.vue`),
              __vite__mapDeps([255, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentQualificationsShow`,
          meta: {
            trans: `global.detail`,
            label: `student.qualification.qualification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Qualifications/Show.vue`),
              __vite__mapDeps([256, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  td = [
    {
      path: `attendance-types`,
      name: `StudentConfigAttendanceType`,
      redirect: {
        name: `StudentConfigAttendanceTypeList`,
      },
      meta: {
        label: `student.attendance_type.attendance_types`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentConfigAttendanceTypeList`,
          meta: {
            trans: `global.list`,
            label: `student.attendance_type.attendance_types`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/AttendanceType/Index.vue`),
              __vite__mapDeps([257, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `StudentConfigAttendanceTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.attendance_type.attendance_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/AttendanceType/Action.vue`),
              __vite__mapDeps([258, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentConfigAttendanceTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.attendance_type.attendance_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/AttendanceType/Action.vue`),
              __vite__mapDeps([258, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentConfigAttendanceTypeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.attendance_type.attendance_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/AttendanceType/Action.vue`),
              __vite__mapDeps([258, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentConfigAttendanceTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `student.attendance_type.attendance_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/AttendanceType/Show.vue`),
              __vite__mapDeps([259, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  nd = [
    {
      path: `houses`,
      name: `StudentConfigHouse`,
      redirect: {
        name: `StudentConfigHouseList`,
      },
      meta: {
        label: `student.house.houses`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentConfigHouseList`,
          meta: {
            trans: `global.list`,
            label: `student.house.houses`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/House/Index.vue`),
              __vite__mapDeps([260, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `StudentConfigHouseCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.house.house`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/House/Action.vue`),
              __vite__mapDeps([261, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentConfigHouseEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.house.house`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/House/Action.vue`),
              __vite__mapDeps([261, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentConfigHouseDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.house.house`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/House/Action.vue`),
              __vite__mapDeps([261, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentConfigHouseShow`,
          meta: {
            trans: `global.detail`,
            label: `student.house.house`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/House/Show.vue`),
              __vite__mapDeps([262, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  rd = [
    {
      path: `document-types`,
      name: `StudentConfigDocumentType`,
      redirect: {
        name: `StudentConfigDocumentTypeList`,
      },
      meta: {
        label: `student.document_type.document_types`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentConfigDocumentTypeList`,
          meta: {
            trans: `global.list`,
            label: `student.document_type.document_types`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/DocumentType/Index.vue`),
              __vite__mapDeps([263, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `StudentConfigDocumentTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `student.document_type.document_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/DocumentType/Action.vue`),
              __vite__mapDeps([264, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `StudentConfigDocumentTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `student.document_type.document_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/DocumentType/Action.vue`),
              __vite__mapDeps([264, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `StudentConfigDocumentTypeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `student.document_type.document_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/DocumentType/Action.vue`),
              __vite__mapDeps([264, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentConfigDocumentTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `student.document_type.document_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/DocumentType/Show.vue`),
              __vite__mapDeps([265, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  id = [
    {
      path: ``,
      name: `StudentGuardianList`,
      meta: {
        trans: `global.list`,
        label: `guardian.guardians`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Guardian/Index.vue`),
          __vite__mapDeps([266, 1, 2, 3, 4, 5, 6, 7, 8, 267]),
        ),
    },
    {
      path: `create`,
      name: `StudentGuardianCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `guardian.guardian`,
        permissions: [`student:edit`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Guardian/Action.vue`),
          __vite__mapDeps([268, 1, 2, 3, 4, 5, 6, 7, 8, 267]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `StudentGuardianEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `guardian.guardian`,
        permissions: [`student:edit`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Guardian/Action.vue`),
          __vite__mapDeps([268, 1, 2, 3, 4, 5, 6, 7, 8, 267]),
        ),
    },
  ],
  X = [
    {
      path: ``,
      name: `StudentRecordList`,
      meta: {
        trans: `global.list`,
        label: `student.record.record`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Record/Index.vue`),
          __vite__mapDeps([269, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  ad = [
    {
      path: ``,
      name: `StudentWalletTransactionList`,
      meta: {
        trans: `global.list`,
        label: `student.wallet.wallet`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/WalletTransaction/Index.vue`),
          __vite__mapDeps([270, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `new`,
      name: `StudentWalletTransactionNew`,
      meta: {
        trans: `global.new`,
        label: `student.wallet.wallet`,
        permissions: [`wallet:payment`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/WalletTransaction/New.vue`),
          __vite__mapDeps([271, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `StudentWalletTransactionShow`,
      meta: {
        trans: `global.detail`,
        label: `student.wallet.wallet`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/WalletTransaction/Show.vue`),
          __vite__mapDeps([272, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  od = [
    {
      path: ``,
      name: `StudentAccountList`,
      meta: {
        trans: `global.list`,
        label: `finance.account.accounts`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Account/Index.vue`),
          __vite__mapDeps([273, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `StudentAccountCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `finance.account.account`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Account/Action.vue`),
          __vite__mapDeps([274, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `StudentAccountEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `finance.account.account`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Account/Action.vue`),
          __vite__mapDeps([274, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `StudentAccountDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `finance.account.account`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Account/Action.vue`),
          __vite__mapDeps([274, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `StudentAccountShow`,
      meta: {
        trans: `global.detail`,
        label: `finance.account.account`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Account/Show.vue`),
          __vite__mapDeps([275, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  sd = [
    {
      path: ``,
      name: `StudentDocumentList`,
      meta: {
        trans: `global.list`,
        label: `student.document.documents`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Document/Index.vue`),
          __vite__mapDeps([276, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `StudentDocumentCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `student.document.document`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Document/Action.vue`),
          __vite__mapDeps([277, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `StudentDocumentEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `student.document.document`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Document/Action.vue`),
          __vite__mapDeps([277, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `StudentDocumentDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `student.document.document`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Document/Action.vue`),
          __vite__mapDeps([277, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `StudentDocumentShow`,
      meta: {
        trans: `global.detail`,
        label: `student.document.document`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Document/Show.vue`),
          __vite__mapDeps([278, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  cd = [
    {
      path: ``,
      name: `StudentDialogueList`,
      meta: {
        trans: `global.list`,
        label: `student.dialogue.dialogues`,
        permissions: [`student:dialogue`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Dialogue/Index.vue`),
          __vite__mapDeps([279, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `StudentDialogueCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.new`,
        label: `student.dialogue.dialogue`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Dialogue/Action.vue`),
          __vite__mapDeps([280, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `StudentDialogueEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `student.dialogue.dialogue`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Dialogue/Action.vue`),
          __vite__mapDeps([280, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `StudentDialogueDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `student.dialogue.dialogue`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Dialogue/Action.vue`),
          __vite__mapDeps([280, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `StudentDialogueShow`,
      meta: {
        trans: `global.detail`,
        label: `student.dialogue.dialogue`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Dialogue/Show.vue`),
          __vite__mapDeps([281, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  ld = [
    {
      path: ``,
      name: `StudentNoteList`,
      meta: {
        trans: `global.list`,
        label: `note.notes`,
        permissions: [`student:note`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Note/Index.vue`),
          __vite__mapDeps([282, 1, 2, 3, 4, 5, 6, 7, 8, 283]),
        ),
    },
  ],
  ud = [
    {
      path: ``,
      name: `StudentQualificationList`,
      meta: {
        trans: `global.list`,
        label: `student.qualification.qualifications`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Qualification/Index.vue`),
          __vite__mapDeps([284, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `StudentQualificationCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `student.qualification.qualification`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Qualification/Action.vue`),
          __vite__mapDeps([285, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `StudentQualificationEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `student.qualification.qualification`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Qualification/Action.vue`),
          __vite__mapDeps([285, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `StudentQualificationDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `student.qualification.qualification`,
        permissions: [`student:edit`, `student-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Qualification/Action.vue`),
          __vite__mapDeps([285, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `StudentQualificationShow`,
      meta: {
        trans: `global.detail`,
        label: `student.qualification.qualification`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/Qualification/Show.vue`),
          __vite__mapDeps([286, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  dd = [
    {
      path: ``,
      name: `StudentProfileEditRequestList`,
      meta: {
        trans: `global.list`,
        label: `finance.edit_request.edit_requests`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/ProfileEditRequest/Index.vue`),
          __vite__mapDeps([287, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `new`,
      name: `StudentProfileEditRequestNew`,
      meta: {
        type: `new`,
        action: `create`,
        trans: `global.new`,
        label: `student.edit_request.edit_request`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/ProfileEditRequest/Action.vue`),
          __vite__mapDeps([288, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `StudentProfileEditRequestShow`,
      meta: {
        trans: `global.detail`,
        label: `student.edit_request.edit_request`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/ProfileEditRequest/Show.vue`),
          __vite__mapDeps([289, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  fd = [
    {
      path: ``,
      name: `StudentCustomFeeList`,
      meta: {
        trans: `global.list`,
        label: `student.fee.custom_fees`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/CustomFee/Index.vue`),
          __vite__mapDeps([290, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `StudentCustomFeeCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `student.fee.custom_fee`,
        permissions: [`fee:set`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/CustomFee/Action.vue`),
          __vite__mapDeps([291, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `StudentCustomFeeEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `student.fee.custom_fee`,
        permissions: [`fee:edit`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/CustomFee/Action.vue`),
          __vite__mapDeps([291, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `StudentCustomFeeDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `student.fee.custom_fee`,
        permissions: [`fee:edit`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/CustomFee/Action.vue`),
          __vite__mapDeps([291, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `StudentCustomFeeShow`,
      meta: {
        trans: `global.detail`,
        label: `student.fee.custom_fee`,
        permissions: [],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/CustomFee/Show.vue`),
          __vite__mapDeps([292, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  pd = [
    {
      path: ``,
      name: `StudentFeeRefundList`,
      meta: {
        trans: `global.list`,
        label: `student.fee_refund.fee_refunds`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/FeeRefund/Index.vue`),
          __vite__mapDeps([293, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `StudentFeeRefundCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `student.fee_refund.fee_refund`,
        permissions: [`fee:edit`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/FeeRefund/Action.vue`),
          __vite__mapDeps([294, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `StudentFeeRefundEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `student.fee_refund.fee_refund`,
        permissions: [`fee:edit`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/FeeRefund/Action.vue`),
          __vite__mapDeps([294, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `StudentFeeRefundDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `student.fee_refund.fee_refund`,
        permissions: [`fee:edit`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/FeeRefund/Action.vue`),
          __vite__mapDeps([294, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `StudentFeeRefundShow`,
      meta: {
        trans: `global.detail`,
        label: `student.fee_refund.fee_refund`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Student/FeeRefund/Show.vue`),
          __vite__mapDeps([295, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ];
function md(e) {
  return kS.getters[`config/config`](e);
}
var hd = () =>
    md(`student.showSinglePageProfile`)
      ? {
          name: `StudentShowProfile`,
        }
      : {
          name: `StudentShowBasic`,
        },
  gd = [
    {
      path: `student`,
      name: `StudentIndex`,
      redirect: {
        name: `StudentList`,
      },
      meta: {
        moduleName: `student`,
        label: `student.student`,
        icon: `fas fa-user-graduate`,
        permissions: [
          `registration:read`,
          `student:transfer-request`,
          `student:transfer`,
          `student:read`,
          `student:config`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `StudentConfig`,
          redirect: {
            name: `StudentConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            label: `student.student`,
            icon: `fas fa-cog`,
            hideChildren: !0,
            permissions: [`student:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Config/Index.vue`),
              __vite__mapDeps([296, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `StudentConfigGeneral`,
              meta: {
                label: `student.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Config/General.vue`),
                  __vite__mapDeps([297, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `registration-stage`,
              prefix: `StudentConfigRegistrationStage`,
              queryType: `registration_stage`,
              label: `student.registration_stage.registration_stage`,
              transKey: `student.registration_stage`,
              navs: [
                {
                  label: K(`student.student`),
                  path: `StudentList`,
                },
                {
                  label: K(`student.config.config`),
                  path: `StudentConfig`,
                },
              ],
            }),
            q({
              path: `enrollment-type`,
              prefix: `StudentConfigEnrollmentType`,
              queryType: `student_enrollment_type`,
              label: `student.enrollment_type.enrollment_type`,
              transKey: `student.enrollment_type`,
              navs: [
                {
                  label: K(`student.student`),
                  path: `StudentList`,
                },
                {
                  label: K(`student.config.config`),
                  path: `StudentConfig`,
                },
              ],
            }),
            q({
              path: `enrollment-status`,
              prefix: `StudentConfigEnrollmentStatus`,
              queryType: `student_enrollment_status`,
              label: `student.enrollment_status.enrollment_status`,
              transKey: `student.enrollment_status`,
              navs: [
                {
                  label: K(`student.student`),
                  path: `StudentList`,
                },
                {
                  label: K(`student.config.config`),
                  path: `StudentConfig`,
                },
              ],
            }),
            ...td,
            ...nd,
            ...rd,
            q({
              path: `dialogue-category`,
              prefix: `StudentConfigDialogueCategory`,
              queryType: `student_dialogue_category`,
              label: `student.dialogue_category.dialogue_category`,
              transKey: `student.dialogue_category`,
              navs: [
                {
                  label: K(`student.student`),
                  path: `StudentList`,
                },
                {
                  label: K(`student.config.config`),
                  path: `StudentConfig`,
                },
              ],
            }),
            q({
              path: `leave-category`,
              prefix: `StudentConfigLeaveCategory`,
              queryType: `student_leave_category`,
              label: `student.leave_category.leave_category`,
              transKey: `student.leave_category`,
              navs: [
                {
                  label: K(`student.student`),
                  path: `StudentList`,
                },
                {
                  label: K(`student.config.config`),
                  path: `StudentConfig`,
                },
              ],
            }),
            q({
              path: `transfer-reason`,
              prefix: `StudentConfigTransferReason`,
              queryType: `student_transfer_reason`,
              label: `student.transfer_reason.transfer_reason`,
              transKey: `student.transfer_reason`,
              navs: [
                {
                  label: K(`student.student`),
                  path: `StudentList`,
                },
                {
                  label: K(`student.config.config`),
                  path: `StudentConfig`,
                },
              ],
            }),
            q({
              path: `group`,
              prefix: `StudentConfigGroup`,
              queryType: `student_group`,
              label: `student.group.group`,
              transKey: `student.group`,
              navs: [
                {
                  label: K(`student.student`),
                  path: `StudentList`,
                },
                {
                  label: K(`student.config.config`),
                  path: `StudentConfig`,
                },
              ],
            }),
          ],
        },
        {
          path: `students`,
          name: `StudentLists`,
          redirect: {
            name: `StudentList`,
          },
          meta: {
            label: `student.students`,
            icon: `fas fa-right-long`,
            permissions: [`student:read`],
            keySearch: !0,
          },
        },
        ...Uu,
        ...Ku,
        {
          path: `roll-number`,
          name: `StudentRollNumber`,
          meta: {
            label: `student.roll_number.roll_number`,
            icon: `fas fa-right-long`,
            permissions: [`student:edit`, `student-record:manage`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/RollNumber/Index.vue`),
              __vite__mapDeps([298, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `photos`,
          name: `StudentPhoto`,
          meta: {
            label: `contact.props.photo`,
            icon: `fas fa-right-long`,
            permissions: [`student:edit`, `student-record:manage`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Photo/Index.vue`),
              __vite__mapDeps([299, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `health-record`,
          name: `StudentHealthRecord`,
          meta: {
            label: `student.health_record.health_record`,
            icon: `fas fa-right-long`,
            permissions: [`student:edit`, `student-record:manage`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/HealthRecord/Index.vue`),
              __vite__mapDeps([300, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `subject`,
          name: `StudentSubject`,
          meta: {
            label: `student.subject.subject`,
            icon: `fas fa-right-long`,
            permissions: [`student:edit`, `student-record:manage`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Subject/Index.vue`),
              __vite__mapDeps([301, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `attendance`,
          name: `StudentAttendance`,
          meta: {
            label: `student.attendance.attendance`,
            icon: `fas fa-right-long`,
            permissions: [`student:list-attendance`],
            keySearch: !0,
            keySearchLabel: `student.attendance.student_attendance`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Attendance/Index.vue`),
              __vite__mapDeps([302, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `attendance/absentees`,
          name: `StudentAttendanceAbsentee`,
          meta: {
            isNotNav: !0,
            label: `student.attendance.absentees`,
            icon: `fas fa-right-long`,
            permissions: [`student:list-attendance`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Attendance/Absentee.vue`),
              __vite__mapDeps([303, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `fee-allocation`,
          name: `StudentFeeAllocation`,
          meta: {
            label: `student.fee_allocation.fee_allocation`,
            icon: `fas fa-right-long`,
            permissions: [`fee:set`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/FeeAllocation/Index.vue`),
              __vite__mapDeps([304, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `service-allocation`,
          name: `StudentServiceAllocation`,
          meta: {
            label: `student.service_allocation.service_allocation`,
            icon: `fas fa-right-long`,
            permissions: [`student:service-allocation`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/ServiceAllocation/Index.vue`),
              __vite__mapDeps([305, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `promotion`,
          name: `StudentPromotion`,
          meta: {
            label: `student.promotion.promotion`,
            icon: `fas fa-right-long`,
            permissions: [`student:promotion`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Promotion/Index.vue`),
              __vite__mapDeps([306, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        ...qu,
        ...Ju,
        ...Yu,
        ...Xu,
        ...Zu,
        {
          path: `alumni`,
          name: `StudentAlumni`,
          meta: {
            trans: `global.list`,
            label: `student.alumni.alumni`,
            icon: `fas fa-right-long`,
            permissions: [`alumni:read`],
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Index.vue`),
              __vite__mapDeps([307, 1, 2, 3, 4, 5, 6, 7, 8, 71, 20, 45, 248]),
            ),
        },
        ...Qu,
        ...Wu,
        ...$u,
        ...ed,
        ...Y,
        {
          path: `migrate-attendance`,
          name: `StudentMigrateAttendance`,
          meta: {
            isNotNav: !0,
            type: `general`,
            action: `general`,
            trans: `student.attendance.migrate_attendance`,
            label: `student.attendance.migrate_attendance`,
            roles: [`admin`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/MigrateAttendance.vue`),
              __vite__mapDeps([308, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `students`,
      name: `Student`,
      redirect: {
        name: `StudentList`,
      },
      meta: {
        isNotNav: !0,
        label: `student.student`,
        icon: `fas fa-user-graduate`,
        hideChildren: !0,
        permissions: [`student:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `StudentList`,
          meta: {
            trans: `global.list`,
            label: `student.students`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Index.vue`),
              __vite__mapDeps([307, 1, 2, 3, 4, 5, 6, 7, 8, 71, 20, 45, 248]),
            ),
        },
        {
          path: `:uuid`,
          name: `StudentShow`,
          redirect: () => hd(),
          meta: {
            trans: `global.detail`,
            label: `student.student`,
            permissions: [`student:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Student/Show.vue`),
              __vite__mapDeps([309, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: ``,
              name: `StudentShowIndex`,
              redirect: () => hd(),
            },
            {
              path: `profile`,
              name: `StudentShowProfile`,
              meta: {
                type: `read`,
                action: `read`,
                trans: `user.profile.profile`,
                label: `user.profile.profile`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Profile.vue`),
                  __vite__mapDeps([310, 1, 2, 3, 4, 5, 6, 7, 8, 34, 311]),
                ),
            },
            {
              path: `basic`,
              name: `StudentShowBasic`,
              meta: {
                type: `read`,
                action: `read`,
                trans: `general.basic`,
                label: `general.basic`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Basic.vue`),
                  __vite__mapDeps([312, 1, 2, 3, 4, 5, 6, 7, 8, 34, 311]),
                ),
            },
            {
              path: `basic/edit`,
              name: `StudentEditBasic`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `student.student`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/EditBasic.vue`),
                  __vite__mapDeps([313, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
                ),
            },
            {
              path: `photo/edit`,
              name: `StudentEditPhoto`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `contact.props.photo`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/EditPhoto.vue`),
                  __vite__mapDeps([314, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `contact`,
              name: `StudentShowContact`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `contact.contact`,
                label: `contact.contact`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Contact.vue`),
                  __vite__mapDeps([315, 1, 2, 3, 4, 5, 6, 7, 8, 34]),
                ),
            },
            {
              path: `contact/edit`,
              name: `StudentEditContact`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `contact.contact`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/EditContact.vue`),
                  __vite__mapDeps([316, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `login`,
              name: `StudentShowLogin`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `student.login.login`,
                label: `student.login.login`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Login.vue`),
                  __vite__mapDeps([317, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `login/edit`,
              name: `StudentEditLogin`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `student.login.login`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/EditLogin.vue`),
                  __vite__mapDeps([318, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `record/change`,
              name: `StudentChangeRecord`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.change`,
                label: `student.record.record`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/ChangeRecord.vue`),
                  __vite__mapDeps([319, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `guardians`,
              name: `StudentGuardian`,
              redirect: {
                name: `StudentGuardianList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...id],
            },
            {
              path: `siblings`,
              name: `StudentSibling`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `student.sibling.sibling`,
                label: `student.sibling.sibling`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Sibling/Index.vue`),
                  __vite__mapDeps([320, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `records`,
              name: `StudentRecord`,
              redirect: {
                name: `StudentRecordList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...X],
            },
            {
              path: `fee`,
              name: `StudentShowFee`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `finance.fee.fee`,
                label: `finance.fee.fee`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Fee/Index.vue`),
                  __vite__mapDeps([321, 1, 2, 3, 4, 5, 6, 7, 8, 24, 25, 21, 22]),
                ),
            },
            {
              path: `wallet`,
              name: `StudentWallet`,
              redirect: {
                name: `StudentWalletTransaction`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
            },
            {
              path: `wallet/transactions`,
              name: `StudentWalletTransaction`,
              redirect: {
                name: `StudentWalletTransactionList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...ad],
            },
            {
              path: `fee/set`,
              name: `StudentSetFee`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `global.set`,
                label: `finance.fee.fee`,
                permissions: [`fee:set`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Fee/Set.vue`),
                  __vite__mapDeps([322, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `fee/edit`,
              name: `StudentEditFee`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `global.edit`,
                label: `finance.fee.fee`,
                permissions: [`fee:edit`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Fee/Edit.vue`),
                  __vite__mapDeps([323, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `optional-fee`,
              name: `StudentOptionalFee`,
              meta: {
                isNotNav: !0,
                permissions: [`fee:set`],
                label: `student.fee.optional_fee`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Fee/OptionalFee.vue`),
                  __vite__mapDeps([324, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `custom-fees`,
              name: `StudentCustomFee`,
              redirect: {
                name: `StudentCustomFeeList`,
              },
              meta: {
                isNotNav: !0,
                permissions: [`fee:set`],
              },
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...fd],
            },
            {
              path: `fee-refunds`,
              name: `StudentFeeRefund`,
              redirect: {
                name: `StudentFeeRefundList`,
              },
              meta: {
                isNotNav: !0,
              },
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...pd],
            },
            {
              path: `attendance`,
              name: `StudentShowAttendance`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `student.attendance.attendance`,
                label: `student.attendance.attendance`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Attendance.vue`),
                  __vite__mapDeps([325, 1, 2, 3, 4, 5, 6, 7, 8, 33]),
                ),
            },
            {
              path: `exam-report`,
              name: `StudentShowExamReport`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `exam.exam_report`,
                label: `exam.exam_report`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/ExamReport.vue`),
                  __vite__mapDeps([326, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `subject`,
              name: `StudentShowSubject`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `academic.subject.subject`,
                label: `academic.subject.subject`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Student/Subject.vue`),
                  __vite__mapDeps([327, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `dialogues`,
              name: `StudentDialogue`,
              redirect: {
                name: `StudentDialogueList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...cd],
            },
            {
              path: `notes`,
              name: `StudentNote`,
              redirect: {
                name: `StudentNoteList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...ld],
            },
            {
              path: `accounts`,
              name: `StudentAccount`,
              redirect: {
                name: `StudentAccountList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...od],
            },
            {
              path: `documents`,
              name: `StudentDocument`,
              redirect: {
                name: `StudentDocumentList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...sd],
            },
            {
              path: `qualifications`,
              name: `StudentQualification`,
              redirect: {
                name: `StudentQualificationList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...ud],
            },
            {
              path: `edit-requests`,
              name: `StudentProfileEditRequest`,
              redirect: {
                name: `StudentProfileEditRequestList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...dd],
            },
          ],
        },
      ],
    },
  ],
  _d = [
    {
      path: `payment-methods`,
      name: `FinancePaymentMethod`,
      redirect: {
        name: `FinancePaymentMethodList`,
      },
      meta: {
        label: `finance.payment_method.payment_method`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`finance:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinancePaymentMethodList`,
          meta: {
            trans: `global.list`,
            label: `finance.payment_method.payment_methods`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/PaymentMethod/Index.vue`),
              __vite__mapDeps([328, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinancePaymentMethodCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.payment_method.payment_method`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/PaymentMethod/Action.vue`),
              __vite__mapDeps([329, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinancePaymentMethodEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.payment_method.payment_method`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/PaymentMethod/Action.vue`),
              __vite__mapDeps([329, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinancePaymentMethodDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.payment_method.payment_method`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/PaymentMethod/Action.vue`),
              __vite__mapDeps([329, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinancePaymentMethodShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.payment_method.payment_method`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/PaymentMethod/Show.vue`),
              __vite__mapDeps([330, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  vd = [
    {
      path: `fee-groups`,
      name: `FinanceFeeGroup`,
      redirect: {
        name: `FinanceFeeGroupList`,
      },
      meta: {
        label: `finance.fee_group.fee_group`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`fee-group:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceFeeGroupList`,
          meta: {
            trans: `global.list`,
            label: `finance.fee_group.fee_groups`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeGroup/Index.vue`),
              __vite__mapDeps([331, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceFeeGroupCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.fee_group.fee_group`,
            permissions: [`fee-group:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeGroup/Action.vue`),
              __vite__mapDeps([332, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceFeeGroupEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.fee_group.fee_group`,
            permissions: [`fee-group:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeGroup/Action.vue`),
              __vite__mapDeps([332, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceFeeGroupDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.fee_group.fee_group`,
            permissions: [`fee-group:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeGroup/Action.vue`),
              __vite__mapDeps([332, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceFeeGroupShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.fee_group.fee_group`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeGroup/Show.vue`),
              __vite__mapDeps([333, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  yd = [
    {
      path: `fee-heads`,
      name: `FinanceFeeHead`,
      redirect: {
        name: `FinanceFeeHeadList`,
      },
      meta: {
        label: `finance.fee_head.fee_head`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`fee-head:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceFeeHeadList`,
          meta: {
            trans: `global.list`,
            label: `finance.fee_head.fee_heads`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeHead/Index.vue`),
              __vite__mapDeps([334, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceFeeHeadCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.fee_head.fee_head`,
            permissions: [`fee-head:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeHead/Action.vue`),
              __vite__mapDeps([335, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceFeeHeadEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.fee_head.fee_head`,
            permissions: [`fee-head:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeHead/Action.vue`),
              __vite__mapDeps([335, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceFeeHeadDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.fee_head.fee_head`,
            permissions: [`fee-head:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeHead/Action.vue`),
              __vite__mapDeps([335, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceFeeHeadShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.fee_head.fee_head`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeHead/Show.vue`),
              __vite__mapDeps([336, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  bd = [
    {
      path: `fee-components`,
      name: `FinanceFeeComponent`,
      redirect: {
        name: `FinanceFeeComponentList`,
      },
      meta: {
        label: `finance.fee_component.fee_component`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`fee-component:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceFeeComponentList`,
          meta: {
            trans: `global.list`,
            label: `finance.fee_component.fee_components`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeComponent/Index.vue`),
              __vite__mapDeps([337, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceFeeComponentCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.fee_component.fee_component`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeComponent/Action.vue`),
              __vite__mapDeps([338, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceFeeComponentEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.fee_component.fee_component`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeComponent/Action.vue`),
              __vite__mapDeps([338, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceFeeComponentDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.fee_component.fee_component`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeComponent/Action.vue`),
              __vite__mapDeps([338, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceFeeComponentShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.fee_component.fee_component`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeComponent/Show.vue`),
              __vite__mapDeps([339, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  xd = [
    {
      path: `fee-concessions`,
      name: `FinanceFeeConcession`,
      redirect: {
        name: `FinanceFeeConcessionList`,
      },
      meta: {
        label: `finance.fee_concession.fee_concession`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`fee-concession:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceFeeConcessionList`,
          meta: {
            trans: `global.list`,
            label: `finance.fee_concession.fee_concessions`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeConcession/Index.vue`),
              __vite__mapDeps([340, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceFeeConcessionCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.fee_concession.fee_concession`,
            permissions: [`fee-concession:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeConcession/Action.vue`),
              __vite__mapDeps([341, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceFeeConcessionEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.fee_concession.fee_concession`,
            permissions: [`fee-concession:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeConcession/Action.vue`),
              __vite__mapDeps([341, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceFeeConcessionDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.fee_concession.fee_concession`,
            permissions: [`fee-concession:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeConcession/Action.vue`),
              __vite__mapDeps([341, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceFeeConcessionShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.fee_concession.fee_concession`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeConcession/Show.vue`),
              __vite__mapDeps([342, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Sd = [
    {
      path: `fee-structure`,
      name: `FinanceFeeStructureIndex`,
      redirect: {
        name: `FinanceFeeStructureList`,
      },
      meta: {
        label: `finance.fee_structure.fee_structure`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`fee-structure:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `print`,
          name: `FinanceFeeStructurePrint`,
          meta: {
            trans: `global.print`,
            label: `finance.fee_structure.fee_structure`,
            keySearch: !0,
            keySearchLabel: `finance.fee_structure.print_fee_structure`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructure/Print/Index.vue`),
              __vite__mapDeps([343, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `fee-structures`,
      name: `FinanceFeeStructure`,
      redirect: {
        name: `FinanceFeeStructureList`,
      },
      meta: {
        isNotNav: !0,
        label: `finance.fee_structure.fee_structure`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`fee-structure:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceFeeStructureList`,
          meta: {
            trans: `global.list`,
            label: `finance.fee_structure.fee_structures`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructure/Index.vue`),
              __vite__mapDeps([344, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `FinanceFeeStructureCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.fee_structure.fee_structure`,
            permissions: [`fee-structure:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructure/Action.vue`),
              __vite__mapDeps([345, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceFeeStructureEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.fee_structure.fee_structure`,
            permissions: [`fee-structure:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructure/Action.vue`),
              __vite__mapDeps([345, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceFeeStructureDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.fee_structure.fee_structure`,
            permissions: [`fee-structure:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructure/Action.vue`),
              __vite__mapDeps([345, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceFeeStructureShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.fee_structure.fee_structure`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructure/Show.vue`),
              __vite__mapDeps([346, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Cd = [
    {
      path: `fee-structure-components`,
      name: `FinanceFeeStructureComponent`,
      redirect: {
        name: `FinanceFeeStructureComponentList`,
      },
      meta: {
        label: `finance.fee_component.fee_component`,
        icon: `fas fa-right-long`,
        isNotNav: !0,
        hideChildren: !0,
        permissions: [`fee-structure:create`, `fee-structure:update`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceFeeStructureComponentList`,
          meta: {
            trans: `global.list`,
            label: `finance.fee_component.fee_components`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructureComponent/Index.vue`),
              __vite__mapDeps([347, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceFeeStructureComponentCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.fee_component.fee_component`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructureComponent/Action.vue`),
              __vite__mapDeps([348, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceFeeStructureComponentEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.fee_component.fee_component`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructureComponent/Action.vue`),
              __vite__mapDeps([348, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceFeeStructureComponentShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.fee_component.fee_component`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/FeeStructureComponent/Show.vue`),
              __vite__mapDeps([349, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  wd = [
    {
      path: `ledger-types`,
      name: `FinanceLedgerType`,
      redirect: {
        name: `FinanceLedgerTypeList`,
      },
      meta: {
        label: `finance.ledger_type.ledger_type`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`ledger-type:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceLedgerTypeList`,
          meta: {
            trans: `global.list`,
            label: `finance.ledger_type.ledger_types`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/LedgerType/Index.vue`),
              __vite__mapDeps([350, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceLedgerTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.ledger_type.ledger_type`,
            permissions: [`ledger-type:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/LedgerType/Action.vue`),
              __vite__mapDeps([351, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceLedgerTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.ledger_type.ledger_type`,
            permissions: [`ledger-type:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/LedgerType/Action.vue`),
              __vite__mapDeps([351, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceLedgerTypeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.ledger_type.ledger_type`,
            permissions: [`ledger-type:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/LedgerType/Action.vue`),
              __vite__mapDeps([351, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceLedgerTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.ledger_type.ledger_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/LedgerType/Show.vue`),
              __vite__mapDeps([352, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Td = [
    {
      path: `ledgers`,
      name: `FinanceLedger`,
      redirect: {
        name: `FinanceLedgerList`,
      },
      meta: {
        label: `finance.ledger.ledger`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`ledger:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceLedgerList`,
          meta: {
            trans: `global.list`,
            label: `finance.ledger.ledgers`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Ledger/Index.vue`),
              __vite__mapDeps([353, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceLedgerCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.ledger.ledger`,
            permissions: [`ledger:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Ledger/Action.vue`),
              __vite__mapDeps([354, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceLedgerEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.ledger.ledger`,
            permissions: [`ledger:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Ledger/Action.vue`),
              __vite__mapDeps([354, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceLedgerDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.ledger.ledger`,
            permissions: [`ledger:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Ledger/Action.vue`),
              __vite__mapDeps([354, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceLedgerShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.ledger.ledger`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Ledger/Show.vue`),
              __vite__mapDeps([355, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ed = [
    {
      path: `taxes`,
      name: `FinanceTax`,
      redirect: {
        name: `FinanceTaxList`,
      },
      meta: {
        label: `finance.tax.tax`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`finance:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceTaxList`,
          meta: {
            trans: `global.list`,
            label: `finance.tax.taxes`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Tax/Index.vue`),
              __vite__mapDeps([356, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceTaxCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.tax.tax`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Tax/Action.vue`),
              __vite__mapDeps([357, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceTaxEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.tax.tax`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Tax/Action.vue`),
              __vite__mapDeps([357, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceTaxDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.tax.tax`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Tax/Action.vue`),
              __vite__mapDeps([357, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceTaxShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.tax.tax`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Tax/Show.vue`),
              __vite__mapDeps([358, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Dd = [
    {
      path: `transactions`,
      name: `FinanceTransaction`,
      redirect: {
        name: `FinanceTransactionList`,
      },
      meta: {
        label: `finance.transaction.transaction`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`transaction:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceTransactionList`,
          meta: {
            trans: `global.list`,
            label: `finance.transaction.transactions`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Transaction/Index.vue`),
              __vite__mapDeps([359, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceTransactionCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.transaction.transaction`,
            permissions: [`transaction:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Transaction/Action.vue`),
              __vite__mapDeps([360, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceTransactionEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.transaction.transaction`,
            permissions: [`transaction:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Transaction/Action.vue`),
              __vite__mapDeps([360, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceTransactionDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.transaction.transaction`,
            permissions: [`transaction:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Transaction/Action.vue`),
              __vite__mapDeps([360, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceTransactionShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.transaction.transaction`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Transaction/Show.vue`),
              __vite__mapDeps([361, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Od = [
    {
      path: `receipts`,
      name: `FinanceReceipt`,
      redirect: {
        name: `FinanceReceiptList`,
      },
      meta: {
        label: `finance.receipt.receipt`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`receipt:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceReceiptList`,
          meta: {
            trans: `global.list`,
            label: `finance.receipt.receipts`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Receipt/Index.vue`),
              __vite__mapDeps([362, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceReceiptCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.receipt.receipt`,
            permissions: [`receipt:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Receipt/Action.vue`),
              __vite__mapDeps([363, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceReceiptEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.receipt.receipt`,
            permissions: [`receipt:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Receipt/Action.vue`),
              __vite__mapDeps([363, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FinanceReceiptDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `finance.receipt.receipt`,
            permissions: [`receipt:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Receipt/Action.vue`),
              __vite__mapDeps([363, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceReceiptShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.receipt.receipt`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Receipt/Show.vue`),
              __vite__mapDeps([364, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  kd = [
    {
      path: `day-closures`,
      name: `FinanceDayClosure`,
      redirect: {
        name: `FinanceDayClosureList`,
      },
      meta: {
        isNotNav: !0,
        label: `finance.day_closure.day_closure`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`transaction:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceDayClosureList`,
          meta: {
            trans: `global.list`,
            label: `finance.day_closure.day_closures`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/DayClosure/Index.vue`),
              __vite__mapDeps([365, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FinanceDayClosureCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `finance.day_closure.day_closure`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/DayClosure/Action.vue`),
              __vite__mapDeps([366, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FinanceDayClosureEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `finance.day_closure.day_closure`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/DayClosure/Action.vue`),
              __vite__mapDeps([366, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
        {
          path: `:uuid`,
          name: `FinanceDayClosureShow`,
          meta: {
            trans: `global.detail`,
            label: `finance.day_closure.day_closure`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/DayClosure/Show.vue`),
              __vite__mapDeps([367, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ad = [
    {
      path: `reports`,
      name: `FinanceReport`,
      redirect: {
        name: `FinanceReportList`,
      },
      meta: {
        label: `general.report`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`finance:report`, `transaction:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FinanceReportList`,
          meta: {
            trans: `global.list`,
            label: `finance.report.report`,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/Index.vue`),
              __vite__mapDeps([368, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `day-book`,
          name: `FinanceReportDayBook`,
          meta: {
            trans: `global.list`,
            label: `finance.report.day_book.day_book`,
            keySearch: !0,
            permissions: [`transaction:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/DayBook/Index.vue`),
              __vite__mapDeps([369, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
        {
          path: `ledger-book`,
          name: `FinanceReportLedgerBook`,
          meta: {
            trans: `global.list`,
            label: `finance.report.ledger_book.ledger_book`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/LedgerBook/Index.vue`),
              __vite__mapDeps([370, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `fee-summary`,
          name: `FinanceReportFeeSummary`,
          meta: {
            trans: `global.list`,
            label: `finance.report.fee_summary.fee_summary`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/FeeSummary/Index.vue`),
              __vite__mapDeps([371, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `fee-concession`,
          name: `FinanceReportFeeConcession`,
          meta: {
            trans: `global.list`,
            label: `finance.report.fee_concession.fee_concession`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/FeeConcession/Index.vue`),
              __vite__mapDeps([372, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `fee-concession-summary`,
          name: `FinanceReportFeeConcessionSummary`,
          meta: {
            trans: `global.list`,
            label: `finance.report.fee_concession_summary.fee_concession_summary`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/FeeConcessionSummary/Index.vue`),
              __vite__mapDeps([373, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `fee-due`,
          name: `FinanceReportFeeDue`,
          meta: {
            trans: `global.list`,
            label: `finance.report.fee_due.fee_due`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/FeeDue/Index.vue`),
              __vite__mapDeps([374, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `installment-wise-fee-due`,
          name: `FinanceReportInstallmentWiseFeeDue`,
          meta: {
            trans: `global.list`,
            label: `finance.report.installment_wise_fee_due.installment_wise_fee_due`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Finance/Report/InstallmentWiseFeeDue/Index.vue`),
              __vite__mapDeps([375, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `fee-head`,
          name: `FinanceReportFeeHead`,
          meta: {
            trans: `global.list`,
            label: `finance.report.fee_head.fee_head`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/FeeHead/Index.vue`),
              __vite__mapDeps([376, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `fee-payment`,
          name: `FinanceReportFeePayment`,
          meta: {
            trans: `global.list`,
            label: `finance.report.fee_payment.fee_payment`,
            keySearch: !0,
            permissions: [`transaction:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/FeePayment/Index.vue`),
              __vite__mapDeps([377, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `online-fee-payment`,
          name: `FinanceReportOnlineFeePayment`,
          meta: {
            trans: `global.list`,
            label: `finance.report.online_fee_payment.online_fee_payment`,
            keySearch: !0,
            permissions: [`transaction:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/OnlineFeePayment/Index.vue`),
              __vite__mapDeps([378, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `head-wise-fee-payment`,
          name: `FinanceReportHeadWiseFeePayment`,
          meta: {
            trans: `global.list`,
            label: `finance.report.head_wise_fee_payment.head_wise_fee_payment`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/HeadWiseFeePayment/Index.vue`),
              __vite__mapDeps([379, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `payment-method-wise-fee-payment`,
          name: `FinanceReportPaymentMethodWiseFeePayment`,
          meta: {
            trans: `global.list`,
            label: `finance.report.payment_method_wise_fee_payment.payment_method_wise_fee_payment`,
            keySearch: !0,
            permissions: [`finance:report`],
          },
          component: () =>
            G(
              () =>
                import(
                  `../../../js/views/Pages/Finance/Report/PaymentMethodWiseFeePayment/Index.vue`
                ),
              __vite__mapDeps([380, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `bank-transfer`,
          name: `FinanceReportBankTransfer`,
          meta: {
            trans: `global.list`,
            label: `finance.report.bank_transfer.bank_transfer`,
            keySearch: !0,
            permissions: [`transaction:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/BankTransfer/Index.vue`),
              __vite__mapDeps([381, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `fee-refund`,
          name: `FinanceReportFeeRefund`,
          meta: {
            trans: `global.list`,
            label: `finance.report.fee_refund.fee_refund`,
            keySearch: !0,
            permissions: [`transaction:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Report/FeeRefund/Index.vue`),
              __vite__mapDeps([382, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  jd = [
    {
      path: `finance`,
      name: `Finance`,
      redirect: {
        name: `FinanceDayClosure`,
      },
      meta: {
        moduleName: `finance`,
        label: `finance.finance`,
        icon: `fas fa-money-bill-alt`,
        permissions: [
          `finance:config`,
          `fee-group:read`,
          `fee-head:read`,
          `fee-concession:read`,
          `fee-structure:read`,
          `ledger-type:read`,
          `ledger:read`,
          `transaction:read`,
          `finance:report`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `FinanceConfig`,
          redirect: {
            name: `FinanceConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`finance:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Finance/Config/Index.vue`),
              __vite__mapDeps([383, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `FinanceConfigGeneral`,
              meta: {
                label: `finance.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Finance/Config/General.vue`),
                  __vite__mapDeps([384, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `transaction-category`,
              prefix: `FinanceConfigTransactionCategory`,
              queryType: `transaction_category`,
              label: `finance.transaction.category.category`,
              transKey: `finance.transaction.category`,
              navs: [
                {
                  label: K(`finance.finance`),
                  path: `FinanceDayClosureList`,
                },
                {
                  label: K(`finance.config.config`),
                  path: `FinanceConfig`,
                },
              ],
            }),
            q({
              path: `fee-concession-type`,
              prefix: `FinanceConfigFeeConcessionType`,
              queryType: `fee_concession_type`,
              label: `finance.fee_concession.type.type`,
              transKey: `finance.fee_concession.type`,
              navs: [
                {
                  label: K(`finance.finance`),
                  path: `FinanceFeeConcessionList`,
                },
                {
                  label: K(`finance.config.config`),
                  path: `FinanceConfig`,
                },
              ],
            }),
            {
              path: `payment-gateway`,
              name: `FinanceConfigPaymentGateway`,
              meta: {
                label: `finance.config.payment_gateway`,
                icon: `far fa-building`,
                key: `payment_gateway`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Finance/Config/PaymentGateway.vue`),
                  __vite__mapDeps([385, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `bank-name`,
              prefix: `FinanceConfigBankName`,
              queryType: `bank_name`,
              label: `finance.bank_name.bank_name`,
              transKey: `finance.bank_name`,
              navs: [
                {
                  label: K(`finance.finance`),
                  path: `Finance`,
                },
                {
                  label: K(`finance.config.config`),
                  path: `FinanceConfig`,
                },
              ],
            }),
            q({
              path: `card-provider`,
              prefix: `FinanceConfigCardProvider`,
              queryType: `card_provider`,
              label: `finance.card_provider.card_provider`,
              transKey: `finance.card_provider`,
              navs: [
                {
                  label: K(`finance.finance`),
                  path: `Finance`,
                },
                {
                  label: K(`finance.config.config`),
                  path: `FinanceConfig`,
                },
              ],
            }),
          ],
        },
        ..._d,
        ...vd,
        ...yd,
        ...bd,
        ...xd,
        ...Sd,
        ...Cd,
        ...wd,
        ...Td,
        ...Ed,
        ...Dd,
        ...Od,
        ...kd,
        ...Ad,
      ],
    },
  ],
  Md = [
    {
      path: `terms`,
      name: `ExamTerm`,
      redirect: {
        name: `ExamTermList`,
      },
      meta: {
        label: `exam.term.term`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`exam-term:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamTermList`,
          meta: {
            trans: `global.list`,
            label: `exam.term.terms`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Term/Index.vue`),
              __vite__mapDeps([386, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `ExamTermCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `exam.term.term`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Term/Action.vue`),
              __vite__mapDeps([387, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ExamTermEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `exam.term.term`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Term/Action.vue`),
              __vite__mapDeps([387, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ExamTermDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `exam.term.term`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Term/Action.vue`),
              __vite__mapDeps([387, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamTermShow`,
          meta: {
            trans: `global.detail`,
            label: `exam.term.term`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Term/Show.vue`),
              __vite__mapDeps([388, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Nd = [
    {
      path: `grades`,
      name: `ExamGrade`,
      redirect: {
        name: `ExamGradeList`,
      },
      meta: {
        label: `exam.grade.grade`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`exam-grade:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamGradeList`,
          meta: {
            trans: `global.list`,
            label: `exam.grade.grades`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Grade/Index.vue`),
              __vite__mapDeps([389, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ExamGradeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `exam.grade.grade`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Grade/Action.vue`),
              __vite__mapDeps([390, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ExamGradeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `exam.grade.grade`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Grade/Action.vue`),
              __vite__mapDeps([390, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ExamGradeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `exam.grade.grade`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Grade/Action.vue`),
              __vite__mapDeps([390, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamGradeShow`,
          meta: {
            trans: `global.detail`,
            label: `exam.grade.grade`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Grade/Show.vue`),
              __vite__mapDeps([391, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Pd = [
    {
      path: `assessments`,
      name: `ExamAssessment`,
      redirect: {
        name: `ExamAssessmentList`,
      },
      meta: {
        label: `exam.assessment.assessment`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`exam-assessment:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamAssessmentList`,
          meta: {
            trans: `global.list`,
            label: `exam.assessment.assessments`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Assessment/Index.vue`),
              __vite__mapDeps([392, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ExamAssessmentCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `exam.assessment.assessment`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Assessment/Action.vue`),
              __vite__mapDeps([393, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ExamAssessmentEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `exam.assessment.assessment`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Assessment/Action.vue`),
              __vite__mapDeps([393, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ExamAssessmentDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `exam.assessment.assessment`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Assessment/Action.vue`),
              __vite__mapDeps([393, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamAssessmentShow`,
          meta: {
            trans: `global.detail`,
            label: `exam.assessment.assessment`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Assessment/Show.vue`),
              __vite__mapDeps([394, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Fd = [
    {
      path: `observations`,
      name: `ExamObservation`,
      redirect: {
        name: `ExamObservationList`,
      },
      meta: {
        label: `exam.observation.observation`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`exam-observation:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamObservationList`,
          meta: {
            trans: `global.list`,
            label: `exam.observation.observations`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Observation/Index.vue`),
              __vite__mapDeps([395, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ExamObservationCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `exam.observation.observation`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Observation/Action.vue`),
              __vite__mapDeps([396, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ExamObservationEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `exam.observation.observation`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Observation/Action.vue`),
              __vite__mapDeps([396, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ExamObservationDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `exam.observation.observation`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Observation/Action.vue`),
              __vite__mapDeps([396, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamObservationShow`,
          meta: {
            trans: `global.detail`,
            label: `exam.observation.observation`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Observation/Show.vue`),
              __vite__mapDeps([397, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Id = [
    {
      path: `competencies`,
      name: `ExamCompetency`,
      redirect: {
        name: `ExamCompetencyList`,
      },
      meta: {
        label: `exam.competency.competency`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`exam-competency:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamCompetencyList`,
          meta: {
            trans: `global.list`,
            label: `exam.competency.competencies`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Competency/Index.vue`),
              __vite__mapDeps([398, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ExamCompetencyCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `exam.competency.competency`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Competency/Action.vue`),
              __vite__mapDeps([399, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ExamCompetencyEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `exam.competency.competency`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Competency/Action.vue`),
              __vite__mapDeps([399, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ExamCompetencyDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `exam.competency.competency`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Competency/Action.vue`),
              __vite__mapDeps([399, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamCompetencyShow`,
          meta: {
            trans: `global.detail`,
            label: `exam.competency.competency`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Competency/Show.vue`),
              __vite__mapDeps([400, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ld = [
    {
      path: `schedules`,
      name: `ExamSchedule`,
      redirect: {
        name: `ExamScheduleList`,
      },
      meta: {
        label: `exam.schedule.schedule`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`exam-schedule:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamScheduleList`,
          meta: {
            trans: `global.list`,
            label: `exam.schedule.schedules`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Schedule/Index.vue`),
              __vite__mapDeps([401, 1, 2, 3, 4, 5, 6, 7, 8, 71]),
            ),
        },
        {
          path: `create`,
          name: `ExamScheduleCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `exam.schedule.schedule`,
            permissions: [`exam-schedule:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Schedule/Action.vue`),
              __vite__mapDeps([402, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ExamScheduleEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `exam.schedule.schedule`,
            permissions: [`exam-schedule:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Schedule/Action.vue`),
              __vite__mapDeps([402, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ExamScheduleDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `exam.schedule.schedule`,
            permissions: [`exam-schedule:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Schedule/Action.vue`),
              __vite__mapDeps([402, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamScheduleShow`,
          meta: {
            trans: `global.detail`,
            label: `exam.schedule.schedule`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Schedule/Show.vue`),
              __vite__mapDeps([403, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/form`,
          name: `ExamScheduleFormSubmission`,
          meta: {
            trans: `global.detail`,
            label: `exam.schedule.form`,
            roles: [`student`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Schedule/FormSubmission.vue`),
              __vite__mapDeps([404, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Rd = [
    {
      path: `forms`,
      name: `ExamForm`,
      redirect: {
        name: `ExamFormList`,
      },
      meta: {
        label: `exam.form.form`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`exam-form:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamFormList`,
          meta: {
            trans: `global.list`,
            label: `exam.form.forms`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Form/Index.vue`),
              __vite__mapDeps([405, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamFormShow`,
          meta: {
            trans: `global.detail`,
            label: `exam.form.form`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Form/Show.vue`),
              __vite__mapDeps([406, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  zd = [
    {
      path: ``,
      name: `ExamOnlineExamQuestionList`,
      meta: {
        trans: `exam.online_exam.question.question`,
        label: `exam.online_exam.question.question`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Exam/OnlineExam/Question/Index.vue`),
          __vite__mapDeps([407, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
        ),
    },
  ],
  Bd = [
    {
      path: ``,
      name: `ExamOnlineExamSubmissionList`,
      meta: {
        trans: `exam.online_exam.submission.submission`,
        label: `exam.online_exam.submission.submission`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Exam/OnlineExam/Submission/Index.vue`),
          __vite__mapDeps([408, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Vd = [
    {
      path: `online-exams`,
      name: `ExamOnlineExam`,
      redirect: {
        name: `ExamOnlineExamList`,
      },
      meta: {
        label: `exam.online_exam.online_exam`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`online-exam:read`],
        keySearch: !0,
        keySearchLabel: `exam.online_exam.online_exam`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamOnlineExamList`,
          meta: {
            trans: `global.list`,
            label: `exam.online_exam.online_exams`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/OnlineExam/Index.vue`),
              __vite__mapDeps([409, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ExamOnlineExamCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `exam.online_exam.online_exam`,
            permission: [`online-exam:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/OnlineExam/Action.vue`),
              __vite__mapDeps([410, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ExamOnlineExamEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `exam.online_exam.online_exam`,
            permission: [`online-exam:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/OnlineExam/Action.vue`),
              __vite__mapDeps([410, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ExamOnlineExamDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `exam.online_exam.online_exam`,
            permission: [`online-exam:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/OnlineExam/Action.vue`),
              __vite__mapDeps([410, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/submit`,
          name: `ExamOnlineExamSubmit`,
          meta: {
            trans: `exam.online_exam.submit`,
            label: `exam.online_exam.submit`,
            role: [`student`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/OnlineExam/Submit.vue`),
              __vite__mapDeps([411, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/submission`,
          name: `ExamOnlineExamStudentSubmission`,
          meta: {
            trans: `exam.online_exam.result`,
            label: `exam.online_exam.result`,
            role: [`student`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/OnlineExam/Submission.vue`),
              __vite__mapDeps([412, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamOnlineExamShow`,
          redirect: {
            name: `ExamOnlineExamShowGeneral`,
          },
          meta: {
            trans: `global.detail`,
            label: `exam.online_exam.online_exam`,
            permissions: [`online-exam:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/OnlineExam/Show.vue`),
              __vite__mapDeps([413, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: ``,
              name: `ExamOnlineExamShowIndex`,
              redirect: {
                name: `ExamOnlineExamShowGeneral`,
              },
            },
            {
              path: `general`,
              name: `ExamOnlineExamShowGeneral`,
              meta: {
                type: `read`,
                action: `read`,
                trans: `general.general`,
                label: `general.general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Exam/OnlineExam/General.vue`),
                  __vite__mapDeps([414, 4, 2]),
                ),
            },
            {
              path: `questions`,
              name: `ExamOnlineExamQuestion`,
              redirect: {
                name: `ExamOnlineExamQuestionList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...zd],
            },
            {
              path: `submissions`,
              name: `ExamOnlineExamSubmission`,
              redirect: {
                name: `ExamOnlineExamSubmissionList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Bd],
            },
          ],
        },
      ],
    },
  ],
  Hd = [
    {
      path: `reports`,
      name: `ExamReport`,
      redirect: {
        name: `ExamReportList`,
      },
      meta: {
        label: `general.report`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`exam:report`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamReportList`,
          meta: {
            trans: `global.list`,
            label: `exam.report.report`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Report/Index.vue`),
              __vite__mapDeps([415, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `mark-summary`,
          name: `ExamReportMarkSummary`,
          meta: {
            trans: `global.list`,
            label: `exam.report.mark_summary.mark_summary`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Report/MarkSummary/Index.vue`),
              __vite__mapDeps([416, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `exam-summary`,
          name: `ExamReportExamSummary`,
          meta: {
            trans: `global.list`,
            label: `exam.report.exam_summary.exam_summary`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Report/ExamSummary/Index.vue`),
              __vite__mapDeps([417, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `consolidated-mark`,
          name: `ExamReportConsolidatedMark`,
          meta: {
            trans: `global.list`,
            label: `exam.report.consolidated_mark.consolidated_mark`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Report/ConsolidatedMark/Index.vue`),
              __vite__mapDeps([418, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ud = [
    {
      path: `exam`,
      name: `ExamIndex`,
      redirect: {
        name: `ExamList`,
      },
      meta: {
        moduleName: `exam`,
        label: `exam.exam`,
        icon: `fas fa-newspaper`,
        permissions: [
          `exam:manage`,
          `exam-term:manage`,
          `exam-grade:manage`,
          `exam-assessment:manage`,
          `exam-observation:manage`,
          `exam-competency:manage`,
          `exam-schedule:read`,
          `exam-form:manage`,
          `online-exam:read`,
          `exam:marks-record`,
          `exam:batch-incharge-wise-marks-record`,
          `exam:subject-incharge-wise-marks-record`,
          `exam:report`,
          `exam-admit-card:access`,
          `exam-marksheet:access`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `ExamConfig`,
          redirect: {
            name: `ExamConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            label: `exam.exam`,
            icon: `fas fa-cog`,
            hideChildren: !0,
            permissions: [`exam:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Config/Index.vue`),
              __vite__mapDeps([419, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `ExamConfigGeneral`,
              meta: {
                label: `exam.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Exam/Config/General.vue`),
                  __vite__mapDeps([420, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: `exams`,
          name: `ExamLists`,
          redirect: {
            name: `ExamList`,
          },
          meta: {
            label: `exam.exams`,
            icon: `fas fa-right-long`,
            permissions: [`exam:manage`],
          },
        },
        ...Md,
        ...Nd,
        ...Pd,
        ...Fd,
        ...Id,
        ...Ld,
        ...Vd,
        ...Rd,
        {
          path: `admit-card`,
          name: `ExamAdmitCard`,
          meta: {
            label: `exam.admit_card.admit_card`,
            icon: `fas fa-right-long`,
            permissions: [`exam-admit-card:access`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/AdmitCard/Index.vue`),
              __vite__mapDeps([421, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `mark`,
          name: `ExamMark`,
          meta: {
            label: `exam.mark`,
            icon: `fas fa-right-long`,
            permissions: [
              `exam:marks-record`,
              `exam:batch-incharge-wise-marks-record`,
              `exam:subject-incharge-wise-marks-record`,
            ],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Mark/Index.vue`),
              __vite__mapDeps([422, 1, 2, 3, 4, 5, 6, 7, 8, 423, 424]),
            ),
        },
        {
          path: `mark/record`,
          name: `ExamMarkRecord`,
          meta: {
            isNotNav: !0,
            label: `exam.mark`,
            icon: `fas fa-right-long`,
            permissions: [
              `exam:marks-record`,
              `exam:batch-incharge-wise-marks-record`,
              `exam:subject-incharge-wise-marks-record`,
            ],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Mark/Record/Index.vue`),
              __vite__mapDeps([425, 1, 2, 3, 4, 5, 6, 7, 8, 423, 424]),
            ),
        },
        {
          path: `observation-mark`,
          name: `ExamObservationMark`,
          meta: {
            isNotNav: !0,
            label: `exam.observation_mark`,
            icon: `fas fa-right-long`,
            permissions: [`exam:marks-record`, `exam:subject-incharge-wise-marks-record`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/ObservationMark/Index.vue`),
              __vite__mapDeps([426, 1, 2, 3, 4, 5, 6, 7, 8, 424]),
            ),
        },
        {
          path: `competency-evaluation`,
          name: `ExamCompetencyEvaluation`,
          meta: {
            isNotNav: !0,
            label: `exam.competency.evaluation`,
            icon: `fas fa-right-long`,
            permissions: [`exam:marks-record`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/CompetencyEvaluation/Index.vue`),
              __vite__mapDeps([427, 1, 2, 3, 4, 5, 6, 7, 8, 424]),
            ),
        },
        {
          path: `comment`,
          name: `ExamComment`,
          meta: {
            isNotNav: !0,
            label: `exam.comment`,
            icon: `fas fa-right-long`,
            permissions: [`exam:marks-record`, `exam:subject-incharge-wise-marks-record`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Comment/Index.vue`),
              __vite__mapDeps([428, 1, 2, 3, 4, 5, 6, 7, 8, 424]),
            ),
        },
        {
          path: `attendance`,
          name: `ExamAttendance`,
          meta: {
            isNotNav: !0,
            label: `student.attendance.attendance`,
            icon: `fas fa-right-long`,
            permissions: [`exam:marks-record`, `exam:subject-incharge-wise-marks-record`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Attendance/Index.vue`),
              __vite__mapDeps([429, 1, 2, 3, 4, 5, 6, 7, 8, 424]),
            ),
        },
        {
          path: `marksheet`,
          name: `ExamMarksheet`,
          redirect: {
            name: `ExamMarksheetPrint`,
          },
          meta: {
            label: `exam.marksheet.marksheet`,
            icon: `fas fa-right-long`,
            permissions: [`exam-marksheet:access`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Marksheet/Index.vue`),
              __vite__mapDeps([430, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `marksheet/legacy`,
          name: `ExamMarksheetLegacy`,
          meta: {
            isNotNav: !0,
            label: `exam.marksheet.marksheet`,
            icon: `fas fa-right-long`,
            permissions: [`exam-marksheet:access`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Marksheet/Index.vue`),
              __vite__mapDeps([430, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `marksheet/process`,
          name: `ExamMarksheetProcess`,
          meta: {
            isNotNav: !0,
            label: `exam.marksheet.marksheet`,
            icon: `fas fa-right-long`,
            permissions: [`exam-marksheet:process`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Marksheet/Process/Index.vue`),
              __vite__mapDeps([431, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `marksheet/print`,
          name: `ExamMarksheetPrint`,
          meta: {
            isNotNav: !0,
            label: `exam.marksheet.marksheet`,
            icon: `fas fa-right-long`,
            permissions: [`exam-marksheet:access`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Marksheet/Print/Index.vue`),
              __vite__mapDeps([432, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        ...Hd,
      ],
    },
    {
      path: `exams`,
      name: `Exam`,
      redirect: {
        name: `ExamList`,
      },
      meta: {
        isNotNav: !0,
        label: `exam.exam`,
        icon: `fas fa-user-graduate`,
        hideChildren: !0,
        permissions: [`exam:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ExamList`,
          meta: {
            trans: `global.list`,
            label: `exam.exams`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Index.vue`),
              __vite__mapDeps([433, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `ExamCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `exam.exam`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Action.vue`),
              __vite__mapDeps([434, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ExamEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `exam.exam`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Action.vue`),
              __vite__mapDeps([434, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ExamDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `exam.exam`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Action.vue`),
              __vite__mapDeps([434, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ExamShow`,
          meta: {
            trans: `global.detail`,
            label: `exam.exam`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Exam/Show.vue`),
              __vite__mapDeps([435, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Wd = [
    {
      path: `departments`,
      name: `EmployeeDepartment`,
      redirect: {
        name: `EmployeeDepartmentList`,
      },
      meta: {
        label: `employee.department.department`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`department:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeDepartmentList`,
          meta: {
            trans: `global.list`,
            label: `employee.department.departments`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Department/Index.vue`),
              __vite__mapDeps([436, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeDepartmentCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.department.department`,
            permissions: [`department:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Department/Action.vue`),
              __vite__mapDeps([437, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeDepartmentEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.department.department`,
            permissions: [`department:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Department/Action.vue`),
              __vite__mapDeps([437, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeDepartmentDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.department.department`,
            permissions: [`department:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Department/Action.vue`),
              __vite__mapDeps([437, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeDepartmentShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.department.department`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Department/Show.vue`),
              __vite__mapDeps([438, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Gd = [
    {
      path: `designations`,
      name: `EmployeeDesignation`,
      redirect: {
        name: `EmployeeDesignationList`,
      },
      meta: {
        label: `employee.designation.designation`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`designation:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeDesignationList`,
          meta: {
            trans: `global.list`,
            label: `employee.designation.designations`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Designation/Index.vue`),
              __vite__mapDeps([439, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `hierarchy`,
          name: `EmployeeDesignationHierarchy`,
          meta: {
            label: `employee.designation.hierarchy_view`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Designation/Hierarchy.vue`),
              __vite__mapDeps([440, 4, 2, 5]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeDesignationCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.designation.designation`,
            permissions: [`designation:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Designation/Action.vue`),
              __vite__mapDeps([441, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeDesignationEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.designation.designation`,
            permissions: [`designation:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Designation/Action.vue`),
              __vite__mapDeps([441, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeDesignationDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.designation.designation`,
            permissions: [`designation:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Designation/Action.vue`),
              __vite__mapDeps([441, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeDesignationShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.designation.designation`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Designation/Show.vue`),
              __vite__mapDeps([442, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Kd = [
    {
      path: `bulk-edit`,
      name: `EmployeeBulkEdit`,
      meta: {
        isNotNav: !0,
        label: `employee.bulk_edit.bulk_edit`,
        icon: `fas fa-right-long`,
        permissions: [`employee:edit`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/BulkEdit/index.vue`),
          __vite__mapDeps([443, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `bulk-edit/address`,
      name: `EmployeeBulkEditAddress`,
      meta: {
        isNotNav: !0,
        label: `employee.bulk_edit.edit_address.edit_address`,
        icon: `fas fa-right-long`,
        permissions: [`employee:edit`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/BulkEdit/EditAddress/Index.vue`),
          __vite__mapDeps([444, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  qd = [
    {
      path: `document-types`,
      name: `EmployeeConfigDocumentType`,
      redirect: {
        name: `EmployeeConfigDocumentTypeList`,
      },
      meta: {
        label: `employee.document_type.document_types`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`employee:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeConfigDocumentTypeList`,
          meta: {
            trans: `global.list`,
            label: `employee.document_type.document_types`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Config/DocumentType/Index.vue`),
              __vite__mapDeps([445, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeConfigDocumentTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.document_type.document_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Config/DocumentType/Action.vue`),
              __vite__mapDeps([446, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeConfigDocumentTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.document_type.document_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Config/DocumentType/Action.vue`),
              __vite__mapDeps([446, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeConfigDocumentTypeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.document_type.document_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Config/DocumentType/Action.vue`),
              __vite__mapDeps([446, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeConfigDocumentTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.document_type.document_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Config/DocumentType/Show.vue`),
              __vite__mapDeps([447, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Jd = [
    {
      path: ``,
      name: `EmployeeRecordList`,
      meta: {
        trans: `global.list`,
        label: `employee.record.records`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Record/Index.vue`),
          __vite__mapDeps([448, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `EmployeeRecordCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `employee.record.record`,
        permissions: [`employment-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Record/Action.vue`),
          __vite__mapDeps([449, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `EmployeeRecordEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `employee.record.record`,
        permissions: [`employment-record:manage`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Record/Action.vue`),
          __vite__mapDeps([449, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `EmployeeRecordShow`,
      meta: {
        trans: `global.detail`,
        label: `employee.record.record`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Record/Show.vue`),
          __vite__mapDeps([450, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Yd = [
    {
      path: ``,
      name: `EmployeeInchargeList`,
      meta: {
        trans: `global.list`,
        label: `employee.incharge.incharges`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Incharge/Index.vue`),
          __vite__mapDeps([451, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Xd = [
    {
      path: ``,
      name: `EmployeeWorkShiftList`,
      meta: {
        trans: `global.list`,
        label: `employee.attendance.work_shift.work_shifts`,
        permissions: [`employee:read`, `work-shift:assign`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/WorkShift/Index.vue`),
          __vite__mapDeps([452, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `EmployeeWorkShiftCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `employee.attendance.work_shift.work_shift`,
        permissions: [`work-shift:assign`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/WorkShift/Action.vue`),
          __vite__mapDeps([453, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `EmployeeWorkShiftEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `employee.attendance.work_shift.work_shift`,
        permissions: [`work-shift:assign`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/WorkShift/Action.vue`),
          __vite__mapDeps([453, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `EmployeeWorkShiftDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `employee.attendance.work_shift.work_shift`,
        permissions: [`work-shift:assign`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/WorkShift/Action.vue`),
          __vite__mapDeps([453, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `EmployeeWorkShiftShow`,
      meta: {
        trans: `global.detail`,
        label: `employee.attendance.work_shift.work_shift`,
        permissions: [`work-shift:assign`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/WorkShift/Show.vue`),
          __vite__mapDeps([454, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Zd = [
    {
      path: ``,
      name: `EmployeeQualificationList`,
      meta: {
        trans: `global.list`,
        label: `employee.qualification.qualifications`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Qualification/Index.vue`),
          __vite__mapDeps([455, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `EmployeeQualificationCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `employee.qualification.qualification`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Qualification/Action.vue`),
          __vite__mapDeps([456, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `EmployeeQualificationEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `employee.qualification.qualification`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Qualification/Action.vue`),
          __vite__mapDeps([456, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `EmployeeQualificationDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `employee.qualification.qualification`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Qualification/Action.vue`),
          __vite__mapDeps([456, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `EmployeeQualificationShow`,
      meta: {
        trans: `global.detail`,
        label: `employee.qualification.qualification`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Qualification/Show.vue`),
          __vite__mapDeps([457, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Qd = [
    {
      path: ``,
      name: `EmployeeDialogueList`,
      meta: {
        trans: `global.list`,
        label: `employee.dialogue.dialogues`,
        permissions: [`employee:dialogue`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Dialogue/Index.vue`),
          __vite__mapDeps([458, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `EmployeeDialogueCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.new`,
        label: `employee.dialogue.dialogue`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Dialogue/Action.vue`),
          __vite__mapDeps([459, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `EmployeeDialogueEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `employee.dialogue.dialogue`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Dialogue/Action.vue`),
          __vite__mapDeps([459, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `EmployeeDialogueDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `employee.dialogue.dialogue`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Dialogue/Action.vue`),
          __vite__mapDeps([459, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `EmployeeDialogueShow`,
      meta: {
        trans: `global.detail`,
        label: `employee.dialogue.dialogue`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Dialogue/Show.vue`),
          __vite__mapDeps([460, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  $d = [
    {
      path: ``,
      name: `EmployeeNoteList`,
      meta: {
        trans: `global.list`,
        label: `note.notes`,
        permissions: [`employee:note`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Note/Index.vue`),
          __vite__mapDeps([461, 1, 2, 3, 4, 5, 6, 7, 8, 462]),
        ),
    },
  ],
  ef = [
    {
      path: ``,
      name: `EmployeeAccountList`,
      meta: {
        trans: `global.list`,
        label: `finance.account.accounts`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Account/Index.vue`),
          __vite__mapDeps([463, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `EmployeeAccountCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `finance.account.account`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Account/Action.vue`),
          __vite__mapDeps([464, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `EmployeeAccountEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `finance.account.account`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Account/Action.vue`),
          __vite__mapDeps([464, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `EmployeeAccountDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `finance.account.account`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Account/Action.vue`),
          __vite__mapDeps([464, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `EmployeeAccountShow`,
      meta: {
        trans: `global.detail`,
        label: `finance.account.account`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Account/Show.vue`),
          __vite__mapDeps([465, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  tf = [
    {
      path: ``,
      name: `EmployeeDocumentList`,
      meta: {
        trans: `global.list`,
        label: `employee.document.documents`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Document/Index.vue`),
          __vite__mapDeps([466, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `EmployeeDocumentCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `employee.document.document`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Document/Action.vue`),
          __vite__mapDeps([467, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `EmployeeDocumentEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `employee.document.document`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Document/Action.vue`),
          __vite__mapDeps([467, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `EmployeeDocumentDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `employee.document.document`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Document/Action.vue`),
          __vite__mapDeps([467, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `EmployeeDocumentShow`,
      meta: {
        trans: `global.detail`,
        label: `employee.document.document`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Document/Show.vue`),
          __vite__mapDeps([468, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  nf = [
    {
      path: ``,
      name: `EmployeeExperienceList`,
      meta: {
        trans: `global.list`,
        label: `employee.experience.experiences`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Experience/Index.vue`),
          __vite__mapDeps([469, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `create`,
      name: `EmployeeExperienceCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `employee.experience.experience`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Experience/Action.vue`),
          __vite__mapDeps([470, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/edit`,
      name: `EmployeeExperienceEdit`,
      meta: {
        type: `edit`,
        action: `update`,
        trans: `global.edit`,
        label: `employee.experience.experience`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Experience/Action.vue`),
          __vite__mapDeps([470, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid/duplicate`,
      name: `EmployeeExperienceDuplicate`,
      meta: {
        type: `duplicate`,
        action: `create`,
        trans: `global.duplicate`,
        label: `employee.experience.experience`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Experience/Action.vue`),
          __vite__mapDeps([470, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `EmployeeExperienceShow`,
      meta: {
        trans: `global.detail`,
        label: `employee.experience.experience`,
        permissions: [`employee:edit`, `employee-record:manage`, `employee:self-service`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Experience/Show.vue`),
          __vite__mapDeps([471, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  rf = [
    {
      path: ``,
      name: `EmployeeProfileEditRequestList`,
      meta: {
        trans: `global.list`,
        label: `finance.edit_request.edit_requests`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/ProfileEditRequest/Index.vue`),
          __vite__mapDeps([472, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `new`,
      name: `EmployeeProfileEditRequestNew`,
      meta: {
        type: `new`,
        action: `create`,
        trans: `global.new`,
        label: `employee.edit_request.edit_request`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/ProfileEditRequest/Action.vue`),
          __vite__mapDeps([473, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:muuid`,
      name: `EmployeeProfileEditRequestShow`,
      meta: {
        trans: `global.detail`,
        label: `employee.edit_request.edit_request`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/ProfileEditRequest/Show.vue`),
          __vite__mapDeps([474, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  af = [
    {
      path: ``,
      name: `EmployeeList`,
      meta: {
        label: `employee.employees`,
        icon: `fas fa-right-long`,
        permissions: [`employee:read`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Index.vue`),
          __vite__mapDeps([475, 1, 2, 3, 4, 5, 6, 7, 8, 71, 20, 45, 476]),
        ),
    },
    {
      path: `config`,
      name: `EmployeeConfig`,
      redirect: {
        name: `EmployeeConfigGeneral`,
      },
      meta: {
        isNotNav: !0,
        type: `config`,
        action: `config`,
        trans: `global.config`,
        label: `config.config`,
        permissions: [`employee:config`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Config/Index.vue`),
          __vite__mapDeps([477, 4, 2]),
        ),
      children: [
        {
          path: ``,
          name: `EmployeeConfigIndex`,
          redirect: {
            name: `EmployeeConfigGeneral`,
          },
        },
        {
          path: `general`,
          name: `EmployeeConfigGeneral`,
          meta: {
            type: `config`,
            action: `config`,
            trans: `config.config`,
            label: `config.config`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Config/General.vue`),
              __vite__mapDeps([478, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        q({
          path: `employment-status`,
          prefix: `EmployeeConfigEmploymentStatus`,
          queryType: `employment_status`,
          label: `employee.employment_status.employment_status`,
          transKey: `employee.employment_status`,
          navs: [
            {
              label: K(`employee.employee`),
              path: `EmployeeList`,
            },
            {
              label: K(`employee.config.config`),
              path: `EmployeeConfig`,
            },
          ],
        }),
        q({
          path: `employment-type`,
          prefix: `EmployeeConfigEmploymentType`,
          queryType: `employment_type`,
          label: `employee.employment_type.employment_type`,
          transKey: `employee.employment_type`,
          navs: [
            {
              label: K(`employee.employee`),
              path: `EmployeeList`,
            },
            {
              label: K(`employee.config.config`),
              path: `EmployeeConfig`,
            },
          ],
        }),
        q({
          path: `dialogue-category`,
          prefix: `EmployeeConfigDialogueCategory`,
          queryType: `employee_dialogue_category`,
          label: `employee.dialogue_category.dialogue_category`,
          transKey: `employee.dialogue_category`,
          navs: [
            {
              label: K(`employee.employee`),
              path: `EmployeeList`,
            },
            {
              label: K(`employee.config.config`),
              path: `EmployeeConfig`,
            },
          ],
        }),
        ...qd,
        q({
          path: `group`,
          prefix: `EmployeeConfigGroup`,
          queryType: `employee_group`,
          label: `employee.group.group`,
          transKey: `employee.group`,
          navs: [
            {
              label: K(`employee.employee`),
              path: `EmployeeList`,
            },
            {
              label: K(`employee.config.config`),
              path: `EmployeeConfig`,
            },
          ],
        }),
      ],
    },
    {
      path: `create`,
      name: `EmployeeCreate`,
      meta: {
        type: `create`,
        action: `create`,
        trans: `global.add`,
        label: `employee.employee`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Action.vue`),
          __vite__mapDeps([479, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `:uuid`,
      name: `EmployeeShow`,
      redirect: {
        name: `EmployeeShowBasic`,
      },
      meta: {
        trans: `global.detail`,
        label: `employee.employee`,
        permissions: [`employee:read`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Show.vue`),
          __vite__mapDeps([480, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
      children: [
        {
          path: ``,
          name: `EmployeeShowIndex`,
          redirect: {
            name: `EmployeeShowBasic`,
          },
        },
        {
          path: `basic`,
          name: `EmployeeShowBasic`,
          meta: {
            type: `read`,
            action: `read`,
            trans: `general.basic`,
            label: `general.basic`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Basic.vue`),
              __vite__mapDeps([481, 1, 2, 3, 4, 5, 6, 7, 8, 482]),
            ),
        },
        {
          path: `basic/edit`,
          name: `EmployeeEditBasic`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.employee`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/EditBasic.vue`),
              __vite__mapDeps([483, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `photo/edit`,
          name: `EmployeeEditPhoto`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `contact.props.photo`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/EditPhoto.vue`),
              __vite__mapDeps([484, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `contact`,
          name: `EmployeeShowContact`,
          meta: {
            type: `general`,
            action: `general`,
            trans: `contact.contact`,
            label: `contact.contact`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Contact.vue`),
              __vite__mapDeps([485, 1, 2, 3, 4, 5, 6, 7, 8, 482]),
            ),
        },
        {
          path: `contact/edit`,
          name: `EmployeeEditContact`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `contact.contact`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/EditContact.vue`),
              __vite__mapDeps([486, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `login`,
          name: `EmployeeShowLogin`,
          meta: {
            type: `general`,
            action: `general`,
            trans: `contact.login.login`,
            label: `contact.login.login`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Login.vue`),
              __vite__mapDeps([487, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `login/edit`,
          name: `EmployeeEditLogin`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `contact.login.login`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/EditLogin.vue`),
              __vite__mapDeps([488, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `records`,
          name: `EmployeeRecord`,
          redirect: {
            name: `EmployeeRecordList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...Jd],
        },
        {
          path: `incharges`,
          name: `EmployeeIncharge`,
          redirect: {
            name: `EmployeeInchargeList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...Yd],
        },
        {
          path: `work-shifts`,
          name: `EmployeeWorkShift`,
          redirect: {
            name: `EmployeeWorkShiftList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...Xd],
        },
        {
          path: `qualifications`,
          name: `EmployeeQualification`,
          redirect: {
            name: `EmployeeQualificationList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...Zd],
        },
        {
          path: `dialogues`,
          name: `EmployeeDialogue`,
          redirect: {
            name: `EmployeeDialogueList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...Qd],
        },
        {
          path: `notes`,
          name: `EmployeeNote`,
          redirect: {
            name: `EmployeeNoteList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...$d],
        },
        {
          path: `accounts`,
          name: `EmployeeAccount`,
          redirect: {
            name: `EmployeeAccountList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...ef],
        },
        {
          path: `documents`,
          name: `EmployeeDocument`,
          redirect: {
            name: `EmployeeDocumentList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...tf],
        },
        {
          path: `experiences`,
          name: `EmployeeExperience`,
          redirect: {
            name: `EmployeeExperienceList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...nf],
        },
        {
          path: `edit-requests`,
          name: `EmployeeProfileEditRequest`,
          redirect: {
            name: `EmployeeProfileEditRequestList`,
          },
          meta: {},
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...rf],
        },
      ],
    },
  ],
  of = [
    {
      path: `types`,
      name: `EmployeeAttendanceType`,
      redirect: {
        name: `EmployeeAttendanceTypeList`,
      },
      meta: {
        label: `employee.attendance.type.type`,
        icon: `fas fa-list-alt`,
        hideChildren: !0,
        permissions: [`attendance:config`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeAttendanceTypeList`,
          meta: {
            trans: `global.list`,
            label: `employee.attendance.type.types`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Type/Index.vue`),
              __vite__mapDeps([489, 1, 2, 3, 4, 5, 6, 7, 8, 490]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeAttendanceTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.attendance.type.type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Type/Action.vue`),
              __vite__mapDeps([491, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeAttendanceTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.attendance.type.type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Type/Action.vue`),
              __vite__mapDeps([491, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeAttendanceTypeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.attendance.type.type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Type/Action.vue`),
              __vite__mapDeps([491, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeAttendanceTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.attendance.type.type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Type/Show.vue`),
              __vite__mapDeps([492, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  sf = [
    {
      path: `work-shift`,
      name: `EmployeeAttendanceWorkShiftReport`,
      meta: {
        trans: `global.report`,
        label: `employee.attendance.work_shift.work_shift`,
        icon: `fas fa-clock`,
        permissions: [`work-shift:read`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Attendance/WorkShift/Assign/Report.vue`),
          __vite__mapDeps([493, 1, 2, 3, 4, 5, 6, 7, 8, 494]),
        ),
    },
    {
      path: `work-shift/assign`,
      name: `EmployeeAttendanceWorkShiftAssign`,
      meta: {
        isNotNav: !0,
        trans: `global.assign`,
        label: `employee.attendance.work_shift.work_shift`,
        permissions: [`work-shift:assign`],
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Employee/Attendance/WorkShift/Assign/Index.vue`),
          __vite__mapDeps([495, 1, 2, 3, 4, 5, 6, 7, 8, 494]),
        ),
    },
    {
      path: `work-shifts`,
      name: `EmployeeAttendanceWorkShift`,
      redirect: {
        name: `EmployeeAttendanceWorkShiftList`,
      },
      meta: {
        isNotNav: !0,
        label: `employee.attendance.work_shift.work_shift`,
        icon: `fas fa-clock`,
        hideChildren: !0,
        permissions: [`work-shift:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeAttendanceWorkShiftList`,
          meta: {
            trans: `global.list`,
            label: `employee.attendance.work_shift.work_shifts`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/WorkShift/Index.vue`),
              __vite__mapDeps([496, 1, 2, 3, 4, 5, 6, 7, 8, 490]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeAttendanceWorkShiftCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.attendance.work_shift.work_shift`,
            permissions: [`work-shift:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/WorkShift/Action.vue`),
              __vite__mapDeps([497, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeAttendanceWorkShiftEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.attendance.work_shift.work_shift`,
            permissions: [`work-shift:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/WorkShift/Action.vue`),
              __vite__mapDeps([497, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeAttendanceWorkShiftDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.attendance.work_shift.work_shift`,
            permissions: [`work-shift:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/WorkShift/Action.vue`),
              __vite__mapDeps([497, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeAttendanceWorkShiftShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.attendance.work_shift.work_shift`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/WorkShift/Show.vue`),
              __vite__mapDeps([498, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  cf = [
    {
      path: `timesheets`,
      name: `EmployeeAttendanceTimesheet`,
      redirect: {
        name: `EmployeeAttendanceTimesheetList`,
      },
      meta: {
        label: `employee.attendance.timesheet.timesheet`,
        icon: `fas fa-stopwatch`,
        hideChildren: !0,
        permissions: [`timesheet:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeAttendanceTimesheetList`,
          meta: {
            trans: `global.list`,
            label: `employee.attendance.timesheet.timesheets`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Timesheet/Index.vue`),
              __vite__mapDeps([499, 1, 2, 3, 4, 5, 6, 7, 8, 490]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeAttendanceTimesheetCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.attendance.timesheet.timesheet`,
            permissions: [`timesheet:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Timesheet/Action.vue`),
              __vite__mapDeps([500, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeAttendanceTimesheetEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.attendance.timesheet.timesheet`,
            permissions: [`timesheet:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Timesheet/Action.vue`),
              __vite__mapDeps([500, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeAttendanceTimesheetDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.attendance.timesheet.timesheet`,
            permissions: [`timesheet:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Timesheet/Action.vue`),
              __vite__mapDeps([500, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeAttendanceTimesheetShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.attendance.timesheet.timesheet`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Timesheet/Show.vue`),
              __vite__mapDeps([501, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  lf = [
    {
      path: `attendance`,
      name: `EmployeeAttendance`,
      redirect: {
        name: `EmployeeAttendanceList`,
      },
      meta: {
        permissions: [`attendance:read`],
        label: `employee.attendance.attendance`,
        icon: `fas fa-right-long`,
        keySearch: !0,
        keySearchLabel: `employee.attendance.employee_attendance`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        ...sf,
        ...cf,
        {
          path: ``,
          name: `EmployeeAttendanceList`,
          meta: {
            icon: `fa-solid fa-table-list`,
            label: `employee.attendance.attendance`,
            permissions: [`attendance:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Index.vue`),
              __vite__mapDeps([502, 1, 2, 3, 4, 5, 6, 7, 8, 503, 490]),
            ),
        },
        {
          path: `mark`,
          name: `EmployeeAttendanceMark`,
          meta: {
            isNotNav: !0,
            label: `employee.attendance.mark`,
            permissions: [`attendance:mark`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Mark.vue`),
              __vite__mapDeps([504, 1, 2, 3, 4, 5, 6, 7, 8, 503]),
            ),
        },
        {
          path: `production`,
          name: `EmployeeAttendanceProduction`,
          meta: {
            isNotNav: !0,
            label: `employee.attendance.mark_production`,
            permissions: [`attendance:mark`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/MarkProduction.vue`),
              __vite__mapDeps([505, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        ...of,
        {
          path: `config`,
          name: `EmployeeAttendanceConfig`,
          redirect: {
            name: `EmployeeAttendanceConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            icon: `fas fa-cog`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`attendance:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Attendance/Config/Index.vue`),
              __vite__mapDeps([506, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `EmployeeAttendanceConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Attendance/Config/General.vue`),
                  __vite__mapDeps([507, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
  ],
  uf = [
    {
      path: `documents`,
      name: `EmployeeDocuments`,
      redirect: {
        name: `EmployeeDocumentsList`,
      },
      meta: {
        isNotNav: !0,
        label: `employee.document.documents`,
        icon: `fas fa-right-long`,
        permissions: [`employee:read`],
        keySearch: !0,
        keySearchLabel: `employee.document.employee_documents`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeDocumentsList`,
          meta: {
            trans: `global.list`,
            label: `employee.document.documents`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Documents/Index.vue`),
              __vite__mapDeps([508, 1, 2, 3, 4, 5, 6, 7, 8, 476]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeDocumentsCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Documents/Action.vue`),
              __vite__mapDeps([509, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeDocumentsEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Documents/Action.vue`),
              __vite__mapDeps([509, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeDocumentsDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Documents/Action.vue`),
              __vite__mapDeps([509, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeDocumentsShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Documents/Show.vue`),
              __vite__mapDeps([510, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  df = [
    {
      path: `accounts`,
      name: `EmployeeAccounts`,
      redirect: {
        name: `EmployeeAccountsList`,
      },
      meta: {
        isNotNav: !0,
        label: `employee.account.accounts`,
        icon: `fas fa-right-long`,
        permissions: [`employee:read`],
        keySearch: !0,
        keySearchLabel: `employee.account.employee_accounts`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeAccountsList`,
          meta: {
            trans: `global.list`,
            label: `employee.account.accounts`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Accounts/Index.vue`),
              __vite__mapDeps([511, 1, 2, 3, 4, 5, 6, 7, 8, 476]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeAccountsCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.account.account`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Accounts/Action.vue`),
              __vite__mapDeps([512, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeAccountsEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.account.account`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Accounts/Action.vue`),
              __vite__mapDeps([512, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeAccountsDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.account.account`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Accounts/Action.vue`),
              __vite__mapDeps([512, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeAccountsShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.account.account`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Accounts/Show.vue`),
              __vite__mapDeps([513, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ff = [
    {
      path: `qualifications`,
      name: `EmployeeQualifications`,
      redirect: {
        name: `EmployeeQualificationsList`,
      },
      meta: {
        isNotNav: !0,
        label: `employee.qualification.qualifications`,
        icon: `fas fa-right-long`,
        permissions: [`employee:read`],
        keySearch: !0,
        keySearchLabel: `employee.qualification.employee_qualifications`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeQualificationsList`,
          meta: {
            trans: `global.list`,
            label: `employee.qualification.qualifications`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Qualifications/Index.vue`),
              __vite__mapDeps([514, 1, 2, 3, 4, 5, 6, 7, 8, 476]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeQualificationsCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.qualification.qualification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Qualifications/Action.vue`),
              __vite__mapDeps([515, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeQualificationsEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.qualification.qualification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Qualifications/Action.vue`),
              __vite__mapDeps([515, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeQualificationsDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.qualification.qualification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Qualifications/Action.vue`),
              __vite__mapDeps([515, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeQualificationsShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.qualification.qualification`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Qualifications/Show.vue`),
              __vite__mapDeps([516, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  pf = [
    {
      path: `experiences`,
      name: `EmployeeExperiences`,
      redirect: {
        name: `EmployeeExperiencesList`,
      },
      meta: {
        isNotNav: !0,
        label: `employee.experience.experiences`,
        icon: `fas fa-right-long`,
        permissions: [`employee:read`],
        keySearch: !0,
        keySearchLabel: `employee.experience.employee_experiences`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeExperiencesList`,
          meta: {
            trans: `global.list`,
            label: `employee.experience.experiences`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Experiences/Index.vue`),
              __vite__mapDeps([517, 1, 2, 3, 4, 5, 6, 7, 8, 476]),
            ),
        },
        {
          path: `create`,
          name: `EmployeeExperiencesCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.experience.experience`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Experiences/Action.vue`),
              __vite__mapDeps([518, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeeExperiencesEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.experience.experience`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Experiences/Action.vue`),
              __vite__mapDeps([518, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `EmployeeExperiencesDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `employee.experience.experience`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Experiences/Action.vue`),
              __vite__mapDeps([518, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeExperiencesShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.experience.experience`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Experiences/Show.vue`),
              __vite__mapDeps([519, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  mf = [
    {
      path: `leave`,
      name: `EmployeeLeave`,
      redirect: {
        name: `EmployeeLeaveRequest`,
      },
      meta: {
        label: `employee.leave.leave`,
        icon: `fas fa-right-long`,
        permissions: [`leave-allocation:read`, `leave-request:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `requests`,
          name: `EmployeeLeaveRequest`,
          redirect: {
            name: `EmployeeLeaveRequestList`,
          },
          meta: {
            label: `employee.leave.request.request`,
            icon: `fas fa-file-medical-alt`,
            hideChildren: !0,
            permissions: [`leave-request:read`],
            keySearch: !0,
            keySearchLabel: `employee.leave.request.employee_request`,
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `EmployeeLeaveRequestList`,
              meta: {
                trans: `global.list`,
                label: `employee.leave.request.requests`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Request/Index.vue`),
                  __vite__mapDeps([520, 1, 2, 3, 4, 5, 6, 7, 8, 521]),
                ),
            },
            {
              path: `create`,
              name: `EmployeeLeaveRequestCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `employee.leave.request.request`,
                permissions: [`leave-request:create`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Request/Action.vue`),
                  __vite__mapDeps([522, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/edit`,
              name: `EmployeeLeaveRequestEdit`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `employee.leave.request.request`,
                permissions: [`leave-request:edit`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Request/Action.vue`),
                  __vite__mapDeps([522, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/duplicate`,
              name: `EmployeeLeaveRequestDuplicate`,
              meta: {
                type: `duplicate`,
                action: `create`,
                trans: `global.duplicate`,
                label: `employee.leave.request.request`,
                permissions: [`leave-request:create`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Request/Action.vue`),
                  __vite__mapDeps([522, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid`,
              name: `EmployeeLeaveRequestShow`,
              meta: {
                trans: `global.detail`,
                label: `employee.leave.request.request`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Request/Show.vue`),
                  __vite__mapDeps([523, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: `allocations`,
          name: `EmployeeLeaveAllocation`,
          redirect: {
            name: `EmployeeLeaveAllocationList`,
          },
          meta: {
            label: `employee.leave.allocation.allocation`,
            icon: `fas fa-user-edit`,
            hideChildren: !0,
            permissions: [`leave-allocation:read`],
            keySearch: !0,
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `EmployeeLeaveAllocationList`,
              meta: {
                trans: `global.list`,
                label: `employee.leave.allocation.allocations`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Allocation/Index.vue`),
                  __vite__mapDeps([524, 1, 2, 3, 4, 5, 6, 7, 8, 521]),
                ),
            },
            {
              path: `create`,
              name: `EmployeeLeaveAllocationCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `employee.leave.allocation.allocation`,
                permissions: [`leave-allocation:create`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Allocation/Action.vue`),
                  __vite__mapDeps([525, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/edit`,
              name: `EmployeeLeaveAllocationEdit`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `employee.leave.allocation.allocation`,
                permissions: [`leave-allocation:edit`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Allocation/Action.vue`),
                  __vite__mapDeps([525, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/duplicate`,
              name: `EmployeeLeaveAllocationDuplicate`,
              meta: {
                type: `duplicate`,
                action: `create`,
                trans: `global.duplicate`,
                label: `employee.leave.allocation.allocation`,
                permissions: [`leave-allocation:create`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Allocation/Action.vue`),
                  __vite__mapDeps([525, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid`,
              name: `EmployeeLeaveAllocationShow`,
              meta: {
                trans: `global.detail`,
                label: `employee.leave.allocation.allocation`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Allocation/Show.vue`),
                  __vite__mapDeps([526, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: `types`,
          name: `EmployeeLeaveType`,
          redirect: {
            name: `EmployeeLeaveTypeList`,
          },
          meta: {
            label: `employee.leave.type.type`,
            icon: `fas fa-list-alt`,
            hideChildren: !0,
            permissions: [`leave:config`],
            keySearch: !0,
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `EmployeeLeaveTypeList`,
              meta: {
                trans: `global.list`,
                label: `employee.leave.type.types`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Type/Index.vue`),
                  __vite__mapDeps([527, 1, 2, 3, 4, 5, 6, 7, 8, 521]),
                ),
            },
            {
              path: `create`,
              name: `EmployeeLeaveTypeCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `employee.leave.type.type`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Type/Action.vue`),
                  __vite__mapDeps([528, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/edit`,
              name: `EmployeeLeaveTypeEdit`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `employee.leave.type.type`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Type/Action.vue`),
                  __vite__mapDeps([528, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/duplicate`,
              name: `EmployeeLeaveTypeDuplicate`,
              meta: {
                type: `duplicate`,
                action: `create`,
                trans: `global.duplicate`,
                label: `employee.leave.type.type`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Type/Action.vue`),
                  __vite__mapDeps([528, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid`,
              name: `EmployeeLeaveTypeShow`,
              meta: {
                trans: `global.detail`,
                label: `employee.leave.type.type`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Type/Show.vue`),
                  __vite__mapDeps([529, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: `config`,
          name: `EmployeeLeaveConfig`,
          redirect: {
            name: `EmployeeLeaveConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            icon: `fas fa-cog`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`leave:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Leave/Config/Index.vue`),
              __vite__mapDeps([530, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `EmployeeLeaveConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Leave/Config/General.vue`),
                  __vite__mapDeps([531, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
  ],
  hf = [
    {
      path: `payroll`,
      name: `EmployeePayroll`,
      redirect: {
        name: `EmployeePayrollList`,
      },
      meta: {
        label: `employee.payroll.payroll`,
        icon: `fas fa-right-long`,
        permissions: [`payroll:read`, `salary-template:read`, `salary-structure:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `EmployeePayrollConfig`,
          redirect: {
            name: `EmployeePayrollConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            icon: `fas fa-cog`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`payroll:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Payroll/Config/Index.vue`),
              __vite__mapDeps([532, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `EmployeePayrollConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/Config/General.vue`),
                  __vite__mapDeps([533, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: ``,
          name: `EmployeePayrollList`,
          meta: {
            label: `employee.payroll.payroll`,
            icon: `fas fa-list-alt`,
            permissions: [`payroll:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Payroll/Index.vue`),
              __vite__mapDeps([534, 1, 2, 3, 4, 5, 6, 7, 8, 71, 45, 535]),
            ),
        },
        {
          path: `salary-structures`,
          name: `EmployeePayrollSalaryStructure`,
          redirect: {
            name: `EmployeePayrollSalaryStructureList`,
          },
          meta: {
            label: `employee.payroll.salary_structure.salary_structure`,
            icon: `fas fa-clone`,
            hideChildren: !0,
            permissions: [`salary-structure:read`],
            keySearch: !0,
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `EmployeePayrollSalaryStructureList`,
              meta: {
                trans: `global.list`,
                label: `employee.payroll.salary_structure.salary_structures`,
              },
              component: () =>
                G(
                  () =>
                    import(`../../../js/views/Pages/Employee/Payroll/SalaryStructure/Index.vue`),
                  __vite__mapDeps([536, 1, 2, 3, 4, 5, 6, 7, 8, 45, 535]),
                ),
            },
            {
              path: `create`,
              name: `EmployeePayrollSalaryStructureCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `employee.payroll.salary_structure.salary_structure`,
                permissions: [`salary-structure:create`],
              },
              component: () =>
                G(
                  () =>
                    import(`../../../js/views/Pages/Employee/Payroll/SalaryStructure/Action.vue`),
                  __vite__mapDeps([537, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/edit`,
              name: `EmployeePayrollSalaryStructureEdit`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `employee.payroll.salary_structure.salary_structure`,
                permissions: [`salary-structure:edit`],
              },
              component: () =>
                G(
                  () =>
                    import(`../../../js/views/Pages/Employee/Payroll/SalaryStructure/Action.vue`),
                  __vite__mapDeps([537, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/duplicate`,
              name: `EmployeePayrollSalaryStructureDuplicate`,
              meta: {
                type: `duplicate`,
                action: `create`,
                trans: `global.duplicate`,
                label: `employee.payroll.salary_structure.salary_structure`,
                permissions: [`salary-structure:create`],
              },
              component: () =>
                G(
                  () =>
                    import(`../../../js/views/Pages/Employee/Payroll/SalaryStructure/Action.vue`),
                  __vite__mapDeps([537, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid`,
              name: `EmployeePayrollSalaryStructureShow`,
              meta: {
                trans: `global.detail`,
                label: `employee.payroll.salary_structure.salary_structure`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/SalaryStructure/Show.vue`),
                  __vite__mapDeps([538, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: `salary-templates`,
          name: `EmployeePayrollSalaryTemplate`,
          redirect: {
            name: `EmployeePayrollSalaryTemplateList`,
          },
          meta: {
            label: `employee.payroll.salary_template.salary_template`,
            icon: `fas fa-folder-open`,
            hideChildren: !0,
            permissions: [`salary-template:read`],
            keySearch: !0,
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `EmployeePayrollSalaryTemplateList`,
              meta: {
                trans: `global.list`,
                label: `employee.payroll.salary_template.salary_templates`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/SalaryTemplate/Index.vue`),
                  __vite__mapDeps([539, 1, 2, 3, 4, 5, 6, 7, 8, 535]),
                ),
            },
            {
              path: `create`,
              name: `EmployeePayrollSalaryTemplateCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `employee.payroll.salary_template.salary_template`,
                permissions: [`salary-template:create`],
              },
              component: () =>
                G(
                  () =>
                    import(`../../../js/views/Pages/Employee/Payroll/SalaryTemplate/Action.vue`),
                  __vite__mapDeps([540, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
                ),
            },
            {
              path: `:uuid/edit`,
              name: `EmployeePayrollSalaryTemplateEdit`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `employee.payroll.salary_template.salary_template`,
                permissions: [`salary-template:edit`],
              },
              component: () =>
                G(
                  () =>
                    import(`../../../js/views/Pages/Employee/Payroll/SalaryTemplate/Action.vue`),
                  __vite__mapDeps([540, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
                ),
            },
            {
              path: `:uuid/duplicate`,
              name: `EmployeePayrollSalaryTemplateDuplicate`,
              meta: {
                type: `duplicate`,
                action: `create`,
                trans: `global.duplicate`,
                label: `employee.payroll.salary_template.salary_template`,
                permissions: [`salary-template:create`],
              },
              component: () =>
                G(
                  () =>
                    import(`../../../js/views/Pages/Employee/Payroll/SalaryTemplate/Action.vue`),
                  __vite__mapDeps([540, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
                ),
            },
            {
              path: `:uuid`,
              name: `EmployeePayrollSalaryTemplateShow`,
              meta: {
                trans: `global.detail`,
                label: `employee.payroll.salary_template.salary_template`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/SalaryTemplate/Show.vue`),
                  __vite__mapDeps([541, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: `pay-heads`,
          name: `EmployeePayrollPayHead`,
          redirect: {
            name: `EmployeePayrollPayHeadList`,
          },
          meta: {
            label: `employee.payroll.pay_head.pay_head`,
            icon: `fas fa-list-alt`,
            hideChildren: !0,
            permissions: [`payroll:config`],
            keySearch: !0,
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `EmployeePayrollPayHeadList`,
              meta: {
                trans: `global.list`,
                label: `employee.payroll.pay_head.pay_heads`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/PayHead/Index.vue`),
                  __vite__mapDeps([542, 1, 2, 3, 4, 5, 6, 7, 8, 63, 535]),
                ),
            },
            {
              path: `create`,
              name: `EmployeePayrollPayHeadCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `employee.payroll.pay_head.pay_head`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/PayHead/Action.vue`),
                  __vite__mapDeps([543, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/edit`,
              name: `EmployeePayrollPayHeadEdit`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `employee.payroll.pay_head.pay_head`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/PayHead/Action.vue`),
                  __vite__mapDeps([543, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/duplicate`,
              name: `EmployeePayrollPayHeadDuplicate`,
              meta: {
                type: `duplicate`,
                action: `create`,
                trans: `global.duplicate`,
                label: `employee.payroll.pay_head.pay_head`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/PayHead/Action.vue`),
                  __vite__mapDeps([543, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid`,
              name: `EmployeePayrollPayHeadShow`,
              meta: {
                trans: `global.detail`,
                label: `employee.payroll.pay_head.pay_head`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Employee/Payroll/PayHead/Show.vue`),
                  __vite__mapDeps([544, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
    {
      path: `payrolls`,
      name: `EmployeePayrolls`,
      redirect: {
        name: `EmployeePayrollList`,
      },
      meta: {
        isNotNav: !0,
        label: `employee.payroll.payrolls`,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeePayrollList`,
          meta: {
            trans: `global.list`,
            label: `employee.payroll.payrolls`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Payroll/Index.vue`),
              __vite__mapDeps([534, 1, 2, 3, 4, 5, 6, 7, 8, 71, 45, 535]),
            ),
        },
        {
          path: `create`,
          name: `EmployeePayrollCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.payroll.payroll`,
            permissions: [`payroll:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Payroll/Action.vue`),
              __vite__mapDeps([545, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
        {
          path: `process`,
          name: `EmployeePayrollProcess`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `employee.payroll.payroll`,
            permissions: [`payroll:process`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Payroll/Process.vue`),
              __vite__mapDeps([546, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `EmployeePayrollEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `employee.payroll.payroll`,
            permissions: [`payroll:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Payroll/Action.vue`),
              __vite__mapDeps([545, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeePayrollShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.payroll.payroll`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/Payroll/Show.vue`),
              __vite__mapDeps([547, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  gf = [
    {
      path: `edit-requests`,
      name: `EmployeeEditRequest`,
      redirect: {
        name: `EmployeeEditRequestList`,
      },
      meta: {
        label: `employee.edit_request.edit_request`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`employee:edit-request-action`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeEditRequestList`,
          meta: {
            trans: `global.list`,
            label: `employee.edit_request.edits_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/EditRequest/Index.vue`),
              __vite__mapDeps([548, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `EmployeeEditRequestShow`,
          meta: {
            trans: `global.detail`,
            label: `employee.edit_request.edit_request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Employee/EditRequest/Show.vue`),
              __vite__mapDeps([549, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  _f = [
    {
      path: `employee`,
      name: `Employee`,
      redirect: {
        name: `EmployeeList`,
      },
      meta: {
        moduleName: `employee`,
        label: `employee.employee`,
        icon: `fas fa-user-tie`,
        permissions: [`employee:read`, `department:read`, `designation:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `EmployeeLists`,
          redirect: {
            name: `EmployeeList`,
          },
          meta: {
            label: `employee.employees`,
            icon: `fas fa-right-long`,
            permissions: [`employee:read`],
          },
        },
        ...Wd,
        ...Gd,
        ...Kd,
        ...lf,
        ...uf,
        ...df,
        ...ff,
        ...pf,
        ...mf,
        ...hf,
        ...gf,
      ],
    },
    {
      path: `employees`,
      name: `Employees`,
      redirect: {
        name: `EmployeeList`,
      },
      meta: {
        isNotNav: !0,
        label: `employee.employees`,
        icon: `fas fa-users`,
        permissions: [`employee:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [...af],
    },
  ],
  vf = [
    {
      path: `attendance`,
      name: `AttendanceAssistant`,
      meta: {
        isNotNav: !0,
        label: `attendance.attendance`,
        icon: `fas fa-laptop-code`,
        roles: [`admin`, `attendance-assistant`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Attendance/Assistant.vue`),
          __vite__mapDeps([550, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `attendance/qr-code`,
      name: `AttendanceQrCode`,
      meta: {
        isNotNav: !0,
        label: `attendance.qr_code`,
        icon: `fas fa-qrcode`,
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Attendance/QrCode.vue`),
          __vite__mapDeps([551, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  yf = [
    {
      path: `diaries`,
      name: `ResourceDiary`,
      redirect: {
        name: `ResourceDiaryList`,
      },
      meta: {
        label: `resource.diary.diary`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`student-diary:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ResourceDiaryList`,
          meta: {
            trans: `global.list`,
            label: `resource.diary.diaries`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Diary/Index.vue`),
              __vite__mapDeps([552, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ResourceDiaryCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `resource.diary.diary`,
            permissions: [`student-diary:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Diary/Action.vue`),
              __vite__mapDeps([553, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `preview`,
          name: `ResourceDiaryPreview`,
          meta: {
            trans: `global.detail`,
            label: `resource.diary.diary`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Diary/Preview.vue`),
              __vite__mapDeps([554, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ResourceDiaryEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `resource.diary.diary`,
            permissions: [`student-diary:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Diary/Action.vue`),
              __vite__mapDeps([553, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ResourceDiaryDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `resource.diary.diary`,
            permissions: [`student-diary:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Diary/Action.vue`),
              __vite__mapDeps([553, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ResourceDiaryShow`,
          meta: {
            trans: `global.detail`,
            label: `resource.diary.diary`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Diary/Show.vue`),
              __vite__mapDeps([555, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  bf = [
    {
      path: `syllabuses`,
      name: `ResourceSyllabus`,
      redirect: {
        name: `ResourceSyllabusList`,
      },
      meta: {
        label: `resource.syllabus.syllabus`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`syllabus:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ResourceSyllabusList`,
          meta: {
            trans: `global.list`,
            label: `resource.syllabus.syllabuses`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Syllabus/Index.vue`),
              __vite__mapDeps([556, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ResourceSyllabusCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `resource.syllabus.syllabus`,
            permissions: [`syllabus:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Syllabus/Action.vue`),
              __vite__mapDeps([557, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ResourceSyllabusEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `resource.syllabus.syllabus`,
            permissions: [`syllabus:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Syllabus/Action.vue`),
              __vite__mapDeps([557, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ResourceSyllabusDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `resource.syllabus.syllabus`,
            permissions: [`syllabus:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Syllabus/Action.vue`),
              __vite__mapDeps([557, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ResourceSyllabusShow`,
          meta: {
            trans: `global.detail`,
            label: `resource.syllabus.syllabus`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Syllabus/Show.vue`),
              __vite__mapDeps([558, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  xf = [
    {
      path: `lesson-plans`,
      name: `ResourceLessonPlan`,
      redirect: {
        name: `ResourceLessonPlanList`,
      },
      meta: {
        label: `resource.lesson_plan.lesson_plan`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`lesson-plan:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ResourceLessonPlanList`,
          meta: {
            trans: `global.list`,
            label: `resource.lesson_plan.lesson_plans`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LessonPlan/Index.vue`),
              __vite__mapDeps([559, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ResourceLessonPlanCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `resource.lesson_plan.lesson_plan`,
            permissions: [`lesson-plan:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LessonPlan/Action.vue`),
              __vite__mapDeps([560, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ResourceLessonPlanEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `resource.lesson_plan.lesson_plan`,
            permissions: [`lesson-plan:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LessonPlan/Action.vue`),
              __vite__mapDeps([560, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ResourceLessonPlanDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `resource.lesson_plan.lesson_plan`,
            permissions: [`lesson-plan:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LessonPlan/Action.vue`),
              __vite__mapDeps([560, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ResourceLessonPlanShow`,
          meta: {
            trans: `global.detail`,
            label: `resource.lesson_plan.lesson_plan`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LessonPlan/Show.vue`),
              __vite__mapDeps([561, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Sf = [
    {
      path: `assignments`,
      name: `ResourceAssignment`,
      redirect: {
        name: `ResourceAssignmentList`,
      },
      meta: {
        label: `resource.assignment.assignment`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`assignment:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ResourceAssignmentList`,
          meta: {
            trans: `global.list`,
            label: `resource.assignment.assignments`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Assignment/Index.vue`),
              __vite__mapDeps([562, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ResourceAssignmentCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `resource.assignment.assignment`,
            permissions: [`assignment:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Assignment/Action.vue`),
              __vite__mapDeps([563, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ResourceAssignmentEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `resource.assignment.assignment`,
            permissions: [`assignment:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Assignment/Action.vue`),
              __vite__mapDeps([563, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ResourceAssignmentDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `resource.assignment.assignment`,
            permissions: [`assignment:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Assignment/Action.vue`),
              __vite__mapDeps([563, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ResourceAssignmentShow`,
          meta: {
            trans: `global.detail`,
            label: `resource.assignment.assignment`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Assignment/Show.vue`),
              __vite__mapDeps([564, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Cf = [
    {
      path: `online-classes`,
      name: `ResourceOnlineClass`,
      redirect: {
        name: `ResourceOnlineClassList`,
      },
      meta: {
        label: `resource.online_class.online_class`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`online-class:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ResourceOnlineClassList`,
          meta: {
            trans: `global.list`,
            label: `resource.online_class.online_classs`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/OnlineClass/Index.vue`),
              __vite__mapDeps([565, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ResourceOnlineClassCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `resource.online_class.online_class`,
            permissions: [`online-class:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/OnlineClass/Action.vue`),
              __vite__mapDeps([566, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ResourceOnlineClassEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `resource.online_class.online_class`,
            permissions: [`online-class:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/OnlineClass/Action.vue`),
              __vite__mapDeps([566, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ResourceOnlineClassDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `resource.online_class.online_class`,
            permissions: [`online-class:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/OnlineClass/Action.vue`),
              __vite__mapDeps([566, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ResourceOnlineClassShow`,
          meta: {
            trans: `global.detail`,
            label: `resource.online_class.online_class`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/OnlineClass/Show.vue`),
              __vite__mapDeps([567, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  wf = [
    {
      path: `learning-materials`,
      name: `ResourceLearningMaterial`,
      redirect: {
        name: `ResourceLearningMaterialList`,
      },
      meta: {
        label: `resource.learning_material.learning_material`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`learning-material:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ResourceLearningMaterialList`,
          meta: {
            trans: `global.list`,
            label: `resource.learning_material.learning_materials`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LearningMaterial/Index.vue`),
              __vite__mapDeps([568, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ResourceLearningMaterialCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `resource.learning_material.learning_material`,
            permissions: [`learning-material:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LearningMaterial/Action.vue`),
              __vite__mapDeps([569, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ResourceLearningMaterialEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `resource.learning_material.learning_material`,
            permissions: [`learning-material:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LearningMaterial/Action.vue`),
              __vite__mapDeps([569, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ResourceLearningMaterialDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `resource.learning_material.learning_material`,
            permissions: [`learning-material:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LearningMaterial/Action.vue`),
              __vite__mapDeps([569, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ResourceLearningMaterialShow`,
          meta: {
            trans: `global.detail`,
            label: `resource.learning_material.learning_material`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/LearningMaterial/Show.vue`),
              __vite__mapDeps([570, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Tf = [
    {
      path: `downloads`,
      name: `ResourceDownload`,
      redirect: {
        name: `ResourceDownloadList`,
      },
      meta: {
        label: `resource.download.download`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`download:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ResourceDownloadList`,
          meta: {
            trans: `global.list`,
            label: `resource.download.downloads`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Download/Index.vue`),
              __vite__mapDeps([571, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ResourceDownloadCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `resource.download.download`,
            permissions: [`download:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Download/Action.vue`),
              __vite__mapDeps([572, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ResourceDownloadEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `resource.download.download`,
            permissions: [`download:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Download/Action.vue`),
              __vite__mapDeps([572, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ResourceDownloadDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `resource.download.download`,
            permissions: [`download:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Download/Action.vue`),
              __vite__mapDeps([572, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ResourceDownloadShow`,
          meta: {
            trans: `global.detail`,
            label: `resource.download.download`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Download/Show.vue`),
              __vite__mapDeps([573, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ef = [
    {
      path: `reports`,
      name: `ResourceReport`,
      redirect: {
        name: `ResourceReportList`,
      },
      meta: {
        label: `general.report`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`resource:report`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ResourceReportList`,
          meta: {
            trans: `global.list`,
            label: `resource.report.report`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Report/Index.vue`),
              __vite__mapDeps([574, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `date-wise-student-diary`,
          name: `ResourceReportDateWiseStudentDiary`,
          meta: {
            trans: `global.list`,
            label: `resource.report.date_wise_student_diary.date_wise_student_diary`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Resource/Report/DateWiseStudentDiary/Index.vue`),
              __vite__mapDeps([575, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `date-wise-assignment`,
          name: `ResourceReportDateWiseAssignment`,
          meta: {
            trans: `global.list`,
            label: `resource.report.date_wise_assignment.date_wise_assignment`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Report/DateWiseAssignment/Index.vue`),
              __vite__mapDeps([576, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `date-wise-learning-material`,
          name: `ResourceReportDateWiseLearningMaterial`,
          meta: {
            trans: `global.list`,
            label: `resource.report.date_wise_learning_material.date_wise_learning_material`,
          },
          component: () =>
            G(
              () =>
                import(
                  `../../../js/views/Pages/Resource/Report/DateWiseLearningMaterial/Index.vue`
                ),
              __vite__mapDeps([577, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Df = [
    {
      path: `resource`,
      name: `Resource`,
      redirect: {
        name: `ResourceAssignment`,
      },
      meta: {
        moduleName: `resource`,
        label: `resource.resource`,
        icon: `fas fa-folder`,
        permissions: [
          `resource:config`,
          `student-diary:read`,
          `assignment:read`,
          `lesson-plan:read`,
          `syllabus:read`,
          `learning-material:read`,
          `download:read`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `ResourceConfig`,
          redirect: {
            name: `ResourceConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`resource:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/Config/Index.vue`),
              __vite__mapDeps([578, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `ResourceConfigGeneral`,
              meta: {
                label: `resource.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Resource/Config/General.vue`),
                  __vite__mapDeps([579, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `assignment-type`,
              prefix: `ResourceConfigAssignmentType`,
              queryType: `assignment_type`,
              label: `resource.assignment.type.type`,
              transKey: `resource.assignment.type`,
              navs: [
                {
                  label: K(`resource.resource`),
                  path: `ResourceAssignmentList`,
                },
                {
                  label: K(`resource.config.config`),
                  path: `ResourceConfig`,
                },
              ],
            }),
          ],
        },
        {
          path: `book-lists`,
          name: `ResourceBookList`,
          meta: {
            icon: `fas fa-right-long`,
            trans: `global.list`,
            label: `resource.book_list.book_lists`,
            permissions: [`book-list:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Resource/BookList/Index.vue`),
              __vite__mapDeps([580, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        ...yf,
        ...bf,
        ...xf,
        ...Sf,
        ...Cf,
        ...wf,
        ...Tf,
        ...Ef,
      ],
    },
  ],
  Of = [
    {
      path: `stoppages`,
      name: `TransportStoppage`,
      redirect: {
        name: `TransportStoppageList`,
      },
      meta: {
        isNotNav: !0,
        label: `transport.stoppage.stoppage`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportStoppageList`,
          meta: {
            trans: `global.list`,
            label: `transport.stoppage.stoppages`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Stoppage/Index.vue`),
              __vite__mapDeps([581, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `TransportStoppageCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.stoppage.stoppage`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Stoppage/Action.vue`),
              __vite__mapDeps([582, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportStoppageEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.stoppage.stoppage`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Stoppage/Action.vue`),
              __vite__mapDeps([582, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportStoppageDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.stoppage.stoppage`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Stoppage/Action.vue`),
              __vite__mapDeps([582, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportStoppageShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.stoppage.stoppage`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Stoppage/Show.vue`),
              __vite__mapDeps([583, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  kf = [
    {
      path: `routes`,
      name: `TransportRoute`,
      redirect: {
        name: `TransportRouteList`,
      },
      meta: {
        label: `transport.route.route`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`transport-route:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportRouteList`,
          meta: {
            trans: `global.list`,
            label: `transport.route.routes`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Route/Index.vue`),
              __vite__mapDeps([584, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `TransportRouteCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.route.route`,
            permissions: [`transport-route:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Route/Action.vue`),
              __vite__mapDeps([585, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportRouteEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.route.route`,
            permissions: [`transport-route:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Route/Action.vue`),
              __vite__mapDeps([585, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportRouteDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.route.route`,
            permissions: [`transport-route:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Route/Action.vue`),
              __vite__mapDeps([585, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportRouteShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.route.route`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Route/Show.vue`),
              __vite__mapDeps([586, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Af = [
    {
      path: `circles`,
      name: `TransportCircle`,
      redirect: {
        name: `TransportCircleList`,
      },
      meta: {
        label: `transport.circle.circle`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`transport-circle:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportCircleList`,
          meta: {
            trans: `global.list`,
            label: `transport.circle.circles`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Circle/Index.vue`),
              __vite__mapDeps([587, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `TransportCircleCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.circle.circle`,
            permissions: [`transport-circle:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Circle/Action.vue`),
              __vite__mapDeps([588, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportCircleEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.circle.circle`,
            permissions: [`transport-circle:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Circle/Action.vue`),
              __vite__mapDeps([588, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportCircleDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.circle.circle`,
            permissions: [`transport-circle:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Circle/Action.vue`),
              __vite__mapDeps([588, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportCircleShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.circle.circle`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Circle/Show.vue`),
              __vite__mapDeps([589, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  jf = [
    {
      path: `fees`,
      name: `TransportFee`,
      redirect: {
        name: `TransportFeeList`,
      },
      meta: {
        label: `transport.fee.fee`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`transport-fee:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportFeeList`,
          meta: {
            trans: `global.list`,
            label: `transport.fee.fees`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Fee/Index.vue`),
              __vite__mapDeps([590, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `TransportFeeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.fee.fee`,
            permissions: [`transport-fee:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Fee/Action.vue`),
              __vite__mapDeps([591, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportFeeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.fee.fee`,
            permissions: [`transport-fee:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Fee/Action.vue`),
              __vite__mapDeps([591, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportFeeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.fee.fee`,
            permissions: [`transport-fee:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Fee/Action.vue`),
              __vite__mapDeps([591, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportFeeShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.fee.fee`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Fee/Show.vue`),
              __vite__mapDeps([592, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Mf = [
    {
      path: `document-types`,
      name: `TransportVehicleConfigDocumentType`,
      redirect: {
        name: `TransportVehicleConfigDocumentTypeList`,
      },
      meta: {
        label: `transport.vehicle.document_type.document_types`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`transport:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleConfigDocumentTypeList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.document_type.document_types`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/DocumentType/Index.vue`),
              __vite__mapDeps([593, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleConfigDocumentTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.document_type.document_type`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/DocumentType/Action.vue`),
              __vite__mapDeps([594, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleConfigDocumentTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.document_type.document_type`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/DocumentType/Action.vue`),
              __vite__mapDeps([594, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleConfigDocumentTypeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.document_type.document_type`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/DocumentType/Action.vue`),
              __vite__mapDeps([594, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleConfigDocumentTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.document_type.document_type`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/DocumentType/Show.vue`),
              __vite__mapDeps([595, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Nf = [
    {
      path: `expense-types`,
      name: `TransportVehicleConfigExpenseType`,
      redirect: {
        name: `TransportVehicleConfigExpenseTypeList`,
      },
      meta: {
        label: `transport.vehicle.expense_type.expense_types`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`transport:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleConfigExpenseTypeList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.expense_type.expense_types`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/ExpenseType/Index.vue`),
              __vite__mapDeps([596, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleConfigExpenseTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.expense_type.expense_type`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/ExpenseType/Action.vue`),
              __vite__mapDeps([597, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleConfigExpenseTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.expense_type.expense_type`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/ExpenseType/Action.vue`),
              __vite__mapDeps([597, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleConfigExpenseTypeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.expense_type.expense_type`,
          },
          component: () =>
            G(
              () =>
                import(`../../../js/views/Pages/Transport/Vehicle/Config/ExpenseType/Action.vue`),
              __vite__mapDeps([597, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleConfigExpenseTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.expense_type.expense_type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Config/ExpenseType/Show.vue`),
              __vite__mapDeps([598, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Pf = [
    {
      path: `incharges`,
      name: `TransportVehicleIncharge`,
      redirect: {
        name: `TransportVehicleInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `transport.vehicle.incharge.incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`vehicle-incharge:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleInchargeList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.incharge.incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Incharge/Index.vue`),
              __vite__mapDeps([599, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.incharge.incharge`,
            permissions: [`vehicle-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Incharge/Action.vue`),
              __vite__mapDeps([600, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.incharge.incharge`,
            permissions: [`vehicle-incharge:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Incharge/Action.vue`),
              __vite__mapDeps([600, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.incharge.incharge`,
            permissions: [`vehicle-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Incharge/Action.vue`),
              __vite__mapDeps([600, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.incharge.incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Incharge/Show.vue`),
              __vite__mapDeps([601, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ff = [
    {
      path: `documents`,
      name: `TransportVehicleDocument`,
      redirect: {
        name: `TransportVehicleDocumentList`,
      },
      meta: {
        label: `transport.vehicle.document.document`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vehicle-document:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleDocumentList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Document/Index.vue`),
              __vite__mapDeps([602, 1, 2, 3, 4, 5, 6, 7, 8, 603]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleDocumentCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.document.document`,
            permissions: [`vehicle-document:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Document/Action.vue`),
              __vite__mapDeps([604, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleDocumentEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.document.document`,
            permissions: [`vehicle-document:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Document/Action.vue`),
              __vite__mapDeps([604, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleDocumentDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.document.document`,
            permissions: [`vehicle-document:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Document/Action.vue`),
              __vite__mapDeps([604, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleDocumentShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.document.document`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Document/Show.vue`),
              __vite__mapDeps([605, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  If = [
    {
      path: `trip-records`,
      name: `TransportVehicleTripRecord`,
      redirect: {
        name: `TransportVehicleTripRecordList`,
      },
      meta: {
        label: `transport.vehicle.trip_record.trip_record`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vehicle-trip-record:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleTripRecordList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.trip_record.trip_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/TripRecord/Index.vue`),
              __vite__mapDeps([606, 1, 2, 3, 4, 5, 6, 7, 8, 603]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleTripRecordCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.trip_record.trip_record`,
            permissions: [`vehicle-trip-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/TripRecord/Action.vue`),
              __vite__mapDeps([607, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleTripRecordEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.trip_record.trip_record`,
            permissions: [`vehicle-trip-record:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/TripRecord/Action.vue`),
              __vite__mapDeps([607, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleTripRecordDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.trip_record.trip_record`,
            permissions: [`vehicle-trip-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/TripRecord/Action.vue`),
              __vite__mapDeps([607, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleTripRecordShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.trip_record.trip_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/TripRecord/Show.vue`),
              __vite__mapDeps([608, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Lf = [
    {
      path: `fuel-records`,
      name: `TransportVehicleFuelRecord`,
      redirect: {
        name: `TransportVehicleFuelRecordList`,
      },
      meta: {
        label: `transport.vehicle.fuel_record.fuel_record`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vehicle-fuel-record:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleFuelRecordList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.fuel_record.fuel_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/FuelRecord/Index.vue`),
              __vite__mapDeps([609, 1, 2, 3, 4, 5, 6, 7, 8, 603]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleFuelRecordCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.fuel_record.fuel_record`,
            permissions: [`vehicle-fuel-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/FuelRecord/Action.vue`),
              __vite__mapDeps([610, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleFuelRecordEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.fuel_record.fuel_record`,
            permissions: [`vehicle-fuel-record:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/FuelRecord/Action.vue`),
              __vite__mapDeps([610, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleFuelRecordDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.fuel_record.fuel_record`,
            permissions: [`vehicle-fuel-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/FuelRecord/Action.vue`),
              __vite__mapDeps([610, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleFuelRecordShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.fuel_record.fuel_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/FuelRecord/Show.vue`),
              __vite__mapDeps([611, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Rf = [
    {
      path: `service-records`,
      name: `TransportVehicleServiceRecord`,
      redirect: {
        name: `TransportVehicleServiceRecordList`,
      },
      meta: {
        label: `transport.vehicle.service_record.service_record`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vehicle-service-record:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleServiceRecordList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.service_record.service_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ServiceRecord/Index.vue`),
              __vite__mapDeps([612, 1, 2, 3, 4, 5, 6, 7, 8, 603]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleServiceRecordCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.service_record.service_record`,
            permissions: [`vehicle-service-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ServiceRecord/Action.vue`),
              __vite__mapDeps([613, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleServiceRecordEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.service_record.service_record`,
            permissions: [`vehicle-service-record:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ServiceRecord/Action.vue`),
              __vite__mapDeps([613, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleServiceRecordDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.service_record.service_record`,
            permissions: [`vehicle-service-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ServiceRecord/Action.vue`),
              __vite__mapDeps([613, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleServiceRecordShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.service_record.service_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ServiceRecord/Show.vue`),
              __vite__mapDeps([614, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  zf = [
    {
      path: `expense-records`,
      name: `TransportVehicleExpenseRecord`,
      redirect: {
        name: `TransportVehicleExpenseRecordList`,
      },
      meta: {
        label: `transport.vehicle.expense_record.expense_record`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vehicle-expense-record:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleExpenseRecordList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.expense_record.expense_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ExpenseRecord/Index.vue`),
              __vite__mapDeps([615, 1, 2, 3, 4, 5, 6, 7, 8, 603]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleExpenseRecordCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.expense_record.expense_record`,
            permissions: [`vehicle-expense-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ExpenseRecord/Action.vue`),
              __vite__mapDeps([616, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleExpenseRecordEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.expense_record.expense_record`,
            permissions: [`vehicle-expense-record:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ExpenseRecord/Action.vue`),
              __vite__mapDeps([616, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleExpenseRecordDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.expense_record.expense_record`,
            permissions: [`vehicle-expense-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ExpenseRecord/Action.vue`),
              __vite__mapDeps([616, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleExpenseRecordShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.expense_record.expense_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/ExpenseRecord/Show.vue`),
              __vite__mapDeps([617, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Bf = [
    {
      path: `case-records`,
      name: `TransportVehicleCaseRecord`,
      redirect: {
        name: `TransportVehicleCaseRecordList`,
      },
      meta: {
        label: `transport.vehicle.case_record.case_record`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vehicle-case-record:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleCaseRecordList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.case_record.case_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/CaseRecord/Index.vue`),
              __vite__mapDeps([618, 1, 2, 3, 4, 5, 6, 7, 8, 603]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleCaseRecordCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.case_record.case_record`,
            permissions: [`vehicle-case-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/CaseRecord/Action.vue`),
              __vite__mapDeps([619, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleCaseRecordEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.case_record.case_record`,
            permissions: [`vehicle-case-record:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/CaseRecord/Action.vue`),
              __vite__mapDeps([619, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleCaseRecordDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.case_record.case_record`,
            permissions: [`vehicle-case-record:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/CaseRecord/Action.vue`),
              __vite__mapDeps([619, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleCaseRecordShow`,
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.case_record.case_record`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/CaseRecord/Show.vue`),
              __vite__mapDeps([620, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Vf = [
    {
      path: ``,
      name: `TransportVehicleDetailDocumentList`,
      meta: {
        trans: `transport.vehicle.document.documents`,
        label: `transport.vehicle.document.documents`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Transport/Vehicle/Detail/Document/Index.vue`),
          __vite__mapDeps([621, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Hf = [
    {
      path: ``,
      name: `TransportVehicleDetailInchargeList`,
      meta: {
        trans: `transport.vehicle.incharge.incharges`,
        label: `transport.vehicle.incharge.incharges`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Transport/Vehicle/Detail/Incharge/Index.vue`),
          __vite__mapDeps([622, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Uf = [
    {
      path: ``,
      name: `TransportVehicleDetailExpenseRecordList`,
      meta: {
        trans: `transport.vehicle.expense_record.expense_records`,
        label: `transport.vehicle.expense_record.expense_records`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Transport/Vehicle/Detail/ExpenseRecord/Index.vue`),
          __vite__mapDeps([623, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Wf = [
    {
      path: ``,
      name: `TransportVehicleDetailCaseRecordList`,
      meta: {
        trans: `transport.vehicle.case_record.case_records`,
        label: `transport.vehicle.case_record.case_records`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Transport/Vehicle/Detail/CaseRecord/Index.vue`),
          __vite__mapDeps([624, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Gf = [
    {
      path: ``,
      name: `TransportVehicleDetailTripRecordList`,
      meta: {
        trans: `transport.vehicle.trip_record.trip_records`,
        label: `transport.vehicle.trip_record.trip_records`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Transport/Vehicle/Detail/TripRecord/Index.vue`),
          __vite__mapDeps([625, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Kf = [
    {
      path: ``,
      name: `TransportVehicleDetailFuelRecordList`,
      meta: {
        trans: `transport.vehicle.fuel_record.fuel_records`,
        label: `transport.vehicle.fuel_record.fuel_records`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Transport/Vehicle/Detail/FuelRecord/Index.vue`),
          __vite__mapDeps([626, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  qf = [
    {
      path: ``,
      name: `TransportVehicleDetailServiceRecordList`,
      meta: {
        trans: `transport.vehicle.service_record.service_records`,
        label: `transport.vehicle.service_record.service_records`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Transport/Vehicle/Detail/ServiceRecord/Index.vue`),
          __vite__mapDeps([627, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Jf = [
    {
      path: `vehicle`,
      name: `TransportVehicleIndex`,
      redirect: {
        name: `TransportVehicleList`,
      },
      meta: {
        isNotNav: !0,
        label: `vehicle.vehicle`,
        icon: `fas fa-right-long`,
        permissions: [
          `vehicle:config`,
          `vehicle-trip-record:read`,
          `vehicle-fuel-record:read`,
          `vehicle-service-record:read`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `TransportVehicleConfig`,
          redirect: {
            name: `TransportVehicleConfigDocumentType`,
          },
          meta: {
            isNotNav: !0,
            label: `transport.vehicle.vehicle`,
            icon: `fas fa-cog`,
            hideChildren: !0,
            permissions: [`vehicle:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Config/Index.vue`),
              __vite__mapDeps([628, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `TransportVehicleConfigGeneral`,
              meta: {
                label: `transport.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Transport/Vehicle/Config/General.vue`),
                  __vite__mapDeps([629, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `type`,
              prefix: `TransportVehicleConfigType`,
              queryType: `vehicle_type`,
              label: `transport.vehicle.type.type`,
              transKey: `transport.vehicle.type`,
              navs: [
                {
                  label: K(`transport.transport`),
                  path: `Transport`,
                },
                {
                  label: K(`transport.vehicle.vehicle`),
                  path: `TransportVehicle`,
                },
                {
                  label: K(`transport.vehicle.config.config`),
                  path: `TransportVehicleConfig`,
                },
              ],
            }),
            ...Mf,
            ...Nf,
            q({
              path: `case-type`,
              prefix: `TransportVehicleConfigCaseType`,
              queryType: `vehicle_case_type`,
              label: `transport.vehicle.case_type.case_type`,
              transKey: `transport.vehicle.case_type`,
              navs: [
                {
                  label: K(`transport.transport`),
                  path: `Transport`,
                },
                {
                  label: K(`transport.vehicle.vehicle`),
                  path: `TransportVehicle`,
                },
                {
                  label: K(`transport.vehicle.config.config`),
                  path: `TransportVehicleConfig`,
                },
              ],
            }),
            q({
              path: `trip-purpose`,
              prefix: `TransportVehicleConfigTripPurpose`,
              queryType: `vehicle_trip_purpose`,
              label: `transport.vehicle.trip_purpose.trip_purpose`,
              transKey: `transport.vehicle.trip_purpose`,
              navs: [
                {
                  label: K(`transport.transport`),
                  path: `Transport`,
                },
                {
                  label: K(`transport.vehicle.vehicle`),
                  path: `TransportVehicle`,
                },
                {
                  label: K(`transport.vehicle.config.config`),
                  path: `TransportVehicleConfig`,
                },
              ],
            }),
          ],
        },
        ...Pf,
        ...Ff,
        ...If,
        ...Lf,
        ...Rf,
        ...zf,
        ...Bf,
      ],
    },
    {
      path: `vehicles`,
      name: `TransportVehicle`,
      redirect: {
        name: `TransportVehicleList`,
      },
      meta: {
        label: `transport.vehicle.vehicle`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vehicle:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportVehicleList`,
          meta: {
            trans: `global.list`,
            label: `transport.vehicle.vehicles`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Index.vue`),
              __vite__mapDeps([630, 1, 2, 3, 4, 5, 6, 7, 8, 71, 603]),
            ),
        },
        {
          path: `create`,
          name: `TransportVehicleCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `transport.vehicle.vehicle`,
            permissions: [`vehicle:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Action.vue`),
              __vite__mapDeps([631, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TransportVehicleEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `transport.vehicle.vehicle`,
            permissions: [`vehicle:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Action.vue`),
              __vite__mapDeps([631, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TransportVehicleDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `transport.vehicle.vehicle`,
            permissions: [`vehicle:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Action.vue`),
              __vite__mapDeps([631, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `TransportVehicleShow`,
          redirect: {
            name: `TransportVehicleShowGeneral`,
          },
          meta: {
            trans: `global.detail`,
            label: `transport.vehicle.vehicle`,
            permissions: [`vehicle:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Vehicle/Show.vue`),
              __vite__mapDeps([632, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: ``,
              name: `TransportVehicleShowIndex`,
              redirect: {
                name: `TransportVehicleShowGeneral`,
              },
            },
            {
              path: `general`,
              name: `TransportVehicleShowGeneral`,
              meta: {
                type: `read`,
                action: `read`,
                trans: `general.general`,
                label: `general.general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Transport/Vehicle/General.vue`),
                  __vite__mapDeps([633, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `documents`,
              name: `TransportVehicleDetailDocument`,
              redirect: {
                name: `TransportVehicleDetailDocumentList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Vf],
            },
            {
              path: `incharges`,
              name: `TransportVehicleDetailIncharge`,
              redirect: {
                name: `TransportVehicleDetailInchargeList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Hf],
            },
            {
              path: `expense-records`,
              name: `TransportVehicleDetailExpense`,
              redirect: {
                name: `TransportVehicleDetailExpenseList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Uf],
            },
            {
              path: `case-records`,
              name: `TransportVehicleDetailCase`,
              redirect: {
                name: `TransportVehicleDetailCaseRecordList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Wf],
            },
            {
              path: `trip-records`,
              name: `TransportVehicleDetailTrip`,
              redirect: {
                name: `TransportVehicleDetailTripRecordList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Gf],
            },
            {
              path: `fuel-records`,
              name: `TransportVehicleDetailFuel`,
              redirect: {
                name: `TransportVehicleDetailFuelRecordList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Kf],
            },
            {
              path: `service-records`,
              name: `TransportVehicleDetailService`,
              redirect: {
                name: `TransportVehicleDetailServiceRecordList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...qf],
            },
          ],
        },
      ],
    },
  ],
  Yf = [
    {
      path: `reports`,
      name: `TransportReport`,
      redirect: {
        name: `TransportReportList`,
      },
      meta: {
        label: `general.report`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`transport:report`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TransportReportList`,
          meta: {
            trans: `global.list`,
            label: `transport.report.report`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Report/Index.vue`),
              __vite__mapDeps([634, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `batch-wise-route`,
          name: `TransportReportBatchWiseRoute`,
          meta: {
            trans: `global.list`,
            label: `transport.report.batch_wise_route.batch_wise_route`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Report/BatchWiseRoute/Index.vue`),
              __vite__mapDeps([635, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `route-wise-student`,
          name: `TransportReportRouteWiseStudent`,
          meta: {
            trans: `global.list`,
            label: `transport.report.route_wise_student.route_wise_student`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Report/RouteWiseStudent/Index.vue`),
              __vite__mapDeps([636, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Xf = [
    {
      path: `transport`,
      name: `Transport`,
      redirect: {
        name: `TransportRoute`,
      },
      meta: {
        moduleName: `transport`,
        label: `transport.transport`,
        icon: `fas fa-truck`,
        permissions: [
          `transport:config`,
          `transport-stoppage:manage`,
          `transport-route:read`,
          `transport-circle:read`,
          `transport-fee:read`,
          `transport:report`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `TransportConfig`,
          redirect: {
            name: `TransportConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`transport:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Transport/Config/Index.vue`),
              __vite__mapDeps([637, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `TransportConfigGeneral`,
              meta: {
                label: `transport.config.config`,
                icon: `far fa-truck`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Transport/Config/General.vue`),
                  __vite__mapDeps([638, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        ...Of,
        ...kf,
        ...Af,
        ...jf,
        ...Jf,
        ...Yf,
      ],
    },
  ],
  Zf = [
    {
      path: `holidays`,
      name: `CalendarHoliday`,
      redirect: {
        name: `CalendarHolidayList`,
      },
      meta: {
        label: `calendar.holiday.holiday`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`holiday:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CalendarHolidayList`,
          meta: {
            trans: `global.list`,
            label: `calendar.holiday.holidays`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Holiday/Index.vue`),
              __vite__mapDeps([639, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `CalendarHolidayCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `calendar.holiday.holiday`,
            permissions: [`holiday:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Holiday/Action.vue`),
              __vite__mapDeps([640, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `CalendarHolidayEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `calendar.holiday.holiday`,
            permissions: [`holiday:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Holiday/Action.vue`),
              __vite__mapDeps([640, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `CalendarHolidayDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `calendar.holiday.holiday`,
            permissions: [`holiday:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Holiday/Action.vue`),
              __vite__mapDeps([640, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `CalendarHolidayShow`,
          meta: {
            trans: `global.detail`,
            label: `calendar.holiday.holiday`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Holiday/Show.vue`),
              __vite__mapDeps([641, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Qf = [
    {
      path: `celebrations`,
      name: `CalendarCelebration`,
      redirect: {
        name: `CalendarCelebrationList`,
      },
      meta: {
        label: `calendar.celebration.celebration`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`celebration:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CalendarCelebrationList`,
          meta: {
            trans: `global.list`,
            label: `calendar.celebration.celebrations`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Celebration/Index.vue`),
              __vite__mapDeps([642, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  $f = [
    {
      path: `events`,
      name: `CalendarEvent`,
      redirect: {
        name: `CalendarEventList`,
      },
      meta: {
        label: `calendar.event.event`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`event:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CalendarEventList`,
          meta: {
            trans: `global.list`,
            label: `calendar.event.events`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Event/Index.vue`),
              __vite__mapDeps([643, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `CalendarEventCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `calendar.event.event`,
            permissions: [`event:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Event/Action.vue`),
              __vite__mapDeps([644, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `CalendarEventEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `calendar.event.event`,
            permissions: [`event:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Event/Action.vue`),
              __vite__mapDeps([644, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `CalendarEventDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `calendar.event.event`,
            permissions: [`event:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Event/Action.vue`),
              __vite__mapDeps([644, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `CalendarEventShow`,
          meta: {
            trans: `global.detail`,
            label: `calendar.event.event`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Event/Show.vue`),
              __vite__mapDeps([645, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ep = [
    {
      path: `calendar`,
      name: `Calendar`,
      redirect: {
        name: `CalendarHoliday`,
      },
      meta: {
        moduleName: `calendar`,
        label: `calendar.calendar`,
        icon: `fas fa-calendar`,
        permissions: [`holiday:read`, `celebration:read`, `event:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `CalendarConfig`,
          redirect: {
            name: `CalendarConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`calendar:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Calendar/Config/Index.vue`),
              __vite__mapDeps([646, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `CalendarConfigGeneral`,
              meta: {
                label: `calendar.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Calendar/Config/General.vue`),
                  __vite__mapDeps([647, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `event-type`,
              prefix: `CalendarConfigEventType`,
              queryType: `event_type`,
              label: `calendar.event.type.type`,
              transKey: `calendar.event.type`,
              navs: [
                {
                  label: K(`calendar.calendar`),
                  path: `CalendarEventList`,
                },
                {
                  label: K(`calendar.config.config`),
                  path: `CalendarConfig`,
                },
              ],
            }),
          ],
        },
        ...Zf,
        ...Qf,
        ...$f,
      ],
    },
  ],
  tp = [
    {
      path: `incharges`,
      name: `InventoryIncharge`,
      redirect: {
        name: `InventoryInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `inventory.incharge.incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`inventory:config`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryInchargeList`,
          meta: {
            trans: `global.list`,
            label: `inventory.incharge.incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Incharge/Index.vue`),
              __vite__mapDeps([648, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.incharge.incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Incharge/Action.vue`),
              __vite__mapDeps([649, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.incharge.incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Incharge/Action.vue`),
              __vite__mapDeps([649, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.incharge.incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Incharge/Action.vue`),
              __vite__mapDeps([649, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.incharge.incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Incharge/Show.vue`),
              __vite__mapDeps([650, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  np = [
    {
      path: `vendors`,
      name: `InventoryVendor`,
      redirect: {
        name: `InventoryVendorList`,
      },
      meta: {
        label: `inventory.vendor.vendor`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vendor:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryVendorList`,
          meta: {
            trans: `global.list`,
            label: `inventory.vendor.vendor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Vendor/Index.vue`),
              __vite__mapDeps([651, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryVendorCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.vendor.vendor`,
            permissions: [`vendor:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Vendor/Action.vue`),
              __vite__mapDeps([652, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryVendorEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.vendor.vendor`,
            permissions: [`vendor:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Vendor/Action.vue`),
              __vite__mapDeps([652, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryVendorDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.vendor.vendor`,
            permissions: [`vendor:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Vendor/Action.vue`),
              __vite__mapDeps([652, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryVendorShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.vendor.vendor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Vendor/Show.vue`),
              __vite__mapDeps([653, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `vendor`,
      name: `InventoryVendorIndex`,
      redirect: {
        name: `InventoryVendorList`,
      },
      meta: {
        isNotNav: !0,
        label: `inventory.vendor.vendor`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`vendor:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `statement`,
          name: `InventoryVendorStatement`,
          meta: {
            trans: `global.list`,
            label: `inventory.vendor.statement.statement`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Vendor/Statement.vue`),
              __vite__mapDeps([654, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  rp = [
    {
      path: `stock-categories`,
      name: `InventoryStockCategory`,
      redirect: {
        name: `InventoryStockCategoryList`,
      },
      meta: {
        label: `inventory.stock_category.category`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-category:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockCategoryList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_category.stock_category`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockCategory/Index.vue`),
              __vite__mapDeps([655, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryStockCategoryCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.stock_category.stock_category`,
            permissions: [`stock-category:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockCategory/Action.vue`),
              __vite__mapDeps([656, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryStockCategoryEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.stock_category.stock_category`,
            permissions: [`stock-category:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockCategory/Action.vue`),
              __vite__mapDeps([656, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryStockCategoryDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.stock_category.stock_category`,
            permissions: [`stock-category:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockCategory/Action.vue`),
              __vite__mapDeps([656, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryStockCategoryShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.stock_category.stock_category`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockCategory/Show.vue`),
              __vite__mapDeps([657, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ip = [
    {
      path: `stock-items`,
      name: `InventoryStockItem`,
      redirect: {
        name: `InventoryStockItemList`,
      },
      meta: {
        label: `inventory.stock_item.item`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-item:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockItemList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_item.stock_item`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockItem/Index.vue`),
              __vite__mapDeps([658, 1, 2, 3, 4, 5, 6, 7, 8, 71, 45]),
            ),
        },
        {
          path: `create`,
          name: `InventoryStockItemCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.stock_item.stock_item`,
            permissions: [`stock-item:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockItem/Action.vue`),
              __vite__mapDeps([659, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryStockItemEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.stock_item.stock_item`,
            permissions: [`stock-item:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockItem/Action.vue`),
              __vite__mapDeps([659, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryStockItemDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.stock_item.stock_item`,
            permissions: [`stock-item:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockItem/Action.vue`),
              __vite__mapDeps([659, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryStockItemShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.stock_item.stock_item`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockItem/Show.vue`),
              __vite__mapDeps([660, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  ap = [
    {
      path: `copies`,
      name: `InventoryStockItemCopy`,
      redirect: {
        name: `InventoryStockItemCopyList`,
      },
      meta: {
        isNotNav: !0,
        label: `inventory.stock_item.copy.copy`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-item:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockItemCopyList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_item.copy.copy`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockItemCopy/Index.vue`),
              __vite__mapDeps([661, 1, 2, 3, 4, 5, 6, 7, 8, 71, 45]),
            ),
        },
      ],
    },
  ],
  op = [
    {
      path: `stock-item/labels`,
      name: `InventoryStockItemLabel`,
      redirect: {
        name: `InventoryStockItemLabelPrint`,
      },
      meta: {
        isNotNav: !0,
        label: `inventory.stock_item.label`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`stock-item:create`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockItemLabelPrint`,
          meta: {
            trans: `global.print`,
            label: `inventory.stock_item.label`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockItemLabel/Print.vue`),
              __vite__mapDeps([662, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  sp = [
    {
      path: `stock-bundles`,
      name: `InventoryStockBundle`,
      redirect: {
        name: `InventoryStockBundleList`,
      },
      meta: {
        label: `inventory.stock_bundle.bundle`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-bundle:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockBundleList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_bundle.stock_bundle`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockBundle/Index.vue`),
              __vite__mapDeps([663, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryStockBundleCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.stock_bundle.stock_bundle`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockBundle/Action.vue`),
              __vite__mapDeps([664, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryStockBundleEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.stock_bundle.stock_bundle`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockBundle/Action.vue`),
              __vite__mapDeps([664, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryStockBundleDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.stock_bundle.stock_bundle`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockBundle/Action.vue`),
              __vite__mapDeps([664, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryStockBundleShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.stock_bundle.stock_bundle`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockBundle/Show.vue`),
              __vite__mapDeps([665, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  cp = [
    {
      path: `stock-requisitions`,
      name: `InventoryStockRequisition`,
      redirect: {
        name: `InventoryStockRequisitionList`,
      },
      meta: {
        label: `inventory.stock_requisition.requisition`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-requisition:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockRequisitionList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_requisition.stock_requisition`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockRequisition/Index.vue`),
              __vite__mapDeps([666, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryStockRequisitionCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.stock_requisition.stock_requisition`,
            permissions: [`stock-requisition:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockRequisition/Action.vue`),
              __vite__mapDeps([667, 1, 2, 3, 4, 5, 6, 7, 8, 668]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryStockRequisitionEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.stock_requisition.stock_requisition`,
            permissions: [`stock-requisition:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockRequisition/Action.vue`),
              __vite__mapDeps([667, 1, 2, 3, 4, 5, 6, 7, 8, 668]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryStockRequisitionDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.stock_requisition.stock_requisition`,
            permissions: [`stock-requisition:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockRequisition/Action.vue`),
              __vite__mapDeps([667, 1, 2, 3, 4, 5, 6, 7, 8, 668]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryStockRequisitionShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.stock_requisition.stock_requisition`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockRequisition/Show.vue`),
              __vite__mapDeps([669, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  lp = [
    {
      path: `stock-purchases`,
      name: `InventoryStockPurchase`,
      redirect: {
        name: `InventoryStockPurchaseList`,
      },
      meta: {
        label: `inventory.stock_purchase.purchase`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-purchase:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockPurchaseList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_purchase.stock_purchase`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockPurchase/Index.vue`),
              __vite__mapDeps([670, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryStockPurchaseCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.stock_purchase.stock_purchase`,
            permissions: [`stock-purchase:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockPurchase/Action.vue`),
              __vite__mapDeps([671, 1, 2, 3, 4, 5, 6, 7, 8, 24, 668]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryStockPurchaseEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.stock_purchase.stock_purchase`,
            permissions: [`stock-purchase:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockPurchase/Action.vue`),
              __vite__mapDeps([671, 1, 2, 3, 4, 5, 6, 7, 8, 24, 668]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryStockPurchaseDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.stock_purchase.stock_purchase`,
            permissions: [`stock-purchase:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockPurchase/Action.vue`),
              __vite__mapDeps([671, 1, 2, 3, 4, 5, 6, 7, 8, 24, 668]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryStockPurchaseShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.stock_purchase.stock_purchase`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockPurchase/Show.vue`),
              __vite__mapDeps([672, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  up = [
    {
      path: `stock-returns`,
      name: `InventoryStockReturn`,
      redirect: {
        name: `InventoryStockReturnList`,
      },
      meta: {
        label: `inventory.stock_return.return`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-return:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockReturnList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_return.stock_return`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockReturn/Index.vue`),
              __vite__mapDeps([673, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryStockReturnCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.stock_return.stock_return`,
            permissions: [`stock-return:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockReturn/Action.vue`),
              __vite__mapDeps([674, 1, 2, 3, 4, 5, 6, 7, 8, 668]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryStockReturnEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.stock_return.stock_return`,
            permissions: [`stock-return:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockReturn/Action.vue`),
              __vite__mapDeps([674, 1, 2, 3, 4, 5, 6, 7, 8, 668]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryStockReturnDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.stock_return.stock_return`,
            permissions: [`stock-return:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockReturn/Action.vue`),
              __vite__mapDeps([674, 1, 2, 3, 4, 5, 6, 7, 8, 668]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryStockReturnShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.stock_return.stock_return`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockReturn/Show.vue`),
              __vite__mapDeps([675, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  dp = [
    {
      path: `stock-transfers`,
      name: `InventoryStockTransfer`,
      redirect: {
        name: `InventoryStockTransferList`,
      },
      meta: {
        label: `inventory.stock_transfer.transfer`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-transfer:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockTransferList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_transfer.stock_transfer`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockTransfer/Index.vue`),
              __vite__mapDeps([676, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryStockTransferCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.stock_transfer.stock_transfer`,
            permissions: [`stock-transfer:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockTransfer/Action.vue`),
              __vite__mapDeps([677, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryStockTransferEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.stock_transfer.stock_transfer`,
            permissions: [`stock-transfer:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockTransfer/Action.vue`),
              __vite__mapDeps([677, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryStockTransferDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.stock_transfer.stock_transfer`,
            permissions: [`stock-transfer:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockTransfer/Action.vue`),
              __vite__mapDeps([677, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryStockTransferShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.stock_transfer.stock_transfer`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockTransfer/Show.vue`),
              __vite__mapDeps([678, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  fp = [
    {
      path: `stock-adjustments`,
      name: `InventoryStockAdjustment`,
      redirect: {
        name: `InventoryStockAdjustmentList`,
      },
      meta: {
        label: `inventory.stock_adjustment.adjustment`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`stock-adjustment:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryStockAdjustmentList`,
          meta: {
            trans: `global.list`,
            label: `inventory.stock_adjustment.stock_adjustment`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockAdjustment/Index.vue`),
              __vite__mapDeps([679, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryStockAdjustmentCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.stock_adjustment.stock_adjustment`,
            permissions: [`stock-adjustment:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockAdjustment/Action.vue`),
              __vite__mapDeps([680, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryStockAdjustmentEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.stock_adjustment.stock_adjustment`,
            permissions: [`stock-adjustment:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockAdjustment/Action.vue`),
              __vite__mapDeps([680, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryStockAdjustmentDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.stock_adjustment.stock_adjustment`,
            permissions: [`stock-adjustment:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockAdjustment/Action.vue`),
              __vite__mapDeps([680, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryStockAdjustmentShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.stock_adjustment.stock_adjustment`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/StockAdjustment/Show.vue`),
              __vite__mapDeps([681, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  pp = [
    {
      path: `reports`,
      name: `InventoryReport`,
      redirect: {
        name: `InventoryReportList`,
      },
      meta: {
        label: `general.report`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`inventory:report`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryReportList`,
          meta: {
            trans: `global.list`,
            label: `inventory.report.report`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Report/Index.vue`),
              __vite__mapDeps([682, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `item-summary`,
          name: `InventoryReportItemSummary`,
          meta: {
            trans: `global.list`,
            label: `inventory.report.item_summary.item_summary`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Report/ItemSummary/Index.vue`),
              __vite__mapDeps([683, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  mp = [
    {
      path: `inventories`,
      name: `Inventory`,
      redirect: {
        name: `InventoryList`,
      },
      meta: {
        isNotNav: !0,
        label: `inventory.inventory`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`inventory:config`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `InventoryList`,
          meta: {
            trans: `global.list`,
            label: `inventory.inventory`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Index.vue`),
              __vite__mapDeps([684, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `InventoryCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `inventory.inventory`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Action.vue`),
              __vite__mapDeps([685, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `InventoryEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `inventory.inventory`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Action.vue`),
              __vite__mapDeps([685, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `InventoryDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `inventory.inventory`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Action.vue`),
              __vite__mapDeps([685, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `InventoryShow`,
          meta: {
            trans: `global.detail`,
            label: `inventory.inventory`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Show.vue`),
              __vite__mapDeps([686, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `inventory`,
      name: `InventoryIndex`,
      redirect: {
        name: `InventoryStockPurchase`,
      },
      meta: {
        moduleName: `inventory`,
        label: `inventory.inventory`,
        icon: `fas fa-warehouse`,
        permissions: [
          `inventory:config`,
          `stock-category:read`,
          `stock-item:read`,
          `stock-requisition:read`,
          `stock-purchase:read`,
          `stock-transfer:read`,
          `stock-adjustment:read`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `InventoryConfig`,
          redirect: {
            name: `InventoryConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`inventory:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Inventory/Config/Index.vue`),
              __vite__mapDeps([687, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `InventoryConfigGeneral`,
              meta: {
                label: `inventory.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Inventory/Config/General.vue`),
                  __vite__mapDeps([688, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `unit`,
              prefix: `InventoryConfigUnit`,
              queryType: `unit`,
              label: `inventory.unit.unit`,
              transKey: `inventory.unit`,
              navs: [
                {
                  label: K(`inventory.inventory`),
                  path: `InventoryList`,
                },
                {
                  label: K(`inventory.config.config`),
                  path: `InventoryConfig`,
                },
              ],
            }),
            q({
              path: `stock_item_condition`,
              prefix: `InventoryConfigStockItemCondition`,
              queryType: `stock_item_condition`,
              label: `inventory.stock_item_condition.stock_item_condition`,
              transKey: `inventory.stock_item_condition`,
              navs: [
                {
                  label: K(`inventory.inventory`),
                  path: `InventoryList`,
                },
                {
                  label: K(`inventory.config.config`),
                  path: `InventoryConfig`,
                },
              ],
            }),
          ],
        },
        ...tp,
        ...np,
        ...rp,
        ...ip,
        ...sp,
        {
          path: `stock-item`,
          name: `InventoryStockItemIndex`,
          redirect: {
            name: `InventoryStockItemCopy`,
          },
          meta: {
            isNotNav: !0,
            label: `inventory.stock_item.stock_item`,
          },
          children: [...ap],
        },
        ...op,
        ...cp,
        ...lp,
        ...up,
        ...dp,
        ...fp,
        ...pp,
      ],
    },
  ],
  hp = [
    {
      path: `store`,
      name: `Store`,
      redirect: {
        name: `StoreStockSale`,
      },
      meta: {
        moduleName: `store`,
        label: `store.store`,
        icon: `fas fa-shop`,
        permissions: [`stock-sale:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `StoreConfig`,
          redirect: {
            name: `StoreConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`inventory:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Store/Config/Index.vue`),
              __vite__mapDeps([689, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `StoreConfigGeneral`,
              meta: {
                label: `inventory.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Store/Config/General.vue`),
                  __vite__mapDeps([690, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: `stock-sales`,
          name: `StoreStockSale`,
          redirect: {
            name: `StoreStockSaleList`,
          },
          meta: {
            label: `store.stock_sale.sale`,
            icon: `fas fa-right-long`,
            hideChildren: !0,
            permissions: [`stock-sale:read`],
            keySearch: !0,
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `StoreStockSaleList`,
              meta: {
                trans: `global.list`,
                label: `store.stock_sale.stock_sale`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Store/StockSale/Index.vue`),
                  __vite__mapDeps([691, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `create`,
              name: `StoreStockSaleCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `store.stock_sale.stock_sale`,
                permissions: [`stock-sale:create`],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Store/StockSale/Action.vue`),
                  __vite__mapDeps([692, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
                ),
            },
            {
              path: `:uuid`,
              name: `StoreStockSaleShow`,
              meta: {
                trans: `global.detail`,
                label: `store.stock_sale.stock_sale`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Store/StockSale/Show.vue`),
                  __vite__mapDeps([693, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
  ],
  gp = [
    {
      path: `announcements`,
      name: `CommunicationAnnouncement`,
      redirect: {
        name: `CommunicationAnnouncementList`,
      },
      meta: {
        label: `communication.announcement.announcement`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`announcement:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CommunicationAnnouncementList`,
          meta: {
            trans: `global.list`,
            label: `communication.announcement.announcements`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Announcement/Index.vue`),
              __vite__mapDeps([694, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `CommunicationAnnouncementCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `communication.announcement.announcement`,
            permissions: [`announcement:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Announcement/Action.vue`),
              __vite__mapDeps([695, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `CommunicationAnnouncementEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `communication.announcement.announcement`,
            permissions: [`announcement:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Announcement/Action.vue`),
              __vite__mapDeps([695, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `CommunicationAnnouncementDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `communication.announcement.announcement`,
            permissions: [`announcement:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Announcement/Action.vue`),
              __vite__mapDeps([695, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `CommunicationAnnouncementShow`,
          meta: {
            trans: `global.detail`,
            label: `communication.announcement.announcement`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Announcement/Show.vue`),
              __vite__mapDeps([696, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  _p = [
    {
      path: `emails`,
      name: `CommunicationEmail`,
      redirect: {
        name: `CommunicationEmailList`,
      },
      meta: {
        label: `communication.email.email`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`email:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CommunicationEmailList`,
          meta: {
            trans: `global.list`,
            label: `communication.email.emails`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Email/Index.vue`),
              __vite__mapDeps([697, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `new`,
          name: `CommunicationEmailNew`,
          meta: {
            type: `new`,
            action: `create`,
            trans: `global.add`,
            label: `communication.email.email`,
            permissions: [`email:send`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Email/Action.vue`),
              __vite__mapDeps([698, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `CommunicationEmailDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `communication.email.email`,
            permissions: [`email:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Email/Action.vue`),
              __vite__mapDeps([698, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `CommunicationEmailShow`,
          meta: {
            trans: `global.detail`,
            label: `communication.email.email`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Email/Show.vue`),
              __vite__mapDeps([699, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  vp = [
    {
      path: `sms`,
      name: `CommunicationSMS`,
      redirect: {
        name: `CommunicationSMSList`,
      },
      meta: {
        label: `communication.sms.sms`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`sms:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CommunicationSMSList`,
          meta: {
            trans: `global.list`,
            label: `communication.sms.sms`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/SMS/Index.vue`),
              __vite__mapDeps([700, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `new`,
          name: `CommunicationSMSNew`,
          meta: {
            type: `new`,
            action: `create`,
            trans: `global.add`,
            label: `communication.sms.sms`,
            permissions: [`sms:send`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/SMS/Action.vue`),
              __vite__mapDeps([701, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `CommunicationSMSDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `communication.sms.sms`,
            permissions: [`sms:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/SMS/Action.vue`),
              __vite__mapDeps([701, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `CommunicationSMSShow`,
          meta: {
            trans: `global.detail`,
            label: `communication.sms.sms`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/SMS/Show.vue`),
              __vite__mapDeps([702, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  yp = [
    {
      path: `whatsapp`,
      name: `CommunicationWhatsApp`,
      redirect: {
        name: `CommunicationWhatsAppList`,
      },
      meta: {
        label: `communication.whatsapp.whatsapp`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`whatsapp:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CommunicationWhatsAppList`,
          meta: {
            trans: `global.list`,
            label: `communication.whatsapp.whatsapp`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/WhatsApp/Index.vue`),
              __vite__mapDeps([703, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `new`,
          name: `CommunicationWhatsAppNew`,
          meta: {
            type: `new`,
            action: `create`,
            trans: `global.add`,
            label: `communication.whatsapp.whatsapp`,
            permissions: [`whatsapp:send`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/WhatsApp/Action.vue`),
              __vite__mapDeps([704, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `CommunicationWhatsAppDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `communication.whatsapp.whatsapp`,
            permissions: [`whatsapp:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/WhatsApp/Action.vue`),
              __vite__mapDeps([704, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `CommunicationWhatsAppShow`,
          meta: {
            trans: `global.detail`,
            label: `communication.whatsapp.whatsapp`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/WhatsApp/Show.vue`),
              __vite__mapDeps([705, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  bp = [
    {
      path: `push-messages`,
      name: `CommunicationPushMessage`,
      redirect: {
        name: `CommunicationPushMessageList`,
      },
      meta: {
        label: `communication.push_message.push_message`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`push-message:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `CommunicationPushMessageList`,
          meta: {
            trans: `global.list`,
            label: `communication.push_message.push_message`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/PushMessage/Index.vue`),
              __vite__mapDeps([706, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `new`,
          name: `CommunicationPushMessageNew`,
          meta: {
            type: `new`,
            action: `create`,
            trans: `global.add`,
            label: `communication.push_message.push_message`,
            permissions: [`push-message:send`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/PushMessage/Action.vue`),
              __vite__mapDeps([707, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `CommunicationPushMessageDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `communication.push_message.push_message`,
            permissions: [`push-message:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/PushMessage/Action.vue`),
              __vite__mapDeps([707, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `CommunicationPushMessageShow`,
          meta: {
            trans: `global.detail`,
            label: `communication.push_message.push_message`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/PushMessage/Show.vue`),
              __vite__mapDeps([708, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  xp = [
    {
      path: `communication`,
      name: `Communication`,
      redirect: {
        name: `CommunicationAnnouncement`,
      },
      meta: {
        moduleName: `communication`,
        label: `communication.communication`,
        icon: `fas fa-bullhorn`,
        permissions: [
          `communication:config`,
          `announcement:read`,
          `email:read`,
          `sms:read`,
          `push-message:read`,
          `whatsapp:read`,
        ],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `CommunicationConfig`,
          redirect: {
            name: `CommunicationConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`communication:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Communication/Config/Index.vue`),
              __vite__mapDeps([709, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `CommunicationConfigGeneral`,
              meta: {
                label: `communication.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Communication/Config/General.vue`),
                  __vite__mapDeps([710, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `announcement-type`,
              prefix: `CommunicationConfigAnnouncementType`,
              queryType: `announcement_type`,
              label: `communication.announcement.type.type`,
              transKey: `communication.announcement.type`,
              navs: [
                {
                  label: K(`communication.communication`),
                  path: `CommunicationAnnouncementList`,
                },
                {
                  label: K(`communication.config.config`),
                  path: `CommunicationConfig`,
                },
              ],
            }),
          ],
        },
        ...gp,
        ..._p,
        ...vp,
        ...yp,
        ...bp,
      ],
    },
  ],
  Sp = [
    {
      path: `books`,
      name: `LibraryBook`,
      redirect: {
        name: `LibraryBookList`,
      },
      meta: {
        label: `library.book.book`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`book:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `LibraryBookList`,
          meta: {
            trans: `global.list`,
            label: `library.book.book`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Book/Index.vue`),
              __vite__mapDeps([711, 1, 2, 3, 4, 5, 6, 7, 8, 71]),
            ),
        },
        {
          path: `create`,
          name: `LibraryBookCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `library.book.book`,
            permissions: [`book:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Book/Action.vue`),
              __vite__mapDeps([712, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `LibraryBookEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `library.book.book`,
            permissions: [`book:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Book/Action.vue`),
              __vite__mapDeps([712, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `LibraryBookDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `library.book.book`,
            permissions: [`book:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Book/Action.vue`),
              __vite__mapDeps([712, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `LibraryBookShow`,
          meta: {
            trans: `global.detail`,
            label: `library.book.book`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Book/Show.vue`),
              __vite__mapDeps([713, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Cp = [
    {
      path: `copies`,
      name: `LibraryBookCopy`,
      redirect: {
        name: `LibraryBookCopyList`,
      },
      meta: {
        isNotNav: !0,
        label: `library.book.copy.copy`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`book:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `LibraryBookCopyList`,
          meta: {
            trans: `global.list`,
            label: `library.book.copy.copy`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/BookCopy/Index.vue`),
              __vite__mapDeps([714, 1, 2, 3, 4, 5, 6, 7, 8, 71, 45]),
            ),
        },
      ],
    },
  ],
  wp = [
    {
      path: `book/labels`,
      name: `LibraryBookLabel`,
      redirect: {
        name: `LibraryBookLabelPrint`,
      },
      meta: {
        isNotNav: !0,
        label: `library.book.label`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`book:create`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `LibraryBookLabelPrint`,
          meta: {
            trans: `global.print`,
            label: `library.book.label`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/BookLabel/Print.vue`),
              __vite__mapDeps([715, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Tp = [
    {
      path: `book-additions`,
      name: `LibraryBookAddition`,
      redirect: {
        name: `LibraryBookAdditionList`,
      },
      meta: {
        label: `library.book_addition.book_addition`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`book-addition:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `LibraryBookAdditionList`,
          meta: {
            trans: `global.list`,
            label: `library.book_addition.book_addition`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/BookAddition/Index.vue`),
              __vite__mapDeps([716, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `LibraryBookAdditionCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `library.book_addition.book_addition`,
            permissions: [`book-addition:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/BookAddition/Action.vue`),
              __vite__mapDeps([717, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `LibraryBookAdditionEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `library.book_addition.book_addition`,
            permissions: [`book-addition:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/BookAddition/Action.vue`),
              __vite__mapDeps([717, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `LibraryBookAdditionDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `library.book_addition.book_addition`,
            permissions: [`book-addition:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/BookAddition/Action.vue`),
              __vite__mapDeps([717, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `LibraryBookAdditionShow`,
          meta: {
            trans: `global.detail`,
            label: `library.book_addition.book_addition`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/BookAddition/Show.vue`),
              __vite__mapDeps([718, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Ep = [
    {
      path: `transactions`,
      name: `LibraryTransaction`,
      redirect: {
        name: `LibraryTransactionList`,
      },
      meta: {
        label: `library.transaction.issue_return`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`book:issue`, `book:return`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `LibraryTransactionList`,
          meta: {
            trans: `global.list`,
            label: `library.transaction.transaction`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Transaction/Index.vue`),
              __vite__mapDeps([719, 1, 2, 3, 4, 5, 6, 7, 8, 71]),
            ),
        },
        {
          path: `create`,
          name: `LibraryTransactionCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `library.transaction.transaction`,
            permissions: [`book:issue`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Transaction/Action.vue`),
              __vite__mapDeps([720, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `LibraryTransactionEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `library.transaction.transaction`,
            permissions: [`book:issue`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Transaction/Action.vue`),
              __vite__mapDeps([720, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `LibraryTransactionShow`,
          meta: {
            trans: `global.detail`,
            label: `library.transaction.transaction`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Transaction/Show.vue`),
              __vite__mapDeps([721, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Dp = [
    {
      path: `book-wise-transactions`,
      name: `LibraryBookWiseTransaction`,
      redirect: {
        name: `LibraryBookWiseTransactionList`,
      },
      meta: {
        isNotNav: !0,
        label: `library.transaction.book_wise_issue_return`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`book:issue`, `book:return`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `LibraryBookWiseTransactionList`,
          meta: {
            trans: `global.list`,
            label: `library.transaction.book_wise_issue_return`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/BookWiseTransaction/Index.vue`),
              __vite__mapDeps([722, 1, 2, 3, 4, 5, 6, 7, 8, 71]),
            ),
        },
      ],
    },
  ],
  Op = [
    {
      path: `reports`,
      name: `LibraryReport`,
      redirect: {
        name: `LibraryReportList`,
      },
      meta: {
        label: `general.report`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`library:report`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `LibraryReportList`,
          meta: {
            trans: `global.list`,
            label: `library.report.report`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Report/Index.vue`),
              __vite__mapDeps([723, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `top-borrower`,
          name: `LibraryReportTopBorrower`,
          meta: {
            trans: `global.list`,
            label: `library.report.top_borrower.top_borrower`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Report/TopBorrower/Index.vue`),
              __vite__mapDeps([724, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `top-book`,
          name: `LibraryReportTopBorrowedBook`,
          meta: {
            trans: `global.list`,
            label: `library.report.top_borrowed_book.top_borrowed_book`,
            keySearch: !0,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Report/TopBorrowedBook/Index.vue`),
              __vite__mapDeps([725, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  kp = [
    {
      path: `library`,
      name: `Library`,
      redirect: {
        name: `LibraryBook`,
      },
      meta: {
        moduleName: `library`,
        label: `library.library`,
        icon: `fas fa-book`,
        permissions: [`library:config`, `book:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `LibraryConfig`,
          redirect: {
            name: `LibraryConfigBookAuthor`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`library:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Library/Config/Index.vue`),
              __vite__mapDeps([726, 4, 2]),
            ),
          children: [
            {
              path: ``,
              name: `LibraryConfigIndex`,
              redirect: {
                name: `LibraryConfigGeneral`,
              },
            },
            {
              path: `general`,
              name: `LibraryConfigGeneral`,
              meta: {
                label: `library.config.config`,
                icon: `far fa-books`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Library/Config/General.vue`),
                  __vite__mapDeps([727, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `book-author`,
              prefix: `LibraryConfigBookAuthor`,
              queryType: `book_author`,
              label: `library.book_author.book_author`,
              transKey: `library.book_author`,
              navs: [
                {
                  label: K(`library.library`),
                  path: `LibraryBookList`,
                },
                {
                  label: K(`library.config.config`),
                  path: `LibraryConfig`,
                },
              ],
            }),
            q({
              path: `book-language`,
              prefix: `LibraryConfigBookLanguage`,
              queryType: `book_language`,
              label: `library.book_language.book_language`,
              transKey: `library.book_language`,
              navs: [
                {
                  label: K(`library.library`),
                  path: `LibraryBookList`,
                },
                {
                  label: K(`library.config.config`),
                  path: `LibraryConfig`,
                },
              ],
            }),
            q({
              path: `book-publisher`,
              prefix: `LibraryConfigBookPublisher`,
              queryType: `book_publisher`,
              label: `library.book_publisher.book_publisher`,
              transKey: `library.book_publisher`,
              navs: [
                {
                  label: K(`library.library`),
                  path: `LibraryBookList`,
                },
                {
                  label: K(`library.config.config`),
                  path: `LibraryConfig`,
                },
              ],
            }),
            q({
              path: `book-topic`,
              prefix: `LibraryConfigBookTopic`,
              queryType: `book_topic`,
              label: `library.book_topic.book_topic`,
              transKey: `library.book_topic`,
              navs: [
                {
                  label: K(`library.library`),
                  path: `LibraryBookList`,
                },
                {
                  label: K(`library.config.config`),
                  path: `LibraryConfig`,
                },
              ],
            }),
            q({
              path: `book-condition`,
              prefix: `LibraryConfigBookCondition`,
              queryType: `book_condition`,
              label: `library.book_condition.book_condition`,
              transKey: `library.book_condition`,
              navs: [
                {
                  label: K(`library.library`),
                  path: `LibraryBookList`,
                },
                {
                  label: K(`library.config.config`),
                  path: `LibraryConfig`,
                },
              ],
            }),
            q({
              path: `book-category`,
              prefix: `LibraryConfigBookCategory`,
              queryType: `book_category`,
              label: `library.book_category.book_category`,
              transKey: `library.book_category`,
              navs: [
                {
                  label: K(`library.library`),
                  path: `LibraryBookList`,
                },
                {
                  label: K(`library.config.config`),
                  path: `LibraryConfig`,
                },
              ],
            }),
          ],
        },
        ...Sp,
        {
          path: `book`,
          name: `LibraryBookIndex`,
          redirect: {
            name: `LibraryBookCopy`,
          },
          meta: {
            isNotNav: !0,
            label: `library.book.book`,
          },
          children: [...Cp],
        },
        ...wp,
        ...Tp,
        ...Ep,
        ...Dp,
        ...Op,
      ],
    },
  ],
  Ap = [
    {
      path: `types`,
      name: `ApprovalType`,
      redirect: {
        name: `ApprovalTypeList`,
      },
      meta: {
        label: `approval.type.type`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`approval-type:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ApprovalTypeList`,
          meta: {
            trans: `global.list`,
            label: `approval.type.types`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Type/Index.vue`),
              __vite__mapDeps([728, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ApprovalTypeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `approval.type.type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Type/Action.vue`),
              __vite__mapDeps([729, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ApprovalTypeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `approval.type.type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Type/Action.vue`),
              __vite__mapDeps([729, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ApprovalTypeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `approval.type.type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Type/Action.vue`),
              __vite__mapDeps([729, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid`,
          name: `ApprovalTypeShow`,
          meta: {
            trans: `global.detail`,
            label: `approval.type.type`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Type/Show.vue`),
              __vite__mapDeps([730, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  jp = [
    {
      path: `requests`,
      name: `ApprovalRequest`,
      redirect: {
        name: `ApprovalRequestList`,
      },
      meta: {
        label: `approval.request.request`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`approval-request:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ApprovalRequestList`,
          meta: {
            trans: `global.list`,
            label: `approval.request.requests`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Request/Index.vue`),
              __vite__mapDeps([731, 1, 2, 3, 4, 5, 6, 7, 8, 732]),
            ),
        },
        {
          path: `create`,
          name: `ApprovalRequestCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `approval.request.request`,
            permissions: [`approval-request:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Request/Action.vue`),
              __vite__mapDeps([733, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ApprovalRequestEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `approval.request.request`,
            permissions: [`approval-request:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Request/Action.vue`),
              __vite__mapDeps([733, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ApprovalRequestDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `approval.request.request`,
            permissions: [`approval-request:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Request/Action.vue`),
              __vite__mapDeps([733, 1, 2, 3, 4, 5, 6, 7, 8, 24]),
            ),
        },
        {
          path: `:uuid`,
          name: `ApprovalRequestShow`,
          meta: {
            trans: `global.detail`,
            label: `approval.request.request`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Request/Show.vue`),
              __vite__mapDeps([734, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
    {
      path: `requests/pending`,
      name: `ApprovalRequestPendingList`,
      meta: {
        label: `approval.request.pending_requests`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`approval-request:read`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Approval/Request/Pending.vue`),
          __vite__mapDeps([735, 1, 2, 3, 4, 5, 6, 7, 8, 732]),
        ),
    },
    {
      path: `requests/processed`,
      name: `ApprovalRequestProcessedList`,
      meta: {
        label: `approval.request.processed_requests`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`approval-request:read`],
        keySearch: !0,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Approval/Request/Processed.vue`),
          __vite__mapDeps([736, 1, 2, 3, 4, 5, 6, 7, 8, 732]),
        ),
    },
  ],
  Mp = [
    {
      path: `approval`,
      name: `Approval`,
      redirect: {
        name: `ApprovalRequest`,
      },
      meta: {
        moduleName: `approval`,
        label: `approval.approval`,
        icon: `fas fa-thumbs-up`,
        permissions: [`approval:config`, `approval-type:manage`, `approval-request:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `ApprovalConfig`,
          redirect: {
            name: `ApprovalConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`approval:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Approval/Config/Index.vue`),
              __vite__mapDeps([737, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `ApprovalConfigGeneral`,
              meta: {
                label: `approval.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Approval/Config/General.vue`),
                  __vite__mapDeps([738, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `request-group`,
              prefix: `ApprovalConfigRequestGroup`,
              queryType: `approval_request_group`,
              label: `approval.request.group.group`,
              transKey: `approval.request.group`,
              navs: [
                {
                  label: K(`approval.approval`),
                  path: `Approval`,
                },
                {
                  label: K(`approval.config.config`),
                  path: `ApprovalConfig`,
                },
              ],
            }),
            q({
              path: `request-nature`,
              prefix: `ApprovalConfigRequestNature`,
              queryType: `approval_request_nature`,
              label: `approval.request.nature.nature`,
              transKey: `approval.request.nature`,
              navs: [
                {
                  label: K(`approval.approval`),
                  path: `Approval`,
                },
                {
                  label: K(`approval.config.config`),
                  path: `ApprovalConfig`,
                },
              ],
            }),
            q({
              path: `request-priority`,
              prefix: `ApprovalConfigRequestPriority`,
              queryType: `approval_request_priority`,
              label: `approval.request.priority.priority`,
              transKey: `approval.request.priority`,
              navs: [
                {
                  label: K(`approval.approval`),
                  path: `Approval`,
                },
                {
                  label: K(`approval.config.config`),
                  path: `ApprovalConfig`,
                },
              ],
            }),
          ],
        },
        ...Ap,
        ...jp,
      ],
    },
  ],
  Np = [
    {
      path: ``,
      name: `TaskChecklistList`,
      meta: {
        trans: `task.checklist.checklist`,
        label: `task.checklist.checklist`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Task/Checklist/Index.vue`),
          __vite__mapDeps([739, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Pp = [
    {
      path: ``,
      name: `TaskMemberList`,
      meta: {
        trans: `task.member.member`,
        label: `task.member.member`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Task/Member/Index.vue`),
          __vite__mapDeps([740, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Fp = [
    {
      path: ``,
      name: `TaskMediaList`,
      meta: {
        trans: `task.media.media`,
        label: `task.media.media`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Task/Media/Index.vue`),
          __vite__mapDeps([741, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Ip = [
    {
      path: ``,
      name: `TaskRepeatList`,
      meta: {
        trans: `task.repeat.repeat`,
        label: `task.repeat.repeat`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Task/Repeat/Index.vue`),
          __vite__mapDeps([742, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Lp = [
    {
      path: `task`,
      name: `Task`,
      redirect: {
        name: `TaskList`,
      },
      meta: {
        moduleName: `task`,
        label: `task.task`,
        icon: `fas fa-list-check`,
        permissions: [`task:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
    },
    {
      path: `tasks`,
      name: `Tasks`,
      redirect: {
        name: `TaskList`,
      },
      meta: {
        isNotNav: !0,
        label: `task.tasks`,
        icon: `fas fa-list-check`,
        permissions: [`task:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `TaskList`,
          meta: {
            label: `task.tasks`,
            icon: `fas fa-chevron-right`,
            permissions: [`task:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Task/Index.vue`),
              __vite__mapDeps([743, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `dashboard`,
          name: `TaskDashboard`,
          meta: {
            noPadding: !0,
            label: `task.dashboard.dashboard`,
            icon: `fas fa-home`,
            permissions: [`task:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Task/Dashboard/Index.vue`),
              __vite__mapDeps([744, 1, 2, 3, 4, 5, 6, 7, 8, 33]),
            ),
        },
        {
          path: `config`,
          name: `TaskConfig`,
          redirect: {
            name: `TaskConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`task:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Task/Config/Index.vue`),
              __vite__mapDeps([745, 4, 2]),
            ),
          children: [
            {
              path: ``,
              name: `TaskConfigIndex`,
              redirect: {
                name: `TaskConfigGeneral`,
              },
            },
            {
              path: `general`,
              name: `TaskConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Task/Config/General.vue`),
                  __vite__mapDeps([746, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `categories`,
              prefix: `TaskConfigCategory`,
              queryType: `task_category`,
              label: `task.category.category`,
              transKey: `task.category`,
              navs: [
                {
                  label: K(`task.task`),
                  path: `TaskList`,
                },
                {
                  label: K(`task.config.config`),
                  path: `TaskConfig`,
                },
              ],
            }),
            q({
              path: `priorities`,
              prefix: `TaskConfigPriority`,
              queryType: `task_priority`,
              label: `task.priority.priority`,
              transKey: `task.priority`,
              navs: [
                {
                  label: K(`task.task`),
                  path: `TaskList`,
                },
                {
                  label: K(`task.config.config`),
                  path: `TaskConfig`,
                },
              ],
            }),
            q({
              path: `lists`,
              prefix: `TaskConfigList`,
              queryType: `task_list`,
              label: `task.list.list`,
              transKey: `task.list`,
              navs: [
                {
                  label: K(`task.task`),
                  path: `TaskList`,
                },
                {
                  label: K(`task.config.config`),
                  path: `TaskConfig`,
                },
              ],
            }),
          ],
        },
        {
          path: `create`,
          name: `TaskCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `task.task`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Task/Action.vue`),
              __vite__mapDeps([747, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `TaskEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `task.task`,
            permissions: [`task:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Task/Action.vue`),
              __vite__mapDeps([747, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `TaskDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `task.task`,
            permissions: [`task:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Task/Action.vue`),
              __vite__mapDeps([747, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid`,
          name: `TaskShow`,
          redirect: {
            name: `TaskShowGeneral`,
          },
          meta: {
            trans: `global.detail`,
            label: `task.task`,
            permissions: [`task:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Task/Show.vue`),
              __vite__mapDeps([748, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: ``,
              name: `TaskShowIndex`,
              redirect: {
                name: `TaskShowGeneral`,
              },
            },
            {
              path: `general`,
              name: `TaskShowGeneral`,
              meta: {
                type: `read`,
                action: `read`,
                trans: `general.general`,
                label: `general.general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Task/General.vue`),
                  __vite__mapDeps([749, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `checklists`,
              name: `TaskChecklist`,
              redirect: {
                name: `TaskChecklistList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Np],
            },
            {
              path: `members`,
              name: `TaskMember`,
              redirect: {
                name: `TaskMemberList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Pp],
            },
            {
              path: `media`,
              name: `TaskMedia`,
              redirect: {
                name: `TaskMediaList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Fp],
            },
            {
              path: `repeats`,
              name: `TaskRepeat`,
              redirect: {
                name: `TaskRepeatList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Ip],
            },
          ],
        },
      ],
    },
  ],
  Rp = [
    {
      path: `faq`,
      name: `HelpdeskFaqIndex`,
      redirect: {
        name: `HelpdeskFaqCategoryList`,
      },
      meta: {
        label: `helpdesk.faq.faq`,
        icon: `fas fa-file-lines`,
        isNotNav: !0,
        hideChildren: !0,
        permissions: [`helpdesk:config`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [],
    },
    {
      path: `faqs`,
      name: `HelpdeskFaq`,
      redirect: {
        name: `HelpdeskFaqList`,
      },
      meta: {
        label: `helpdesk.faq.faq`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`faq:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `HelpdeskFaqList`,
          meta: {
            trans: `global.list`,
            label: `helpdesk.faq.faqs`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Faq/Index.vue`),
              __vite__mapDeps([750, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `create`,
          name: `HelpdeskFaqCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `helpdesk.faq.faq`,
            permissions: [`faq:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Faq/Action.vue`),
              __vite__mapDeps([751, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `HelpdeskFaqEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `helpdesk.faq.faq`,
            permissions: [`faq:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Faq/Action.vue`),
              __vite__mapDeps([751, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `HelpdeskFaqDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `helpdesk.faq.faq`,
            permissions: [`faq:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Faq/Action.vue`),
              __vite__mapDeps([751, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `HelpdeskFaqShow`,
          meta: {
            trans: `global.detail`,
            label: `helpdesk.faq.faq`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Faq/Show.vue`),
              __vite__mapDeps([752, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  zp = [
    {
      path: `ticket`,
      name: `HelpdeskTicketIndex`,
      redirect: {
        name: `HelpdeskTicketCategoryList`,
      },
      meta: {
        label: `helpdesk.ticket.ticket`,
        icon: `fas fa-file-lines`,
        isNotNav: !0,
        hideChildren: !0,
        permissions: [`helpdesk:config`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [],
    },
    {
      path: `tickets`,
      name: `HelpdeskTicket`,
      redirect: {
        name: `HelpdeskTicketList`,
      },
      meta: {
        label: `helpdesk.ticket.ticket`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`ticket:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `HelpdeskTicketList`,
          meta: {
            trans: `global.list`,
            label: `helpdesk.ticket.tickets`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Ticket/Index.vue`),
              __vite__mapDeps([753, 1, 2, 3, 4, 5, 6, 7, 8, 20, 45]),
            ),
        },
        {
          path: `create`,
          name: `HelpdeskTicketCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `helpdesk.ticket.ticket`,
            permissions: [`ticket:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Ticket/Action.vue`),
              __vite__mapDeps([754, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `HelpdeskTicketEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `helpdesk.ticket.ticket`,
            permissions: [`ticket:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Ticket/Action.vue`),
              __vite__mapDeps([754, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `HelpdeskTicketDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `helpdesk.ticket.ticket`,
            permissions: [`ticket:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Ticket/Action.vue`),
              __vite__mapDeps([754, 1, 2, 3, 4, 5, 6, 7, 8, 20]),
            ),
        },
        {
          path: `:uuid`,
          name: `HelpdeskTicketShow`,
          meta: {
            trans: `global.detail`,
            label: `helpdesk.ticket.ticket`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Ticket/Show.vue`),
              __vite__mapDeps([755, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Bp = [
    {
      path: `helpdesk`,
      name: `Helpdesk`,
      redirect: {
        name: `HelpdeskFaqList`,
      },
      meta: {
        moduleName: `helpdesk`,
        label: `helpdesk.helpdesk`,
        icon: `fas fa-headset`,
        hideChildren: !1,
        permissions: [`faq:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        ...Rp,
        ...zp,
        {
          path: `config`,
          name: `HelpdeskConfig`,
          redirect: {
            name: `HelpdeskConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`helpdesk:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Helpdesk/Config/Index.vue`),
              __vite__mapDeps([756, 4, 2]),
            ),
          children: [
            {
              path: ``,
              name: `HelpdeskConfigIndex`,
              redirect: {
                name: `HelpdeskConfigGeneral`,
              },
            },
            {
              path: `general`,
              name: `HelpdeskConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Helpdesk/Config/General.vue`),
                  __vite__mapDeps([757, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `faq-category`,
              prefix: `HelpdeskFaqConfigCategory`,
              queryType: `faq_category`,
              label: `helpdesk.faq.category.category`,
              transKey: `helpdesk.faq.category`,
              navs: [
                {
                  label: K(`helpdesk.helpdesk`),
                  path: `HelpdeskConfig`,
                },
                {
                  label: K(`helpdesk.faq.faq`),
                  path: `HelpdeskFaq`,
                },
              ],
            }),
            q({
              path: `ticket-category`,
              prefix: `HelpdeskTicketConfigCategory`,
              queryType: `ticket_category`,
              label: `helpdesk.ticket.category.category`,
              transKey: `helpdesk.ticket.category`,
              navs: [
                {
                  label: K(`helpdesk.helpdesk`),
                  path: `HelpdeskConfig`,
                },
                {
                  label: K(`helpdesk.ticket.ticket`),
                  path: `HelpdeskTicket`,
                },
              ],
            }),
            q({
              path: `ticket-priority`,
              prefix: `HelpdeskTicketConfigPriority`,
              queryType: `ticket_priority`,
              label: `helpdesk.ticket.priority.priority`,
              transKey: `helpdesk.ticket.priority`,
              navs: [
                {
                  label: K(`helpdesk.helpdesk`),
                  path: `HelpdeskConfig`,
                },
                {
                  label: K(`helpdesk.ticket.ticket`),
                  path: `HelpdeskTicket`,
                },
              ],
            }),
          ],
        },
      ],
    },
  ],
  Vp = [
    {
      path: `discipline`,
      name: `Discipline`,
      redirect: {
        name: `DisciplineIncident`,
      },
      meta: {
        moduleName: `discipline`,
        label: `discipline.discipline`,
        icon: `fas fa-school-circle-exclamation`,
        permissions: [`incident:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `DisciplineConfig`,
          redirect: {
            name: `DisciplineConfigIncidentCategory`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`discipline:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Discipline/Config/Index.vue`),
              __vite__mapDeps([758, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `DisciplineConfigGeneral`,
              meta: {
                label: `discipline.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Discipline/Config/General.vue`),
                  __vite__mapDeps([759, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `incident-category`,
              prefix: `DisciplineConfigIncidentCategory`,
              queryType: `incident_category`,
              label: `discipline.incident.category.category`,
              transKey: `discipline.incident.category`,
              navs: [
                {
                  label: K(`discipline.discipline`),
                  path: `DisciplineIncidentList`,
                },
                {
                  label: K(`discipline.config.config`),
                  path: `DisciplineConfig`,
                },
              ],
            }),
          ],
        },
        {
          path: `incidents`,
          name: `DisciplineIncident`,
          redirect: {
            name: `DisciplineIncidentList`,
          },
          meta: {
            label: `discipline.incident.incident`,
            icon: `fas fa-right-long`,
            hideChildren: !0,
            permissions: [`incident:manage`],
            keySearch: !0,
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [
            {
              path: ``,
              name: `DisciplineIncidentList`,
              meta: {
                trans: `global.list`,
                label: `discipline.incident.incidents`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Discipline/Incident/Index.vue`),
                  __vite__mapDeps([760, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `create`,
              name: `DisciplineIncidentCreate`,
              meta: {
                type: `create`,
                action: `create`,
                trans: `global.add`,
                label: `discipline.incident.incident`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Discipline/Incident/Action.vue`),
                  __vite__mapDeps([761, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/edit`,
              name: `DisciplineIncidentEdit`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `discipline.incident.incident`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Discipline/Incident/Action.vue`),
                  __vite__mapDeps([761, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid/duplicate`,
              name: `DisciplineIncidentDuplicate`,
              meta: {
                type: `duplicate`,
                action: `create`,
                trans: `global.duplicate`,
                label: `discipline.incident.incident`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Discipline/Incident/Action.vue`),
                  __vite__mapDeps([761, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:uuid`,
              name: `DisciplineIncidentShow`,
              meta: {
                trans: `global.detail`,
                label: `discipline.incident.incident`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Discipline/Incident/Show.vue`),
                  __vite__mapDeps([762, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
  ],
  Hp = [
    {
      path: `gallery`,
      name: `GalleryIndex`,
      redirect: {
        name: `GalleryList`,
      },
      meta: {
        moduleName: `gallery`,
        label: `gallery.gallery`,
        icon: `fas fa-image`,
        isNotNav: !0,
        hideChildren: !0,
        permissions: [`gallery:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `GalleryConfig`,
          redirect: {
            name: `GalleryConfigGeneral`,
          },
          meta: {
            label: `gallery.gallery`,
            icon: `fas fa-cog`,
            hideChildren: !0,
            permissions: [`gallery:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Gallery/Config/Index.vue`),
              __vite__mapDeps([763, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `GalleryConfigGeneral`,
              meta: {
                label: `gallery.config.general`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Gallery/Config/General.vue`),
                  __vite__mapDeps([764, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
    {
      path: `galleries`,
      name: `Gallery`,
      redirect: {
        name: `GalleryList`,
      },
      meta: {
        moduleName: `gallery`,
        label: `gallery.gallery`,
        icon: `fas fa-image`,
        hideChildren: !0,
        permissions: [`gallery:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `GalleryList`,
          meta: {
            trans: `global.list`,
            label: `gallery.galleries`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Gallery/Index.vue`),
              __vite__mapDeps([765, 1, 2, 3, 4, 5, 6, 7, 8, 11]),
            ),
        },
        {
          path: `create`,
          name: `GalleryCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `gallery.gallery`,
            permissions: [`gallery:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Gallery/Action.vue`),
              __vite__mapDeps([766, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `GalleryEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `gallery.gallery`,
            permissions: [`gallery:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Gallery/Action.vue`),
              __vite__mapDeps([766, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `GalleryDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `gallery.gallery`,
            permissions: [`gallery:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Gallery/Action.vue`),
              __vite__mapDeps([766, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `GalleryShow`,
          meta: {
            trans: `global.detail`,
            label: `gallery.gallery`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Gallery/Show.vue`),
              __vite__mapDeps([767, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Up = [
    {
      path: `menu-items`,
      name: `MessMenuItem`,
      redirect: {
        name: `MessMenuItemList`,
      },
      meta: {
        label: `mess.menu.item`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`menu-item:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `MessMenuItemList`,
          meta: {
            trans: `global.list`,
            label: `mess.menu.item`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MenuItem/Index.vue`),
              __vite__mapDeps([768, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `MessMenuItemCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `mess.menu.item`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MenuItem/Action.vue`),
              __vite__mapDeps([769, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `MessMenuItemEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `mess.menu.item`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MenuItem/Action.vue`),
              __vite__mapDeps([769, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `MessMenuItemDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `mess.menu.item`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MenuItem/Action.vue`),
              __vite__mapDeps([769, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `MessMenuItemShow`,
          meta: {
            trans: `global.detail`,
            label: `mess.menu.item`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MenuItem/Show.vue`),
              __vite__mapDeps([770, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Wp = [
    {
      path: `meals`,
      name: `MessMeal`,
      redirect: {
        name: `MessMealList`,
      },
      meta: {
        label: `mess.meal.meal`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`meal:manage`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `MessMealList`,
          meta: {
            trans: `global.list`,
            label: `mess.meal.meal`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/Meal/Index.vue`),
              __vite__mapDeps([771, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `MessMealCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `mess.meal.meal`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/Meal/Action.vue`),
              __vite__mapDeps([772, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `MessMealEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `mess.meal.meal`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/Meal/Action.vue`),
              __vite__mapDeps([772, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `MessMealDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `mess.meal.meal`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/Meal/Action.vue`),
              __vite__mapDeps([772, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `MessMealShow`,
          meta: {
            trans: `global.detail`,
            label: `mess.meal.meal`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/Meal/Show.vue`),
              __vite__mapDeps([773, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Gp = [
    {
      path: `meal-logs`,
      name: `MessMealLog`,
      redirect: {
        name: `MessMealLogList`,
      },
      meta: {
        label: `mess.meal.log.log`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`meal-log:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `MessMealLogList`,
          meta: {
            trans: `global.list`,
            label: `mess.meal.log.log`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MealLog/Index.vue`),
              __vite__mapDeps([774, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `MessMealLogCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `mess.meal.log.log`,
            permissions: [`meal-log:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MealLog/Action.vue`),
              __vite__mapDeps([775, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `MessMealLogEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `mess.meal.log.log`,
            permissions: [`meal-log:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MealLog/Action.vue`),
              __vite__mapDeps([775, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `MessMealLogDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `mess.meal.log.log`,
            permissions: [`meal-log:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MealLog/Action.vue`),
              __vite__mapDeps([775, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `MessMealLogShow`,
          meta: {
            trans: `global.detail`,
            label: `mess.meal.log.log`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/MealLog/Show.vue`),
              __vite__mapDeps([776, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Kp = [
    {
      path: `mess`,
      name: `Mess`,
      redirect: {
        name: `MessMeal`,
      },
      meta: {
        moduleName: `mess`,
        label: `mess.mess`,
        icon: `fas fa-utensils`,
        permissions: [`mess:config`, `menu-item:manage`, `meal:manage`, `meal-log:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `MessConfig`,
          redirect: {
            name: `MessConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`mess:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Mess/Config/Index.vue`),
              __vite__mapDeps([777, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `MessConfigGeneral`,
              meta: {
                label: `mess.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Mess/Config/General.vue`),
                  __vite__mapDeps([778, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        ...Up,
        ...Wp,
        ...Gp,
      ],
    },
  ],
  qp = [
    {
      path: ``,
      name: `ActivityTripParticipantList`,
      meta: {
        trans: `activity.trip.participant.participants`,
        label: `activity.trip.participant.participants`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Activity/Trip/Participant/Index.vue`),
          __vite__mapDeps([779, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Jp = [
    {
      path: ``,
      name: `ActivityTripMediaList`,
      meta: {
        trans: `activity.trip.media.media`,
        label: `activity.trip.media.media`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Activity/Trip/Media/Index.vue`),
          __vite__mapDeps([780, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Yp = [
    {
      path: `trips`,
      name: `ActivityTrip`,
      redirect: {
        name: `ActivityTripList`,
      },
      meta: {
        label: `activity.trip.trip`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
        permissions: [`trip:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ActivityTripList`,
          meta: {
            trans: `global.list`,
            label: `activity.trip.trips`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Activity/Trip/Index.vue`),
              __vite__mapDeps([781, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ActivityTripCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `activity.trip.trip`,
            permissions: [`trip:manage`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Activity/Trip/Action.vue`),
              __vite__mapDeps([782, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `ActivityTripEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `activity.trip.trip`,
            permissions: [`trip:manage`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Activity/Trip/Action.vue`),
              __vite__mapDeps([782, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ActivityTripDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `activity.trip.trip`,
            permissions: [`trip:manage`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Activity/Trip/Action.vue`),
              __vite__mapDeps([782, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ActivityTripShow`,
          redirect: {
            name: `ActivityTripShowGeneral`,
          },
          meta: {
            trans: `global.detail`,
            label: `activity.trip.trip`,
            permissions: [`trip:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Activity/Trip/Show.vue`),
              __vite__mapDeps([783, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: ``,
              name: `ActivityTripShowIndex`,
              redirect: {
                name: `ActivityTripShowGeneral`,
              },
            },
            {
              path: `general`,
              name: `ActivityTripShowGeneral`,
              meta: {
                type: `read`,
                action: `read`,
                trans: `general.general`,
                label: `general.general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Activity/Trip/General.vue`),
                  __vite__mapDeps([784, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `participants`,
              name: `ActivityTripParticipant`,
              redirect: {
                name: `ActivityTripParticipantList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...qp],
            },
            {
              path: `media`,
              name: `ActivityTripMedia`,
              redirect: {
                name: `ActivityTripMediaList`,
              },
              meta: {},
              component: {
                template: `<router-view></router-view>`,
              },
              children: [...Jp],
            },
          ],
        },
      ],
    },
  ],
  Xp = [
    {
      path: `activity`,
      name: `Activity`,
      redirect: {
        name: `ActivityTrip`,
      },
      meta: {
        moduleName: `activity`,
        label: `activity.activity`,
        icon: `fas fa-sliders`,
        permissions: [`trip:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `ActivityConfig`,
          redirect: {
            name: `ActivityConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`activity:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Activity/Config/Index.vue`),
              __vite__mapDeps([785, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `ActivityConfigGeneral`,
              meta: {
                label: `activity.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Activity/Config/General.vue`),
                  __vite__mapDeps([786, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `trip-type`,
              prefix: `ActivityConfigTripType`,
              queryType: `trip_type`,
              label: `activity.trip.type.type`,
              transKey: `activity.trip.type`,
              navs: [
                {
                  label: K(`activity.activity`),
                  path: `ActivityTripList`,
                },
                {
                  label: K(`activity.config.config`),
                  path: `ActivityConfig`,
                },
              ],
            }),
          ],
        },
        ...Yp,
      ],
    },
  ],
  Zp = [
    {
      path: `blocks`,
      name: `HostelBlock`,
      redirect: {
        name: `HostelBlockList`,
      },
      meta: {
        label: `hostel.block.block`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `HostelBlockList`,
          meta: {
            trans: `global.list`,
            label: `hostel.block.blocks`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Block/Index.vue`),
              __vite__mapDeps([787, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `HostelBlockCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `hostel.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Block/Action.vue`),
              __vite__mapDeps([788, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `HostelBlockEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `hostel.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Block/Action.vue`),
              __vite__mapDeps([788, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `HostelBlockDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `hostel.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Block/Action.vue`),
              __vite__mapDeps([788, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `HostelBlockShow`,
          meta: {
            trans: `global.detail`,
            label: `hostel.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Block/Show.vue`),
              __vite__mapDeps([789, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  Qp = [
    {
      path: `block-incharges`,
      name: `HostelBlockIncharge`,
      redirect: {
        name: `HostelBlockInchargeList`,
      },
      meta: {
        isNotNav: !0,
        label: `hostel.block_incharge.block_incharge`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`hostel-incharge:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `HostelBlockInchargeList`,
          meta: {
            trans: `global.list`,
            label: `hostel.block_incharge.block_incharges`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/BlockIncharge/Index.vue`),
              __vite__mapDeps([790, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `HostelBlockInchargeCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `hostel.block_incharge.block_incharge`,
            permissions: [`hostel-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/BlockIncharge/Action.vue`),
              __vite__mapDeps([791, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `HostelBlockInchargeEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `hostel.block_incharge.block_incharge`,
            permissions: [`hostel-incharge:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/BlockIncharge/Action.vue`),
              __vite__mapDeps([791, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `HostelBlockInchargeDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `hostel.block_incharge.block_incharge`,
            permissions: [`hostel-incharge:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/BlockIncharge/Action.vue`),
              __vite__mapDeps([791, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `HostelBlockInchargeShow`,
          meta: {
            trans: `global.detail`,
            label: `hostel.block_incharge.block_incharge`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/BlockIncharge/Show.vue`),
              __vite__mapDeps([792, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  $p = [
    {
      path: `floors`,
      name: `HostelFloor`,
      redirect: {
        name: `HostelFloorList`,
      },
      meta: {
        isNotNav: !0,
        label: `hostel.floor.floor`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `HostelFloorList`,
          meta: {
            trans: `global.list`,
            label: `hostel.floor.floors`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Floor/Index.vue`),
              __vite__mapDeps([793, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `HostelFloorCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `hostel.floor.floor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Floor/Action.vue`),
              __vite__mapDeps([794, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `HostelFloorEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `hostel.floor.floor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Floor/Action.vue`),
              __vite__mapDeps([794, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `HostelFloorDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `hostel.floor.floor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Floor/Action.vue`),
              __vite__mapDeps([794, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `HostelFloorShow`,
          meta: {
            trans: `global.detail`,
            label: `hostel.floor.floor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Floor/Show.vue`),
              __vite__mapDeps([795, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  em = [
    {
      path: `rooms`,
      name: `HostelRoom`,
      redirect: {
        name: `HostelRoomList`,
      },
      meta: {
        isNotNav: !0,
        label: `hostel.room.room`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `HostelRoomList`,
          meta: {
            trans: `global.list`,
            label: `hostel.room.rooms`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Room/Index.vue`),
              __vite__mapDeps([796, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `HostelRoomCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `hostel.room.room`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Room/Action.vue`),
              __vite__mapDeps([797, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `HostelRoomEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `hostel.room.room`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Room/Action.vue`),
              __vite__mapDeps([797, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `HostelRoomDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `hostel.room.room`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Room/Action.vue`),
              __vite__mapDeps([797, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `HostelRoomShow`,
          meta: {
            trans: `global.detail`,
            label: `hostel.room.room`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/Room/Show.vue`),
              __vite__mapDeps([798, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  tm = [
    {
      path: `room-allocations`,
      name: `HostelRoomAllocation`,
      redirect: {
        name: `HostelRoomAllocationList`,
      },
      meta: {
        label: `hostel.room_allocation.room_allocation`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`hostel-room-allocation:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `HostelRoomAllocationList`,
          meta: {
            trans: `global.list`,
            label: `hostel.room_allocation.room_allocations`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/RoomAllocation/Index.vue`),
              __vite__mapDeps([799, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `HostelRoomAllocationCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `hostel.room_allocation.room_allocation`,
            permissions: [`hostel-room-allocation:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/RoomAllocation/Action.vue`),
              __vite__mapDeps([800, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `HostelRoomAllocationEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `hostel.room_allocation.room_allocation`,
            permissions: [`hostel-room-allocation:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/RoomAllocation/Action.vue`),
              __vite__mapDeps([800, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `HostelRoomAllocationDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `hostel.room_allocation.room_allocation`,
            permissions: [`hostel-room-allocation:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/RoomAllocation/Action.vue`),
              __vite__mapDeps([800, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `HostelRoomAllocationShow`,
          meta: {
            trans: `global.detail`,
            label: `hostel.room_allocation.room_allocation`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Hostel/RoomAllocation/Show.vue`),
              __vite__mapDeps([801, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  nm = [
    {
      path: `hostel`,
      name: `Hostel`,
      redirect: {
        name: `HostelBlock`,
      },
      meta: {
        moduleName: `hostel`,
        label: `hostel.hostel`,
        icon: `fas fa-hotel`,
        permissions: [`hostel:manage`, `hostel-room-allocation:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [...Zp, ...Qp, ...$p, ...em, ...tm],
    },
  ],
  rm = [
    {
      path: `forms`,
      name: `Form`,
      redirect: {
        name: `FormList`,
      },
      meta: {
        moduleName: `form`,
        label: `form.form`,
        icon: `fas fa-rectangle-list`,
        hideChildren: !0,
        permissions: [`form:config`, `form:read`, `form:submit`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `FormList`,
          meta: {
            trans: `global.list`,
            label: `form.form`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Form/Index.vue`),
              __vite__mapDeps([802, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `FormCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `form.form`,
            permissions: [`form:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Form/Action.vue`),
              __vite__mapDeps([803, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `FormEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `form.form`,
            permissions: [`form:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Form/Action.vue`),
              __vite__mapDeps([803, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `FormDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `form.form`,
            permissions: [`form:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Form/Action.vue`),
              __vite__mapDeps([803, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `:uuid`,
          name: `FormShow`,
          meta: {
            trans: `global.detail`,
            label: `form.form`,
            permissions: [`form:create`, `form:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Form/Show.vue`),
              __vite__mapDeps([804, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/submit`,
          name: `FormSubmit`,
          meta: {
            trans: `global.detail`,
            label: `form.form`,
            permissions: [`form:submit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Form/Submit.vue`),
              __vite__mapDeps([805, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/submissions`,
          name: `FormSubmission`,
          redirect: {
            name: `FormSubmissionList`,
          },
          meta: {
            trans: `global.detail`,
            label: `form.form`,
            permissions: [`form-submission:manage`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Form/Submission/Layout.vue`),
              __vite__mapDeps([806, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: ``,
              name: `FormSubmissionList`,
              meta: {},
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Form/Submission/Index.vue`),
                  __vite__mapDeps([807, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `:muuid`,
              name: `FormSubmissionShow`,
              meta: {
                trans: `global.detail`,
                label: `form.submission.submission`,
                permissions: [],
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Form/Submission/Show.vue`),
                  __vite__mapDeps([808, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
    {
      path: `form`,
      name: `FormIndex`,
      redirect: {
        name: `FormList`,
      },
      meta: {
        label: `form.form`,
        icon: `fas fa-input`,
        permissions: [`form:config`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `FormConfig`,
          redirect: {
            name: `FormConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`form:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Form/Config/Index.vue`),
              __vite__mapDeps([809, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `FormConfigGeneral`,
              meta: {
                label: `form.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Form/Config/General.vue`),
                  __vite__mapDeps([810, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
  ],
  im = [
    {
      path: `blocks`,
      name: `AssetBuildingBlock`,
      redirect: {
        name: `AssetBuildingBlockList`,
      },
      meta: {
        isNotNav: !0,
        label: `asset.building.block.block`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AssetBuildingBlockList`,
          meta: {
            trans: `global.list`,
            label: `asset.building.block.blocks`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Block/Index.vue`),
              __vite__mapDeps([811, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AssetBuildingBlockCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `asset.building.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Block/Action.vue`),
              __vite__mapDeps([812, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AssetBuildingBlockEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `asset.building.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Block/Action.vue`),
              __vite__mapDeps([812, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AssetBuildingBlockDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `asset.building.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Block/Action.vue`),
              __vite__mapDeps([812, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AssetBuildingBlockShow`,
          meta: {
            trans: `global.detail`,
            label: `asset.building.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Block/Show.vue`),
              __vite__mapDeps([813, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  am = [
    {
      path: `floors`,
      name: `AssetBuildingFloor`,
      redirect: {
        name: `AssetBuildingFloorList`,
      },
      meta: {
        isNotNav: !0,
        label: `asset.building.floor.floor`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AssetBuildingFloorList`,
          meta: {
            trans: `global.list`,
            label: `asset.building.floor.floors`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Floor/Index.vue`),
              __vite__mapDeps([814, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AssetBuildingFloorCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `asset.building.floor.floor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Floor/Action.vue`),
              __vite__mapDeps([815, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AssetBuildingFloorEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `asset.building.floor.floor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Floor/Action.vue`),
              __vite__mapDeps([815, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AssetBuildingFloorDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `asset.building.floor.floor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Floor/Action.vue`),
              __vite__mapDeps([815, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AssetBuildingFloorShow`,
          meta: {
            trans: `global.detail`,
            label: `asset.building.floor.floor`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Floor/Show.vue`),
              __vite__mapDeps([816, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  om = [
    {
      path: `rooms`,
      name: `AssetBuildingRoom`,
      redirect: {
        name: `AssetBuildingRoomList`,
      },
      meta: {
        isNotNav: !0,
        label: `asset.building.room.room`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `AssetBuildingRoomList`,
          meta: {
            trans: `global.list`,
            label: `asset.building.room.rooms`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Room/Index.vue`),
              __vite__mapDeps([817, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `AssetBuildingRoomCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `asset.building.room.room`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Room/Action.vue`),
              __vite__mapDeps([818, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `AssetBuildingRoomEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `asset.building.room.room`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Room/Action.vue`),
              __vite__mapDeps([818, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `AssetBuildingRoomDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `asset.building.room.room`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Room/Action.vue`),
              __vite__mapDeps([818, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `AssetBuildingRoomShow`,
          meta: {
            trans: `global.detail`,
            label: `asset.building.room.room`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Asset/Building/Room/Show.vue`),
              __vite__mapDeps([819, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  sm = [
    {
      path: `asset`,
      name: `Asset`,
      redirect: {
        name: `AssetBuilding`,
      },
      meta: {
        moduleName: `asset`,
        label: `asset.asset`,
        icon: `fas fa-building`,
        permissions: [`asset:config`, `building:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `building`,
          name: `AssetBuilding`,
          redirect: {
            name: `AssetBuildingBlock`,
          },
          meta: {
            label: `asset.building.building`,
            icon: `fas fa-right-long`,
            permissions: [`building:manage`],
          },
          component: {
            template: `<router-view></router-view>`,
          },
          children: [...im, ...am, ...om],
        },
      ],
    },
  ],
  cm = [
    {
      path: `pages`,
      name: `SitePage`,
      redirect: {
        name: `SitePageList`,
      },
      meta: {
        label: `site.page.page`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `SitePageList`,
          meta: {
            trans: `global.list`,
            label: `site.page.pages`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Page/Index.vue`),
              __vite__mapDeps([820, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `SitePageCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `site.page.page`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Page/Action.vue`),
              __vite__mapDeps([821, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `SitePageEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `site.page.page`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Page/Edit.vue`),
              __vite__mapDeps([822, 1, 2, 3, 4, 5, 6, 7, 8, 823]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `SitePageDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `site.page.page`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Page/Action.vue`),
              __vite__mapDeps([821, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `SitePageShow`,
          meta: {
            trans: `global.detail`,
            label: `site.page.page`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Page/Show.vue`),
              __vite__mapDeps([824, 1, 2, 3, 4, 5, 6, 7, 8, 823]),
            ),
        },
      ],
    },
  ],
  lm = [
    {
      path: `menus`,
      name: `SiteMenu`,
      redirect: {
        name: `SiteMenuList`,
      },
      meta: {
        label: `site.menu.menu`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `SiteMenuList`,
          meta: {
            trans: `global.list`,
            label: `site.menu.menus`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Menu/Index.vue`),
              __vite__mapDeps([825, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `SiteMenuCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `site.menu.menu`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Menu/Action.vue`),
              __vite__mapDeps([826, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `SiteMenuEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `site.menu.menu`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Menu/Action.vue`),
              __vite__mapDeps([826, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `SiteMenuDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `site.menu.menu`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Menu/Action.vue`),
              __vite__mapDeps([826, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `SiteMenuShow`,
          redirect: {
            name: `SiteMenuList`,
          },
          meta: {
            trans: `global.detail`,
            label: `site.menu.menu`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Menu/Show.vue`),
              __vite__mapDeps([827, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  um = [
    {
      path: `blocks`,
      name: `SiteBlock`,
      redirect: {
        name: `SiteBlockList`,
      },
      meta: {
        label: `site.block.block`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `SiteBlockList`,
          meta: {
            trans: `global.list`,
            label: `site.block.blocks`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Block/Index.vue`),
              __vite__mapDeps([828, 1, 2, 3, 4, 5, 6, 7, 8, 63]),
            ),
        },
        {
          path: `create`,
          name: `SiteBlockCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `site.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Block/Action.vue`),
              __vite__mapDeps([829, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `SiteBlockEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `site.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Block/Edit.vue`),
              __vite__mapDeps([830, 1, 2, 3, 4, 5, 6, 7, 8, 831]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `SiteBlockDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `site.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Block/Action.vue`),
              __vite__mapDeps([829, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `SiteBlockShow`,
          meta: {
            trans: `global.detail`,
            label: `site.block.block`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Block/Show.vue`),
              __vite__mapDeps([832, 1, 2, 3, 4, 5, 6, 7, 8, 831]),
            ),
        },
      ],
    },
  ],
  dm = [
    {
      path: `site`,
      name: `Site`,
      redirect: {
        name: `SitePage`,
      },
      meta: {
        moduleName: `site`,
        label: `site.site`,
        icon: `fas fa-globe`,
        permissions: [`site:manage`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `SiteConfig`,
          redirect: {
            name: `SiteConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Site/Config/Index.vue`),
              __vite__mapDeps([833, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `SiteConfigGeneral`,
              meta: {
                label: `site.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Site/Config/General.vue`),
                  __vite__mapDeps([834, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        ...cm,
        ...lm,
        ...um,
      ],
    },
  ],
  fm = [
    {
      path: `blogs`,
      name: `Blog`,
      redirect: {
        name: `BlogList`,
      },
      meta: {
        moduleName: `blog`,
        label: `blog.blog`,
        icon: `fas fa-pen-to-square`,
        hideChildren: !0,
        permissions: [`blog:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `BlogList`,
          meta: {
            trans: `global.list`,
            label: `blog.blog`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Blog/Index.vue`),
              __vite__mapDeps([835, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `config`,
          name: `BlogConfig`,
          redirect: {
            name: `BlogConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`blog:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Blog/Config/Index.vue`),
              __vite__mapDeps([836, 4, 2]),
            ),
          children: [
            {
              path: ``,
              name: `BlogConfigIndex`,
              redirect: {
                name: `BlogConfigGeneral`,
              },
            },
            {
              path: `general`,
              name: `BlogConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Blog/Config/General.vue`),
                  __vite__mapDeps([837, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `categories`,
              prefix: `BlogConfigCategory`,
              queryType: `blog_category`,
              label: `blog.category.category`,
              transKey: `blog.category`,
              navs: [
                {
                  label: K(`blog.blog`),
                  path: `BlogList`,
                },
                {
                  label: K(`blog.config.config`),
                  path: `BlogConfig`,
                },
              ],
            }),
          ],
        },
        {
          path: `create`,
          name: `BlogCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `blog.blog`,
            permissions: [`blog:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Blog/Action.vue`),
              __vite__mapDeps([838, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `BlogEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `blog.blog`,
            permissions: [`blog:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Blog/Edit.vue`),
              __vite__mapDeps([839, 1, 2, 3, 4, 5, 6, 7, 8, 840]),
            ),
        },
        {
          path: `:uuid`,
          name: `BlogShow`,
          meta: {
            trans: `global.detail`,
            label: `blog.blog`,
            permissions: [`blog:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Blog/Show.vue`),
              __vite__mapDeps([841, 1, 2, 3, 4, 5, 6, 7, 8, 840]),
            ),
        },
      ],
    },
  ],
  pm = [
    {
      path: `news`,
      name: `News`,
      redirect: {
        name: `NewsList`,
      },
      meta: {
        moduleName: `news`,
        label: `news.news`,
        icon: `fas fa-newspaper`,
        hideChildren: !0,
        permissions: [`news:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `NewsList`,
          meta: {
            trans: `global.list`,
            label: `news.news`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/News/Index.vue`),
              __vite__mapDeps([842, 1, 2, 3, 4, 5, 6, 7, 8, 45]),
            ),
        },
        {
          path: `config`,
          name: `NewsConfig`,
          redirect: {
            name: `NewsConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`news:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/News/Config/Index.vue`),
              __vite__mapDeps([843, 4, 2]),
            ),
          children: [
            {
              path: ``,
              name: `NewsConfigIndex`,
              redirect: {
                name: `NewsConfigGeneral`,
              },
            },
            {
              path: `general`,
              name: `NewsConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/News/Config/General.vue`),
                  __vite__mapDeps([844, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `categories`,
              prefix: `NewsConfigCategory`,
              queryType: `news_category`,
              label: `news.category.category`,
              transKey: `news.category`,
              navs: [
                {
                  label: K(`news.news`),
                  path: `NewsList`,
                },
                {
                  label: K(`news.config.config`),
                  path: `NewsConfig`,
                },
              ],
            }),
          ],
        },
        {
          path: `create`,
          name: `NewsCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `news.news`,
            permissions: [`news:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/News/Action.vue`),
              __vite__mapDeps([845, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `NewsEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `news.news`,
            permissions: [`news:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/News/Edit.vue`),
              __vite__mapDeps([846, 1, 2, 3, 4, 5, 6, 7, 8, 847]),
            ),
        },
        {
          path: `:uuid`,
          name: `NewsShow`,
          meta: {
            trans: `global.detail`,
            label: `news.news`,
            permissions: [`news:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/News/Show.vue`),
              __vite__mapDeps([848, 1, 2, 3, 4, 5, 6, 7, 8, 847]),
            ),
        },
      ],
    },
  ],
  mm = [
    {
      path: `vacancies`,
      name: `RecruitmentVacancy`,
      redirect: {
        name: `RecruitmentVacancyList`,
      },
      meta: {
        label: `recruitment.vacancy.vacancy`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`job-vacancy:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `RecruitmentVacancyList`,
          meta: {
            trans: `global.list`,
            label: `recruitment.vacancy.vacancies`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Vacancy/Index.vue`),
              __vite__mapDeps([849, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `RecruitmentVacancyCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `recruitment.vacancy.vacancy`,
            permissions: [`job-vacancy:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Vacancy/Action.vue`),
              __vite__mapDeps([850, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `RecruitmentVacancyEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `recruitment.vacancy.vacancy`,
            permissions: [`job-vacancy:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Vacancy/Action.vue`),
              __vite__mapDeps([850, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `RecruitmentVacancyDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `recruitment.vacancy.vacancy`,
            permissions: [`job-vacancy:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Vacancy/Action.vue`),
              __vite__mapDeps([850, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `RecruitmentVacancyShow`,
          meta: {
            trans: `global.detail`,
            label: `recruitment.vacancy.vacancy`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Vacancy/Show.vue`),
              __vite__mapDeps([851, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  hm = [
    {
      path: `applications`,
      name: `RecruitmentApplication`,
      redirect: {
        name: `RecruitmentApplicationList`,
      },
      meta: {
        label: `recruitment.application.application`,
        icon: `fas fa-right-long`,
        hideChildren: !0,
        permissions: [`job-application:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `RecruitmentApplicationList`,
          meta: {
            trans: `global.list`,
            label: `recruitment.application.applications`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Application/Index.vue`),
              __vite__mapDeps([852, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `RecruitmentApplicationCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `recruitment.application.application`,
            permissions: [`job-application:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Application/Action.vue`),
              __vite__mapDeps([853, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `RecruitmentApplicationEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `recruitment.application.application`,
            permissions: [`job-application:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Application/Action.vue`),
              __vite__mapDeps([853, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `RecruitmentApplicationShow`,
          meta: {
            trans: `global.detail`,
            label: `recruitment.application.application`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Application/Show.vue`),
              __vite__mapDeps([854, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ],
  gm = [
    {
      path: `recruitment`,
      name: `Recruitment`,
      redirect: {
        name: `RecruitmentVacancy`,
      },
      meta: {
        moduleName: `recruitment`,
        label: `recruitment.recruitment`,
        icon: `fas fa-file-lines`,
        permissions: [`recruitment:config`, `job-vacancy:read`, `job-application:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `RecruitmentConfig`,
          redirect: {
            name: `RecruitmentConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`recruitment:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Recruitment/Config/Index.vue`),
              __vite__mapDeps([855, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `RecruitmentConfigGeneral`,
              meta: {
                label: `recruitment.config.config`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Recruitment/Config/General.vue`),
                  __vite__mapDeps([856, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        ...mm,
        ...hm,
      ],
    },
  ],
  _m = [
    {
      path: `guardians`,
      name: `Guardian`,
      redirect: {
        name: `GuardianList`,
      },
      meta: {
        moduleName: `guardian`,
        label: `guardian.guardian`,
        icon: `fas fa-user-group`,
        hideChildren: !0,
        permissions: [`guardian:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `GuardianConfig`,
          redirect: {
            name: `GuardianConfigGeneral`,
          },
          meta: {
            isNotNav: !0,
            type: `config`,
            action: `config`,
            trans: `global.config`,
            label: `config.config`,
            permissions: [`guardian:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Guardian/Config/Index.vue`),
              __vite__mapDeps([857, 4, 2]),
            ),
          children: [
            {
              path: ``,
              name: `GuardianConfigIndex`,
              redirect: {
                name: `GuardianConfigGeneral`,
              },
            },
            {
              path: `general`,
              name: `GuardianConfigGeneral`,
              meta: {
                type: `config`,
                action: `config`,
                trans: `config.config`,
                label: `config.config`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Guardian/Config/General.vue`),
                  __vite__mapDeps([858, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
        {
          path: ``,
          name: `GuardianList`,
          meta: {
            trans: `global.list`,
            label: `guardian.guardians`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Guardian/Index.vue`),
              __vite__mapDeps([859, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `GuardianShow`,
          redirect: {
            name: `GuardianShowBasic`,
          },
          meta: {
            trans: `global.detail`,
            label: `guardian.guardian`,
            permissions: [`guardian:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Guardian/Show.vue`),
              __vite__mapDeps([860, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: ``,
              name: `GuardianShowIndex`,
              redirect: {
                name: `GuardianShowBasic`,
              },
            },
            {
              path: `basic`,
              name: `GuardianShowBasic`,
              meta: {
                type: `read`,
                action: `read`,
                trans: `general.basic`,
                label: `general.basic`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Guardian/Basic.vue`),
                  __vite__mapDeps([861, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `basic/edit`,
              name: `GuardianEditBasic`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `guardian.guardian`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Guardian/EditBasic.vue`),
                  __vite__mapDeps([862, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `photo/edit`,
              name: `GuardianEditPhoto`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `contact.props.photo`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Guardian/EditPhoto.vue`),
                  __vite__mapDeps([863, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `contact`,
              name: `GuardianShowContact`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `contact.contact`,
                label: `contact.contact`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Guardian/Contact.vue`),
                  __vite__mapDeps([864, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `contact/edit`,
              name: `GuardianEditContact`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `contact.contact`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Guardian/EditContact.vue`),
                  __vite__mapDeps([865, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `login`,
              name: `GuardianShowLogin`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `guardian.login.login`,
                label: `guardian.login.login`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Guardian/Login.vue`),
                  __vite__mapDeps([866, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `login/edit`,
              name: `GuardianEditLogin`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `guardian.login.login`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Guardian/EditLogin.vue`),
                  __vite__mapDeps([867, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
  ],
  vm = [
    {
      path: `contact`,
      name: `ContactIndex`,
      redirect: {
        name: `ContactList`,
      },
      meta: {
        moduleName: `contact`,
        label: `contact.contact`,
        icon: `fas fa-address-card`,
        isNotNav: !0,
        hideChildren: !0,
        permissions: [`contact:read`],
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `ContactConfig`,
          redirect: {
            name: `ContactConfigGeneral`,
          },
          meta: {
            label: `contact.contact`,
            icon: `fas fa-cog`,
            hideChildren: !0,
            permissions: [`contact:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Contact/Config/Index.vue`),
              __vite__mapDeps([868, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `ContactConfigGeneral`,
              meta: {
                label: `contact.config.general`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Contact/Config/General.vue`),
                  __vite__mapDeps([869, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            q({
              path: `religion`,
              prefix: `ContactConfigReligion`,
              queryType: `religion`,
              label: `contact.religion.religion`,
              transKey: `contact.religion`,
              navs: [
                {
                  label: K(`contact.contact`),
                  path: `ContactList`,
                },
                {
                  label: K(`contact.config.config`),
                  path: `ContactConfig`,
                },
              ],
            }),
            q({
              path: `caste`,
              prefix: `ContactConfigCaste`,
              queryType: `member_caste`,
              label: `contact.caste.caste`,
              transKey: `contact.caste`,
              navs: [
                {
                  label: K(`contact.contact`),
                  path: `ContactList`,
                },
                {
                  label: K(`contact.config.config`),
                  path: `ContactConfig`,
                },
              ],
            }),
            q({
              path: `category`,
              prefix: `ContactConfigCategory`,
              queryType: `member_category`,
              label: `contact.category.category`,
              transKey: `contact.category`,
              navs: [
                {
                  label: K(`contact.contact`),
                  path: `ContactList`,
                },
                {
                  label: K(`contact.config.config`),
                  path: `ContactConfig`,
                },
              ],
            }),
            {
              path: `document-types`,
              name: `ContactConfigDocumentType`,
              redirect: {
                name: `ContactConfigDocumentTypeList`,
              },
              meta: {
                label: `contact.document_type.document_types`,
                icon: `fas fa-right-long`,
                hideChildren: !0,
                permissions: [`contact:config`],
                keySearch: !0,
              },
              component: {
                template: `<router-view></router-view>`,
              },
              children: [
                {
                  path: ``,
                  name: `ContactConfigDocumentTypeList`,
                  meta: {
                    trans: `global.list`,
                    label: `contact.document_type.document_types`,
                  },
                  component: () =>
                    G(
                      () => import(`../../../js/views/Pages/Contact/Config/DocumentType/Index.vue`),
                      __vite__mapDeps([870, 1, 2, 3, 4, 5, 6, 7, 8]),
                    ),
                },
                {
                  path: `create`,
                  name: `ContactConfigDocumentTypeCreate`,
                  meta: {
                    type: `create`,
                    action: `create`,
                    trans: `global.add`,
                    label: `contact.document_type.document_type`,
                  },
                  component: () =>
                    G(
                      () =>
                        import(`../../../js/views/Pages/Contact/Config/DocumentType/Action.vue`),
                      __vite__mapDeps([871, 1, 2, 3, 4, 5, 6, 7, 8]),
                    ),
                },
                {
                  path: `:uuid/edit`,
                  name: `ContactConfigDocumentTypeEdit`,
                  meta: {
                    type: `edit`,
                    action: `update`,
                    trans: `global.edit`,
                    label: `contact.document_type.document_type`,
                  },
                  component: () =>
                    G(
                      () =>
                        import(`../../../js/views/Pages/Contact/Config/DocumentType/Action.vue`),
                      __vite__mapDeps([871, 1, 2, 3, 4, 5, 6, 7, 8]),
                    ),
                },
                {
                  path: `:uuid/duplicate`,
                  name: `ContactConfigDocumentTypeDuplicate`,
                  meta: {
                    type: `duplicate`,
                    action: `create`,
                    trans: `global.duplicate`,
                    label: `contact.document_type.document_type`,
                  },
                  component: () =>
                    G(
                      () =>
                        import(`../../../js/views/Pages/Contact/Config/DocumentType/Action.vue`),
                      __vite__mapDeps([871, 1, 2, 3, 4, 5, 6, 7, 8]),
                    ),
                },
                {
                  path: `:uuid`,
                  name: `ContactConfigDocumentTypeShow`,
                  meta: {
                    trans: `global.detail`,
                    label: `contact.document_type.document_type`,
                  },
                  component: () =>
                    G(
                      () => import(`../../../js/views/Pages/Contact/Config/DocumentType/Show.vue`),
                      __vite__mapDeps([872, 1, 2, 3, 4, 5, 6, 7, 8]),
                    ),
                },
              ],
            },
            q({
              path: `qualification-level`,
              prefix: `ContactConfigQualificationLevel`,
              queryType: `qualification_level`,
              label: `contact.qualification_level.qualification_level`,
              transKey: `contact.qualification_level`,
              navs: [
                {
                  label: K(`contact.contact`),
                  path: `ContactList`,
                },
                {
                  label: K(`contact.config.config`),
                  path: `ContactConfig`,
                },
              ],
            }),
          ],
        },
      ],
    },
    {
      path: `contacts`,
      name: `Contact`,
      redirect: {
        name: `ContactList`,
      },
      meta: {
        label: `contact.contact`,
        icon: `fas fa-people-group`,
        hideChildren: !0,
        permissions: [`contact:read`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `ContactList`,
          meta: {
            trans: `global.list`,
            label: `contact.contacts`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Contact/Index.vue`),
              __vite__mapDeps([873, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `ContactCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `contact.contact`,
            permissions: [`contact:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Contact/Action.vue`),
              __vite__mapDeps([874, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `ContactDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `contact.contact`,
            permissions: [`contact:create`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Contact/Action.vue`),
              __vite__mapDeps([874, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `ContactShow`,
          redirect: {
            name: `ContactShowBasic`,
          },
          meta: {
            trans: `global.detail`,
            label: `contact.contact`,
            permissions: [`contact:read`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Contact/Show.vue`),
              __vite__mapDeps([875, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
          children: [
            {
              path: ``,
              name: `ContactShowIndex`,
              redirect: {
                name: `ContactShowBasic`,
              },
            },
            {
              path: `basic`,
              name: `ContactShowBasic`,
              meta: {
                type: `read`,
                action: `read`,
                trans: `general.basic`,
                label: `general.basic`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Contact/Basic.vue`),
                  __vite__mapDeps([876, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `basic/edit`,
              name: `ContactEditBasic`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `contact.contact`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Contact/EditBasic.vue`),
                  __vite__mapDeps([877, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `photo/edit`,
              name: `ContactEditPhoto`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `contact.props.photo`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Contact/EditPhoto.vue`),
                  __vite__mapDeps([878, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `contact`,
              name: `ContactShowContact`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `contact.contact`,
                label: `contact.contact`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Contact/Contact.vue`),
                  __vite__mapDeps([879, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `contact/edit`,
              name: `ContactEditContact`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `contact.contact`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Contact/EditContact.vue`),
                  __vite__mapDeps([880, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `login`,
              name: `ContactShowLogin`,
              meta: {
                type: `general`,
                action: `general`,
                trans: `contact.login.login`,
                label: `contact.login.login`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Contact/Login.vue`),
                  __vite__mapDeps([881, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
            {
              path: `login/edit`,
              name: `ContactEditLogin`,
              meta: {
                type: `edit`,
                action: `update`,
                trans: `global.edit`,
                label: `contact.login.login`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Contact/EditLogin.vue`),
                  __vite__mapDeps([882, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
  ],
  ym = [
    {
      path: `devices`,
      name: `Device`,
      redirect: {
        name: `DeviceList`,
      },
      meta: {
        isNotNav: !0,
        label: `device.device`,
        icon: `fas fa-microchip`,
        hideChildren: !0,
        roles: [`admin`],
        keySearch: !0,
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `DeviceList`,
          meta: {
            trans: `global.list`,
            label: `device.devices`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Device/Index.vue`),
              __vite__mapDeps([883, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `create`,
          name: `DeviceCreate`,
          meta: {
            type: `create`,
            action: `create`,
            trans: `global.add`,
            label: `device.device`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Device/Action.vue`),
              __vite__mapDeps([884, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `DeviceEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `device.device`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Device/Action.vue`),
              __vite__mapDeps([884, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid/duplicate`,
          name: `DeviceDuplicate`,
          meta: {
            type: `duplicate`,
            action: `create`,
            trans: `global.duplicate`,
            label: `device.device`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Device/Action.vue`),
              __vite__mapDeps([884, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
        {
          path: `:uuid`,
          name: `DeviceShow`,
          meta: {
            trans: `global.detail`,
            label: `device.device`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Device/Show.vue`),
              __vite__mapDeps([885, 1, 2, 3, 4, 5, 6, 7, 8]),
            ),
        },
      ],
    },
  ];
function bm(e) {
  return kS.getters[`config/config`](e);
}
var xm = [
    {
      path: `post`,
      name: `PostIndex`,
      redirect: {
        name: `PostList`,
      },
      meta: {
        moduleName: `post`,
        label: `post.post`,
        icon: `fas fa-newspaper`,
        isNotNav: !0,
        hideChildren: !0,
        permissions: [`post:read`],
        keySearch: !0,
      },
      beforeEnter: (e, t, n) => {
        bm(`feature.enablePost`) ? n() : n(`/`);
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: `config`,
          name: `PostConfig`,
          redirect: {
            name: `PostConfigGeneral`,
          },
          meta: {
            label: `post.post`,
            icon: `fas fa-cog`,
            hideChildren: !0,
            permissions: [`post:config`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Post/Config/Index.vue`),
              __vite__mapDeps([886, 4, 2]),
            ),
          children: [
            {
              path: `general`,
              name: `PostConfigGeneral`,
              meta: {
                label: `post.config.general`,
                icon: `far fa-building`,
                key: `general`,
              },
              component: () =>
                G(
                  () => import(`../../../js/views/Pages/Post/Config/General.vue`),
                  __vite__mapDeps([887, 1, 2, 3, 4, 5, 6, 7, 8]),
                ),
            },
          ],
        },
      ],
    },
    {
      path: `posts`,
      name: `Post`,
      redirect: {
        name: `PostList`,
      },
      meta: {
        isNotNav: !0,
        label: `post.post`,
        icon: `fas fa-image`,
        hideChildren: !0,
        permissions: [`post:read`],
      },
      beforeEnter: (e, t, n) => {
        bm(`feature.enablePost`) ? n() : n(`/`);
      },
      component: {
        template: `<router-view></router-view>`,
      },
      children: [
        {
          path: ``,
          name: `PostList`,
          meta: {
            trans: `global.list`,
            label: `post.posts`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Post/Index.vue`),
              __vite__mapDeps([29, 1, 2, 3, 4, 5, 6, 7, 8, 30, 31, 10, 11]),
            ),
        },
        {
          path: `:uuid/edit`,
          name: `PostEdit`,
          meta: {
            type: `edit`,
            action: `update`,
            trans: `global.edit`,
            label: `post.post`,
            permissions: [`post:edit`],
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Post/Edit.vue`),
              __vite__mapDeps([888, 1, 2, 3, 4, 5, 6, 7, 8, 30, 31]),
            ),
        },
        {
          path: `:uuid`,
          name: `PostShow`,
          meta: {
            trans: `global.detail`,
            label: `post.post`,
          },
          component: () =>
            G(
              () => import(`../../../js/views/Pages/Post/Show.vue`),
              __vite__mapDeps([889, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11]),
            ),
        },
      ],
    },
  ],
  Sm = [
    ...Ul,
    ...Wl,
    ...ql,
    ...vu,
    ...Hu,
    ...gd,
    ...jd,
    ...Ud,
    ..._f,
    ...vf,
    ...Df,
    ...Xf,
    ...ep,
    ...mp,
    ...hp,
    ...xp,
    ...kp,
    ...Mp,
    ...Lp,
    ...Bp,
    ...Vp,
    ...Hp,
    ..._m,
    ...vm,
    ...ym,
    ...xm,
    ...Kp,
    ...Xp,
    ...nm,
    ...rm,
    ...sm,
    ...dm,
    ...fm,
    ...pm,
    ...gm,
    ...Jl,
    ...Zl,
    ...Ql,
    ...tu,
    ...cu,
    ...lu,
    ...su,
    ...uu,
    ...du,
  ],
  Cm = [
    {
      path: `login`,
      name: `Login`,
      meta: {
        title: `auth.login.page_title`,
        description: `auth.login.page_description`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/Login.vue`),
          __vite__mapDeps([890, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `email-otp-login`,
      name: `EmailOtpLogin`,
      meta: {
        title: `auth.login.page_title`,
        description: `auth.login.page_description`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/EmailOtp.vue`),
          __vite__mapDeps([891, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `sms-otp-login`,
      name: `SmsOtpLogin`,
      meta: {
        title: `auth.login.page_title`,
        description: `auth.login.page_description`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/SMSOtp.vue`),
          __vite__mapDeps([892, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `security`,
      name: `TwoFactorSecurity`,
      meta: {
        title: `auth.login.page_title`,
        description: `auth.login.page_description`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/TwoFactorSecurity.vue`),
          __vite__mapDeps([893, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `register`,
      name: `Register`,
      meta: {
        title: `auth.register.page_title`,
        description: `auth.register.page_description`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/Register.vue`),
          __vite__mapDeps([894, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
      beforeEnter: (e, t, n) => {
        kS.getters[`config/config`](`auth.enableRegistration`)
          ? n()
          : n({
              name: `Login`,
            });
      },
    },
    {
      path: `register/email`,
      name: `EmailRequest`,
      meta: {
        title: `auth.register.page_title`,
        description: `auth.register.page_description`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/EmailRequest.vue`),
          __vite__mapDeps([895, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
      beforeEnter: (e, t, n) => {
        kS.getters[`config/config`](`auth.enableRegistration`) &&
        kS.getters[`config/config`](`auth.enableEmailVerification`)
          ? n()
          : n({
              name: `Login`,
            });
      },
    },
    {
      path: `register/verify/:token`,
      name: `EmailVerification`,
      meta: {
        title: `auth.register.page_title`,
        description: `auth.register.page_description`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/EmailVerification.vue`),
          __vite__mapDeps([896, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
      beforeEnter: (e, t, n) => {
        kS.getters[`config/config`](`auth.enableRegistration`) &&
        kS.getters[`config/config`](`auth.enableEmailVerification`)
          ? n()
          : n({
              name: `Login`,
            });
      },
    },
    {
      path: `password`,
      name: `Password`,
      meta: {
        title: `auth.password.page_title`,
        description: `auth.password.page_description`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Auth/Password.vue`),
          __vite__mapDeps([897, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
      beforeEnter: (e, t, n) => {
        kS.getters[`config/config`](`auth.enableResetPassword`)
          ? n()
          : n({
              name: `Login`,
            });
      },
    },
  ],
  wm = [
    {
      path: `install`,
      name: `Install`,
      meta: {
        title: `setup.install.install_wizard`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Install/Index.vue`),
          __vite__mapDeps([898, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
      beforeEnter: (e, t, n) => {
        kS.getters[`config/configs`].requiresInstall ? n() : n(`/`);
      },
    },
  ],
  Tm = [
    {
      path: `team/selection`,
      name: `TeamSelection`,
      meta: {},
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Team/Selection.vue`),
          __vite__mapDeps([899, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
      beforeEnter: (e, t, n) => {
        kS.getters[`auth/user/currentTeamId`]
          ? e.query.ref
            ? n(e.query.ref)
            : n({
                name: `Dashboard`,
              })
          : n();
      },
    },
  ],
  Em = [
    {
      path: `error`,
      name: `ErrorGeneral`,
      meta: {
        title: `general.errors.error_page_title`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Errors/Index.vue`),
          __vite__mapDeps([900, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `401`,
      name: `Error401`,
      meta: {
        title: `general.errors.unauthorized_title`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Errors/401.vue`),
          __vite__mapDeps([901, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `403`,
      name: `Error403`,
      meta: {
        title: `general.errors.permission_denied_title`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Errors/403.vue`),
          __vite__mapDeps([902, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
    {
      path: `404`,
      name: `Error404`,
      meta: {
        title: `general.errors.page_not_found_title`,
      },
      component: () =>
        G(
          () => import(`../../../js/views/Pages/Errors/404.vue`),
          __vite__mapDeps([903, 1, 2, 3, 4, 5, 6, 7, 8]),
        ),
    },
  ],
  Dm = () =>
    G(
      () => import(`../../../js/views/Layouts/Blank.vue`),
      __vite__mapDeps([904, 1, 2, 3, 4, 5, 6, 7, 8]),
    ),
  Om = () =>
    G(
      () => import(`../../../js/views/Layouts/App.vue`),
      __vite__mapDeps([905, 1, 2, 3, 4, 5, 6, 7, 8, 67, 68, 906]),
    ),
  km = () =>
    G(
      () => import(`../../../js/views/Layouts/Guest.vue`),
      __vite__mapDeps([907, 1, 2, 3, 4, 5, 6, 7, 8]),
    ),
  Am = () =>
    G(
      () => import(`../../../js/views/Layouts/Setup.vue`),
      __vite__mapDeps([908, 1, 2, 3, 4, 5, 6, 7, 8]),
    ),
  jm = () =>
    G(
      () => import(`../../../js/views/Layouts/Empty.vue`),
      __vite__mapDeps([909, 1, 2, 3, 4, 5, 6, 7, 8]),
    ),
  Mm = () =>
    G(
      () => import(`../../../js/views/Layouts/Error.vue`),
      __vite__mapDeps([910, 1, 2, 3, 4, 5, 6, 7, 8]),
    ),
  Nm = [
    {
      path: `/`,
      name: `Guest`,
      component: km,
      redirect: {
        name: `Login`,
      },
      meta: {
        isNotNav: !0,
        belongsTo: `guest`,
      },
      children: [...Cm],
    },
    {
      path: `/`,
      name: `Blank`,
      component: Dm,
      meta: {
        isNotNav: !0,
        belongsTo: `blank`,
      },
      children: [...Vl],
    },
    {
      path: `/`,
      name: `Empty`,
      component: jm,
      meta: {
        isNotNav: !0,
        belongsTo: `auth`,
      },
      children: [...Tm],
    },
    {
      path: `/`,
      name: `App`,
      component: Om,
      redirect: {
        name: `Dashboard`,
      },
      meta: {
        belongsTo: `auth`,
      },
      children: [...Sm],
    },
    {
      path: `/`,
      name: `Setup`,
      component: Am,
      redirect: {
        name: `install`,
      },
      meta: {
        isNotNav: !0,
        belongsTo: `setup`,
      },
      children: [...wm],
    },
    {
      path: `/`,
      name: `Error`,
      component: Mm,
      meta: {
        isNotNav: !0,
        belongsTo: `setup`,
      },
      children: [...Em],
    },
    {
      path: `/:pathMatch(.*)*`,
      name: `NotFound`,
      meta: {
        isNotNav: !0,
      },
      beforeEnter: (e, t, n) => {
        n({
          name: `Error404`,
          replace: !0,
          query: {
            ref: e.fullPath,
            from: t.fullPath,
          },
        });
      },
    },
  ],
  Pm = (e) =>
    e
      ? e.reduce(
          (e, t) => (
            e.push({
              name: t.name
                .replace(/\./g, ` `)
                .replace(/_/g, ` `)
                .replace(/\b\w/g, (e) => e.toUpperCase())
                .replace(/\s/g, ``),
              visibility: t.visibility,
              position: t.position || 0,
            }),
            t.children && e.push(...Pm(t.children)),
            e
          ),
          [],
        )
      : [];
function Fm(e, t) {
  return e
    .filter((e) => {
      let n = !1,
        r = t.find(
          (t) => t.name === e.name || t.name + `List` === e.name || t.name + `Index` === e.name,
        );
      if (r && !r.visibility) return !1;
      let i = kS.getters[`config/configs`].tenant.availableModules;
      if (e.meta?.moduleName && !i.includes(e.meta.moduleName)) return !1;
      if (!e.meta) n = !0;
      else {
        if (e.meta.isNotNav === !0) return !1;
        e.meta.isNotNav;
        let t = !1,
          r = !1;
        if (
          (e.meta.hasOwnProperty(`feature`) &&
            !kS.getters[`config/configs`].feature[e.meta.feature]) ||
          (e.meta.hasOwnProperty(`superAdmin`) &&
            e.meta.superAdmin &&
            !kS.getters[`auth/user/isSuperAdmin`]) ||
          (e.meta.hasOwnProperty(`roles`) &&
            e.meta.roles.length &&
            ((t = kS.getters[`auth/user/hasAnyRole`](e.meta.roles)), !t)) ||
          (e.meta.hasOwnProperty(`permissions`) &&
            e.meta.permissions.length &&
            ((r = e.meta.allPermissions
              ? kS.getters[`auth/user/hasAllPermissions`](e.meta.permissions)
              : kS.getters[`auth/user/hasAnyPermission`](e.meta.permissions)),
            !r))
        )
          return !1;
        n = !0;
      }
      return n ? (e.children && e.children.length && (e.children = Fm(e.children, t)), !0) : !1;
    })
    .sort((e, n) => {
      let r = t.find(
          (t) => t.name === e.name || t.name + `List` === e.name || t.name + `Index` === e.name,
        ),
        i = t.find(
          (e) => e.name === n.name || e.name + `List` === n.name || e.name + `Index` === n.name,
        );
      return !r || !i ? 0 : (r.position || 0) - (i.position || 0);
    });
}
var Im = [];
function Lm(e) {
  return (
    e.map((e) => {
      Im.length ||
        (e.name === `Config` ? (Im = e) : e.children && e.children.length && (Im = Lm(e.children)));
    }),
    Im
  );
}
var Rm = {
    namespaced: !0,
    modules: {},
    state: () => ({
      navigations: [],
      configNavigations: [],
    }),
    mutations: {
      SET_NAVIGATION: (e, { navigations: t = [], configNavigations: n = [] }) => {
        ((e.navigations = t), (e.configNavigations = n));
      },
      RESET_NAVIGATION: (e) => {
        ((e.navigations = []), (e.configNavigations = []));
      },
    },
    actions: {
      setNavigation({ commit: e }) {
        let t = kS.getters[`config/configs`].module;
        t.sort((e, t) => e.position - t.position);
        let n = Pm(t),
          r = Fm(_.cloneDeep(Nm), n),
          i = Lm(r);
        e(`SET_NAVIGATION`, {
          navigations: r,
          configNavigations: i ? i.children : [],
        });
      },
      resetNavigation({ commit: e }) {
        e(`RESET_NAVIGATION`);
      },
    },
    getters: {
      navigations: (e) => e.navigations,
      configNavigations: (e) => e.configNavigations,
      mainCategories: (e) => {
        let t = {
            key: `core`,
            label: `Core`,
            icon: `fas fa-th-large`,
          },
          n = new Map();
        return (
          e.navigations.forEach((e) => {
            (e.children || []).forEach((e) => {
              let r = e.meta && e.meta.mainCategory ? e.meta.mainCategory : t;
              n.has(r.key) || n.set(r.key, r);
            });
          }),
          Array.from(n.values())
        );
      },
    },
  },
  zm = B(),
  Bm = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/config/mail-templates`,
      templateUrl: `/app/config/templates`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async toggleStatus({ state: e, commit: t }, n) {
        await z({
          url: e.templateUrl + `/` + n.uuid + `/status`,
          method: `POST`,
        })
          .then((e) => {
            zm.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Vm = B(),
  Hm = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/config/sms-templates`,
      templateUrl: `/app/config/templates`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async toggleStatus({ state: e, commit: t }, n) {
        await z({
          url: e.templateUrl + `/` + n.uuid + `/status`,
          method: `POST`,
        })
          .then((e) => {
            Vm.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Um = B(),
  Wm = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/config/whatsapp-templates`,
      templateUrl: `/app/config/templates`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async toggleStatus({ state: e, commit: t }, n) {
        await z({
          url: e.templateUrl + `/` + n.uuid + `/status`,
          method: `POST`,
        })
          .then((e) => {
            Um.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Gm = B(),
  Km = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/config/push-notification-templates`,
      templateUrl: `/app/config/templates`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async toggleStatus({ state: e, commit: t }, n) {
        await z({
          url: e.templateUrl + `/` + n.uuid + `/status`,
          method: `POST`,
        })
          .then((e) => {
            Gm.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  qm = B(),
  Jm = () => ({
    initURL: `/config`,
    initAppURL: `/app/config`,
    config: {
      auth: {},
      system: {},
      general: {},
    },
    isLoaded: !1,
    formErrors: [],
  }),
  Ym = {
    namespaced: !0,
    state: Jm,
    modules: {
      mailTemplate: Bm,
      smsTemplate: Hm,
      whatsappTemplate: Wm,
      pushNotificationTemplate: Km,
    },
    mutations: {
      ...H,
      ADD_CONFIG: (e, t = {}) => {
        e.config = Object.assign({}, e.config, t);
      },
      SET_CONFIG: (e, t = {}) => {
        e.config = t;
      },
      SET_IS_LOADED: (e, t) => {
        e.isLoaded = t;
      },
      RESET_CONFIG: (e) => {
        e.config = Jm.config;
      },
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite: U.preRequisite,
      async get({ state: e, commit: t, dispatch: n }, r) {
        (r && t(`RESET_CONFIG`),
          await z({
            url: e.initURL,
            method: `GET`,
          })
            .then((e) => {
              (t(`ADD_CONFIG`, e), t(`SET_IS_LOADED`, !0));
            })
            .catch((e) => {
              (t(`RESET_STATE`), V(e));
            }));
      },
      async modulePreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initAppURL + `/module-pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async fetch({ state: e, commit: t }, n) {
        return await z({
          url: e.initAppURL + `?type=` + n.type,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            V(e);
          });
      },
      async store({ state: e, commit: t }, n) {
        return await z({
          url: e.initAppURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), qm.success(e.message));
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async storeModule({ state: e, commit: t }, n) {
        return await z({
          url: e.initAppURL + `/module`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), qm.success(e.message));
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async testMailConnection({ state: e, commit: t }, n) {
        return await z({
          url: e.initAppURL + `/mail/test`,
          method: `GET`,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), qm.success(e.message));
          })
          .catch((e) => {
            t(`SET_FORM_ERRORS`, V(e));
          });
      },
      async testSMS({ state: e, commit: t }, n) {
        return await z({
          url: e.initAppURL + `/sms/test`,
          method: `GET`,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), qm.success(e.message));
          })
          .catch((e) => {
            t(`SET_FORM_ERRORS`, V(e));
          });
      },
      async testWhatsApp({ state: e, commit: t }, n) {
        return await z({
          url: e.initAppURL + `/whatsapp/test`,
          method: `GET`,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), qm.success(e.message));
          })
          .catch((e) => {
            t(`SET_FORM_ERRORS`, V(e));
          });
      },
      async testPusherConnection({ state: e, commit: t }, n) {
        return await z({
          url: e.initAppURL + `/pusher/test`,
          method: `GET`,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), qm.success(e.message));
          })
          .catch((e) => {
            t(`SET_FORM_ERRORS`, V(e));
          });
      },
      async testAppNotification({ state: e, commit: t }, n) {
        return await z({
          url: e.initAppURL + `/app/test`,
          method: `GET`,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), qm.success(e.message));
          })
          .catch((e) => {
            t(`SET_FORM_ERRORS`, V(e));
          });
      },
      setConfig({ commit: e }, t) {
        e(`SET_CONFIG`, t);
      },
      setLoaded({ commit: e }, t) {
        e(`SET_IS_LOADED`, t);
      },
      resetConfig({ commit: e }) {
        e(`RESET_CONFIG`);
      },
      resetState({ commit: e }) {
        e(`RESET_STATE`);
      },
    },
    getters: {
      ...W,
      configs: (e) => e.config,
      config: (e) => (t) => {
        let n = t.split(`.`),
          r = e.config;
        return (
          n.forEach((e) => {
            if (r === void 0) return null;
            r = r[e];
          }),
          r
        );
      },
      isLoaded: (e) => e.isLoaded,
    },
  },
  Xm = () => ({
    sidebar: {
      mobile: !1,
      type: `mini`,
    },
    display: `dark`,
    selectedMainCategory: null,
  }),
  Zm = {
    namespaced: !0,
    state: Xm,
    modules: {},
    mutations: {
      SET_MOBILE_SIDEBAR: (e, t) => {
        e.sidebar.mobile = t;
      },
      SET_SIDEBAR_TYPE: (e, t) => {
        e.sidebar.type = t;
      },
      SET_DISPLAY: (e, t) => {
        e.display = t;
      },
      SET_SELECTED_MAIN_CATEGORY: (e, t) => {
        e.selectedMainCategory = t;
      },
      RESET_STATE: (e) => {
        e = Xm;
      },
    },
    actions: {
      setMobileSidebar({ commit: e }, t) {
        e(`SET_MOBILE_SIDEBAR`, t);
      },
      async setSidebarType({ commit: e }, t) {
        e(`SET_SIDEBAR_TYPE`, t);
      },
      async setDisplay({ commit: e }, t) {
        e(`SET_DISPLAY`, t);
      },
      setSelectedMainCategory({ commit: e }, t) {
        e(`SET_SELECTED_MAIN_CATEGORY`, t);
      },
      async setLayout({ commit: e }, t = {}) {
        (e(`SET_SIDEBAR_TYPE`, t.sidebar),
          t.display === `dark`
            ? document.body.classList.add(`dark`)
            : document.body.classList.remove(`dark`),
          e(`SET_DISPLAY`, t.display));
      },
      async setUserLayout({ commit: e, dispatch: t }, n) {
        await z({
          url: `/app/user/preference`,
          method: `POST`,
          data: n,
        })
          .then((e) => {
            (t(`setLayout`, e.user.preference.layout),
              t(`auth/user/setUserPreference`, e.user, {
                root: !0,
              }));
          })
          .catch((e) => {
            throw e;
          });
      },
      resetState({ commit: e }) {
        e(`RESET_STATE`);
      },
    },
    getters: {
      mobileSidebar: (e) => !!e.sidebar.mobile,
      getSidebarType: (e) => e.sidebar.type,
      getDisplay: (e) => e.display,
      selectedMainCategory: (e) => e.selectedMainCategory,
    },
  };
B();
var Qm = {
  namespaced: !0,
  state: () => ({
    initURL: `/app/search`,
    formErrors: {},
  }),
  modules: {},
  mutations: {
    ...H,
  },
  actions: {
    resetFormErrors: U.resetFormErrors,
    search({ state: e, commit: t }, n) {
      return z({
        url: D(e.initURL, n),
        method: `GET`,
      })
        .then((e) => e)
        .catch((e) => {
          throw e;
        });
    },
  },
  getters: {},
};
B();
var $m = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/dashboard/`,
      formErrors: {},
    }),
    modules: {
      search: Qm,
    },
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      getStat({ state: e, commit: t }) {
        return z({
          url: e.initURL + `stat`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getStudentChartData({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `student-chart-data`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getTransactionChartData({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `transaction-chart-data`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getEmployeeAttendanceSummary({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `employee-attendance-summary`, n),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getSchedule({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `schedule`, n),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getStudentList({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `student`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getSubjects({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `subjects`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getTimetable({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `timetable`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getTransportRoute({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `transport-route`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getMessSchedule({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `mess-schedule`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getInstituteInfo({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `institute-info`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      getFormList({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `form-list`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      fetchGallery({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `gallery`, n),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      fetchCelebration({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `celebration`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
    },
    getters: {},
  },
  eh = B(),
  th = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      upload({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + n.path,
          method: `POST`,
          data: n.data,
          upload: !0,
          headers: n.headers,
        })
          .then(
            (e) => (
              t(`SET_FORM_ERRORS`, {}),
              e.hasOwnProperty(`message`) && eh.success(e.message),
              e
            ),
          )
          .catch((e) => {
            throw (V(e), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + n.path,
          method: `DELETE`,
          headers: n.headers,
        })
          .then(
            (e) => (
              t(`SET_FORM_ERRORS`, {}),
              e.hasOwnProperty(`message`) && eh.success(e.message),
              e
            ),
          )
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {},
  },
  nh =
    {
      localStorageKey: `Mint School - SaaS based School ERP Solution_production`,
    }.localStorageKey + `_active_role`,
  rh = [`student`, `guardian`];
function ih(e = []) {
  return e.some((e) => rh.includes(e)) && e.some((e) => !rh.includes(e));
}
function ah(e = [], t = null) {
  return e.includes(`*`) || !ih(e) || !t
    ? e
    : rh.includes(t)
      ? e.filter((e) => rh.includes(e))
      : e.filter((e) => !rh.includes(e));
}
var oh = B(),
  sh = {
    namespaced: !0,
    state: () => ({
      user: {
        uuid: ``,
        email: ``,
        username: ``,
        status: ``,
        avatar: ``,
        profile: {},
        roles: [],
        permissions: [],
        preference: {
          system: {},
          layout: {},
        },
        isSuperAdmin: !1,
        forceChangePassword: !1,
        currentTeamId: null,
        currentPeriodId: null,
        scope: ``,
        scopeDetail: null,
        activeRole: null,
      },
      formErrors: {},
    }),
    mutations: {
      ...H,
      SET_USER_UUID: (e, t = ``) => {
        e.user.uuid = t;
      },
      SET_USER_EMAIL: (e, t = ``) => {
        e.user.email = t;
      },
      SET_USER_USERNAME: (e, t = ``) => {
        e.user.username = t;
      },
      SET_USER_STATUS: (e, t = ``) => {
        e.user.status = t;
      },
      SET_USER_AVATAR: (e, t = ``) => {
        e.user.avatar = t;
      },
      SET_USER_PROFILE: (e, t = {}) => {
        e.user.profile = t;
      },
      SET_USER_ROLES: (e, t = []) => {
        e.user.roles = t;
      },
      SET_USER_PERMISSIONS: (e, t = []) => {
        e.user.permissions = t;
      },
      SET_USER_PREFERENCE: (e, t = {}) => {
        e.user.preference = t;
      },
      SET_IS_SUPER_ADMIN: (e, t = {}) => {
        e.user.isSuperAdmin = t;
      },
      SET_FORCE_CHANGE_PASSWORD: (e, t = {}) => {
        e.user.forceChangePassword = t;
      },
      SET_CURRENT_TEAM_ID: (e, t = {}) => {
        e.user.currentTeamId = t;
      },
      SET_CURRENT_PERIOD_ID: (e, t = {}) => {
        e.user.currentPeriodId = t;
      },
      SET_USER_SCOPE: (e, t = {}) => {
        e.user.scope = t;
      },
      SET_USER_SCOPE_DETAIL: (e, t = {}) => {
        e.user.scopeDetail = t;
      },
      SET_ACTIVE_ROLE: (e, t = null) => {
        e.user.activeRole = t;
      },
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async setCSRF() {
        await Fs.get(`/sanctum/csrf-cookie`, {
          withCredentials: !0,
        })
          .then(() => {})
          .catch((e) => {
            throw e;
          });
      },
      async setUser({ commit: e }, t) {
        (e(`SET_USER_UUID`, t.uuid),
          e(`SET_USER_EMAIL`, t.email),
          e(`SET_USER_USERNAME`, t.username),
          e(`SET_USER_STATUS`, t.status),
          e(`SET_USER_AVATAR`, t.avatar),
          e(`SET_USER_PROFILE`, t.profile),
          e(`SET_USER_ROLES`, t.roles),
          e(`SET_USER_PERMISSIONS`, t.permissions),
          e(`SET_USER_PREFERENCE`, t.preference),
          e(`SET_IS_SUPER_ADMIN`, !!t.isSuperAdmin),
          e(`SET_FORCE_CHANGE_PASSWORD`, t.forceChangePassword),
          e(`SET_CURRENT_TEAM_ID`, t.currentTeamId),
          e(`SET_CURRENT_PERIOD_ID`, t.currentPeriodId),
          e(`SET_USER_SCOPE`, t.scope),
          e(`SET_USER_SCOPE_DETAIL`, t.scopeDetail),
          e(
            `SET_ACTIVE_ROLE`,
            t.activeRole === void 0 ? (localStorage.getItem(nh) ?? null) : t.activeRole,
          ));
      },
      async resetForceChangePassword({ commit: e }) {
        e(`SET_FORCE_CHANGE_PASSWORD`, !1);
      },
      async resetUser({ commit: e }) {
        e(`RESET_STATE`);
      },
      async setUserPreference({ commit: e }, t) {
        e(`SET_USER_PREFERENCE`, t.preference);
      },
      async login({ commit: e, dispatch: t, getters: n }, r) {
        let i = null;
        return (
          await z({
            url: `/auth/login`,
            method: `POST`,
            data: r.form,
          })
            .then((e) => {
              (Ml(r), t(`setUser`, e.user), (i = e), e.twoFactorSecurity || oh.success(e.message));
            })
            .catch((t) => {
              throw (Ml(r), e(`SET_FORM_ERRORS`, V(t)), t);
            }),
          i?.twoFactorSecurity
            ? i
            : (await t(`config/get`, null, {
                root: !0,
              }),
              await t(`layout/setLayout`, n.preference.layout, {
                root: !0,
              }),
              await t(`navigation/setNavigation`, null, {
                root: !0,
              }),
              i)
        );
      },
      async verifyTwoFactorSecurity({ commit: e, dispatch: t, getters: n }, r) {
        (await z({
          url: `/auth/security`,
          method: `POST`,
          data: r.form,
        })
          .then((t) => {
            (Ml(r), e(`SET_FORM_ERRORS`, {}), oh.success(`Security verification successful.`));
          })
          .catch((t) => {
            throw (Ml(r), e(`SET_FORM_ERRORS`, V(t)), t);
          }),
          await t(`config/get`, null, {
            root: !0,
          }),
          await t(`layout/setLayout`, n.preference.layout, {
            root: !0,
          }),
          await t(`navigation/setNavigation`, null, {
            root: !0,
          }));
      },
      async requestOtp({ commit: e, dispatch: t }, n) {
        (delete n.form.otp,
          await z({
            url: `/auth/login/otp/request`,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              (Ml(n), oh.success(e.message));
            })
            .catch((t) => {
              throw (Ml(n), e(`SET_FORM_ERRORS`, V(t)), t);
            }));
      },
      async confirmOtp({ commit: e, dispatch: t, getters: n }, r) {
        (await z({
          url: `/auth/login/otp/confirm`,
          method: `POST`,
          data: r.form,
        })
          .then((e) => {
            (Ml(r), t(`setUser`, e.user), oh.success(e.message), console.log(`login successful`));
          })
          .catch((t) => {
            throw (Ml(r), e(`SET_FORM_ERRORS`, V(t)), t);
          }),
          console.log(`config get`),
          await t(`config/get`, null, {
            root: !0,
          }),
          console.log(`layout set`),
          await t(`layout/setLayout`, n.preference.layout, {
            root: !0,
          }),
          console.log(`navigation set`),
          await t(`navigation/setNavigation`, null, {
            root: !0,
          }),
          console.log(`navigation set done`));
      },
      async logout({ commit: e, dispatch: t }, n = {}) {
        (await z({
          url: `/auth/logout`,
          method: `POST`,
        })
          .then((t) => {
            (Ml(n), e(`RESET_STATE`), oh.success(t.message));
          })
          .catch((t) => {
            (Ml(n), e(`RESET_STATE`));
          }),
          await t(`config/get`, null, {
            root: !0,
          }),
          await t(`navigation/resetNavigation`, null, {
            root: !0,
          }));
      },
      async impersonate({ commit: e, dispatch: t, getters: n }, r) {
        await z({
          url: `app/users/` + r.uuid + `/impersonate`,
          method: `POST`,
        })
          .then((n) => {
            (e(`RESET_STATE`),
              t(`setUser`, n.user, {
                root: !0,
              }));
          })
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      async unimpersonate({ commit: e, dispatch: t, getters: n }, r) {
        await z({
          url: `app/users/unimpersonate`,
          method: `POST`,
        })
          .then((n) => {
            (e(`RESET_STATE`),
              t(`setUser`, n.user, {
                root: !0,
              }));
          })
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      async fetch({ commit: e, dispatch: t }, n) {
        return await z({
          url: `/auth/user`,
          method: `GET`,
        })
          .then((e) => (Ml(n), t(`setUser`, e), e))
          .catch((e) => {
            throw (
              Ml(n),
              store
                .dispatch(`auth/user/logout`)
                .then(() => {})
                .catch((e) => {}),
              e
            );
          });
      },
      async confirmPassword({ commit: e, dispatch: t }, n) {
        await z({
          url: `/auth/confirm-password`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      async updateScope({ commit: e, dispatch: t }, n) {
        await z({
          url: `/app/users/scope`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            (Ml(n), t(`setUser`, e.user));
          })
          .catch((e) => {
            throw (Ml(n), e);
          });
      },
      async switchRole({ commit: e, dispatch: t }, n) {
        (await z({
          url: `/app/users/active-role`,
          method: `POST`,
          data: {
            role: n,
          },
        })
          .then((e) => {
            (n ? localStorage.setItem(nh, n) : localStorage.removeItem(nh), t(`setUser`, e.user));
          })
          .catch((e) => {
            throw e;
          }),
          await t(`navigation/setNavigation`, null, {
            root: !0,
          }));
      },
    },
    getters: {
      ...W,
      getUser: (e) => e.user,
      user: (e) => (t) => {
        let n = t.split(`.`),
          r = e.user;
        return (
          n.forEach((e) => {
            r = r[e];
          }),
          r
        );
      },
      preference: (e) => e.user.preference,
      isSuperAdmin: (e) => e.user.isSuperAdmin,
      forceChangePassword: (e) => e.user.forceChangePassword,
      currentTeamId: (e) => e.user.currentTeamId,
      currentPeriodId: (e) => e.user.currentPeriodId,
      activeRole: (e) => e.user.activeRole,
      hasMixedRoles: (e) => ih(e.user.roles),
      effectiveRoles: (e) => ah(e.user.roles, e.user.activeRole),
      hasRole: (e, t) => (e) =>
        t.effectiveRoles.includes(`*`) || t.effectiveRoles.indexOf(e) !== -1,
      hasAnyRole:
        (e, t) =>
        (e = []) =>
          t.effectiveRoles.includes(`*`) || t.effectiveRoles.some((t) => e.indexOf(t) !== -1),
      hasAllRoles:
        (e, t) =>
        (e = []) =>
          t.effectiveRoles.includes(`*`) || e.every((e) => t.effectiveRoles.indexOf(e) !== -1),
      hasPermission: (e) => (t) =>
        e.user.permissions.includes(`*`) || e.user.permissions.indexOf(t) !== -1,
      hasAnyPermission:
        (e) =>
        (t = []) =>
          e.user.permissions.includes(`*`) || t.some((t) => e.user.permissions.indexOf(t) !== -1),
      hasAllPermissions:
        (e) =>
        (t = []) =>
          e.user.permissions.includes(`*`) || t.every((t) => e.user.permissions.indexOf(t) !== -1),
    },
  },
  ch = B(),
  lh = {
    namespaced: !0,
    state: () => ({
      formErrors: {},
    }),
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      register({ commit: e }, t) {
        return z({
          url: `/auth/register`,
          method: `POST`,
          data: t.form,
        })
          .then((t) => {
            (e(`SET_FORM_ERRORS`, {}), ch.success(t.message));
          })
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      emailRequest({ commit: e }, t) {
        return z({
          url: `/auth/register/email`,
          method: `POST`,
          data: t.form,
        })
          .then((e) => {
            ch.success(e.message);
          })
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      emailVerification({ commit: e }, t) {
        return z({
          url: `/auth/register/verify`,
          method: `POST`,
          data: {
            token: t.token,
          },
        })
          .then((e) => {
            ch.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  uh = B(),
  dh = {
    namespaced: !0,
    modules: {
      user: sh,
      register: lh,
      password: {
        namespaced: !0,
        state: () => ({
          initURL: `/auth/password`,
          passwordRequestSent: !1,
          resetTokenConfirmed: !1,
          formErrors: {},
        }),
        mutations: {
          ...H,
          SET_PASSWORD_REQUEST_SENT: (e, t) => {
            e.passwordRequestSent = t;
          },
          SET_RESET_TOKEN_CONFIRMED: (e, t) => {
            e.resetTokenConfirmed = t;
          },
        },
        actions: {
          resetFormErrors: U.resetFormErrors,
          passwordRequest({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/request`,
              method: `POST`,
              data: {
                email: n.form.email,
              },
            })
              .then((e) => {
                (t(`SET_PASSWORD_REQUEST_SENT`, !0), uh.success(e.message));
              })
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          resetTokenConfirm({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/confirm`,
              method: `POST`,
              data: {
                email: n.form.email,
                code: n.form.code,
              },
            })
              .then((e) => {
                t(`SET_RESET_TOKEN_CONFIRMED`, !0);
              })
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          resetPassword({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/reset`,
              method: `POST`,
              data: n.form,
            })
              .then((e) => {
                (t(`SET_PASSWORD_REQUEST_SENT`, !1),
                  t(`SET_RESET_TOKEN_CONFIRMED`, !1),
                  uh.success(e.message));
              })
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
        },
        getters: {
          ...W,
          isPasswordRequestSent: (e) => e.passwordRequestSent,
          isResetTokenConfirmed: (e) => e.resetTokenConfirmed,
        },
      },
      failedLoginAttempt: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/failed-login-attempts`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          list: U.list,
        },
        getters: {
          ...W,
        },
      },
    },
    state: () => ({}),
    mutations: {},
    actions: {},
    getters: {},
  },
  fh = B(),
  ph = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/user`,
      initAuthURL: `/auth/user`,
      formErrors: {},
    }),
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async fetch({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initAuthURL,
          method: `GET`,
        })
          .then((e) => {
            n(`auth/user/setUser`, e, {
              root: !0,
            });
          })
          .catch((e) => {
            throw (
              n(`auth/user/logout`, null, {
                root: !0,
              })
                .then(() => {})
                .catch((e) => {}),
              e
            );
          });
      },
      async preference({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initURL + `/preference`,
          method: `POST`,
          data: r.form,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}),
              n(`auth/user/setUserPreference`, e.user.preference, {
                root: !0,
              }),
              fh.success(e.message));
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      changePassword({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/password`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), fh.success(e.message));
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateProfile({ state: e, commit: t, dispatch: n }, r) {
        return await z({
          url: e.initURL + `/profile`,
          method: `POST`,
          data: r.form,
        })
          .then(
            (e) => (
              t(`SET_FORM_ERRORS`, {}),
              n(`auth/user/setUser`, e.user, {
                root: !0,
              }),
              fh.success(e.message),
              e
            ),
          )
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateAccount({ state: e, commit: t, dispatch: n }, r) {
        return await z({
          url: e.initURL + `/profile/account`,
          method: `POST`,
          data: r.form,
        })
          .then(
            (e) => (
              t(`SET_FORM_ERRORS`, {}),
              n(`auth/user/setUser`, e.user, {
                root: !0,
              }),
              fh.success(e.message),
              e
            ),
          )
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async verifyAccount({ state: e, commit: t, dispatch: n }, r) {
        return await z({
          url: e.initURL + `/profile/verify`,
          method: `POST`,
          data: r.form,
        })
          .then(
            (e) => (
              t(`SET_FORM_ERRORS`, {}),
              n(`auth/user/setUser`, e.user, {
                root: !0,
              }),
              fh.success(e.message),
              e
            ),
          )
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getAuthenticatorStatus({ state: e, commit: t }) {
        return z({
          url: e.initURL + `/security/authenticator`,
          method: `GET`,
        }).catch((e) => {
          throw (t(`SET_FORM_ERRORS`, V(e)), e);
        });
      },
      async setupAuthenticator({ state: e, commit: t }) {
        return z({
          url: e.initURL + `/security/authenticator/setup`,
          method: `POST`,
        }).catch((e) => {
          throw (t(`SET_FORM_ERRORS`, V(e)), e);
        });
      },
      async enableAuthenticator({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/security/authenticator/enable`,
          method: `POST`,
          data: n.form,
        })
          .then(
            (e) => (t(`SET_FORM_ERRORS`, {}), fh.success(`Authenticator enabled successfully.`), e),
          )
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async disableAuthenticator({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/security/authenticator/disable`,
          method: `POST`,
          data: n.form,
        })
          .then(
            (e) => (
              t(`SET_FORM_ERRORS`, {}),
              fh.success(`Authenticator disabled successfully.`),
              e
            ),
          )
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  mh = B(),
  hh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/users`,
      subInitUrl: `/app/user`,
      formErrors: {},
    }),
    modules: {
      profile: ph,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async status({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            mh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async forceChangePassword({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.subInitUrl + `/force-change-password`,
          method: `POST`,
          data: r.form,
        })
          .then(async (e) => {
            (await n(`auth/user/resetForceChangePassword`, null, {
              root: !0,
            }),
              mh.success(e.message));
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async toggleForceChangePassword({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initURL + `/` + r.uuid + `/toggle-force-change-password`,
          method: `POST`,
        })
          .then(async (e) => {
            mh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async disableTwoFactor({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/disable-two-factor`,
          method: `POST`,
        })
          .then((e) => {
            mh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async sendTestNotification({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initURL + `/` + r.uuid + `/test-notification/` + r.type,
          method: `POST`,
        })
          .then(async (e) => {
            mh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  gh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/organizations`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  _h = B(),
  vh = () => ({}),
  Z = {
    SET_FORM_ERRORS: (e, t = {}) => {
      e.formErrors = t;
    },
    RESET_STATE: (e) => {
      e = vh;
    },
  },
  Q = {
    resetFormErrors({ commit: e }) {
      e(`SET_FORM_ERRORS`);
    },
    preRequisite({ state: e, commit: t }, n) {
      let r = ``;
      r = Array.isArray(n.data) ? n.data.join(`,`) : n.data;
      let i = e.initURL + `/` + n.uuid + e.module + `/pre-requisite`;
      return (
        r && (i += `?type=` + r),
        z({
          url: i,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          })
      );
    },
    list({ state: e, commit: t }, n) {
      return Js(e.initURL + `/` + n.uuid + e.module, n.params)
        .then((e) => e)
        .catch((e) => {
          throw (V(e), e);
        });
    },
    async get({ state: e, commit: t }, n) {
      return await Xs(e.initURL + `/` + n.uuid + e.module, n.moduleUuid)
        .then((e) => e)
        .catch((e) => {
          throw (V(e), e);
        });
    },
    async create({ state: e, commit: t }, n) {
      await Ys(e.initURL + `/` + n.uuid + e.module, n.form)
        .then((e) => {
          _h.success(e.message);
        })
        .catch((e) => {
          throw (t(`SET_FORM_ERRORS`, V(e)), e);
        });
    },
    async update({ state: e, commit: t }, n) {
      await Zs(e.initURL + `/` + n.uuid + e.module, n.moduleUuid, n.form)
        .then((e) => {
          _h.success(e.message);
        })
        .catch((e) => {
          throw (t(`SET_FORM_ERRORS`, V(e)), e);
        });
    },
    async delete({ state: e, commit: t }, n) {
      await Qs(e.initURL + `/` + n.uuid + e.module, n.moduleUuid)
        .then((e) => {
          _h.success(e.message);
        })
        .catch((e) => {
          throw (V(e), e);
        });
    },
    resetState({ commit: e }) {
      e(`RESET_STATE`);
    },
  },
  $ = {
    getFormErrors: (e) => e.formErrors,
  };
B();
var yh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/teams`,
      module: `/roles`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      resetFormErrors: Q.resetFormErrors,
      resetState: Q.resetState,
      list: Q.list,
      create: Q.create,
      delete: Q.delete,
    },
    getters: {
      ...$,
    },
  },
  bh = B(),
  xh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/teams`,
      module: `/permissions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      resetState: U.resetState,
      async preRequisite({ state: e, commit: t }, n) {
        return await z(e.initURL + `/` + n.uuid + e.module + `/pre-requisite?module=` + n.data)
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async roleWiseAssign({ state: e, commit: t, dispatch: n }, r) {
        (await Ys(e.initURL + `/` + r.uuid + e.module + `/role/assign`, r.form)
          .then((e) => {
            bh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          }),
          await n(`auth/user/fetch`, null, {
            root: !0,
          }));
      },
      async search({ state: e, commit: t }, n) {
        return await z(e.initURL + `/` + n.uuid + e.module + `/search?q=` + n.query)
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async searchUser({ state: e, commit: t }, n) {
        return await z(e.initURL + `/` + n.uuid + e.module + `/user/search?q=` + n.query)
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async userWiseAssign({ state: e, commit: t, dispatch: n }, r) {
        (await Ys(e.initURL + `/` + r.uuid + e.module + `/user/assign`, r.form)
          .then((e) => {
            bh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          }),
          await n(`auth/user/fetch`, null, {
            root: !0,
          }));
      },
    },
    getters: {
      ...W,
    },
  },
  Sh = B(),
  Ch = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/teams`,
      formErrors: {},
    }),
    modules: {
      role: yh,
      permission: xh,
    },
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite: U.preRequisite,
      list: U.list,
      get: U.get,
      delete: U.delete,
      async create({ state: e, commit: t, dispatch: n }, r) {
        (await Ys(e.initURL, r.form)
          .then((e) => {
            Sh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          }),
          await n(`config/get`, !1, {
            root: !0,
          }));
      },
      async select({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/select`,
          method: `POST`,
          data: null,
        })
          .then((e) => {
            Sh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async update({ state: e, commit: t, dispatch: n }, r) {
        (await Zs(e.initURL, r.uuid, r.form)
          .then((e) => {
            Sh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          }),
          await n(`config/get`, !1, {
            root: !0,
          }));
      },
      async storeConfig({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            (t(`SET_FORM_ERRORS`, {}), Sh.success(e.message));
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateAdmin({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initURL + `/` + r.uuid + `/admin`,
          method: `POST`,
          data: r.form,
        })
          .then((e) => {
            Sh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateUsers({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initURL + `/users`,
          method: `POST`,
          data: r.form,
        })
          .then((e) => {
            Sh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async sync({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initURL + `/` + r.uuid + `/sync`,
          method: `POST`,
          data: r.form,
        })
          .then((e) => {
            Sh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async import({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initURL + `/` + r.uuid + `/import`,
          method: `POST`,
          data: r.form,
        })
          .then((e) => {
            Sh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPeriods({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/periods`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  wh = n((e, t) => {
    (function () {
      var n,
        r = `4.18.1`,
        i = 200,
        a = `Unsupported core-js use. Try https://npms.io/search?q=ponyfill.`,
        o = `Expected a function`,
        s = "Invalid `variable` option passed into `_.template`",
        c = "Invalid `imports` option passed into `_.template`",
        l = `__lodash_hash_undefined__`,
        u = 500,
        d = `__lodash_placeholder__`,
        f = 1,
        p = 2,
        m = 4,
        h = 1,
        g = 2,
        v = 1,
        y = 2,
        b = 4,
        x = 8,
        S = 16,
        C = 32,
        w = 64,
        T = 128,
        ee = 256,
        te = 512,
        ne = 30,
        re = `...`,
        E = 800,
        ie = 16,
        ae = 1,
        oe = 2,
        D = 3,
        O = 1 / 0,
        k = 9007199254740991,
        se = 17976931348623157e292,
        ce = NaN,
        le = 4294967295,
        ue = le - 1,
        de = le >>> 1,
        fe = [
          [`ary`, T],
          [`bind`, v],
          [`bindKey`, y],
          [`curry`, x],
          [`curryRight`, S],
          [`flip`, te],
          [`partial`, C],
          [`partialRight`, w],
          [`rearg`, ee],
        ],
        pe = `[object Arguments]`,
        me = `[object Array]`,
        he = `[object AsyncFunction]`,
        ge = `[object Boolean]`,
        _e = `[object Date]`,
        ve = `[object DOMException]`,
        ye = `[object Error]`,
        be = `[object Function]`,
        xe = `[object GeneratorFunction]`,
        Se = `[object Map]`,
        Ce = `[object Number]`,
        we = `[object Null]`,
        Te = `[object Object]`,
        A = `[object Promise]`,
        Ee = `[object Proxy]`,
        De = `[object RegExp]`,
        Oe = `[object Set]`,
        ke = `[object String]`,
        Ae = `[object Symbol]`,
        je = `[object Undefined]`,
        Me = `[object WeakMap]`,
        Ne = `[object WeakSet]`,
        Pe = `[object ArrayBuffer]`,
        Fe = `[object DataView]`,
        Ie = `[object Float32Array]`,
        Le = `[object Float64Array]`,
        Re = `[object Int8Array]`,
        ze = `[object Int16Array]`,
        Be = `[object Int32Array]`,
        Ve = `[object Uint8Array]`,
        He = `[object Uint8ClampedArray]`,
        Ue = `[object Uint16Array]`,
        We = `[object Uint32Array]`,
        Ge = /\b__p \+= '';/g,
        Ke = /\b(__p \+=) '' \+/g,
        qe = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
        Je = /&(?:amp|lt|gt|quot|#39);/g,
        Ye = /[&<>"']/g,
        Xe = RegExp(Je.source),
        Ze = RegExp(Ye.source),
        Qe = /<%-([\s\S]+?)%>/g,
        $e = /<%([\s\S]+?)%>/g,
        et = /<%=([\s\S]+?)%>/g,
        tt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        nt = /^\w*$/,
        rt =
          /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        it = /[\\^$.*+?()[\]{}|]/g,
        at = RegExp(it.source),
        ot = /^\s+/,
        st = /\s/,
        ct = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
        lt = /\{\n\/\* \[wrapped with (.+)\] \*/,
        ut = /,? & /,
        dt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
        ft = /[()=,{}\[\]\/\s]/,
        pt = /\\(\\)?/g,
        mt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
        ht = /\w*$/,
        gt = /^[-+]0x[0-9a-f]+$/i,
        _t = /^0b[01]+$/i,
        vt = /^\[object .+?Constructor\]$/,
        yt = /^0o[0-7]+$/i,
        bt = /^(?:0|[1-9]\d*)$/,
        xt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
        St = /($^)/,
        Ct = /['\n\r\u2028\u2029\\]/g,
        wt = `\\ud800-\\udfff`,
        Tt = `\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff`,
        Et = `\\u2700-\\u27bf`,
        j = `a-z\\xdf-\\xf6\\xf8-\\xff`,
        Dt = `\\xac\\xb1\\xd7\\xf7`,
        Ot = `\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf`,
        kt = `\\u2000-\\u206f`,
        At = ` \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000`,
        jt = `A-Z\\xc0-\\xd6\\xd8-\\xde`,
        Mt = `\\ufe0e\\ufe0f`,
        Nt = Dt + Ot + kt + At,
        Pt = `['’]`,
        M = `[` + wt + `]`,
        Ft = `[` + Nt + `]`,
        It = `[` + Tt + `]`,
        Lt = `\\d+`,
        Rt = `[` + Et + `]`,
        zt = `[` + j + `]`,
        Bt = `[^` + wt + Nt + Lt + Et + j + jt + `]`,
        Vt = `\\ud83c[\\udffb-\\udfff]`,
        Ht = `(?:` + It + `|` + Vt + `)`,
        Ut = `[^` + wt + `]`,
        Wt = `(?:\\ud83c[\\udde6-\\uddff]){2}`,
        Gt = `[\\ud800-\\udbff][\\udc00-\\udfff]`,
        Kt = `[` + jt + `]`,
        qt = `\\u200d`,
        Jt = `(?:` + zt + `|` + Bt + `)`,
        Yt = `(?:` + Kt + `|` + Bt + `)`,
        Xt = `(?:` + Pt + `(?:d|ll|m|re|s|t|ve))?`,
        Zt = `(?:` + Pt + `(?:D|LL|M|RE|S|T|VE))?`,
        Qt = Ht + `?`,
        $t = `[` + Mt + `]?`,
        en = `(?:` + qt + `(?:` + [Ut, Wt, Gt].join(`|`) + `)` + $t + Qt + `)*`,
        tn = `\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])`,
        nn = `\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])`,
        rn = $t + Qt + en,
        an = `(?:` + [Rt, Wt, Gt].join(`|`) + `)` + rn,
        on = `(?:` + [Ut + It + `?`, It, Wt, Gt, M].join(`|`) + `)`,
        sn = RegExp(Pt, `g`),
        cn = RegExp(It, `g`),
        ln = RegExp(Vt + `(?=` + Vt + `)|` + on + rn, `g`),
        un = RegExp(
          [
            Kt + `?` + zt + `+` + Xt + `(?=` + [Ft, Kt, `$`].join(`|`) + `)`,
            Yt + `+` + Zt + `(?=` + [Ft, Kt + Jt, `$`].join(`|`) + `)`,
            Kt + `?` + Jt + `+` + Xt,
            Kt + `+` + Zt,
            nn,
            tn,
            Lt,
            an,
          ].join(`|`),
          `g`,
        ),
        dn = RegExp(`[` + qt + wt + Tt + Mt + `]`),
        fn = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
        pn =
          `Array.Buffer.DataView.Date.Error.Float32Array.Float64Array.Function.Int8Array.Int16Array.Int32Array.Map.Math.Object.Promise.RegExp.Set.String.Symbol.TypeError.Uint8Array.Uint8ClampedArray.Uint16Array.Uint32Array.WeakMap._.clearTimeout.isFinite.parseInt.setTimeout`.split(
            `.`,
          ),
        mn = -1,
        hn = {};
      ((hn[Ie] = hn[Le] = hn[Re] = hn[ze] = hn[Be] = hn[Ve] = hn[He] = hn[Ue] = hn[We] = !0),
        (hn[pe] =
          hn[me] =
          hn[Pe] =
          hn[ge] =
          hn[Fe] =
          hn[_e] =
          hn[ye] =
          hn[be] =
          hn[Se] =
          hn[Ce] =
          hn[Te] =
          hn[De] =
          hn[Oe] =
          hn[ke] =
          hn[Me] =
            !1));
      var gn = {};
      ((gn[pe] =
        gn[me] =
        gn[Pe] =
        gn[Fe] =
        gn[ge] =
        gn[_e] =
        gn[Ie] =
        gn[Le] =
        gn[Re] =
        gn[ze] =
        gn[Be] =
        gn[Se] =
        gn[Ce] =
        gn[Te] =
        gn[De] =
        gn[Oe] =
        gn[ke] =
        gn[Ae] =
        gn[Ve] =
        gn[He] =
        gn[Ue] =
        gn[We] =
          !0),
        (gn[ye] = gn[be] = gn[Me] = !1));
      var _n = {
          À: `A`,
          Á: `A`,
          Â: `A`,
          Ã: `A`,
          Ä: `A`,
          Å: `A`,
          à: `a`,
          á: `a`,
          â: `a`,
          ã: `a`,
          ä: `a`,
          å: `a`,
          Ç: `C`,
          ç: `c`,
          Ð: `D`,
          ð: `d`,
          È: `E`,
          É: `E`,
          Ê: `E`,
          Ë: `E`,
          è: `e`,
          é: `e`,
          ê: `e`,
          ë: `e`,
          Ì: `I`,
          Í: `I`,
          Î: `I`,
          Ï: `I`,
          ì: `i`,
          í: `i`,
          î: `i`,
          ï: `i`,
          Ñ: `N`,
          ñ: `n`,
          Ò: `O`,
          Ó: `O`,
          Ô: `O`,
          Õ: `O`,
          Ö: `O`,
          Ø: `O`,
          ò: `o`,
          ó: `o`,
          ô: `o`,
          õ: `o`,
          ö: `o`,
          ø: `o`,
          Ù: `U`,
          Ú: `U`,
          Û: `U`,
          Ü: `U`,
          ù: `u`,
          ú: `u`,
          û: `u`,
          ü: `u`,
          Ý: `Y`,
          ý: `y`,
          ÿ: `y`,
          Æ: `Ae`,
          æ: `ae`,
          Þ: `Th`,
          þ: `th`,
          ß: `ss`,
          Ā: `A`,
          Ă: `A`,
          Ą: `A`,
          ā: `a`,
          ă: `a`,
          ą: `a`,
          Ć: `C`,
          Ĉ: `C`,
          Ċ: `C`,
          Č: `C`,
          ć: `c`,
          ĉ: `c`,
          ċ: `c`,
          č: `c`,
          Ď: `D`,
          Đ: `D`,
          ď: `d`,
          đ: `d`,
          Ē: `E`,
          Ĕ: `E`,
          Ė: `E`,
          Ę: `E`,
          Ě: `E`,
          ē: `e`,
          ĕ: `e`,
          ė: `e`,
          ę: `e`,
          ě: `e`,
          Ĝ: `G`,
          Ğ: `G`,
          Ġ: `G`,
          Ģ: `G`,
          ĝ: `g`,
          ğ: `g`,
          ġ: `g`,
          ģ: `g`,
          Ĥ: `H`,
          Ħ: `H`,
          ĥ: `h`,
          ħ: `h`,
          Ĩ: `I`,
          Ī: `I`,
          Ĭ: `I`,
          Į: `I`,
          İ: `I`,
          ĩ: `i`,
          ī: `i`,
          ĭ: `i`,
          į: `i`,
          ı: `i`,
          Ĵ: `J`,
          ĵ: `j`,
          Ķ: `K`,
          ķ: `k`,
          ĸ: `k`,
          Ĺ: `L`,
          Ļ: `L`,
          Ľ: `L`,
          Ŀ: `L`,
          Ł: `L`,
          ĺ: `l`,
          ļ: `l`,
          ľ: `l`,
          ŀ: `l`,
          ł: `l`,
          Ń: `N`,
          Ņ: `N`,
          Ň: `N`,
          Ŋ: `N`,
          ń: `n`,
          ņ: `n`,
          ň: `n`,
          ŋ: `n`,
          Ō: `O`,
          Ŏ: `O`,
          Ő: `O`,
          ō: `o`,
          ŏ: `o`,
          ő: `o`,
          Ŕ: `R`,
          Ŗ: `R`,
          Ř: `R`,
          ŕ: `r`,
          ŗ: `r`,
          ř: `r`,
          Ś: `S`,
          Ŝ: `S`,
          Ş: `S`,
          Š: `S`,
          ś: `s`,
          ŝ: `s`,
          ş: `s`,
          š: `s`,
          Ţ: `T`,
          Ť: `T`,
          Ŧ: `T`,
          ţ: `t`,
          ť: `t`,
          ŧ: `t`,
          Ũ: `U`,
          Ū: `U`,
          Ŭ: `U`,
          Ů: `U`,
          Ű: `U`,
          Ų: `U`,
          ũ: `u`,
          ū: `u`,
          ŭ: `u`,
          ů: `u`,
          ű: `u`,
          ų: `u`,
          Ŵ: `W`,
          ŵ: `w`,
          Ŷ: `Y`,
          ŷ: `y`,
          Ÿ: `Y`,
          Ź: `Z`,
          Ż: `Z`,
          Ž: `Z`,
          ź: `z`,
          ż: `z`,
          ž: `z`,
          Ĳ: `IJ`,
          ĳ: `ij`,
          Œ: `Oe`,
          œ: `oe`,
          ŉ: `'n`,
          ſ: `s`,
        },
        vn = {
          "&": `&amp;`,
          "<": `&lt;`,
          ">": `&gt;`,
          '"': `&quot;`,
          "'": `&#39;`,
        },
        yn = {
          "&amp;": `&`,
          "&lt;": `<`,
          "&gt;": `>`,
          "&quot;": `"`,
          "&#39;": `'`,
        },
        bn = {
          "\\": `\\`,
          "'": `'`,
          "\n": `n`,
          "\r": `r`,
          "\u2028": `u2028`,
          "\u2029": `u2029`,
        },
        xn = parseFloat,
        Sn = parseInt,
        Cn = typeof global == `object` && global && global.Object === Object && global,
        wn = typeof self == `object` && self && self.Object === Object && self,
        Tn = Cn || wn || Function(`return this`)(),
        En = typeof e == `object` && e && !e.nodeType && e,
        Dn = En && typeof t == `object` && t && !t.nodeType && t,
        On = Dn && Dn.exports === En,
        kn = On && Cn.process,
        An = (function () {
          try {
            return (
              (Dn && Dn.require && Dn.require(`util`).types) ||
              (kn && kn.binding && kn.binding(`util`))
            );
          } catch {}
        })(),
        jn = An && An.isArrayBuffer,
        Mn = An && An.isDate,
        Nn = An && An.isMap,
        Pn = An && An.isRegExp,
        Fn = An && An.isSet,
        In = An && An.isTypedArray;
      function Ln(e, t, n) {
        switch (n.length) {
          case 0:
            return e.call(t);
          case 1:
            return e.call(t, n[0]);
          case 2:
            return e.call(t, n[0], n[1]);
          case 3:
            return e.call(t, n[0], n[1], n[2]);
        }
        return e.apply(t, n);
      }
      function Rn(e, t, n, r) {
        for (var i = -1, a = e == null ? 0 : e.length; ++i < a;) {
          var o = e[i];
          t(r, o, n(o), e);
        }
        return r;
      }
      function zn(e, t) {
        for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
        return e;
      }
      function Bn(e, t) {
        for (var n = e == null ? 0 : e.length; n-- && t(e[n], n, e) !== !1;);
        return e;
      }
      function Vn(e, t) {
        for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (!t(e[n], n, e)) return !1;
        return !0;
      }
      function Hn(e, t) {
        for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
          var o = e[n];
          t(o, n, e) && (a[i++] = o);
        }
        return a;
      }
      function Un(e, t) {
        return !!(e != null && e.length) && tr(e, t, 0) > -1;
      }
      function Wn(e, t, n) {
        for (var r = -1, i = e == null ? 0 : e.length; ++r < i;) if (n(t, e[r])) return !0;
        return !1;
      }
      function Gn(e, t) {
        for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
        return i;
      }
      function Kn(e, t) {
        for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
        return e;
      }
      function qn(e, t, n, r) {
        var i = -1,
          a = e == null ? 0 : e.length;
        for (r && a && (n = e[++i]); ++i < a;) n = t(n, e[i], i, e);
        return n;
      }
      function Jn(e, t, n, r) {
        var i = e == null ? 0 : e.length;
        for (r && i && (n = e[--i]); i--;) n = t(n, e[i], i, e);
        return n;
      }
      function Yn(e, t) {
        for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
        return !1;
      }
      var Xn = ar(`length`);
      function Zn(e) {
        return e.split(``);
      }
      function Qn(e) {
        return e.match(dt) || [];
      }
      function $n(e, t, n) {
        var r;
        return (
          n(e, function (e, n, i) {
            if (t(e, n, i)) return ((r = n), !1);
          }),
          r
        );
      }
      function er(e, t, n, r) {
        for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;)
          if (t(e[a], a, e)) return a;
        return -1;
      }
      function tr(e, t, n) {
        return t === t ? jr(e, t, n) : er(e, rr, n);
      }
      function nr(e, t, n, r) {
        for (var i = n - 1, a = e.length; ++i < a;) if (r(e[i], t)) return i;
        return -1;
      }
      function rr(e) {
        return e !== e;
      }
      function ir(e, t) {
        var n = e == null ? 0 : e.length;
        return n ? lr(e, t) / n : ce;
      }
      function ar(e) {
        return function (t) {
          return t == null ? n : t[e];
        };
      }
      function or(e) {
        return function (t) {
          return e == null ? n : e[t];
        };
      }
      function sr(e, t, n, r, i) {
        return (
          i(e, function (e, i, a) {
            n = r ? ((r = !1), e) : t(n, e, i, a);
          }),
          n
        );
      }
      function cr(e, t) {
        var n = e.length;
        for (e.sort(t); n--;) e[n] = e[n].value;
        return e;
      }
      function lr(e, t) {
        for (var r, i = -1, a = e.length; ++i < a;) {
          var o = t(e[i]);
          o !== n && (r = r === n ? o : r + o);
        }
        return r;
      }
      function ur(e, t) {
        for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
        return r;
      }
      function dr(e, t) {
        return Gn(t, function (t) {
          return [t, e[t]];
        });
      }
      function fr(e) {
        return e && e.slice(0, Fr(e) + 1).replace(ot, ``);
      }
      function pr(e) {
        return function (t) {
          return e(t);
        };
      }
      function mr(e, t) {
        return Gn(t, function (t) {
          return e[t];
        });
      }
      function hr(e, t) {
        return e.has(t);
      }
      function gr(e, t) {
        for (var n = -1, r = e.length; ++n < r && tr(t, e[n], 0) > -1;);
        return n;
      }
      function _r(e, t) {
        for (var n = e.length; n-- && tr(t, e[n], 0) > -1;);
        return n;
      }
      function vr(e, t) {
        for (var n = e.length, r = 0; n--;) e[n] === t && ++r;
        return r;
      }
      var yr = or(_n),
        br = or(vn);
      function xr(e) {
        return `\\` + bn[e];
      }
      function Sr(e, t) {
        return e == null ? n : e[t];
      }
      function Cr(e) {
        return dn.test(e);
      }
      function wr(e) {
        return fn.test(e);
      }
      function Tr(e) {
        for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
        return n;
      }
      function Er(e) {
        var t = -1,
          n = Array(e.size);
        return (
          e.forEach(function (e, r) {
            n[++t] = [r, e];
          }),
          n
        );
      }
      function Dr(e, t) {
        return function (n) {
          return e(t(n));
        };
      }
      function Or(e, t) {
        for (var n = -1, r = e.length, i = 0, a = []; ++n < r;) {
          var o = e[n];
          (o === t || o === d) && ((e[n] = d), (a[i++] = n));
        }
        return a;
      }
      function kr(e) {
        var t = -1,
          n = Array(e.size);
        return (
          e.forEach(function (e) {
            n[++t] = e;
          }),
          n
        );
      }
      function Ar(e) {
        var t = -1,
          n = Array(e.size);
        return (
          e.forEach(function (e) {
            n[++t] = [e, e];
          }),
          n
        );
      }
      function jr(e, t, n) {
        for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
        return -1;
      }
      function Mr(e, t, n) {
        for (var r = n + 1; r--;) if (e[r] === t) return r;
        return r;
      }
      function Nr(e) {
        return Cr(e) ? Lr(e) : Xn(e);
      }
      function Pr(e) {
        return Cr(e) ? Rr(e) : Zn(e);
      }
      function Fr(e) {
        for (var t = e.length; t-- && st.test(e.charAt(t)););
        return t;
      }
      var Ir = or(yn);
      function Lr(e) {
        for (var t = (ln.lastIndex = 0); ln.test(e);) ++t;
        return t;
      }
      function Rr(e) {
        return e.match(ln) || [];
      }
      function zr(e) {
        return e.match(un) || [];
      }
      var Br = (function e(t) {
        t = t == null ? Tn : Br.defaults(Tn.Object(), t, Br.pick(Tn, pn));
        var st = t.Array,
          dt = t.Date,
          wt = t.Error,
          Tt = t.Function,
          Et = t.Math,
          j = t.Object,
          Dt = t.RegExp,
          Ot = t.String,
          kt = t.TypeError,
          At = st.prototype,
          jt = Tt.prototype,
          Mt = j.prototype,
          Nt = t[`__core-js_shared__`],
          Pt = jt.toString,
          M = Mt.hasOwnProperty,
          Ft = 0,
          It = (function () {
            var e = /[^.]+$/.exec((Nt && Nt.keys && Nt.keys.IE_PROTO) || ``);
            return e ? `Symbol(src)_1.` + e : ``;
          })(),
          Lt = Mt.toString,
          Rt = Pt.call(j),
          zt = Tn._,
          Bt = Dt(
            `^` +
              Pt.call(M)
                .replace(it, `\\$&`)
                .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, `$1.*?`) +
              `$`,
          ),
          Vt = On ? t.Buffer : n,
          Ht = t.Symbol,
          Ut = t.Uint8Array,
          Wt = Vt ? Vt.allocUnsafe : n,
          Gt = Dr(j.getPrototypeOf, j),
          Kt = j.create,
          qt = Mt.propertyIsEnumerable,
          Jt = At.splice,
          Yt = Ht ? Ht.isConcatSpreadable : n,
          Xt = Ht ? Ht.iterator : n,
          Zt = Ht ? Ht.toStringTag : n,
          Qt = (function () {
            try {
              var e = us(j, `defineProperty`);
              return (e({}, ``, {}), e);
            } catch {}
          })(),
          $t = t.clearTimeout !== Tn.clearTimeout && t.clearTimeout,
          en = dt && dt.now !== Tn.Date.now && dt.now,
          tn = t.setTimeout !== Tn.setTimeout && t.setTimeout,
          nn = Et.ceil,
          rn = Et.floor,
          an = j.getOwnPropertySymbols,
          on = Vt ? Vt.isBuffer : n,
          ln = t.isFinite,
          un = At.join,
          dn = Dr(j.keys, j),
          fn = Et.max,
          _n = Et.min,
          vn = dt.now,
          yn = t.parseInt,
          bn = Et.random,
          Cn = At.reverse,
          wn = us(t, `DataView`),
          En = us(t, `Map`),
          Dn = us(t, `Promise`),
          kn = us(t, `Set`),
          An = us(t, `WeakMap`),
          Xn = us(j, `create`),
          Zn = An && new An(),
          or = {},
          jr = Ys(wn),
          Lr = Ys(En),
          Rr = Ys(Dn),
          Vr = Ys(kn),
          Hr = Ys(An),
          Ur = Ht ? Ht.prototype : n,
          Wr = Ur ? Ur.valueOf : n,
          Gr = Ur ? Ur.toString : n;
        function N(e) {
          if (Mu(e) && !J(e) && !(e instanceof P)) {
            if (e instanceof Jr) return e;
            if (M.call(e, `__wrapped__`)) return Zs(e);
          }
          return new Jr(e);
        }
        var Kr = (function () {
          function e() {}
          return function (t) {
            if (!ju(t)) return {};
            if (Kt) return Kt(t);
            e.prototype = t;
            var r = new e();
            return ((e.prototype = n), r);
          };
        })();
        function qr() {}
        function Jr(e, t) {
          ((this.__wrapped__ = e),
            (this.__actions__ = []),
            (this.__chain__ = !!t),
            (this.__index__ = 0),
            (this.__values__ = n));
        }
        ((N.templateSettings = {
          escape: Qe,
          evaluate: $e,
          interpolate: et,
          variable: ``,
          imports: {
            _: N,
          },
        }),
          (N.prototype = qr.prototype),
          (N.prototype.constructor = N),
          (Jr.prototype = Kr(qr.prototype)),
          (Jr.prototype.constructor = Jr));
        function P(e) {
          ((this.__wrapped__ = e),
            (this.__actions__ = []),
            (this.__dir__ = 1),
            (this.__filtered__ = !1),
            (this.__iteratees__ = []),
            (this.__takeCount__ = le),
            (this.__views__ = []));
        }
        function Yr() {
          var e = new P(this.__wrapped__);
          return (
            (e.__actions__ = So(this.__actions__)),
            (e.__dir__ = this.__dir__),
            (e.__filtered__ = this.__filtered__),
            (e.__iteratees__ = So(this.__iteratees__)),
            (e.__takeCount__ = this.__takeCount__),
            (e.__views__ = So(this.__views__)),
            e
          );
        }
        function Xr() {
          if (this.__filtered__) {
            var e = new P(this);
            ((e.__dir__ = -1), (e.__filtered__ = !0));
          } else ((e = this.clone()), (e.__dir__ *= -1));
          return e;
        }
        function Zr() {
          var e = this.__wrapped__.value(),
            t = this.__dir__,
            n = J(e),
            r = t < 0,
            i = n ? e.length : 0,
            a = hs(0, i, this.__views__),
            o = a.start,
            s = a.end,
            c = s - o,
            l = r ? s : o - 1,
            u = this.__iteratees__,
            d = u.length,
            f = 0,
            p = _n(c, this.__takeCount__);
          if (!n || (!r && i == c && p == c)) return ro(e, this.__actions__);
          var m = [];
          outer: for (; c-- && f < p;) {
            l += t;
            for (var h = -1, g = e[l]; ++h < d;) {
              var v = u[h],
                y = v.iteratee,
                b = v.type,
                x = y(g);
              if (b == oe) g = x;
              else if (!x) {
                if (b == ae) continue outer;
                break outer;
              }
            }
            m[f++] = g;
          }
          return m;
        }
        ((P.prototype = Kr(qr.prototype)), (P.prototype.constructor = P));
        function Qr(e) {
          var t = -1,
            n = e == null ? 0 : e.length;
          for (this.clear(); ++t < n;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }
        function $r() {
          ((this.__data__ = Xn ? Xn(null) : {}), (this.size = 0));
        }
        function ei(e) {
          var t = this.has(e) && delete this.__data__[e];
          return ((this.size -= +!!t), t);
        }
        function ti(e) {
          var t = this.__data__;
          if (Xn) {
            var r = t[e];
            return r === l ? n : r;
          }
          return M.call(t, e) ? t[e] : n;
        }
        function ni(e) {
          var t = this.__data__;
          return Xn ? t[e] !== n : M.call(t, e);
        }
        function ri(e, t) {
          var r = this.__data__;
          return ((this.size += +!this.has(e)), (r[e] = Xn && t === n ? l : t), this);
        }
        ((Qr.prototype.clear = $r),
          (Qr.prototype.delete = ei),
          (Qr.prototype.get = ti),
          (Qr.prototype.has = ni),
          (Qr.prototype.set = ri));
        function ii(e) {
          var t = -1,
            n = e == null ? 0 : e.length;
          for (this.clear(); ++t < n;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }
        function ai() {
          ((this.__data__ = []), (this.size = 0));
        }
        function oi(e) {
          var t = this.__data__,
            n = ji(t, e);
          return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Jt.call(t, n, 1), --this.size, !0);
        }
        function si(e) {
          var t = this.__data__,
            r = ji(t, e);
          return r < 0 ? n : t[r][1];
        }
        function ci(e) {
          return ji(this.__data__, e) > -1;
        }
        function li(e, t) {
          var n = this.__data__,
            r = ji(n, e);
          return (r < 0 ? (++this.size, n.push([e, t])) : (n[r][1] = t), this);
        }
        ((ii.prototype.clear = ai),
          (ii.prototype.delete = oi),
          (ii.prototype.get = si),
          (ii.prototype.has = ci),
          (ii.prototype.set = li));
        function ui(e) {
          var t = -1,
            n = e == null ? 0 : e.length;
          for (this.clear(); ++t < n;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }
        function di() {
          ((this.size = 0),
            (this.__data__ = {
              hash: new Qr(),
              map: new (En || ii)(),
              string: new Qr(),
            }));
        }
        function fi(e) {
          var t = cs(this, e).delete(e);
          return ((this.size -= +!!t), t);
        }
        function pi(e) {
          return cs(this, e).get(e);
        }
        function mi(e) {
          return cs(this, e).has(e);
        }
        function hi(e, t) {
          var n = cs(this, e),
            r = n.size;
          return (n.set(e, t), (this.size += n.size == r ? 0 : 1), this);
        }
        ((ui.prototype.clear = di),
          (ui.prototype.delete = fi),
          (ui.prototype.get = pi),
          (ui.prototype.has = mi),
          (ui.prototype.set = hi));
        function gi(e) {
          var t = -1,
            n = e == null ? 0 : e.length;
          for (this.__data__ = new ui(); ++t < n;) this.add(e[t]);
        }
        function _i(e) {
          return (this.__data__.set(e, l), this);
        }
        function vi(e) {
          return this.__data__.has(e);
        }
        ((gi.prototype.add = gi.prototype.push = _i), (gi.prototype.has = vi));
        function yi(e) {
          var t = (this.__data__ = new ii(e));
          this.size = t.size;
        }
        function bi() {
          ((this.__data__ = new ii()), (this.size = 0));
        }
        function xi(e) {
          var t = this.__data__,
            n = t.delete(e);
          return ((this.size = t.size), n);
        }
        function Si(e) {
          return this.__data__.get(e);
        }
        function Ci(e) {
          return this.__data__.has(e);
        }
        function wi(e, t) {
          var n = this.__data__;
          if (n instanceof ii) {
            var r = n.__data__;
            if (!En || r.length < i - 1) return (r.push([e, t]), (this.size = ++n.size), this);
            n = this.__data__ = new ui(r);
          }
          return (n.set(e, t), (this.size = n.size), this);
        }
        ((yi.prototype.clear = bi),
          (yi.prototype.delete = xi),
          (yi.prototype.get = Si),
          (yi.prototype.has = Ci),
          (yi.prototype.set = wi));
        function Ti(e, t) {
          var n = J(e),
            r = !n && hu(e),
            i = !n && !r && bu(e),
            a = !n && !r && !i && qu(e),
            o = n || r || i || a,
            s = o ? ur(e.length, Ot) : [],
            c = s.length;
          for (var l in e)
            (t || M.call(e, l)) &&
              !(
                o &&
                (l == `length` ||
                  (i && (l == `offset` || l == `parent`)) ||
                  (a && (l == `buffer` || l == `byteLength` || l == `byteOffset`)) ||
                  Cs(l, c))
              ) &&
              s.push(l);
          return s;
        }
        function Ei(e) {
          var t = e.length;
          return t ? e[Ra(0, t - 1)] : n;
        }
        function Di(e, t) {
          return Ks(So(e), Li(t, 0, e.length));
        }
        function Oi(e) {
          return Ks(So(e));
        }
        function ki(e, t, r) {
          ((r !== n && !fu(e[t], r)) || (r === n && !(t in e))) && Fi(e, t, r);
        }
        function Ai(e, t, r) {
          var i = e[t];
          (!(M.call(e, t) && fu(i, r)) || (r === n && !(t in e))) && Fi(e, t, r);
        }
        function ji(e, t) {
          for (var n = e.length; n--;) if (fu(e[n][0], t)) return n;
          return -1;
        }
        function Mi(e, t, n, r) {
          return (
            Ui(e, function (e, i, a) {
              t(r, e, n(e), a);
            }),
            r
          );
        }
        function Ni(e, t) {
          return e && Co(t, Dd(t), e);
        }
        function Pi(e, t) {
          return e && Co(t, Od(t), e);
        }
        function Fi(e, t, n) {
          t == `__proto__` && Qt
            ? Qt(e, t, {
                configurable: !0,
                enumerable: !0,
                value: n,
                writable: !0,
              })
            : (e[t] = n);
        }
        function Ii(e, t) {
          for (var r = -1, i = t.length, a = st(i), o = e == null; ++r < i;)
            a[r] = o ? n : xd(e, t[r]);
          return a;
        }
        function Li(e, t, r) {
          return (e === e && (r !== n && (e = e <= r ? e : r), t !== n && (e = e >= t ? e : t)), e);
        }
        function Ri(e, t, r, i, a, o) {
          var s,
            c = t & f,
            l = t & p,
            u = t & m;
          if ((r && (s = a ? r(e, i, a, o) : r(e)), s !== n)) return s;
          if (!ju(e)) return e;
          var d = J(e);
          if (d) {
            if (((s = vs(e)), !c)) return So(e, s);
          } else {
            var h = ms(e),
              g = h == be || h == xe;
            if (bu(e)) return fo(e, c);
            if (h == Te || h == pe || (g && !a)) {
              if (((s = l || g ? {} : ys(e)), !c)) return l ? To(e, Pi(s, e)) : wo(e, Ni(s, e));
            } else {
              if (!gn[h]) return a ? e : {};
              s = bs(e, h, c);
            }
          }
          o ||= new yi();
          var v = o.get(e);
          if (v) return v;
          (o.set(e, s),
            Wu(e)
              ? e.forEach(function (n) {
                  s.add(Ri(n, t, r, n, e, o));
                })
              : Nu(e) &&
                e.forEach(function (n, i) {
                  s.set(i, Ri(n, t, r, i, e, o));
                }));
          var y = d ? n : (u ? (l ? is : rs) : l ? Od : Dd)(e);
          return (
            zn(y || e, function (n, i) {
              (y && ((i = n), (n = e[i])), Ai(s, i, Ri(n, t, r, i, e, o)));
            }),
            s
          );
        }
        function zi(e) {
          var t = Dd(e);
          return function (n) {
            return Bi(n, e, t);
          };
        }
        function Bi(e, t, r) {
          var i = r.length;
          if (e == null) return !i;
          for (e = j(e); i--;) {
            var a = r[i],
              o = t[a],
              s = e[a];
            if ((s === n && !(a in e)) || !o(s)) return !1;
          }
          return !0;
        }
        function Vi(e, t, r) {
          if (typeof e != `function`) throw new kt(o);
          return Hs(function () {
            e.apply(n, r);
          }, t);
        }
        function Hi(e, t, n, r) {
          var a = -1,
            o = Un,
            s = !0,
            c = e.length,
            l = [],
            u = t.length;
          if (!c) return l;
          (n && (t = Gn(t, pr(n))),
            r ? ((o = Wn), (s = !1)) : t.length >= i && ((o = hr), (s = !1), (t = new gi(t))));
          outer: for (; ++a < c;) {
            var d = e[a],
              f = n == null ? d : n(d);
            if (((d = r || d !== 0 ? d : 0), s && f === f)) {
              for (var p = u; p--;) if (t[p] === f) continue outer;
              l.push(d);
            } else o(t, f, r) || l.push(d);
          }
          return l;
        }
        var Ui = Oo(Qi),
          Wi = Oo($i, !0);
        function Gi(e, t) {
          var n = !0;
          return (
            Ui(e, function (e, r, i) {
              return ((n = !!t(e, r, i)), n);
            }),
            n
          );
        }
        function Ki(e, t, r) {
          for (var i = -1, a = e.length; ++i < a;) {
            var o = e[i],
              s = t(o);
            if (s != null && (c === n ? s === s && !Ku(s) : r(s, c)))
              var c = s,
                l = o;
          }
          return l;
        }
        function qi(e, t, r, i) {
          var a = e.length;
          for (
            r = Y(r),
              r < 0 && (r = -r > a ? 0 : a + r),
              i = i === n || i > a ? a : Y(i),
              i < 0 && (i += a),
              i = r > i ? 0 : td(i);
            r < i;
          )
            e[r++] = t;
          return e;
        }
        function Ji(e, t) {
          var n = [];
          return (
            Ui(e, function (e, r, i) {
              t(e, r, i) && n.push(e);
            }),
            n
          );
        }
        function Yi(e, t, n, r, i) {
          var a = -1,
            o = e.length;
          for (n ||= Ss, i ||= []; ++a < o;) {
            var s = e[a];
            t > 0 && n(s) ? (t > 1 ? Yi(s, t - 1, n, r, i) : Kn(i, s)) : r || (i[i.length] = s);
          }
          return i;
        }
        var Xi = ko(),
          Zi = ko(!0);
        function Qi(e, t) {
          return e && Xi(e, t, Dd);
        }
        function $i(e, t) {
          return e && Zi(e, t, Dd);
        }
        function ea(e, t) {
          return Hn(t, function (t) {
            return Ou(e[t]);
          });
        }
        function ta(e, t) {
          t = so(t, e);
          for (var r = 0, i = t.length; e != null && r < i;) e = e[Js(t[r++])];
          return r && r == i ? e : n;
        }
        function na(e, t, n) {
          var r = t(e);
          return J(e) ? r : Kn(r, n(e));
        }
        function ra(e) {
          return e == null ? (e === n ? je : we) : Zt && Zt in j(e) ? ds(e) : Is(e);
        }
        function ia(e, t) {
          return e > t;
        }
        function aa(e, t) {
          return e != null && M.call(e, t);
        }
        function oa(e, t) {
          return e != null && t in j(e);
        }
        function sa(e, t, n) {
          return e >= _n(t, n) && e < fn(t, n);
        }
        function ca(e, t, r) {
          for (
            var i = r ? Wn : Un, a = e[0].length, o = e.length, s = o, c = st(o), l = 1 / 0, u = [];
            s--;
          ) {
            var d = e[s];
            (s && t && (d = Gn(d, pr(t))),
              (l = _n(d.length, l)),
              (c[s] = !r && (t || (a >= 120 && d.length >= 120)) ? new gi(s && d) : n));
          }
          d = e[0];
          var f = -1,
            p = c[0];
          outer: for (; ++f < a && u.length < l;) {
            var m = d[f],
              h = t ? t(m) : m;
            if (((m = r || m !== 0 ? m : 0), !(p ? hr(p, h) : i(u, h, r)))) {
              for (s = o; --s;) {
                var g = c[s];
                if (!(g ? hr(g, h) : i(e[s], h, r))) continue outer;
              }
              (p && p.push(h), u.push(m));
            }
          }
          return u;
        }
        function la(e, t, n, r) {
          return (
            Qi(e, function (e, i, a) {
              t(r, n(e), i, a);
            }),
            r
          );
        }
        function ua(e, t, r) {
          ((t = so(t, e)), (e = Rs(e, t)));
          var i = e == null ? e : e[Js(xc(t))];
          return i == null ? n : Ln(i, e, r);
        }
        function da(e) {
          return Mu(e) && ra(e) == pe;
        }
        function fa(e) {
          return Mu(e) && ra(e) == Pe;
        }
        function pa(e) {
          return Mu(e) && ra(e) == _e;
        }
        function ma(e, t, n, r, i) {
          return e === t
            ? !0
            : e == null || t == null || (!Mu(e) && !Mu(t))
              ? e !== e && t !== t
              : ha(e, t, n, r, ma, i);
        }
        function ha(e, t, n, r, i, a) {
          var o = J(e),
            s = J(t),
            c = o ? me : ms(e),
            l = s ? me : ms(t);
          ((c = c == pe ? Te : c), (l = l == pe ? Te : l));
          var u = c == Te,
            d = l == Te,
            f = c == l;
          if (f && bu(e)) {
            if (!bu(t)) return !1;
            ((o = !0), (u = !1));
          }
          if (f && !u)
            return ((a ||= new yi()), o || qu(e) ? $o(e, t, n, r, i, a) : es(e, t, c, n, r, i, a));
          if (!(n & h)) {
            var p = u && M.call(e, `__wrapped__`),
              m = d && M.call(t, `__wrapped__`);
            if (p || m) {
              var g = p ? e.value() : e,
                v = m ? t.value() : t;
              return ((a ||= new yi()), i(g, v, n, r, a));
            }
          }
          return f ? ((a ||= new yi()), ts(e, t, n, r, i, a)) : !1;
        }
        function ga(e) {
          return Mu(e) && ms(e) == Se;
        }
        function _a(e, t, r, i) {
          var a = r.length,
            o = a,
            s = !i;
          if (e == null) return !o;
          for (e = j(e); a--;) {
            var c = r[a];
            if (s && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
          }
          for (; ++a < o;) {
            c = r[a];
            var l = c[0],
              u = e[l],
              d = c[1];
            if (s && c[2]) {
              if (u === n && !(l in e)) return !1;
            } else {
              var f = new yi();
              if (i) var p = i(u, d, l, e, t, f);
              if (!(p === n ? ma(d, u, h | g, i, f) : p)) return !1;
            }
          }
          return !0;
        }
        function va(e) {
          return !ju(e) || Os(e) ? !1 : (Ou(e) ? Bt : vt).test(Ys(e));
        }
        function ya(e) {
          return Mu(e) && ra(e) == De;
        }
        function ba(e) {
          return Mu(e) && ms(e) == Oe;
        }
        function xa(e) {
          return Mu(e) && Au(e.length) && !!hn[ra(e)];
        }
        function Sa(e) {
          return typeof e == `function`
            ? e
            : e == null
              ? If
              : typeof e == `object`
                ? J(e)
                  ? Oa(e[0], e[1])
                  : Da(e)
                : Yf(e);
        }
        function Ca(e) {
          if (!As(e)) return dn(e);
          var t = [];
          for (var n in j(e)) M.call(e, n) && n != `constructor` && t.push(n);
          return t;
        }
        function wa(e) {
          if (!ju(e)) return Fs(e);
          var t = As(e),
            n = [];
          for (var r in e) (r == `constructor` && (t || !M.call(e, r))) || n.push(r);
          return n;
        }
        function Ta(e, t) {
          return e < t;
        }
        function Ea(e, t) {
          var n = -1,
            r = _u(e) ? st(e.length) : [];
          return (
            Ui(e, function (e, i, a) {
              r[++n] = t(e, i, a);
            }),
            r
          );
        }
        function Da(e) {
          var t = ls(e);
          return t.length == 1 && t[0][2]
            ? Ms(t[0][0], t[0][1])
            : function (n) {
                return n === e || _a(n, e, t);
              };
        }
        function Oa(e, t) {
          return Ts(e) && js(t)
            ? Ms(Js(e), t)
            : function (r) {
                var i = xd(r, e);
                return i === n && i === t ? Cd(r, e) : ma(t, i, h | g);
              };
        }
        function ka(e, t, r, i, a) {
          e !== t &&
            Xi(
              t,
              function (o, s) {
                if (((a ||= new yi()), ju(o))) Aa(e, t, s, r, ka, i, a);
                else {
                  var c = i ? i(Bs(e, s), o, s + ``, e, t, a) : n;
                  (c === n && (c = o), ki(e, s, c));
                }
              },
              Od,
            );
        }
        function Aa(e, t, r, i, a, o, s) {
          var c = Bs(e, r),
            l = Bs(t, r),
            u = s.get(l);
          if (u) {
            ki(e, r, u);
            return;
          }
          var d = o ? o(c, l, r + ``, e, t, s) : n,
            f = d === n;
          if (f) {
            var p = J(l),
              m = !p && bu(l),
              h = !p && !m && qu(l);
            ((d = l),
              p || m || h
                ? J(c)
                  ? (d = c)
                  : vu(c)
                    ? (d = So(c))
                    : m
                      ? ((f = !1), (d = fo(l, !0)))
                      : h
                        ? ((f = !1), (d = _o(l, !0)))
                        : (d = [])
                : Vu(l) || hu(l)
                  ? ((d = c), hu(c) ? (d = rd(c)) : (!ju(c) || Ou(c)) && (d = ys(l)))
                  : (f = !1));
          }
          (f && (s.set(l, d), a(d, l, i, o, s), s.delete(l)), ki(e, r, d));
        }
        function ja(e, t) {
          var r = e.length;
          if (r) return ((t += t < 0 ? r : 0), Cs(t, r) ? e[t] : n);
        }
        function Ma(e, t, n) {
          t = t.length
            ? Gn(t, function (e) {
                return J(e)
                  ? function (t) {
                      return ta(t, e.length === 1 ? e[0] : e);
                    }
                  : e;
              })
            : [If];
          var r = -1;
          return (
            (t = Gn(t, pr(R()))),
            cr(
              Ea(e, function (e, n, i) {
                return {
                  criteria: Gn(t, function (t) {
                    return t(e);
                  }),
                  index: ++r,
                  value: e,
                };
              }),
              function (e, t) {
                return yo(e, t, n);
              },
            )
          );
        }
        function Na(e, t) {
          return Pa(e, t, function (t, n) {
            return Cd(e, n);
          });
        }
        function Pa(e, t, n) {
          for (var r = -1, i = t.length, a = {}; ++r < i;) {
            var o = t[r],
              s = ta(e, o);
            n(s, o) && Ha(a, so(o, e), s);
          }
          return a;
        }
        function Fa(e) {
          return function (t) {
            return ta(t, e);
          };
        }
        function Ia(e, t, n, r) {
          var i = r ? nr : tr,
            a = -1,
            o = t.length,
            s = e;
          for (e === t && (t = So(t)), n && (s = Gn(e, pr(n))); ++a < o;)
            for (var c = 0, l = t[a], u = n ? n(l) : l; (c = i(s, u, c, r)) > -1;)
              (s !== e && Jt.call(s, c, 1), Jt.call(e, c, 1));
          return e;
        }
        function La(e, t) {
          for (var n = e ? t.length : 0, r = n - 1; n--;) {
            var i = t[n];
            if (n == r || i !== a) {
              var a = i;
              Cs(i) ? Jt.call(e, i, 1) : eo(e, i);
            }
          }
          return e;
        }
        function Ra(e, t) {
          return e + rn(bn() * (t - e + 1));
        }
        function F(e, t, n, r) {
          for (var i = -1, a = fn(nn((t - e) / (n || 1)), 0), o = st(a); a--;)
            ((o[r ? a : ++i] = e), (e += n));
          return o;
        }
        function za(e, t) {
          var n = ``;
          if (!e || t < 1 || t > k) return n;
          do (t % 2 && (n += e), (t = rn(t / 2)), t && (e += e));
          while (t);
          return n;
        }
        function I(e, t) {
          return Us(Ls(e, t, If), e + ``);
        }
        function Ba(e) {
          return Ei(Kd(e));
        }
        function Va(e, t) {
          var n = Kd(e);
          return Ks(n, Li(t, 0, n.length));
        }
        function Ha(e, t, r, i) {
          if (!ju(e)) return e;
          t = so(t, e);
          for (var a = -1, o = t.length, s = o - 1, c = e; c != null && ++a < o;) {
            var l = Js(t[a]),
              u = r;
            if (l === `__proto__` || l === `constructor` || l === `prototype`) return e;
            if (a != s) {
              var d = c[l];
              ((u = i ? i(d, l, c) : n), u === n && (u = ju(d) ? d : Cs(t[a + 1]) ? [] : {}));
            }
            (Ai(c, l, u), (c = c[l]));
          }
          return e;
        }
        var Ua = Zn
            ? function (e, t) {
                return (Zn.set(e, t), e);
              }
            : If,
          Wa = Qt
            ? function (e, t) {
                return Qt(e, `toString`, {
                  configurable: !0,
                  enumerable: !1,
                  value: Mf(t),
                  writable: !0,
                });
              }
            : If;
        function Ga(e) {
          return Ks(Kd(e));
        }
        function Ka(e, t, n) {
          var r = -1,
            i = e.length;
          (t < 0 && (t = -t > i ? 0 : i + t),
            (n = n > i ? i : n),
            n < 0 && (n += i),
            (i = t > n ? 0 : (n - t) >>> 0),
            (t >>>= 0));
          for (var a = st(i); ++r < i;) a[r] = e[r + t];
          return a;
        }
        function qa(e, t) {
          var n;
          return (
            Ui(e, function (e, r, i) {
              return ((n = t(e, r, i)), !n);
            }),
            !!n
          );
        }
        function Ja(e, t, n) {
          var r = 0,
            i = e == null ? r : e.length;
          if (typeof t == `number` && t === t && i <= de) {
            for (; r < i;) {
              var a = (r + i) >>> 1,
                o = e[a];
              o !== null && !Ku(o) && (n ? o <= t : o < t) ? (r = a + 1) : (i = a);
            }
            return i;
          }
          return Ya(e, t, If, n);
        }
        function Ya(e, t, r, i) {
          var a = 0,
            o = e == null ? 0 : e.length;
          if (o === 0) return 0;
          t = r(t);
          for (var s = t !== t, c = t === null, l = Ku(t), u = t === n; a < o;) {
            var d = rn((a + o) / 2),
              f = r(e[d]),
              p = f !== n,
              m = f === null,
              h = f === f,
              g = Ku(f);
            if (s) var v = i || h;
            else
              v = u
                ? h && (i || p)
                : c
                  ? h && p && (i || !m)
                  : l
                    ? h && p && !m && (i || !g)
                    : m || g
                      ? !1
                      : i
                        ? f <= t
                        : f < t;
            v ? (a = d + 1) : (o = d);
          }
          return _n(o, ue);
        }
        function Xa(e, t) {
          for (var n = -1, r = e.length, i = 0, a = []; ++n < r;) {
            var o = e[n],
              s = t ? t(o) : o;
            if (!n || !fu(s, c)) {
              var c = s;
              a[i++] = o === 0 ? 0 : o;
            }
          }
          return a;
        }
        function Za(e) {
          return typeof e == `number` ? e : Ku(e) ? ce : +e;
        }
        function Qa(e) {
          if (typeof e == `string`) return e;
          if (J(e)) return Gn(e, Qa) + ``;
          if (Ku(e)) return Gr ? Gr.call(e) : ``;
          var t = e + ``;
          return t == `0` && 1 / e == -O ? `-0` : t;
        }
        function $a(e, t, n) {
          var r = -1,
            a = Un,
            o = e.length,
            s = !0,
            c = [],
            l = c;
          if (n) ((s = !1), (a = Wn));
          else if (o >= i) {
            var u = t ? null : qo(e);
            if (u) return kr(u);
            ((s = !1), (a = hr), (l = new gi()));
          } else l = t ? [] : c;
          outer: for (; ++r < o;) {
            var d = e[r],
              f = t ? t(d) : d;
            if (((d = n || d !== 0 ? d : 0), s && f === f)) {
              for (var p = l.length; p--;) if (l[p] === f) continue outer;
              (t && l.push(f), c.push(d));
            } else a(l, f, n) || (l !== c && l.push(f), c.push(d));
          }
          return c;
        }
        function eo(e, t) {
          t = so(t, e);
          var n = -1,
            r = t.length;
          if (!r) return !0;
          for (; ++n < r;) {
            var i = Js(t[n]);
            if (
              (i === `__proto__` && !M.call(e, `__proto__`)) ||
              ((i === `constructor` || i === `prototype`) && n < r - 1)
            )
              return !1;
          }
          var a = Rs(e, t);
          return a == null || delete a[Js(xc(t))];
        }
        function to(e, t, n, r) {
          return Ha(e, t, n(ta(e, t)), r);
        }
        function no(e, t, n, r) {
          for (var i = e.length, a = r ? i : -1; (r ? a-- : ++a < i) && t(e[a], a, e););
          return n ? Ka(e, r ? 0 : a, r ? a + 1 : i) : Ka(e, r ? a + 1 : 0, r ? i : a);
        }
        function ro(e, t) {
          var n = e;
          return (
            n instanceof P && (n = n.value()),
            qn(
              t,
              function (e, t) {
                return t.func.apply(t.thisArg, Kn([e], t.args));
              },
              n,
            )
          );
        }
        function io(e, t, n) {
          var r = e.length;
          if (r < 2) return r ? $a(e[0]) : [];
          for (var i = -1, a = st(r); ++i < r;)
            for (var o = e[i], s = -1; ++s < r;) s != i && (a[i] = Hi(a[i] || o, e[s], t, n));
          return $a(Yi(a, 1), t, n);
        }
        function L(e, t, r) {
          for (var i = -1, a = e.length, o = t.length, s = {}; ++i < a;) {
            var c = i < o ? t[i] : n;
            r(s, e[i], c);
          }
          return s;
        }
        function ao(e) {
          return vu(e) ? e : [];
        }
        function oo(e) {
          return typeof e == `function` ? e : If;
        }
        function so(e, t) {
          return J(e) ? e : Ts(e, t) ? [e] : qs(X(e));
        }
        var co = I;
        function lo(e, t, r) {
          var i = e.length;
          return ((r = r === n ? i : r), !t && r >= i ? e : Ka(e, t, r));
        }
        var uo =
          $t ||
          function (e) {
            return Tn.clearTimeout(e);
          };
        function fo(e, t) {
          if (t) return e.slice();
          var n = e.length,
            r = Wt ? Wt(n) : new e.constructor(n);
          return (e.copy(r), r);
        }
        function po(e) {
          var t = new e.constructor(e.byteLength);
          return (new Ut(t).set(new Ut(e)), t);
        }
        function mo(e, t) {
          var n = t ? po(e.buffer) : e.buffer;
          return new e.constructor(n, e.byteOffset, e.byteLength);
        }
        function ho(e) {
          var t = new e.constructor(e.source, ht.exec(e));
          return ((t.lastIndex = e.lastIndex), t);
        }
        function go(e) {
          return Wr ? j(Wr.call(e)) : {};
        }
        function _o(e, t) {
          var n = t ? po(e.buffer) : e.buffer;
          return new e.constructor(n, e.byteOffset, e.length);
        }
        function vo(e, t) {
          if (e !== t) {
            var r = e !== n,
              i = e === null,
              a = e === e,
              o = Ku(e),
              s = t !== n,
              c = t === null,
              l = t === t,
              u = Ku(t);
            if (
              (!c && !u && !o && e > t) ||
              (o && s && l && !c && !u) ||
              (i && s && l) ||
              (!r && l) ||
              !a
            )
              return 1;
            if (
              (!i && !o && !u && e < t) ||
              (u && r && a && !i && !o) ||
              (c && r && a) ||
              (!s && a) ||
              !l
            )
              return -1;
          }
          return 0;
        }
        function yo(e, t, n) {
          for (var r = -1, i = e.criteria, a = t.criteria, o = i.length, s = n.length; ++r < o;) {
            var c = vo(i[r], a[r]);
            if (c) return r >= s ? c : c * (n[r] == `desc` ? -1 : 1);
          }
          return e.index - t.index;
        }
        function bo(e, t, n, r) {
          for (
            var i = -1,
              a = e.length,
              o = n.length,
              s = -1,
              c = t.length,
              l = fn(a - o, 0),
              u = st(c + l),
              d = !r;
            ++s < c;
          )
            u[s] = t[s];
          for (; ++i < o;) (d || i < a) && (u[n[i]] = e[i]);
          for (; l--;) u[s++] = e[i++];
          return u;
        }
        function xo(e, t, n, r) {
          for (
            var i = -1,
              a = e.length,
              o = -1,
              s = n.length,
              c = -1,
              l = t.length,
              u = fn(a - s, 0),
              d = st(u + l),
              f = !r;
            ++i < u;
          )
            d[i] = e[i];
          for (var p = i; ++c < l;) d[p + c] = t[c];
          for (; ++o < s;) (f || i < a) && (d[p + n[o]] = e[i++]);
          return d;
        }
        function So(e, t) {
          var n = -1,
            r = e.length;
          for (t ||= st(r); ++n < r;) t[n] = e[n];
          return t;
        }
        function Co(e, t, r, i) {
          var a = !r;
          r ||= {};
          for (var o = -1, s = t.length; ++o < s;) {
            var c = t[o],
              l = i ? i(r[c], e[c], c, r, e) : n;
            (l === n && (l = e[c]), a ? Fi(r, c, l) : Ai(r, c, l));
          }
          return r;
        }
        function wo(e, t) {
          return Co(e, fs(e), t);
        }
        function To(e, t) {
          return Co(e, ps(e), t);
        }
        function Eo(e, t) {
          return function (n, r) {
            var i = J(n) ? Rn : Mi,
              a = t ? t() : {};
            return i(n, e, R(r, 2), a);
          };
        }
        function Do(e) {
          return I(function (t, r) {
            var i = -1,
              a = r.length,
              o = a > 1 ? r[a - 1] : n,
              s = a > 2 ? r[2] : n;
            for (
              o = e.length > 3 && typeof o == `function` ? (a--, o) : n,
                s && ws(r[0], r[1], s) && ((o = a < 3 ? n : o), (a = 1)),
                t = j(t);
              ++i < a;
            ) {
              var c = r[i];
              c && e(t, c, i, o);
            }
            return t;
          });
        }
        function Oo(e, t) {
          return function (n, r) {
            if (n == null) return n;
            if (!_u(n)) return e(n, r);
            for (
              var i = n.length, a = t ? i : -1, o = j(n);
              (t ? a-- : ++a < i) && r(o[a], a, o) !== !1;
            );
            return n;
          };
        }
        function ko(e) {
          return function (t, n, r) {
            for (var i = -1, a = j(t), o = r(t), s = o.length; s--;) {
              var c = o[e ? s : ++i];
              if (n(a[c], c, a) === !1) break;
            }
            return t;
          };
        }
        function Ao(e, t, n) {
          var r = t & v,
            i = No(e);
          function a() {
            return (this && this !== Tn && this instanceof a ? i : e).apply(
              r ? n : this,
              arguments,
            );
          }
          return a;
        }
        function jo(e) {
          return function (t) {
            t = X(t);
            var r = Cr(t) ? Pr(t) : n,
              i = r ? r[0] : t.charAt(0),
              a = r ? lo(r, 1).join(``) : t.slice(1);
            return i[e]() + a;
          };
        }
        function Mo(e) {
          return function (t) {
            return qn(Df($d(t).replace(sn, ``)), e, ``);
          };
        }
        function No(e) {
          return function () {
            var t = arguments;
            switch (t.length) {
              case 0:
                return new e();
              case 1:
                return new e(t[0]);
              case 2:
                return new e(t[0], t[1]);
              case 3:
                return new e(t[0], t[1], t[2]);
              case 4:
                return new e(t[0], t[1], t[2], t[3]);
              case 5:
                return new e(t[0], t[1], t[2], t[3], t[4]);
              case 6:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
              case 7:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
            }
            var n = Kr(e.prototype),
              r = e.apply(n, t);
            return ju(r) ? r : n;
          };
        }
        function Po(e, t, r) {
          var i = No(e);
          function a() {
            for (var o = arguments.length, s = st(o), c = o, l = ss(a); c--;) s[c] = arguments[c];
            var u = o < 3 && s[0] !== l && s[o - 1] !== l ? [] : Or(s, l);
            return (
              (o -= u.length),
              o < r
                ? Go(e, t, Lo, a.placeholder, n, s, u, n, n, r - o)
                : Ln(this && this !== Tn && this instanceof a ? i : e, this, s)
            );
          }
          return a;
        }
        function Fo(e) {
          return function (t, r, i) {
            var a = j(t);
            if (!_u(t)) {
              var o = R(r, 3);
              ((t = Dd(t)),
                (r = function (e) {
                  return o(a[e], e, a);
                }));
            }
            var s = e(t, r, i);
            return s > -1 ? a[o ? t[s] : s] : n;
          };
        }
        function Io(e) {
          return ns(function (t) {
            var r = t.length,
              i = r,
              a = Jr.prototype.thru;
            for (e && t.reverse(); i--;) {
              var s = t[i];
              if (typeof s != `function`) throw new kt(o);
              if (a && !c && os(s) == `wrapper`) var c = new Jr([], !0);
            }
            for (i = c ? i : r; ++i < r;) {
              s = t[i];
              var l = os(s),
                u = l == `wrapper` ? as(s) : n;
              c =
                u && Ds(u[0]) && u[1] == (T | x | C | ee) && !u[4].length && u[9] == 1
                  ? c[os(u[0])].apply(c, u[3])
                  : s.length == 1 && Ds(s)
                    ? c[l]()
                    : c.thru(s);
            }
            return function () {
              var e = arguments,
                n = e[0];
              if (c && e.length == 1 && J(n)) return c.plant(n).value();
              for (var i = 0, a = r ? t[i].apply(this, e) : n; ++i < r;) a = t[i].call(this, a);
              return a;
            };
          });
        }
        function Lo(e, t, r, i, a, o, s, c, l, u) {
          var d = t & T,
            f = t & v,
            p = t & y,
            m = t & (x | S),
            h = t & te,
            g = p ? n : No(e);
          function b() {
            for (var n = arguments.length, v = st(n), y = n; y--;) v[y] = arguments[y];
            if (m)
              var x = ss(b),
                S = vr(v, x);
            if ((i && (v = bo(v, i, a, m)), o && (v = xo(v, o, s, m)), (n -= S), m && n < u)) {
              var C = Or(v, x);
              return Go(e, t, Lo, b.placeholder, r, v, C, c, l, u - n);
            }
            var w = f ? r : this,
              T = p ? w[e] : e;
            return (
              (n = v.length),
              c ? (v = zs(v, c)) : h && n > 1 && v.reverse(),
              d && l < n && (v.length = l),
              this && this !== Tn && this instanceof b && (T = g || No(T)),
              T.apply(w, v)
            );
          }
          return b;
        }
        function Ro(e, t) {
          return function (n, r) {
            return la(n, e, t(r), {});
          };
        }
        function zo(e, t) {
          return function (r, i) {
            var a;
            if (r === n && i === n) return t;
            if ((r !== n && (a = r), i !== n)) {
              if (a === n) return i;
              (typeof r == `string` || typeof i == `string`
                ? ((r = Qa(r)), (i = Qa(i)))
                : ((r = Za(r)), (i = Za(i))),
                (a = e(r, i)));
            }
            return a;
          };
        }
        function Bo(e) {
          return ns(function (t) {
            return (
              (t = Gn(t, pr(R()))),
              I(function (n) {
                var r = this;
                return e(t, function (e) {
                  return Ln(e, r, n);
                });
              })
            );
          });
        }
        function Vo(e, t) {
          t = t === n ? ` ` : Qa(t);
          var r = t.length;
          if (r < 2) return r ? za(t, e) : t;
          var i = za(t, nn(e / Nr(t)));
          return Cr(t) ? lo(Pr(i), 0, e).join(``) : i.slice(0, e);
        }
        function Ho(e, t, n, r) {
          var i = t & v,
            a = No(e);
          function o() {
            for (
              var t = -1,
                s = arguments.length,
                c = -1,
                l = r.length,
                u = st(l + s),
                d = this && this !== Tn && this instanceof o ? a : e;
              ++c < l;
            )
              u[c] = r[c];
            for (; s--;) u[c++] = arguments[++t];
            return Ln(d, i ? n : this, u);
          }
          return o;
        }
        function Uo(e) {
          return function (t, r, i) {
            return (
              i && typeof i != `number` && ws(t, r, i) && (r = i = n),
              (t = ed(t)),
              r === n ? ((r = t), (t = 0)) : (r = ed(r)),
              (i = i === n ? (t < r ? 1 : -1) : ed(i)),
              F(t, r, i, e)
            );
          };
        }
        function Wo(e) {
          return function (t, n) {
            return (
              (typeof t == `string` && typeof n == `string`) || ((t = nd(t)), (n = nd(n))),
              e(t, n)
            );
          };
        }
        function Go(e, t, r, i, a, o, s, c, l, u) {
          var d = t & x,
            f = d ? s : n,
            p = d ? n : s,
            m = d ? o : n,
            h = d ? n : o;
          ((t |= d ? C : w), (t &= ~(d ? w : C)), t & b || (t &= ~(v | y)));
          var g = [e, t, a, m, f, h, p, c, l, u],
            S = r.apply(n, g);
          return (Ds(e) && Vs(S, g), (S.placeholder = i), Ws(S, e, t));
        }
        function Ko(e) {
          var t = Et[e];
          return function (e, n) {
            if (((e = nd(e)), (n = n == null ? 0 : _n(Y(n), 292)), n && ln(e))) {
              var r = (X(e) + `e`).split(`e`);
              return (
                (r = (X(t(r[0] + `e` + (+r[1] + n))) + `e`).split(`e`)),
                +(r[0] + `e` + (+r[1] - n))
              );
            }
            return t(e);
          };
        }
        var qo =
          kn && 1 / kr(new kn([, -0]))[1] == O
            ? function (e) {
                return new kn(e);
              }
            : Wf;
        function Jo(e) {
          return function (t) {
            var n = ms(t);
            return n == Se ? Er(t) : n == Oe ? Ar(t) : dr(t, e(t));
          };
        }
        function Yo(e, t, r, i, a, s, c, l) {
          var u = t & y;
          if (!u && typeof e != `function`) throw new kt(o);
          var d = i ? i.length : 0;
          if (
            (d || ((t &= ~(C | w)), (i = a = n)),
            (c = c === n ? c : fn(Y(c), 0)),
            (l = l === n ? l : Y(l)),
            (d -= a ? a.length : 0),
            t & w)
          ) {
            var f = i,
              p = a;
            i = a = n;
          }
          var m = u ? n : as(e),
            h = [e, t, r, i, a, f, p, s, c, l];
          if (
            (m && Ps(h, m),
            (e = h[0]),
            (t = h[1]),
            (r = h[2]),
            (i = h[3]),
            (a = h[4]),
            (l = h[9] = h[9] === n ? (u ? 0 : e.length) : fn(h[9] - d, 0)),
            !l && t & (x | S) && (t &= ~(x | S)),
            !t || t == v)
          )
            var g = Ao(e, t, r);
          else
            g =
              t == x || t == S
                ? Po(e, t, l)
                : (t == C || t == (v | C)) && !a.length
                  ? Ho(e, t, r, i)
                  : Lo.apply(n, h);
          return Ws((m ? Ua : Vs)(g, h), e, t);
        }
        function Xo(e, t, r, i) {
          return e === n || (fu(e, Mt[r]) && !M.call(i, r)) ? t : e;
        }
        function Zo(e, t, r, i, a, o) {
          return (ju(e) && ju(t) && (o.set(t, e), ka(e, t, n, Zo, o), o.delete(t)), e);
        }
        function Qo(e) {
          return Vu(e) ? n : e;
        }
        function $o(e, t, r, i, a, o) {
          var s = r & h,
            c = e.length,
            l = t.length;
          if (c != l && !(s && l > c)) return !1;
          var u = o.get(e),
            d = o.get(t);
          if (u && d) return u == t && d == e;
          var f = -1,
            p = !0,
            m = r & g ? new gi() : n;
          for (o.set(e, t), o.set(t, e); ++f < c;) {
            var v = e[f],
              y = t[f];
            if (i) var b = s ? i(y, v, f, t, e, o) : i(v, y, f, e, t, o);
            if (b !== n) {
              if (b) continue;
              p = !1;
              break;
            }
            if (m) {
              if (
                !Yn(t, function (e, t) {
                  if (!hr(m, t) && (v === e || a(v, e, r, i, o))) return m.push(t);
                })
              ) {
                p = !1;
                break;
              }
            } else if (!(v === y || a(v, y, r, i, o))) {
              p = !1;
              break;
            }
          }
          return (o.delete(e), o.delete(t), p);
        }
        function es(e, t, n, r, i, a, o) {
          switch (n) {
            case Fe:
              if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
              ((e = e.buffer), (t = t.buffer));
            case Pe:
              return !(e.byteLength != t.byteLength || !a(new Ut(e), new Ut(t)));
            case ge:
            case _e:
            case Ce:
              return fu(+e, +t);
            case ye:
              return e.name == t.name && e.message == t.message;
            case De:
            case ke:
              return e == t + ``;
            case Se:
              var s = Er;
            case Oe:
              var c = r & h;
              if (((s ||= kr), e.size != t.size && !c)) return !1;
              var l = o.get(e);
              if (l) return l == t;
              ((r |= g), o.set(e, t));
              var u = $o(s(e), s(t), r, i, a, o);
              return (o.delete(e), u);
            case Ae:
              if (Wr) return Wr.call(e) == Wr.call(t);
          }
          return !1;
        }
        function ts(e, t, r, i, a, o) {
          var s = r & h,
            c = rs(e),
            l = c.length;
          if (l != rs(t).length && !s) return !1;
          for (var u = l; u--;) {
            var d = c[u];
            if (!(s ? d in t : M.call(t, d))) return !1;
          }
          var f = o.get(e),
            p = o.get(t);
          if (f && p) return f == t && p == e;
          var m = !0;
          (o.set(e, t), o.set(t, e));
          for (var g = s; ++u < l;) {
            d = c[u];
            var v = e[d],
              y = t[d];
            if (i) var b = s ? i(y, v, d, t, e, o) : i(v, y, d, e, t, o);
            if (!(b === n ? v === y || a(v, y, r, i, o) : b)) {
              m = !1;
              break;
            }
            g ||= d == `constructor`;
          }
          if (m && !g) {
            var x = e.constructor,
              S = t.constructor;
            x != S &&
              `constructor` in e &&
              `constructor` in t &&
              !(
                typeof x == `function` &&
                x instanceof x &&
                typeof S == `function` &&
                S instanceof S
              ) &&
              (m = !1);
          }
          return (o.delete(e), o.delete(t), m);
        }
        function ns(e) {
          return Us(Ls(e, n, uc), e + ``);
        }
        function rs(e) {
          return na(e, Dd, fs);
        }
        function is(e) {
          return na(e, Od, ps);
        }
        var as = Zn
          ? function (e) {
              return Zn.get(e);
            }
          : Wf;
        function os(e) {
          for (var t = e.name + ``, n = or[t], r = M.call(or, t) ? n.length : 0; r--;) {
            var i = n[r],
              a = i.func;
            if (a == null || a == e) return i.name;
          }
          return t;
        }
        function ss(e) {
          return (M.call(N, `placeholder`) ? N : e).placeholder;
        }
        function R() {
          var e = N.iteratee || Lf;
          return ((e = e === Lf ? Sa : e), arguments.length ? e(arguments[0], arguments[1]) : e);
        }
        function cs(e, t) {
          var n = e.__data__;
          return Es(t) ? n[typeof t == `string` ? `string` : `hash`] : n.map;
        }
        function ls(e) {
          for (var t = Dd(e), n = t.length; n--;) {
            var r = t[n],
              i = e[r];
            t[n] = [r, i, js(i)];
          }
          return t;
        }
        function us(e, t) {
          var r = Sr(e, t);
          return va(r) ? r : n;
        }
        function ds(e) {
          var t = M.call(e, Zt),
            r = e[Zt];
          try {
            e[Zt] = n;
            var i = !0;
          } catch {}
          var a = Lt.call(e);
          return (i && (t ? (e[Zt] = r) : delete e[Zt]), a);
        }
        var fs = an
            ? function (e) {
                return e == null
                  ? []
                  : ((e = j(e)),
                    Hn(an(e), function (t) {
                      return qt.call(e, t);
                    }));
              }
            : $f,
          ps = an
            ? function (e) {
                for (var t = []; e;) (Kn(t, fs(e)), (e = Gt(e)));
                return t;
              }
            : $f,
          ms = ra;
        ((wn && ms(new wn(new ArrayBuffer(1))) != Fe) ||
          (En && ms(new En()) != Se) ||
          (Dn && ms(Dn.resolve()) != A) ||
          (kn && ms(new kn()) != Oe) ||
          (An && ms(new An()) != Me)) &&
          (ms = function (e) {
            var t = ra(e),
              r = t == Te ? e.constructor : n,
              i = r ? Ys(r) : ``;
            if (i)
              switch (i) {
                case jr:
                  return Fe;
                case Lr:
                  return Se;
                case Rr:
                  return A;
                case Vr:
                  return Oe;
                case Hr:
                  return Me;
              }
            return t;
          });
        function hs(e, t, n) {
          for (var r = -1, i = n.length; ++r < i;) {
            var a = n[r],
              o = a.size;
            switch (a.type) {
              case `drop`:
                e += o;
                break;
              case `dropRight`:
                t -= o;
                break;
              case `take`:
                t = _n(t, e + o);
                break;
              case `takeRight`:
                e = fn(e, t - o);
                break;
            }
          }
          return {
            start: e,
            end: t,
          };
        }
        function gs(e) {
          var t = e.match(lt);
          return t ? t[1].split(ut) : [];
        }
        function _s(e, t, n) {
          t = so(t, e);
          for (var r = -1, i = t.length, a = !1; ++r < i;) {
            var o = Js(t[r]);
            if (!(a = e != null && n(e, o))) break;
            e = e[o];
          }
          return a || ++r != i
            ? a
            : ((i = e == null ? 0 : e.length), !!i && Au(i) && Cs(o, i) && (J(e) || hu(e)));
        }
        function vs(e) {
          var t = e.length,
            n = new e.constructor(t);
          return (
            t &&
              typeof e[0] == `string` &&
              M.call(e, `index`) &&
              ((n.index = e.index), (n.input = e.input)),
            n
          );
        }
        function ys(e) {
          return typeof e.constructor == `function` && !As(e) ? Kr(Gt(e)) : {};
        }
        function bs(e, t, n) {
          var r = e.constructor;
          switch (t) {
            case Pe:
              return po(e);
            case ge:
            case _e:
              return new r(+e);
            case Fe:
              return mo(e, n);
            case Ie:
            case Le:
            case Re:
            case ze:
            case Be:
            case Ve:
            case He:
            case Ue:
            case We:
              return _o(e, n);
            case Se:
              return new r();
            case Ce:
            case ke:
              return new r(e);
            case De:
              return ho(e);
            case Oe:
              return new r();
            case Ae:
              return go(e);
          }
        }
        function xs(e, t) {
          var n = t.length;
          if (!n) return e;
          var r = n - 1;
          return (
            (t[r] = (n > 1 ? `& ` : ``) + t[r]),
            (t = t.join(n > 2 ? `, ` : ` `)),
            e.replace(
              ct,
              `{
/* [wrapped with ` +
                t +
                `] */
`,
            )
          );
        }
        function Ss(e) {
          return J(e) || hu(e) || !!(Yt && e && e[Yt]);
        }
        function Cs(e, t) {
          var n = typeof e;
          return (
            (t ??= k),
            !!t && (n == `number` || (n != `symbol` && bt.test(e))) && e > -1 && e % 1 == 0 && e < t
          );
        }
        function ws(e, t, n) {
          if (!ju(n)) return !1;
          var r = typeof t;
          return (r == `number` ? _u(n) && Cs(t, n.length) : r == `string` && t in n)
            ? fu(n[t], e)
            : !1;
        }
        function Ts(e, t) {
          if (J(e)) return !1;
          var n = typeof e;
          return n == `number` || n == `symbol` || n == `boolean` || e == null || Ku(e)
            ? !0
            : nt.test(e) || !tt.test(e) || (t != null && e in j(t));
        }
        function Es(e) {
          var t = typeof e;
          return t == `string` || t == `number` || t == `symbol` || t == `boolean`
            ? e !== `__proto__`
            : e === null;
        }
        function Ds(e) {
          var t = os(e),
            n = N[t];
          if (typeof n != `function` || !(t in P.prototype)) return !1;
          if (e === n) return !0;
          var r = as(n);
          return !!r && e === r[0];
        }
        function Os(e) {
          return !!It && It in e;
        }
        var ks = Nt ? Ou : ep;
        function As(e) {
          var t = e && e.constructor;
          return e === ((typeof t == `function` && t.prototype) || Mt);
        }
        function js(e) {
          return e === e && !ju(e);
        }
        function Ms(e, t) {
          return function (r) {
            return r == null ? !1 : r[e] === t && (t !== n || e in j(r));
          };
        }
        function Ns(e) {
          var t = Yl(e, function (e) {
              return (n.size === u && n.clear(), e);
            }),
            n = t.cache;
          return t;
        }
        function Ps(e, t) {
          var n = e[1],
            r = t[1],
            i = n | r,
            a = i < (v | y | T),
            o =
              (r == T && n == x) ||
              (r == T && n == ee && e[7].length <= t[8]) ||
              (r == (T | ee) && t[7].length <= t[8] && n == x);
          if (!(a || o)) return e;
          r & v && ((e[2] = t[2]), (i |= n & v ? 0 : b));
          var s = t[3];
          if (s) {
            var c = e[3];
            ((e[3] = c ? bo(c, s, t[4]) : s), (e[4] = c ? Or(e[3], d) : t[4]));
          }
          return (
            (s = t[5]),
            s && ((c = e[5]), (e[5] = c ? xo(c, s, t[6]) : s), (e[6] = c ? Or(e[5], d) : t[6])),
            (s = t[7]),
            s && (e[7] = s),
            r & T && (e[8] = e[8] == null ? t[8] : _n(e[8], t[8])),
            (e[9] ??= t[9]),
            (e[0] = t[0]),
            (e[1] = i),
            e
          );
        }
        function Fs(e) {
          var t = [];
          if (e != null) for (var n in j(e)) t.push(n);
          return t;
        }
        function Is(e) {
          return Lt.call(e);
        }
        function Ls(e, t, r) {
          return (
            (t = fn(t === n ? e.length - 1 : t, 0)),
            function () {
              for (var n = arguments, i = -1, a = fn(n.length - t, 0), o = st(a); ++i < a;)
                o[i] = n[t + i];
              i = -1;
              for (var s = st(t + 1); ++i < t;) s[i] = n[i];
              return ((s[t] = r(o)), Ln(e, this, s));
            }
          );
        }
        function Rs(e, t) {
          return t.length < 2 ? e : ta(e, Ka(t, 0, -1));
        }
        function zs(e, t) {
          for (var r = e.length, i = _n(t.length, r), a = So(e); i--;) {
            var o = t[i];
            e[i] = Cs(o, r) ? a[o] : n;
          }
          return e;
        }
        function Bs(e, t) {
          if (!(t === `constructor` && typeof e[t] == `function`) && t != `__proto__`) return e[t];
        }
        var Vs = Gs(Ua),
          Hs =
            tn ||
            function (e, t) {
              return Tn.setTimeout(e, t);
            },
          Us = Gs(Wa);
        function Ws(e, t, n) {
          var r = t + ``;
          return Us(e, xs(r, Xs(gs(r), n)));
        }
        function Gs(e) {
          var t = 0,
            r = 0;
          return function () {
            var i = vn(),
              a = ie - (i - r);
            if (((r = i), a > 0)) {
              if (++t >= E) return arguments[0];
            } else t = 0;
            return e.apply(n, arguments);
          };
        }
        function Ks(e, t) {
          var r = -1,
            i = e.length,
            a = i - 1;
          for (t = t === n ? i : t; ++r < t;) {
            var o = Ra(r, a),
              s = e[o];
            ((e[o] = e[r]), (e[r] = s));
          }
          return ((e.length = t), e);
        }
        var qs = Ns(function (e) {
          var t = [];
          return (
            e.charCodeAt(0) === 46 && t.push(``),
            e.replace(rt, function (e, n, r, i) {
              t.push(r ? i.replace(pt, `$1`) : n || e);
            }),
            t
          );
        });
        function Js(e) {
          if (typeof e == `string` || Ku(e)) return e;
          var t = e + ``;
          return t == `0` && 1 / e == -O ? `-0` : t;
        }
        function Ys(e) {
          if (e != null) {
            try {
              return Pt.call(e);
            } catch {}
            try {
              return e + ``;
            } catch {}
          }
          return ``;
        }
        function Xs(e, t) {
          return (
            zn(fe, function (n) {
              var r = `_.` + n[0];
              t & n[1] && !Un(e, r) && e.push(r);
            }),
            e.sort()
          );
        }
        function Zs(e) {
          if (e instanceof P) return e.clone();
          var t = new Jr(e.__wrapped__, e.__chain__);
          return (
            (t.__actions__ = So(e.__actions__)),
            (t.__index__ = e.__index__),
            (t.__values__ = e.__values__),
            t
          );
        }
        function Qs(e, t, r) {
          t = (r ? ws(e, t, r) : t === n) ? 1 : fn(Y(t), 0);
          var i = e == null ? 0 : e.length;
          if (!i || t < 1) return [];
          for (var a = 0, o = 0, s = st(nn(i / t)); a < i;) s[o++] = Ka(e, a, (a += t));
          return s;
        }
        function z(e) {
          for (var t = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++t < n;) {
            var a = e[t];
            a && (i[r++] = a);
          }
          return i;
        }
        function $s() {
          var e = arguments.length;
          if (!e) return [];
          for (var t = st(e - 1), n = arguments[0], r = e; r--;) t[r - 1] = arguments[r];
          return Kn(J(n) ? So(n) : [n], Yi(t, 1));
        }
        var ec = I(function (e, t) {
            return vu(e) ? Hi(e, Yi(t, 1, vu, !0)) : [];
          }),
          tc = I(function (e, t) {
            var r = xc(t);
            return (vu(r) && (r = n), vu(e) ? Hi(e, Yi(t, 1, vu, !0), R(r, 2)) : []);
          }),
          nc = I(function (e, t) {
            var r = xc(t);
            return (vu(r) && (r = n), vu(e) ? Hi(e, Yi(t, 1, vu, !0), n, r) : []);
          });
        function rc(e, t, r) {
          var i = e == null ? 0 : e.length;
          return i ? ((t = r || t === n ? 1 : Y(t)), Ka(e, t < 0 ? 0 : t, i)) : [];
        }
        function ic(e, t, r) {
          var i = e == null ? 0 : e.length;
          return i ? ((t = r || t === n ? 1 : Y(t)), (t = i - t), Ka(e, 0, t < 0 ? 0 : t)) : [];
        }
        function ac(e, t) {
          return e && e.length ? no(e, R(t, 3), !0, !0) : [];
        }
        function oc(e, t) {
          return e && e.length ? no(e, R(t, 3), !0) : [];
        }
        function sc(e, t, n, r) {
          var i = e == null ? 0 : e.length;
          return i
            ? (n && typeof n != `number` && ws(e, t, n) && ((n = 0), (r = i)), qi(e, t, n, r))
            : [];
        }
        function cc(e, t, n) {
          var r = e == null ? 0 : e.length;
          if (!r) return -1;
          var i = n == null ? 0 : Y(n);
          return (i < 0 && (i = fn(r + i, 0)), er(e, R(t, 3), i));
        }
        function lc(e, t, r) {
          var i = e == null ? 0 : e.length;
          if (!i) return -1;
          var a = i - 1;
          return (
            r !== n && ((a = Y(r)), (a = r < 0 ? fn(i + a, 0) : _n(a, i - 1))),
            er(e, R(t, 3), a, !0)
          );
        }
        function uc(e) {
          return e != null && e.length ? Yi(e, 1) : [];
        }
        function dc(e) {
          return e != null && e.length ? Yi(e, O) : [];
        }
        function fc(e, t) {
          return e != null && e.length ? ((t = t === n ? 1 : Y(t)), Yi(e, t)) : [];
        }
        function pc(e) {
          for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n;) {
            var i = e[t];
            Fi(r, i[0], i[1]);
          }
          return r;
        }
        function mc(e) {
          return e && e.length ? e[0] : n;
        }
        function hc(e, t, n) {
          var r = e == null ? 0 : e.length;
          if (!r) return -1;
          var i = n == null ? 0 : Y(n);
          return (i < 0 && (i = fn(r + i, 0)), tr(e, t, i));
        }
        function gc(e) {
          return e != null && e.length ? Ka(e, 0, -1) : [];
        }
        var _c = I(function (e) {
            var t = Gn(e, ao);
            return t.length && t[0] === e[0] ? ca(t) : [];
          }),
          vc = I(function (e) {
            var t = xc(e),
              r = Gn(e, ao);
            return (
              t === xc(r) ? (t = n) : r.pop(),
              r.length && r[0] === e[0] ? ca(r, R(t, 2)) : []
            );
          }),
          yc = I(function (e) {
            var t = xc(e),
              r = Gn(e, ao);
            return (
              (t = typeof t == `function` ? t : n),
              t && r.pop(),
              r.length && r[0] === e[0] ? ca(r, n, t) : []
            );
          });
        function bc(e, t) {
          return e == null ? `` : un.call(e, t);
        }
        function xc(e) {
          var t = e == null ? 0 : e.length;
          return t ? e[t - 1] : n;
        }
        function Sc(e, t, r) {
          var i = e == null ? 0 : e.length;
          if (!i) return -1;
          var a = i;
          return (
            r !== n && ((a = Y(r)), (a = a < 0 ? fn(i + a, 0) : _n(a, i - 1))),
            t === t ? Mr(e, t, a) : er(e, rr, a, !0)
          );
        }
        function Cc(e, t) {
          return e && e.length ? ja(e, Y(t)) : n;
        }
        var wc = I(Tc);
        function Tc(e, t) {
          return e && e.length && t && t.length ? Ia(e, t) : e;
        }
        function Ec(e, t, n) {
          return e && e.length && t && t.length ? Ia(e, t, R(n, 2)) : e;
        }
        function Dc(e, t, r) {
          return e && e.length && t && t.length ? Ia(e, t, n, r) : e;
        }
        var Oc = ns(function (e, t) {
          var n = e == null ? 0 : e.length,
            r = Ii(e, t);
          return (
            La(
              e,
              Gn(t, function (e) {
                return Cs(e, n) ? +e : e;
              }).sort(vo),
            ),
            r
          );
        });
        function kc(e, t) {
          var n = [];
          if (!(e && e.length)) return n;
          var r = -1,
            i = [],
            a = e.length;
          for (t = R(t, 3); ++r < a;) {
            var o = e[r];
            t(o, r, e) && (n.push(o), i.push(r));
          }
          return (La(e, i), n);
        }
        function Ac(e) {
          return e == null ? e : Cn.call(e);
        }
        function jc(e, t, r) {
          var i = e == null ? 0 : e.length;
          return i
            ? (r && typeof r != `number` && ws(e, t, r)
                ? ((t = 0), (r = i))
                : ((t = t == null ? 0 : Y(t)), (r = r === n ? i : Y(r))),
              Ka(e, t, r))
            : [];
        }
        function Mc(e, t) {
          return Ja(e, t);
        }
        function Nc(e, t, n) {
          return Ya(e, t, R(n, 2));
        }
        function Pc(e, t) {
          var n = e == null ? 0 : e.length;
          if (n) {
            var r = Ja(e, t);
            if (r < n && fu(e[r], t)) return r;
          }
          return -1;
        }
        function Fc(e, t) {
          return Ja(e, t, !0);
        }
        function Ic(e, t, n) {
          return Ya(e, t, R(n, 2), !0);
        }
        function Lc(e, t) {
          if (e != null && e.length) {
            var n = Ja(e, t, !0) - 1;
            if (fu(e[n], t)) return n;
          }
          return -1;
        }
        function Rc(e) {
          return e && e.length ? Xa(e) : [];
        }
        function zc(e, t) {
          return e && e.length ? Xa(e, R(t, 2)) : [];
        }
        function Bc(e) {
          var t = e == null ? 0 : e.length;
          return t ? Ka(e, 1, t) : [];
        }
        function Vc(e, t, r) {
          return e && e.length ? ((t = r || t === n ? 1 : Y(t)), Ka(e, 0, t < 0 ? 0 : t)) : [];
        }
        function Hc(e, t, r) {
          var i = e == null ? 0 : e.length;
          return i ? ((t = r || t === n ? 1 : Y(t)), (t = i - t), Ka(e, t < 0 ? 0 : t, i)) : [];
        }
        function Uc(e, t) {
          return e && e.length ? no(e, R(t, 3), !1, !0) : [];
        }
        function Wc(e, t) {
          return e && e.length ? no(e, R(t, 3)) : [];
        }
        var Gc = I(function (e) {
            return $a(Yi(e, 1, vu, !0));
          }),
          Kc = I(function (e) {
            var t = xc(e);
            return (vu(t) && (t = n), $a(Yi(e, 1, vu, !0), R(t, 2)));
          }),
          qc = I(function (e) {
            var t = xc(e);
            return ((t = typeof t == `function` ? t : n), $a(Yi(e, 1, vu, !0), n, t));
          });
        function Jc(e) {
          return e && e.length ? $a(e) : [];
        }
        function Yc(e, t) {
          return e && e.length ? $a(e, R(t, 2)) : [];
        }
        function Xc(e, t) {
          return ((t = typeof t == `function` ? t : n), e && e.length ? $a(e, n, t) : []);
        }
        function Zc(e) {
          if (!(e && e.length)) return [];
          var t = 0;
          return (
            (e = Hn(e, function (e) {
              if (vu(e)) return ((t = fn(e.length, t)), !0);
            })),
            ur(t, function (t) {
              return Gn(e, ar(t));
            })
          );
        }
        function Qc(e, t) {
          if (!(e && e.length)) return [];
          var r = Zc(e);
          return t == null
            ? r
            : Gn(r, function (e) {
                return Ln(t, n, e);
              });
        }
        var $c = I(function (e, t) {
            return vu(e) ? Hi(e, t) : [];
          }),
          el = I(function (e) {
            return io(Hn(e, vu));
          }),
          tl = I(function (e) {
            var t = xc(e);
            return (vu(t) && (t = n), io(Hn(e, vu), R(t, 2)));
          }),
          nl = I(function (e) {
            var t = xc(e);
            return ((t = typeof t == `function` ? t : n), io(Hn(e, vu), n, t));
          }),
          rl = I(Zc);
        function il(e, t) {
          return L(e || [], t || [], Ai);
        }
        function al(e, t) {
          return L(e || [], t || [], Ha);
        }
        var ol = I(function (e) {
          var t = e.length,
            r = t > 1 ? e[t - 1] : n;
          return ((r = typeof r == `function` ? (e.pop(), r) : n), Qc(e, r));
        });
        function sl(e) {
          var t = N(e);
          return ((t.__chain__ = !0), t);
        }
        function cl(e, t) {
          return (t(e), e);
        }
        function ll(e, t) {
          return t(e);
        }
        var ul = ns(function (e) {
          var t = e.length,
            r = t ? e[0] : 0,
            i = this.__wrapped__,
            a = function (t) {
              return Ii(t, e);
            };
          return t > 1 || this.__actions__.length || !(i instanceof P) || !Cs(r)
            ? this.thru(a)
            : ((i = i.slice(r, +r + +!!t)),
              i.__actions__.push({
                func: ll,
                args: [a],
                thisArg: n,
              }),
              new Jr(i, this.__chain__).thru(function (e) {
                return (t && !e.length && e.push(n), e);
              }));
        });
        function dl() {
          return sl(this);
        }
        function fl() {
          return new Jr(this.value(), this.__chain__);
        }
        function pl() {
          this.__values__ === n && (this.__values__ = $u(this.value()));
          var e = this.__index__ >= this.__values__.length;
          return {
            done: e,
            value: e ? n : this.__values__[this.__index__++],
          };
        }
        function ml() {
          return this;
        }
        function hl(e) {
          for (var t, r = this; r instanceof qr;) {
            var i = Zs(r);
            ((i.__index__ = 0), (i.__values__ = n), t ? (a.__wrapped__ = i) : (t = i));
            var a = i;
            r = r.__wrapped__;
          }
          return ((a.__wrapped__ = e), t);
        }
        function gl() {
          var e = this.__wrapped__;
          if (e instanceof P) {
            var t = e;
            return (
              this.__actions__.length && (t = new P(this)),
              (t = t.reverse()),
              t.__actions__.push({
                func: ll,
                args: [Ac],
                thisArg: n,
              }),
              new Jr(t, this.__chain__)
            );
          }
          return this.thru(Ac);
        }
        function _l() {
          return ro(this.__wrapped__, this.__actions__);
        }
        var vl = Eo(function (e, t, n) {
          M.call(e, n) ? ++e[n] : Fi(e, n, 1);
        });
        function yl(e, t, r) {
          var i = J(e) ? Vn : Gi;
          return (r && ws(e, t, r) && (t = n), i(e, R(t, 3)));
        }
        function bl(e, t) {
          return (J(e) ? Hn : Ji)(e, R(t, 3));
        }
        var xl = Fo(cc),
          Sl = Fo(lc);
        function Cl(e, t) {
          return Yi(jl(e, t), 1);
        }
        function wl(e, t) {
          return Yi(jl(e, t), O);
        }
        function Tl(e, t, r) {
          return ((r = r === n ? 1 : Y(r)), Yi(jl(e, t), r));
        }
        function El(e, t) {
          return (J(e) ? zn : Ui)(e, R(t, 3));
        }
        function B(e, t) {
          return (J(e) ? Bn : Wi)(e, R(t, 3));
        }
        var Dl = Eo(function (e, t, n) {
          M.call(e, n) ? e[n].push(t) : Fi(e, n, [t]);
        });
        function Ol(e, t, n, r) {
          ((e = _u(e) ? e : Kd(e)), (n = n && !r ? Y(n) : 0));
          var i = e.length;
          return (
            n < 0 && (n = fn(i + n, 0)),
            Gu(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && tr(e, t, n) > -1
          );
        }
        var kl = I(function (e, t, n) {
            var r = -1,
              i = typeof t == `function`,
              a = _u(e) ? st(e.length) : [];
            return (
              Ui(e, function (e) {
                a[++r] = i ? Ln(t, e, n) : ua(e, t, n);
              }),
              a
            );
          }),
          Al = Eo(function (e, t, n) {
            Fi(e, n, t);
          });
        function jl(e, t) {
          return (J(e) ? Gn : Ea)(e, R(t, 3));
        }
        function V(e, t, r, i) {
          return e == null
            ? []
            : (J(t) || (t = t == null ? [] : [t]),
              (r = i ? n : r),
              J(r) || (r = r == null ? [] : [r]),
              Ma(e, t, r));
        }
        var Ml = Eo(
          function (e, t, n) {
            e[+!n].push(t);
          },
          function () {
            return [[], []];
          },
        );
        function Nl(e, t, n) {
          var r = J(e) ? qn : sr,
            i = arguments.length < 3;
          return r(e, R(t, 4), n, i, Ui);
        }
        function Pl(e, t, n) {
          var r = J(e) ? Jn : sr,
            i = arguments.length < 3;
          return r(e, R(t, 4), n, i, Wi);
        }
        function H(e, t) {
          return (J(e) ? Hn : Ji)(e, q(R(t, 3)));
        }
        function U(e) {
          return (J(e) ? Ei : Ba)(e);
        }
        function W(e, t, r) {
          return ((t = (r ? ws(e, t, r) : t === n) ? 1 : Y(t)), (J(e) ? Di : Va)(e, t));
        }
        function Fl(e) {
          return (J(e) ? Oi : Ga)(e);
        }
        function Il(e) {
          if (e == null) return 0;
          if (_u(e)) return Gu(e) ? Nr(e) : e.length;
          var t = ms(e);
          return t == Se || t == Oe ? e.size : Ca(e).length;
        }
        function Ll(e, t, r) {
          var i = J(e) ? Yn : qa;
          return (r && ws(e, t, r) && (t = n), i(e, R(t, 3)));
        }
        var Rl = I(function (e, t) {
            if (e == null) return [];
            var n = t.length;
            return (
              n > 1 && ws(e, t[0], t[1]) ? (t = []) : n > 2 && ws(t[0], t[1], t[2]) && (t = [t[0]]),
              Ma(e, Yi(t, 1), [])
            );
          }),
          zl =
            en ||
            function () {
              return Tn.Date.now();
            };
        function Bl(e, t) {
          if (typeof t != `function`) throw new kt(o);
          return (
            (e = Y(e)),
            function () {
              if (--e < 1) return t.apply(this, arguments);
            }
          );
        }
        function G(e, t, r) {
          return ((t = r ? n : t), (t = e && t == null ? e.length : t), Yo(e, T, n, n, n, n, t));
        }
        function Vl(e, t) {
          var r;
          if (typeof t != `function`) throw new kt(o);
          return (
            (e = Y(e)),
            function () {
              return (--e > 0 && (r = t.apply(this, arguments)), e <= 1 && (t = n), r);
            }
          );
        }
        var Hl = I(function (e, t, n) {
            var r = v;
            if (n.length) {
              var i = Or(n, ss(Hl));
              r |= C;
            }
            return Yo(e, r, t, n, i);
          }),
          Ul = I(function (e, t, n) {
            var r = v | y;
            if (n.length) {
              var i = Or(n, ss(Ul));
              r |= C;
            }
            return Yo(t, r, e, n, i);
          });
        function Wl(e, t, r) {
          t = r ? n : t;
          var i = Yo(e, x, n, n, n, n, n, t);
          return ((i.placeholder = Wl.placeholder), i);
        }
        function Gl(e, t, r) {
          t = r ? n : t;
          var i = Yo(e, S, n, n, n, n, n, t);
          return ((i.placeholder = Gl.placeholder), i);
        }
        function Kl(e, t, r) {
          var i,
            a,
            s,
            c,
            l,
            u,
            d = 0,
            f = !1,
            p = !1,
            m = !0;
          if (typeof e != `function`) throw new kt(o);
          ((t = nd(t) || 0),
            ju(r) &&
              ((f = !!r.leading),
              (p = `maxWait` in r),
              (s = p ? fn(nd(r.maxWait) || 0, t) : s),
              (m = `trailing` in r ? !!r.trailing : m)));
          function h(t) {
            var r = i,
              o = a;
            return ((i = a = n), (d = t), (c = e.apply(o, r)), c);
          }
          function g(e) {
            return ((d = e), (l = Hs(b, t)), f ? h(e) : c);
          }
          function v(e) {
            var n = e - u,
              r = e - d,
              i = t - n;
            return p ? _n(i, s - r) : i;
          }
          function y(e) {
            var r = e - u,
              i = e - d;
            return u === n || r >= t || r < 0 || (p && i >= s);
          }
          function b() {
            var e = zl();
            if (y(e)) return x(e);
            l = Hs(b, v(e));
          }
          function x(e) {
            return ((l = n), m && i ? h(e) : ((i = a = n), c));
          }
          function S() {
            (l !== n && uo(l), (d = 0), (i = u = a = l = n));
          }
          function C() {
            return l === n ? c : x(zl());
          }
          function w() {
            var e = zl(),
              r = y(e);
            if (((i = arguments), (a = this), (u = e), r)) {
              if (l === n) return g(u);
              if (p) return (uo(l), (l = Hs(b, t)), h(u));
            }
            return (l === n && (l = Hs(b, t)), c);
          }
          return ((w.cancel = S), (w.flush = C), w);
        }
        var ql = I(function (e, t) {
            return Vi(e, 1, t);
          }),
          Jl = I(function (e, t, n) {
            return Vi(e, nd(t) || 0, n);
          });
        function K(e) {
          return Yo(e, te);
        }
        function Yl(e, t) {
          if (typeof e != `function` || (t != null && typeof t != `function`)) throw new kt(o);
          var n = function () {
            var r = arguments,
              i = t ? t.apply(this, r) : r[0],
              a = n.cache;
            if (a.has(i)) return a.get(i);
            var o = e.apply(this, r);
            return ((n.cache = a.set(i, o) || a), o);
          };
          return ((n.cache = new (Yl.Cache || ui)()), n);
        }
        Yl.Cache = ui;
        function q(e) {
          if (typeof e != `function`) throw new kt(o);
          return function () {
            var t = arguments;
            switch (t.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, t[0]);
              case 2:
                return !e.call(this, t[0], t[1]);
              case 3:
                return !e.call(this, t[0], t[1], t[2]);
            }
            return !e.apply(this, t);
          };
        }
        function Xl(e) {
          return Vl(2, e);
        }
        var Zl = co(function (e, t) {
            t = t.length == 1 && J(t[0]) ? Gn(t[0], pr(R())) : Gn(Yi(t, 1), pr(R()));
            var n = t.length;
            return I(function (r) {
              for (var i = -1, a = _n(r.length, n); ++i < a;) r[i] = t[i].call(this, r[i]);
              return Ln(e, this, r);
            });
          }),
          Ql = I(function (e, t) {
            return Yo(e, C, n, t, Or(t, ss(Ql)));
          }),
          $l = I(function (e, t) {
            return Yo(e, w, n, t, Or(t, ss($l)));
          }),
          eu = ns(function (e, t) {
            return Yo(e, ee, n, n, n, t);
          });
        function tu(e, t) {
          if (typeof e != `function`) throw new kt(o);
          return ((t = t === n ? t : Y(t)), I(e, t));
        }
        function nu(e, t) {
          if (typeof e != `function`) throw new kt(o);
          return (
            (t = t == null ? 0 : fn(Y(t), 0)),
            I(function (n) {
              var r = n[t],
                i = lo(n, 0, t);
              return (r && Kn(i, r), Ln(e, this, i));
            })
          );
        }
        function ru(e, t, n) {
          var r = !0,
            i = !0;
          if (typeof e != `function`) throw new kt(o);
          return (
            ju(n) &&
              ((r = `leading` in n ? !!n.leading : r), (i = `trailing` in n ? !!n.trailing : i)),
            Kl(e, t, {
              leading: r,
              maxWait: t,
              trailing: i,
            })
          );
        }
        function iu(e) {
          return G(e, 1);
        }
        function au(e, t) {
          return Ql(oo(t), e);
        }
        function ou() {
          if (!arguments.length) return [];
          var e = arguments[0];
          return J(e) ? e : [e];
        }
        function su(e) {
          return Ri(e, m);
        }
        function cu(e, t) {
          return ((t = typeof t == `function` ? t : n), Ri(e, m, t));
        }
        function lu(e) {
          return Ri(e, f | m);
        }
        function uu(e, t) {
          return ((t = typeof t == `function` ? t : n), Ri(e, f | m, t));
        }
        function du(e, t) {
          return t == null || Bi(e, t, Dd(t));
        }
        function fu(e, t) {
          return e === t || (e !== e && t !== t);
        }
        var pu = Wo(ia),
          mu = Wo(function (e, t) {
            return e >= t;
          }),
          hu = da(
            (function () {
              return arguments;
            })(),
          )
            ? da
            : function (e) {
                return Mu(e) && M.call(e, `callee`) && !qt.call(e, `callee`);
              },
          J = st.isArray,
          gu = jn ? pr(jn) : fa;
        function _u(e) {
          return e != null && Au(e.length) && !Ou(e);
        }
        function vu(e) {
          return Mu(e) && _u(e);
        }
        function yu(e) {
          return e === !0 || e === !1 || (Mu(e) && ra(e) == ge);
        }
        var bu = on || ep,
          xu = Mn ? pr(Mn) : pa;
        function Su(e) {
          return Mu(e) && e.nodeType === 1 && !Vu(e);
        }
        function Cu(e) {
          if (e == null) return !0;
          if (
            _u(e) &&
            (J(e) ||
              typeof e == `string` ||
              typeof e.splice == `function` ||
              bu(e) ||
              qu(e) ||
              hu(e))
          )
            return !e.length;
          var t = ms(e);
          if (t == Se || t == Oe) return !e.size;
          if (As(e)) return !Ca(e).length;
          for (var n in e) if (M.call(e, n)) return !1;
          return !0;
        }
        function wu(e, t) {
          return ma(e, t);
        }
        function Tu(e, t, r) {
          r = typeof r == `function` ? r : n;
          var i = r ? r(e, t) : n;
          return i === n ? ma(e, t, n, r) : !!i;
        }
        function Eu(e) {
          if (!Mu(e)) return !1;
          var t = ra(e);
          return (
            t == ye ||
            t == ve ||
            (typeof e.message == `string` && typeof e.name == `string` && !Vu(e))
          );
        }
        function Du(e) {
          return typeof e == `number` && ln(e);
        }
        function Ou(e) {
          if (!ju(e)) return !1;
          var t = ra(e);
          return t == be || t == xe || t == he || t == Ee;
        }
        function ku(e) {
          return typeof e == `number` && e == Y(e);
        }
        function Au(e) {
          return typeof e == `number` && e > -1 && e % 1 == 0 && e <= k;
        }
        function ju(e) {
          var t = typeof e;
          return e != null && (t == `object` || t == `function`);
        }
        function Mu(e) {
          return typeof e == `object` && !!e;
        }
        var Nu = Nn ? pr(Nn) : ga;
        function Pu(e, t) {
          return e === t || _a(e, t, ls(t));
        }
        function Fu(e, t, r) {
          return ((r = typeof r == `function` ? r : n), _a(e, t, ls(t), r));
        }
        function Iu(e) {
          return Bu(e) && e != +e;
        }
        function Lu(e) {
          if (ks(e)) throw new wt(a);
          return va(e);
        }
        function Ru(e) {
          return e === null;
        }
        function zu(e) {
          return e == null;
        }
        function Bu(e) {
          return typeof e == `number` || (Mu(e) && ra(e) == Ce);
        }
        function Vu(e) {
          if (!Mu(e) || ra(e) != Te) return !1;
          var t = Gt(e);
          if (t === null) return !0;
          var n = M.call(t, `constructor`) && t.constructor;
          return typeof n == `function` && n instanceof n && Pt.call(n) == Rt;
        }
        var Hu = Pn ? pr(Pn) : ya;
        function Uu(e) {
          return ku(e) && e >= -k && e <= k;
        }
        var Wu = Fn ? pr(Fn) : ba;
        function Gu(e) {
          return typeof e == `string` || (!J(e) && Mu(e) && ra(e) == ke);
        }
        function Ku(e) {
          return typeof e == `symbol` || (Mu(e) && ra(e) == Ae);
        }
        var qu = In ? pr(In) : xa;
        function Ju(e) {
          return e === n;
        }
        function Yu(e) {
          return Mu(e) && ms(e) == Me;
        }
        function Xu(e) {
          return Mu(e) && ra(e) == Ne;
        }
        var Zu = Wo(Ta),
          Qu = Wo(function (e, t) {
            return e <= t;
          });
        function $u(e) {
          if (!e) return [];
          if (_u(e)) return Gu(e) ? Pr(e) : So(e);
          if (Xt && e[Xt]) return Tr(e[Xt]());
          var t = ms(e);
          return (t == Se ? Er : t == Oe ? kr : Kd)(e);
        }
        function ed(e) {
          return e
            ? ((e = nd(e)), e === O || e === -O ? (e < 0 ? -1 : 1) * se : e === e ? e : 0)
            : e === 0
              ? e
              : 0;
        }
        function Y(e) {
          var t = ed(e),
            n = t % 1;
          return t === t ? (n ? t - n : t) : 0;
        }
        function td(e) {
          return e ? Li(Y(e), 0, le) : 0;
        }
        function nd(e) {
          if (typeof e == `number`) return e;
          if (Ku(e)) return ce;
          if (ju(e)) {
            var t = typeof e.valueOf == `function` ? e.valueOf() : e;
            e = ju(t) ? t + `` : t;
          }
          if (typeof e != `string`) return e === 0 ? e : +e;
          e = fr(e);
          var n = _t.test(e);
          return n || yt.test(e) ? Sn(e.slice(2), n ? 2 : 8) : gt.test(e) ? ce : +e;
        }
        function rd(e) {
          return Co(e, Od(e));
        }
        function id(e) {
          return e ? Li(Y(e), -k, k) : e === 0 ? e : 0;
        }
        function X(e) {
          return e == null ? `` : Qa(e);
        }
        var ad = Do(function (e, t) {
            if (As(t) || _u(t)) {
              Co(t, Dd(t), e);
              return;
            }
            for (var n in t) M.call(t, n) && Ai(e, n, t[n]);
          }),
          od = Do(function (e, t) {
            Co(t, Od(t), e);
          }),
          sd = Do(function (e, t, n, r) {
            Co(t, Od(t), e, r);
          }),
          cd = Do(function (e, t, n, r) {
            Co(t, Dd(t), e, r);
          }),
          ld = ns(Ii);
        function ud(e, t) {
          var n = Kr(e);
          return t == null ? n : Ni(n, t);
        }
        var dd = I(function (e, t) {
            e = j(e);
            var r = -1,
              i = t.length,
              a = i > 2 ? t[2] : n;
            for (a && ws(t[0], t[1], a) && (i = 1); ++r < i;)
              for (var o = t[r], s = Od(o), c = -1, l = s.length; ++c < l;) {
                var u = s[c],
                  d = e[u];
                (d === n || (fu(d, Mt[u]) && !M.call(e, u))) && (e[u] = o[u]);
              }
            return e;
          }),
          fd = I(function (e) {
            return (e.push(n, Zo), Ln(Md, n, e));
          });
        function pd(e, t) {
          return $n(e, R(t, 3), Qi);
        }
        function md(e, t) {
          return $n(e, R(t, 3), $i);
        }
        function hd(e, t) {
          return e == null ? e : Xi(e, R(t, 3), Od);
        }
        function gd(e, t) {
          return e == null ? e : Zi(e, R(t, 3), Od);
        }
        function _d(e, t) {
          return e && Qi(e, R(t, 3));
        }
        function vd(e, t) {
          return e && $i(e, R(t, 3));
        }
        function yd(e) {
          return e == null ? [] : ea(e, Dd(e));
        }
        function bd(e) {
          return e == null ? [] : ea(e, Od(e));
        }
        function xd(e, t, r) {
          var i = e == null ? n : ta(e, t);
          return i === n ? r : i;
        }
        function Sd(e, t) {
          return e != null && _s(e, t, aa);
        }
        function Cd(e, t) {
          return e != null && _s(e, t, oa);
        }
        var wd = Ro(function (e, t, n) {
            (t != null && typeof t.toString != `function` && (t = Lt.call(t)), (e[t] = n));
          }, Mf(If)),
          Td = Ro(function (e, t, n) {
            (t != null && typeof t.toString != `function` && (t = Lt.call(t)),
              M.call(e, t) ? e[t].push(n) : (e[t] = [n]));
          }, R),
          Ed = I(ua);
        function Dd(e) {
          return _u(e) ? Ti(e) : Ca(e);
        }
        function Od(e) {
          return _u(e) ? Ti(e, !0) : wa(e);
        }
        function kd(e, t) {
          var n = {};
          return (
            (t = R(t, 3)),
            Qi(e, function (e, r, i) {
              Fi(n, t(e, r, i), e);
            }),
            n
          );
        }
        function Ad(e, t) {
          var n = {};
          return (
            (t = R(t, 3)),
            Qi(e, function (e, r, i) {
              Fi(n, r, t(e, r, i));
            }),
            n
          );
        }
        var jd = Do(function (e, t, n) {
            ka(e, t, n);
          }),
          Md = Do(function (e, t, n, r) {
            ka(e, t, n, r);
          }),
          Nd = ns(function (e, t) {
            var n = {};
            if (e == null) return n;
            var r = !1;
            ((t = Gn(t, function (t) {
              return ((t = so(t, e)), (r ||= t.length > 1), t);
            })),
              Co(e, is(e), n),
              r && (n = Ri(n, f | p | m, Qo)));
            for (var i = t.length; i--;) eo(n, t[i]);
            return n;
          });
        function Pd(e, t) {
          return Id(e, q(R(t)));
        }
        var Fd = ns(function (e, t) {
          return e == null ? {} : Na(e, t);
        });
        function Id(e, t) {
          if (e == null) return {};
          var n = Gn(is(e), function (e) {
            return [e];
          });
          return (
            (t = R(t)),
            Pa(e, n, function (e, n) {
              return t(e, n[0]);
            })
          );
        }
        function Ld(e, t, r) {
          t = so(t, e);
          var i = -1,
            a = t.length;
          for (a || ((a = 1), (e = n)); ++i < a;) {
            var o = e == null ? n : e[Js(t[i])];
            (o === n && ((i = a), (o = r)), (e = Ou(o) ? o.call(e) : o));
          }
          return e;
        }
        function Rd(e, t, n) {
          return e == null ? e : Ha(e, t, n);
        }
        function zd(e, t, r, i) {
          return ((i = typeof i == `function` ? i : n), e == null ? e : Ha(e, t, r, i));
        }
        var Bd = Jo(Dd),
          Vd = Jo(Od);
        function Hd(e, t, n) {
          var r = J(e),
            i = r || bu(e) || qu(e);
          if (((t = R(t, 4)), n == null)) {
            var a = e && e.constructor;
            n = i ? (r ? new a() : []) : ju(e) && Ou(a) ? Kr(Gt(e)) : {};
          }
          return (
            (i ? zn : Qi)(e, function (e, r, i) {
              return t(n, e, r, i);
            }),
            n
          );
        }
        function Ud(e, t) {
          return e == null ? !0 : eo(e, t);
        }
        function Wd(e, t, n) {
          return e == null ? e : to(e, t, oo(n));
        }
        function Gd(e, t, r, i) {
          return ((i = typeof i == `function` ? i : n), e == null ? e : to(e, t, oo(r), i));
        }
        function Kd(e) {
          return e == null ? [] : mr(e, Dd(e));
        }
        function qd(e) {
          return e == null ? [] : mr(e, Od(e));
        }
        function Jd(e, t, r) {
          return (
            r === n && ((r = t), (t = n)),
            r !== n && ((r = nd(r)), (r = r === r ? r : 0)),
            t !== n && ((t = nd(t)), (t = t === t ? t : 0)),
            Li(nd(e), t, r)
          );
        }
        function Yd(e, t, r) {
          return (
            (t = ed(t)),
            r === n ? ((r = t), (t = 0)) : (r = ed(r)),
            (e = nd(e)),
            sa(e, t, r)
          );
        }
        function Xd(e, t, r) {
          if (
            (r && typeof r != `boolean` && ws(e, t, r) && (t = r = n),
            r === n &&
              (typeof t == `boolean`
                ? ((r = t), (t = n))
                : typeof e == `boolean` && ((r = e), (e = n))),
            e === n && t === n
              ? ((e = 0), (t = 1))
              : ((e = ed(e)), t === n ? ((t = e), (e = 0)) : (t = ed(t))),
            e > t)
          ) {
            var i = e;
            ((e = t), (t = i));
          }
          if (r || e % 1 || t % 1) {
            var a = bn();
            return _n(e + a * (t - e + xn(`1e-` + ((a + ``).length - 1))), t);
          }
          return Ra(e, t);
        }
        var Zd = Mo(function (e, t, n) {
          return ((t = t.toLowerCase()), e + (n ? Qd(t) : t));
        });
        function Qd(e) {
          return Ef(X(e).toLowerCase());
        }
        function $d(e) {
          return ((e = X(e)), e && e.replace(xt, yr).replace(cn, ``));
        }
        function ef(e, t, r) {
          ((e = X(e)), (t = Qa(t)));
          var i = e.length;
          r = r === n ? i : Li(Y(r), 0, i);
          var a = r;
          return ((r -= t.length), r >= 0 && e.slice(r, a) == t);
        }
        function tf(e) {
          return ((e = X(e)), e && Ze.test(e) ? e.replace(Ye, br) : e);
        }
        function nf(e) {
          return ((e = X(e)), e && at.test(e) ? e.replace(it, `\\$&`) : e);
        }
        var rf = Mo(function (e, t, n) {
            return e + (n ? `-` : ``) + t.toLowerCase();
          }),
          af = Mo(function (e, t, n) {
            return e + (n ? ` ` : ``) + t.toLowerCase();
          }),
          of = jo(`toLowerCase`);
        function sf(e, t, n) {
          ((e = X(e)), (t = Y(t)));
          var r = t ? Nr(e) : 0;
          if (!t || r >= t) return e;
          var i = (t - r) / 2;
          return Vo(rn(i), n) + e + Vo(nn(i), n);
        }
        function cf(e, t, n) {
          ((e = X(e)), (t = Y(t)));
          var r = t ? Nr(e) : 0;
          return t && r < t ? e + Vo(t - r, n) : e;
        }
        function lf(e, t, n) {
          ((e = X(e)), (t = Y(t)));
          var r = t ? Nr(e) : 0;
          return t && r < t ? Vo(t - r, n) + e : e;
        }
        function uf(e, t, n) {
          return (n || t == null ? (t = 0) : (t &&= +t), yn(X(e).replace(ot, ``), t || 0));
        }
        function df(e, t, r) {
          return ((t = (r ? ws(e, t, r) : t === n) ? 1 : Y(t)), za(X(e), t));
        }
        function ff() {
          var e = arguments,
            t = X(e[0]);
          return e.length < 3 ? t : t.replace(e[1], e[2]);
        }
        var pf = Mo(function (e, t, n) {
          return e + (n ? `_` : ``) + t.toLowerCase();
        });
        function mf(e, t, r) {
          return (
            r && typeof r != `number` && ws(e, t, r) && (t = r = n),
            (r = r === n ? le : r >>> 0),
            r
              ? ((e = X(e)),
                e && (typeof t == `string` || (t != null && !Hu(t))) && ((t = Qa(t)), !t && Cr(e))
                  ? lo(Pr(e), 0, r)
                  : e.split(t, r))
              : []
          );
        }
        var hf = Mo(function (e, t, n) {
          return e + (n ? ` ` : ``) + Ef(t);
        });
        function gf(e, t, n) {
          return (
            (e = X(e)),
            (n = n == null ? 0 : Li(Y(n), 0, e.length)),
            (t = Qa(t)),
            e.slice(n, n + t.length) == t
          );
        }
        function _f(e, t, r) {
          var i = N.templateSettings;
          (r && ws(e, t, r) && (t = n), (e = X(e)), (t = cd({}, t, i, Xo)));
          var a = cd({}, t.imports, i.imports, Xo),
            o = Dd(a),
            l = mr(a, o);
          zn(o, function (e) {
            if (ft.test(e)) throw new wt(c);
          });
          var u,
            d,
            f = 0,
            p = t.interpolate || St,
            m = `__p += '`,
            h = Dt(
              (t.escape || St).source +
                `|` +
                p.source +
                `|` +
                (p === et ? mt : St).source +
                `|` +
                (t.evaluate || St).source +
                `|$`,
              `g`,
            ),
            g =
              `//# sourceURL=` +
              (M.call(t, `sourceURL`)
                ? (t.sourceURL + ``).replace(/\s/g, ` `)
                : `lodash.templateSources[` + ++mn + `]`) +
              `
`;
          (e.replace(h, function (t, n, r, i, a, o) {
            return (
              (r ||= i),
              (m += e.slice(f, o).replace(Ct, xr)),
              n &&
                ((u = !0),
                (m +=
                  `' +
__e(` +
                  n +
                  `) +
'`)),
              a &&
                ((d = !0),
                (m +=
                  `';
` +
                  a +
                  `;
__p += '`)),
              r &&
                (m +=
                  `' +
((__t = (` +
                  r +
                  `)) == null ? '' : __t) +
'`),
              (f = o + t.length),
              t
            );
          }),
            (m += `';
`));
          var v = M.call(t, `variable`) && t.variable;
          if (!v)
            m =
              `with (obj) {
` +
              m +
              `
}
`;
          else if (ft.test(v)) throw new wt(s);
          ((m = (d ? m.replace(Ge, ``) : m).replace(Ke, `$1`).replace(qe, `$1;`)),
            (m =
              `function(` +
              (v || `obj`) +
              `) {
` +
              (v
                ? ``
                : `obj || (obj = {});
`) +
              `var __t, __p = ''` +
              (u ? `, __e = _.escape` : ``) +
              (d
                ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`
                : `;
`) +
              m +
              `return __p
}`));
          var y = Of(function () {
            return Tt(o, g + `return ` + m).apply(n, l);
          });
          if (((y.source = m), Eu(y))) throw y;
          return y;
        }
        function vf(e) {
          return X(e).toLowerCase();
        }
        function yf(e) {
          return X(e).toUpperCase();
        }
        function bf(e, t, r) {
          if (((e = X(e)), e && (r || t === n))) return fr(e);
          if (!e || !(t = Qa(t))) return e;
          var i = Pr(e),
            a = Pr(t);
          return lo(i, gr(i, a), _r(i, a) + 1).join(``);
        }
        function xf(e, t, r) {
          if (((e = X(e)), e && (r || t === n))) return e.slice(0, Fr(e) + 1);
          if (!e || !(t = Qa(t))) return e;
          var i = Pr(e);
          return lo(i, 0, _r(i, Pr(t)) + 1).join(``);
        }
        function Sf(e, t, r) {
          if (((e = X(e)), e && (r || t === n))) return e.replace(ot, ``);
          if (!e || !(t = Qa(t))) return e;
          var i = Pr(e);
          return lo(i, gr(i, Pr(t))).join(``);
        }
        function Cf(e, t) {
          var r = ne,
            i = re;
          if (ju(t)) {
            var a = `separator` in t ? t.separator : a;
            ((r = `length` in t ? Y(t.length) : r), (i = `omission` in t ? Qa(t.omission) : i));
          }
          e = X(e);
          var o = e.length;
          if (Cr(e)) {
            var s = Pr(e);
            o = s.length;
          }
          if (r >= o) return e;
          var c = r - Nr(i);
          if (c < 1) return i;
          var l = s ? lo(s, 0, c).join(``) : e.slice(0, c);
          if (a === n) return l + i;
          if ((s && (c += l.length - c), Hu(a))) {
            if (e.slice(c).search(a)) {
              var u,
                d = l;
              for (
                a.global || (a = Dt(a.source, X(ht.exec(a)) + `g`)), a.lastIndex = 0;
                (u = a.exec(d));
              )
                var f = u.index;
              l = l.slice(0, f === n ? c : f);
            }
          } else if (e.indexOf(Qa(a), c) != c) {
            var p = l.lastIndexOf(a);
            p > -1 && (l = l.slice(0, p));
          }
          return l + i;
        }
        function wf(e) {
          return ((e = X(e)), e && Xe.test(e) ? e.replace(Je, Ir) : e);
        }
        var Tf = Mo(function (e, t, n) {
            return e + (n ? ` ` : ``) + t.toUpperCase();
          }),
          Ef = jo(`toUpperCase`);
        function Df(e, t, r) {
          return (
            (e = X(e)),
            (t = r ? n : t),
            t === n ? (wr(e) ? zr(e) : Qn(e)) : e.match(t) || []
          );
        }
        var Of = I(function (e, t) {
            try {
              return Ln(e, n, t);
            } catch (e) {
              return Eu(e) ? e : new wt(e);
            }
          }),
          kf = ns(function (e, t) {
            return (
              zn(t, function (t) {
                ((t = Js(t)), Fi(e, t, Hl(e[t], e)));
              }),
              e
            );
          });
        function Af(e) {
          var t = e == null ? 0 : e.length,
            n = R();
          return (
            (e = t
              ? Gn(e, function (e) {
                  if (typeof e[1] != `function`) throw new kt(o);
                  return [n(e[0]), e[1]];
                })
              : []),
            I(function (n) {
              for (var r = -1; ++r < t;) {
                var i = e[r];
                if (Ln(i[0], this, n)) return Ln(i[1], this, n);
              }
            })
          );
        }
        function jf(e) {
          return zi(Ri(e, f));
        }
        function Mf(e) {
          return function () {
            return e;
          };
        }
        function Nf(e, t) {
          return e == null || e !== e ? t : e;
        }
        var Pf = Io(),
          Ff = Io(!0);
        function If(e) {
          return e;
        }
        function Lf(e) {
          return Sa(typeof e == `function` ? e : Ri(e, f));
        }
        function Rf(e) {
          return Da(Ri(e, f));
        }
        function zf(e, t) {
          return Oa(e, Ri(t, f));
        }
        var Bf = I(function (e, t) {
            return function (n) {
              return ua(n, e, t);
            };
          }),
          Vf = I(function (e, t) {
            return function (n) {
              return ua(e, n, t);
            };
          });
        function Hf(e, t, n) {
          var r = Dd(t),
            i = ea(t, r);
          n == null &&
            !(ju(t) && (i.length || !r.length)) &&
            ((n = t), (t = e), (e = this), (i = ea(t, Dd(t))));
          var a = !(ju(n) && `chain` in n) || !!n.chain,
            o = Ou(e);
          return (
            zn(i, function (n) {
              var r = t[n];
              ((e[n] = r),
                o &&
                  (e.prototype[n] = function () {
                    var t = this.__chain__;
                    if (a || t) {
                      var n = e(this.__wrapped__);
                      return (
                        (n.__actions__ = So(this.__actions__)).push({
                          func: r,
                          args: arguments,
                          thisArg: e,
                        }),
                        (n.__chain__ = t),
                        n
                      );
                    }
                    return r.apply(e, Kn([this.value()], arguments));
                  }));
            }),
            e
          );
        }
        function Uf() {
          return (Tn._ === this && (Tn._ = zt), this);
        }
        function Wf() {}
        function Gf(e) {
          return (
            (e = Y(e)),
            I(function (t) {
              return ja(t, e);
            })
          );
        }
        var Kf = Bo(Gn),
          qf = Bo(Vn),
          Jf = Bo(Yn);
        function Yf(e) {
          return Ts(e) ? ar(Js(e)) : Fa(e);
        }
        function Xf(e) {
          return function (t) {
            return e == null ? n : ta(e, t);
          };
        }
        var Zf = Uo(),
          Qf = Uo(!0);
        function $f() {
          return [];
        }
        function ep() {
          return !1;
        }
        function tp() {
          return {};
        }
        function np() {
          return ``;
        }
        function rp() {
          return !0;
        }
        function ip(e, t) {
          if (((e = Y(e)), e < 1 || e > k)) return [];
          var n = le,
            r = _n(e, le);
          ((t = R(t)), (e -= le));
          for (var i = ur(r, t); ++n < e;) t(n);
          return i;
        }
        function ap(e) {
          return J(e) ? Gn(e, Js) : Ku(e) ? [e] : So(qs(X(e)));
        }
        function op(e) {
          var t = ++Ft;
          return X(e) + t;
        }
        var sp = zo(function (e, t) {
            return e + t;
          }, 0),
          cp = Ko(`ceil`),
          lp = zo(function (e, t) {
            return e / t;
          }, 1),
          up = Ko(`floor`);
        function dp(e) {
          return e && e.length ? Ki(e, If, ia) : n;
        }
        function fp(e, t) {
          return e && e.length ? Ki(e, R(t, 2), ia) : n;
        }
        function pp(e) {
          return ir(e, If);
        }
        function mp(e, t) {
          return ir(e, R(t, 2));
        }
        function hp(e) {
          return e && e.length ? Ki(e, If, Ta) : n;
        }
        function gp(e, t) {
          return e && e.length ? Ki(e, R(t, 2), Ta) : n;
        }
        var _p = zo(function (e, t) {
            return e * t;
          }, 1),
          vp = Ko(`round`),
          yp = zo(function (e, t) {
            return e - t;
          }, 0);
        function bp(e) {
          return e && e.length ? lr(e, If) : 0;
        }
        function xp(e, t) {
          return e && e.length ? lr(e, R(t, 2)) : 0;
        }
        return (
          (N.after = Bl),
          (N.ary = G),
          (N.assign = ad),
          (N.assignIn = od),
          (N.assignInWith = sd),
          (N.assignWith = cd),
          (N.at = ld),
          (N.before = Vl),
          (N.bind = Hl),
          (N.bindAll = kf),
          (N.bindKey = Ul),
          (N.castArray = ou),
          (N.chain = sl),
          (N.chunk = Qs),
          (N.compact = z),
          (N.concat = $s),
          (N.cond = Af),
          (N.conforms = jf),
          (N.constant = Mf),
          (N.countBy = vl),
          (N.create = ud),
          (N.curry = Wl),
          (N.curryRight = Gl),
          (N.debounce = Kl),
          (N.defaults = dd),
          (N.defaultsDeep = fd),
          (N.defer = ql),
          (N.delay = Jl),
          (N.difference = ec),
          (N.differenceBy = tc),
          (N.differenceWith = nc),
          (N.drop = rc),
          (N.dropRight = ic),
          (N.dropRightWhile = ac),
          (N.dropWhile = oc),
          (N.fill = sc),
          (N.filter = bl),
          (N.flatMap = Cl),
          (N.flatMapDeep = wl),
          (N.flatMapDepth = Tl),
          (N.flatten = uc),
          (N.flattenDeep = dc),
          (N.flattenDepth = fc),
          (N.flip = K),
          (N.flow = Pf),
          (N.flowRight = Ff),
          (N.fromPairs = pc),
          (N.functions = yd),
          (N.functionsIn = bd),
          (N.groupBy = Dl),
          (N.initial = gc),
          (N.intersection = _c),
          (N.intersectionBy = vc),
          (N.intersectionWith = yc),
          (N.invert = wd),
          (N.invertBy = Td),
          (N.invokeMap = kl),
          (N.iteratee = Lf),
          (N.keyBy = Al),
          (N.keys = Dd),
          (N.keysIn = Od),
          (N.map = jl),
          (N.mapKeys = kd),
          (N.mapValues = Ad),
          (N.matches = Rf),
          (N.matchesProperty = zf),
          (N.memoize = Yl),
          (N.merge = jd),
          (N.mergeWith = Md),
          (N.method = Bf),
          (N.methodOf = Vf),
          (N.mixin = Hf),
          (N.negate = q),
          (N.nthArg = Gf),
          (N.omit = Nd),
          (N.omitBy = Pd),
          (N.once = Xl),
          (N.orderBy = V),
          (N.over = Kf),
          (N.overArgs = Zl),
          (N.overEvery = qf),
          (N.overSome = Jf),
          (N.partial = Ql),
          (N.partialRight = $l),
          (N.partition = Ml),
          (N.pick = Fd),
          (N.pickBy = Id),
          (N.property = Yf),
          (N.propertyOf = Xf),
          (N.pull = wc),
          (N.pullAll = Tc),
          (N.pullAllBy = Ec),
          (N.pullAllWith = Dc),
          (N.pullAt = Oc),
          (N.range = Zf),
          (N.rangeRight = Qf),
          (N.rearg = eu),
          (N.reject = H),
          (N.remove = kc),
          (N.rest = tu),
          (N.reverse = Ac),
          (N.sampleSize = W),
          (N.set = Rd),
          (N.setWith = zd),
          (N.shuffle = Fl),
          (N.slice = jc),
          (N.sortBy = Rl),
          (N.sortedUniq = Rc),
          (N.sortedUniqBy = zc),
          (N.split = mf),
          (N.spread = nu),
          (N.tail = Bc),
          (N.take = Vc),
          (N.takeRight = Hc),
          (N.takeRightWhile = Uc),
          (N.takeWhile = Wc),
          (N.tap = cl),
          (N.throttle = ru),
          (N.thru = ll),
          (N.toArray = $u),
          (N.toPairs = Bd),
          (N.toPairsIn = Vd),
          (N.toPath = ap),
          (N.toPlainObject = rd),
          (N.transform = Hd),
          (N.unary = iu),
          (N.union = Gc),
          (N.unionBy = Kc),
          (N.unionWith = qc),
          (N.uniq = Jc),
          (N.uniqBy = Yc),
          (N.uniqWith = Xc),
          (N.unset = Ud),
          (N.unzip = Zc),
          (N.unzipWith = Qc),
          (N.update = Wd),
          (N.updateWith = Gd),
          (N.values = Kd),
          (N.valuesIn = qd),
          (N.without = $c),
          (N.words = Df),
          (N.wrap = au),
          (N.xor = el),
          (N.xorBy = tl),
          (N.xorWith = nl),
          (N.zip = rl),
          (N.zipObject = il),
          (N.zipObjectDeep = al),
          (N.zipWith = ol),
          (N.entries = Bd),
          (N.entriesIn = Vd),
          (N.extend = od),
          (N.extendWith = sd),
          Hf(N, N),
          (N.add = sp),
          (N.attempt = Of),
          (N.camelCase = Zd),
          (N.capitalize = Qd),
          (N.ceil = cp),
          (N.clamp = Jd),
          (N.clone = su),
          (N.cloneDeep = lu),
          (N.cloneDeepWith = uu),
          (N.cloneWith = cu),
          (N.conformsTo = du),
          (N.deburr = $d),
          (N.defaultTo = Nf),
          (N.divide = lp),
          (N.endsWith = ef),
          (N.eq = fu),
          (N.escape = tf),
          (N.escapeRegExp = nf),
          (N.every = yl),
          (N.find = xl),
          (N.findIndex = cc),
          (N.findKey = pd),
          (N.findLast = Sl),
          (N.findLastIndex = lc),
          (N.findLastKey = md),
          (N.floor = up),
          (N.forEach = El),
          (N.forEachRight = B),
          (N.forIn = hd),
          (N.forInRight = gd),
          (N.forOwn = _d),
          (N.forOwnRight = vd),
          (N.get = xd),
          (N.gt = pu),
          (N.gte = mu),
          (N.has = Sd),
          (N.hasIn = Cd),
          (N.head = mc),
          (N.identity = If),
          (N.includes = Ol),
          (N.indexOf = hc),
          (N.inRange = Yd),
          (N.invoke = Ed),
          (N.isArguments = hu),
          (N.isArray = J),
          (N.isArrayBuffer = gu),
          (N.isArrayLike = _u),
          (N.isArrayLikeObject = vu),
          (N.isBoolean = yu),
          (N.isBuffer = bu),
          (N.isDate = xu),
          (N.isElement = Su),
          (N.isEmpty = Cu),
          (N.isEqual = wu),
          (N.isEqualWith = Tu),
          (N.isError = Eu),
          (N.isFinite = Du),
          (N.isFunction = Ou),
          (N.isInteger = ku),
          (N.isLength = Au),
          (N.isMap = Nu),
          (N.isMatch = Pu),
          (N.isMatchWith = Fu),
          (N.isNaN = Iu),
          (N.isNative = Lu),
          (N.isNil = zu),
          (N.isNull = Ru),
          (N.isNumber = Bu),
          (N.isObject = ju),
          (N.isObjectLike = Mu),
          (N.isPlainObject = Vu),
          (N.isRegExp = Hu),
          (N.isSafeInteger = Uu),
          (N.isSet = Wu),
          (N.isString = Gu),
          (N.isSymbol = Ku),
          (N.isTypedArray = qu),
          (N.isUndefined = Ju),
          (N.isWeakMap = Yu),
          (N.isWeakSet = Xu),
          (N.join = bc),
          (N.kebabCase = rf),
          (N.last = xc),
          (N.lastIndexOf = Sc),
          (N.lowerCase = af),
          (N.lowerFirst = of),
          (N.lt = Zu),
          (N.lte = Qu),
          (N.max = dp),
          (N.maxBy = fp),
          (N.mean = pp),
          (N.meanBy = mp),
          (N.min = hp),
          (N.minBy = gp),
          (N.stubArray = $f),
          (N.stubFalse = ep),
          (N.stubObject = tp),
          (N.stubString = np),
          (N.stubTrue = rp),
          (N.multiply = _p),
          (N.nth = Cc),
          (N.noConflict = Uf),
          (N.noop = Wf),
          (N.now = zl),
          (N.pad = sf),
          (N.padEnd = cf),
          (N.padStart = lf),
          (N.parseInt = uf),
          (N.random = Xd),
          (N.reduce = Nl),
          (N.reduceRight = Pl),
          (N.repeat = df),
          (N.replace = ff),
          (N.result = Ld),
          (N.round = vp),
          (N.runInContext = e),
          (N.sample = U),
          (N.size = Il),
          (N.snakeCase = pf),
          (N.some = Ll),
          (N.sortedIndex = Mc),
          (N.sortedIndexBy = Nc),
          (N.sortedIndexOf = Pc),
          (N.sortedLastIndex = Fc),
          (N.sortedLastIndexBy = Ic),
          (N.sortedLastIndexOf = Lc),
          (N.startCase = hf),
          (N.startsWith = gf),
          (N.subtract = yp),
          (N.sum = bp),
          (N.sumBy = xp),
          (N.template = _f),
          (N.times = ip),
          (N.toFinite = ed),
          (N.toInteger = Y),
          (N.toLength = td),
          (N.toLower = vf),
          (N.toNumber = nd),
          (N.toSafeInteger = id),
          (N.toString = X),
          (N.toUpper = yf),
          (N.trim = bf),
          (N.trimEnd = xf),
          (N.trimStart = Sf),
          (N.truncate = Cf),
          (N.unescape = wf),
          (N.uniqueId = op),
          (N.upperCase = Tf),
          (N.upperFirst = Ef),
          (N.each = El),
          (N.eachRight = B),
          (N.first = mc),
          Hf(
            N,
            (function () {
              var e = {};
              return (
                Qi(N, function (t, n) {
                  M.call(N.prototype, n) || (e[n] = t);
                }),
                e
              );
            })(),
            {
              chain: !1,
            },
          ),
          (N.VERSION = r),
          zn([`bind`, `bindKey`, `curry`, `curryRight`, `partial`, `partialRight`], function (e) {
            N[e].placeholder = N;
          }),
          zn([`drop`, `take`], function (e, t) {
            ((P.prototype[e] = function (r) {
              r = r === n ? 1 : fn(Y(r), 0);
              var i = this.__filtered__ && !t ? new P(this) : this.clone();
              return (
                i.__filtered__
                  ? (i.__takeCount__ = _n(r, i.__takeCount__))
                  : i.__views__.push({
                      size: _n(r, le),
                      type: e + (i.__dir__ < 0 ? `Right` : ``),
                    }),
                i
              );
            }),
              (P.prototype[e + `Right`] = function (t) {
                return this.reverse()[e](t).reverse();
              }));
          }),
          zn([`filter`, `map`, `takeWhile`], function (e, t) {
            var n = t + 1,
              r = n == ae || n == D;
            P.prototype[e] = function (e) {
              var t = this.clone();
              return (
                t.__iteratees__.push({
                  iteratee: R(e, 3),
                  type: n,
                }),
                (t.__filtered__ = t.__filtered__ || r),
                t
              );
            };
          }),
          zn([`head`, `last`], function (e, t) {
            var n = `take` + (t ? `Right` : ``);
            P.prototype[e] = function () {
              return this[n](1).value()[0];
            };
          }),
          zn([`initial`, `tail`], function (e, t) {
            var n = `drop` + (t ? `` : `Right`);
            P.prototype[e] = function () {
              return this.__filtered__ ? new P(this) : this[n](1);
            };
          }),
          (P.prototype.compact = function () {
            return this.filter(If);
          }),
          (P.prototype.find = function (e) {
            return this.filter(e).head();
          }),
          (P.prototype.findLast = function (e) {
            return this.reverse().find(e);
          }),
          (P.prototype.invokeMap = I(function (e, t) {
            return typeof e == `function`
              ? new P(this)
              : this.map(function (n) {
                  return ua(n, e, t);
                });
          })),
          (P.prototype.reject = function (e) {
            return this.filter(q(R(e)));
          }),
          (P.prototype.slice = function (e, t) {
            e = Y(e);
            var r = this;
            return r.__filtered__ && (e > 0 || t < 0)
              ? new P(r)
              : (e < 0 ? (r = r.takeRight(-e)) : e && (r = r.drop(e)),
                t !== n && ((t = Y(t)), (r = t < 0 ? r.dropRight(-t) : r.take(t - e))),
                r);
          }),
          (P.prototype.takeRightWhile = function (e) {
            return this.reverse().takeWhile(e).reverse();
          }),
          (P.prototype.toArray = function () {
            return this.take(le);
          }),
          Qi(P.prototype, function (e, t) {
            var r = /^(?:filter|find|map|reject)|While$/.test(t),
              i = /^(?:head|last)$/.test(t),
              a = N[i ? `take` + (t == `last` ? `Right` : ``) : t],
              o = i || /^find/.test(t);
            a &&
              (N.prototype[t] = function () {
                var t = this.__wrapped__,
                  s = i ? [1] : arguments,
                  c = t instanceof P,
                  l = s[0],
                  u = c || J(t),
                  d = function (e) {
                    var t = a.apply(N, Kn([e], s));
                    return i && f ? t[0] : t;
                  };
                u && r && typeof l == `function` && l.length != 1 && (c = u = !1);
                var f = this.__chain__,
                  p = !!this.__actions__.length,
                  m = o && !f,
                  h = c && !p;
                if (!o && u) {
                  t = h ? t : new P(this);
                  var g = e.apply(t, s);
                  return (
                    g.__actions__.push({
                      func: ll,
                      args: [d],
                      thisArg: n,
                    }),
                    new Jr(g, f)
                  );
                }
                return m && h
                  ? e.apply(this, s)
                  : ((g = this.thru(d)), m ? (i ? g.value()[0] : g.value()) : g);
              });
          }),
          zn([`pop`, `push`, `shift`, `sort`, `splice`, `unshift`], function (e) {
            var t = At[e],
              n = /^(?:push|sort|unshift)$/.test(e) ? `tap` : `thru`,
              r = /^(?:pop|shift)$/.test(e);
            N.prototype[e] = function () {
              var e = arguments;
              if (r && !this.__chain__) {
                var i = this.value();
                return t.apply(J(i) ? i : [], e);
              }
              return this[n](function (n) {
                return t.apply(J(n) ? n : [], e);
              });
            };
          }),
          Qi(P.prototype, function (e, t) {
            var n = N[t];
            if (n) {
              var r = n.name + ``;
              (M.call(or, r) || (or[r] = []),
                or[r].push({
                  name: t,
                  func: n,
                }));
            }
          }),
          (or[Lo(n, y).name] = [
            {
              name: `wrapper`,
              func: n,
            },
          ]),
          (P.prototype.clone = Yr),
          (P.prototype.reverse = Xr),
          (P.prototype.value = Zr),
          (N.prototype.at = ul),
          (N.prototype.chain = dl),
          (N.prototype.commit = fl),
          (N.prototype.next = pl),
          (N.prototype.plant = hl),
          (N.prototype.reverse = gl),
          (N.prototype.toJSON = N.prototype.valueOf = N.prototype.value = _l),
          (N.prototype.first = N.prototype.head),
          Xt && (N.prototype[Xt] = ml),
          N
        );
      })();
      typeof define == `function` && typeof define.amd == `object` && define.amd
        ? ((Tn._ = Br),
          define(function () {
            return Br;
          }))
        : Dn
          ? (((Dn.exports = Br)._ = Br), (En._ = Br))
          : (Tn._ = Br);
    }).call(e);
  });
(wh(), B());
var Th = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/`,
      formErrors: {},
    }),
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async getUnreadCount({ state: e, commit: t }) {
        return z({
          url: e.initURL + `chat/unread-count`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      async getChats({ state: e, commit: t }, n) {
        try {
          return await z({
            url: D(e.initURL + `chat`, n),
            method: `GET`,
          });
        } catch (e) {
          throw (V(e), e);
        }
      },
      async getChat({ state: e, commit: t }, n) {
        try {
          return await z({
            url: `${e.initURL}chat/${n}`,
            method: `GET`,
          });
        } catch (e) {
          throw (V(e), e);
        }
      },
      async createChat({ state: e, commit: t }, n) {
        try {
          return await z({
            url: e.initURL + `chat`,
            method: `POST`,
            data: n,
          });
        } catch (e) {
          throw (V(e), e);
        }
      },
      async createGroupChat({ state: e, commit: t }, n) {
        try {
          return await z({
            url: e.initURL + `chat/group`,
            method: `POST`,
            data: n,
          });
        } catch (e) {
          throw (V(e), e);
        }
      },
      async getMessages({ state: e, commit: t }, n) {
        try {
          return await z({
            url: `${e.initURL}chat/${n.uuid}/messages?cursor=${n.cursor}`,
            method: `GET`,
          });
        } catch (e) {
          throw (V(e), e);
        }
      },
      async sendMessage({ state: e, commit: t }, { uuid: n, message: r }) {
        try {
          return await z({
            url: `${e.initURL}chat/${n}/messages`,
            method: `POST`,
            data: r,
          });
        } catch (e) {
          throw (V(e), e);
        }
      },
      async sendVoiceMessage({ state: e, commit: t }, n) {
        try {
          return await z({
            url: `${e.initURL}chat/${n.uuid}/messages`,
            method: `POST`,
            upload: !0,
            data: n.data,
          });
        } catch (e) {
          throw (V(e), e);
        }
      },
      async markAsRead({ state: e, commit: t }, n) {
        try {
          return await z({
            url: `${e.initURL}chat/${n}/read`,
            method: `POST`,
          });
        } catch (e) {
          throw e;
        }
      },
      async deleteChat({ state: e, commit: t }, n) {
        try {
          return await z({
            url: `${e.initURL}chat/${n}`,
            method: `DELETE`,
          });
        } catch (e) {
          throw (V(e), e);
        }
      },
      async searchUsers({ state: e, commit: t }, n) {
        try {
          return await z({
            url: `${e.initURL}chat/users`,
            method: `GET`,
            params: {
              query: n.query,
              chat: n.chatUuid,
            },
          });
        } catch (e) {
          throw e;
        }
      },
      async updateGroupInfo({ state: e, commit: t }, n) {
        return z({
          url: `${e.initURL}chat/${n.chatUuid}/group/info`,
          method: `POST`,
          data: {
            name: n.name,
            description: n.description,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async updateGroupConfig({ state: e, commit: t }, n) {
        return z({
          url: `${e.initURL}chat/${n.chatUuid}/group/config`,
          method: `POST`,
          data: n.config,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async addGroupParticipant({ state: e, commit: t }, { chatUuid: n, userUuid: r }) {
        return z({
          url: `${e.initURL}chat/${n}/group/participants`,
          method: `POST`,
          data: {
            user: r,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async removeGroupParticipant({ state: e, commit: t }, { chatUuid: n, userUuid: r }) {
        return (
          console.log(n, r),
          z({
            url: `${e.initURL}chat/${n}/group/participants/${r}`,
            method: `DELETE`,
          })
            .then((e) => e)
            .catch((e) => {
              throw (V(e), e);
            })
        );
      },
      async makeAdmin({ state: e, commit: t }, n) {
        return z({
          url: `${e.initURL}chat/${n.chatUuid}/group/make-admin`,
          method: `POST`,
          data: {
            user: n.userUuid,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async removeAdmin({ state: e, commit: t }, n) {
        return z({
          url: `${e.initURL}chat/${n.chatUuid}/group/remove-admin`,
          method: `POST`,
          data: {
            user: n.userUuid,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Eh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/custom-fields`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Dh = B(),
  Oh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/utility/todos`,
      optionURL: `/app/options`,
      todos: {},
      todo: {},
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
      SET_TODOS: (e, t) => {
        e.todos = t;
      },
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite: U.preRequisite,
      list: U.list,
      get: U.get,
      create: U.create,
      update: U.update,
      delete: U.delete,
      resetState: U.resetState,
      async status({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
        })
          .then((e) => {
            Dh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async archive({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/archive`,
          method: `POST`,
        })
          .then((e) => {
            Dh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unarchive({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unarchive`,
          method: `POST`,
        })
          .then((e) => {
            Dh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            Dh.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async addList({ state: e, commit: t }, n) {
        return await z({
          url: e.optionURL + `?type=todo_list`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorderList({ state: e, commit: t }, n) {
        await z({
          url: e.optionURL + `/reorder?type=todo_list`,
          method: `POST`,
          data: n,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async moveList({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/lists/move`,
          method: `POST`,
          data: n,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorderItems({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
      listTodos: (e) => e.todos,
    },
  };
B();
var kh = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      todo: Oh,
      activityLog: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/utility/activity-logs`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          list: U.list,
          resetState: U.resetState,
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  Ah = B(),
  jh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/options`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      resetState: U.resetState,
      preRequisite: U.preRequisite,
      list({ state: e, commit: t }, n) {
        return (
          n.queryType != null && (n.params.type = n.queryType),
          Js(e.initURL, n.params)
            .then((e) => e)
            .catch((e) => {
              throw (V(e), e);
            })
        );
      },
      async get({ state: e, commit: t }, n) {
        return await Xs(e.initURL, n.uuid, {
          type: n.queryType,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async create({ state: e, commit: t }, n) {
        await Ys(e.initURL, n.form, {
          type: n.queryType,
        })
          .then((e) => {
            Ah.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async update({ state: e, commit: t }, n) {
        await Zs(e.initURL, n.uuid, n.form, {
          type: n.queryType,
        })
          .then((e) => {
            Ah.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async delete({ state: e, commit: t }, n) {
        await Qs(e.initURL, n.uuid, {
          type: n.queryType,
        })
          .then((e) => {
            Ah.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Ah.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Mh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/tags`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Nh = B(),
  Ph = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/comments`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async store({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL,
          method: `POST`,
          data: n,
        })
          .then((e) => (Nh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Fh = B(),
  Ih = (e = {}) => {
    if (e.studentUuid) return `students/${e.studentUuid}`;
    if (e.employeeUuid) return `employees/${e.employeeUuid}`;
    throw Error(`Missing entity uuid for note endpoint`);
  },
  Lh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/notes`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async fetch({ commit: e }, t) {
        return await z({
          url: `/app/${Ih(t)}/notes`,
          method: `GET`,
          params: t.params,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async store({ commit: e }, t) {
        return await z({
          url: `/app/${Ih(t)}/notes`,
          method: `POST`,
          data: {
            body: t.body,
            visibility: t.visibility,
          },
        })
          .then((e) => (Fh.success(e.message), e))
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      async destroy({ commit: e }, t) {
        return await z({
          url: `/app/${Ih(t)}/notes/${t.uuid}`,
          method: `DELETE`,
        })
          .then((e) => (Fh.success(e.message), e))
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var Rh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/notifications`,
      notifications: {
        data: [],
        meta: {},
      },
      unreadCount: 0,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
      SET_NOTIFICATIONS(e, t) {
        e.notifications = t;
      },
      SET_UNREAD_COUNT(e, t) {
        e.unreadCount = t;
      },
    },
    actions: {
      list({ state: e, commit: t }, n) {
        return Js(e.initURL, n.params)
          .then((e) => (t(`SET_NOTIFICATIONS`, e), t(`SET_UNREAD_COUNT`, e.meta.unreadCount), e))
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async markAsRead({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/mark-as-read`,
          method: `POST`,
        })
          .then((n) => {
            t(`SET_UNREAD_COUNT`, e.unreadCount - 1);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async markAllAsRead({ state: e, commit: t }) {
        await z({
          url: e.initURL + `/mark-all-as-read`,
          method: `POST`,
        })
          .then((e) => {
            t(`SET_UNREAD_COUNT`, 0);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
      notifications: (e) => e.notifications,
      unreadCount: (e) => e.unreadCount,
    },
  },
  zh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reminders`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var Bh = {
    namespaced: !0,
    state: () => ({
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: `app/` + n.url,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Vh = B(),
  Hh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      history({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + n.path,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      deleteHistory({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + n.path + `/` + n.uuid,
          method: `DELETE`,
        })
          .then((e) => (Vh.success(e.message), e))
          .catch((e) => {
            throw (V(e), e);
          });
      },
      upload({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + n.path,
          method: `POST`,
          data: n.data,
          upload: !0,
        })
          .then((e) => (t(`SET_FORM_ERRORS`, {}), Vh.success(e.message), e))
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {},
  };
B();
var Uh = {
  namespaced: !0,
  state: () => ({
    initURL: `/app/support`,
    formErrors: {},
  }),
  modules: {},
  mutations: {
    ...H,
  },
  actions: {
    async generateToken({ state: e, commit: t }) {
      return await z({
        url: e.initURL + `/token`,
        method: `POST`,
      })
        .then((e) => e)
        .catch((e) => {
          throw (t(`SET_FORM_ERRORS`, V(e)), e);
        });
    },
  },
  getters: {
    ...W,
  },
};
B();
var Wh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/subscriptions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async calculate({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/calculate`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async initiate({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/initiate`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async fail({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/fail`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Gh = B(),
  Kh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/online-enquiry`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/pre-requisite`, n),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPrograms({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/programs`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPeriods({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/periods`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getCourses({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.period + `/courses?program=` + n.program,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getBatches({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.period + `/` + n.course + `/batches`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async create({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Gh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  qh = B(),
  Jh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/online-registrations`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/pre-requisite`, n),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPrograms({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/programs`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPeriods({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/periods`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getCourses({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.period + `/courses?program=` + n.program,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getBatches({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.period + `/` + n.course + `/batches`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async initiate({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (qh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async initiateMinimal({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/minimal`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (qh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async confirm({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/confirm`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (qh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async find({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/find`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async verify({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/verify`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getRegistration({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return await z({
          url: e.initURL + `/` + n.number,
          method: `GET`,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateBasic({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return await z({
          url: e.initURL + `/` + n.uuid + `/basic`,
          method: `PATCH`,
          data: n.form,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => {
            qh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateContact({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return await z({
          url: e.initURL + `/` + n.uuid + `/contact`,
          method: `PATCH`,
          data: n.form,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => {
            qh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async uploadFile({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return await z({
          url: e.initURL + `/` + n.uuid + `/upload`,
          method: `POST`,
          data: n.form,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => (qh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateReview({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return await z({
          url: e.initURL + `/` + n.uuid + `/review`,
          method: `PATCH`,
          data: n.form,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => {
            qh.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async paymentPreRequisite({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return z({
          url: e.initURL + `/` + n.uuid + `/payment/pre-requisite`,
          method: `GET`,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async initiatePayment({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return await z({
          url: e.initURL + `/` + n.uuid + `/payment/initiate`,
          method: `POST`,
          data: n,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async completePayment({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return await z({
          url: e.initURL + `/` + n.uuid + `/payment/complete`,
          method: `POST`,
          data: n,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => (qh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async failPayment({ state: e, commit: t }, n) {
        let r = localStorage.getItem(`authToken`);
        return await z({
          url: e.initURL + `/` + n.uuid + `/payment/fail`,
          method: `POST`,
          data: n,
          headers: {
            "auth-token": r,
          },
        })
          .then((e) => (qh.error(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Yh = B(),
  Xh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/guest-registration-payments`,
      anonymousInitURL: `/app/anonymous-payments`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPaymentDetail({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/fee-detail`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getAnonymousPaymentDetail({ state: e, commit: t }, n) {
        return z({
          url: e.anonymousInitURL + `/fee-detail`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async initiatePayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/initiate`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async completePayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/complete`,
          method: `POST`,
          data: n,
        })
          .then((e) => (Yh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async failPayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/fail`,
          method: `POST`,
          data: n,
        })
          .then((e) => (Yh.error(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Zh = B(),
  Qh = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/guest-payments`,
      anonymousInitURL: `/app/anonymous-payments`,
      formErrors: {},
    }),
    modules: {
      registration: Xh,
    },
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPeriods({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/periods`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getCourses({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/` + n.period + `/courses`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPaymentDetail({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/fee-detail`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getAnonymousPaymentDetail({ state: e, commit: t }, n) {
        return z({
          url: e.anonymousInitURL + `/fee-detail`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async initiatePayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/initiate`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async completePayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/complete`,
          method: `POST`,
          data: n,
        })
          .then((e) => (Zh.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async failPayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/fail`,
          method: `POST`,
          data: n,
        })
          .then((e) => (Zh.error(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  $h = B(),
  eg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/guest/student/verification`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPeriods({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/periods`,
          method: `GET`,
          params: {
            action: n.action,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getCourses({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.team + `/` + n.period + `/courses`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getStudentDetail({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/detail`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async generateOtp({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/generate-otp`,
          method: `POST`,
          data: n,
        })
          .then((e) => {
            $h.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  tg = B(),
  ng = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/guest/student/photo`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async uploadPhoto({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n,
        })
          .then((e) => {
            tg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var rg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transfer-certificate`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async verify({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/verify`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  ig = B(),
  ag = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/enquiries`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async showGuardians({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/guardians`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async showDocuments({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/documents`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async showQualifications({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/qualifications`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateStatus({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            ig.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateDetail({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/detail?tab=` + n.form.tab,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            ig.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async convertToRegistration({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/registration`,
          method: `POST`,
        })
          .then((e) => {
            ig.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async bulkConvertToRegistration({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/registration`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            ig.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async removeFollowUp({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/follow-ups/` + n.moduleUuid,
          method: `DELETE`,
        })
          .then((e) => {
            ig.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            ig.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async updateBulkAssignTo({ state: e, commit: t }, n) {
        let r = e.initURL + `/assign`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              ig.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkStage({ state: e, commit: t }, n) {
        let r = e.initURL + `/stage`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              ig.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkType({ state: e, commit: t }, n) {
        let r = e.initURL + `/type`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              ig.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkSource({ state: e, commit: t }, n) {
        let r = e.initURL + `/source`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              ig.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
    },
    getters: {
      ...W,
    },
  },
  og = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/enquiries`,
      module: `/qualifications`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  sg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/enquiries`,
      module: `/documents`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  cg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/enquiries`,
      module: `/follow-ups`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  lg = B(),
  ug = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/visitor-logs`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async markExit({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/exit`,
          method: `POST`,
        })
          .then((e) => {
            lg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  dg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/gate-passes`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  fg = B(),
  pg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/complaints`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assign({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (fg.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unassign({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/unassign/` + n.moduleUuid,
          method: `POST`,
        })
          .then((e) => (fg.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async addLog({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/logs`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (fg.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async removeLog({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/logs/` + n.moduleUuid,
          method: `POST`,
        })
          .then((e) => (fg.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  mg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/call-logs`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  hg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/reception/correspondences`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  gg = B(),
  _g = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      enquiry: ag,
      enquiryQualification: og,
      enquiryDocument: sg,
      enquiryFollowUp: cg,
      visitorLog: ug,
      gatePass: dg,
      complaint: pg,
      callLog: mg,
      correspondence: hg,
      query: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/reception/queries`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
          async action({ state: e, commit: t }, n) {
            return await z({
              url: e.initURL + `/` + n.uuid + `/action`,
              method: `POST`,
              data: n.form,
            })
              .then((e) => (gg.success(e.message), e))
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  vg = B(),
  yg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/departments`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      updateConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            vg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            vg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  bg = B(),
  xg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/department-incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assignPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign/pre-requisite`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async assign({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            bg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Sg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/program-types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Cg = B(),
  wg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/programs`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      updateConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Cg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Cg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Tg = B(),
  Eg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/program-incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assignPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign/pre-requisite`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async assign({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Tg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Dg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/sessions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Og = B(),
  kg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/periods`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      list: U.list,
      preRequisite: U.preRequisite,
      get: U.get,
      delete: U.delete,
      async create({ state: e, commit: t, dispatch: n }, r) {
        (await Ys(e.initURL, r.form)
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          }),
          await n(`config/get`, !1, {
            root: !0,
          }),
          await n(`auth/user/fetch`, !1, {
            root: !0,
          }));
      },
      async select({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/select`,
          method: `POST`,
          data: null,
        })
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async default({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/default`,
          method: `POST`,
          data: null,
        })
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async archive({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/archive`,
          method: `POST`,
        })
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unarchive({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unarchive`,
          method: `POST`,
        })
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async lockExam({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/lock-exam`,
          method: `POST`,
        })
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unlockExam({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unlock-exam`,
          method: `POST`,
        })
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async update({ state: e, commit: t, dispatch: n }, r) {
        (await Zs(e.initURL, r.uuid, r.form)
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          }),
          await n(`config/get`, !1, {
            root: !0,
          }),
          await n(`auth/user/fetch`, !1, {
            root: !0,
          }));
      },
      async storeConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async import({ state: e, commit: t, dispatch: n }, r) {
        await z({
          url: e.initURL + `/` + r.uuid + `/import`,
          method: `POST`,
          data: r.form,
        })
          .then((e) => {
            Og.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Ag = B(),
  jg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/divisions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      updateConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ag.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Ag.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateCurrentPeriod({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/period`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ag.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async createChatGroup({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/chat-group`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ag.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Mg = B(),
  Ng = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/division-incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assignPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign/pre-requisite`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async assign({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Mg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Pg = B(),
  Fg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/courses`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      updateConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Pg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async addBatches({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/batches`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Pg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Pg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorderBatch({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder-batch`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Pg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateCurrentPeriod({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/period`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Pg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateEnrollmentSeat({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/enrollment-seat`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Pg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Ig = B(),
  Lg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/course-incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assignPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign/pre-requisite`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async assign({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ig.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Rg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/enrollment-seats`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  zg = B(),
  Bg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/batches`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      listSubjects({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/subjects`,
          method: `GET`,
        })
          .then((e) => e.data)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            zg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateCurrentPeriod({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/period`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            zg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      getOptionalFeeHeads({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/optional-fee-heads`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorderSubject({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder-subject`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            zg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Vg = B(),
  Hg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/batch-incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assignPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign/pre-requisite`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async assign({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Vg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Ug = B(),
  Wg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/subjects`,
      module: `/records`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      updateFee({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ug.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  Gg = B(),
  Kg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/subject/groups`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Gg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async syncSubjects({ state: e, commit: t }, n) {
        return await z({
          url: `${e.initURL}/${n.uuid}/subjects`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Gg.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  qg = B(),
  Jg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/subjects`,
      formErrors: {},
    }),
    modules: {
      subjectRecord: Wg,
      subjectGroup: Kg,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      allocation({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/allocation`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            qg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            qg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async setupPreRequisite({ commit: e }) {
        return await z({
          url: `/app/academic/subject/setup/pre-requisite`,
          method: `GET`,
        }).catch((t) => {
          throw (e(`SET_FORM_ERRORS`, V(t)), t);
        });
      },
      async setupAssign({ commit: e }, t) {
        return await z({
          url: `/app/academic/subject/setup/assign`,
          method: `POST`,
          data: t.form,
        })
          .then((e) => (qg.success(e.message), e))
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      async setupReorder({ commit: e }, t) {
        return await z({
          url: `/app/academic/subject/setup/reorder`,
          method: `POST`,
          data: t.form,
        })
          .then((e) => (qg.success(e.message), e))
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Yg = B(),
  Xg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/subject-incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assignPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign/pre-requisite`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async assign({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Yg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Zg = B(),
  Qg = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/batch-subject-incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      async assignPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign/pre-requisite`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async assign({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Zg.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  $g = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/class-timings`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  e_ = B(),
  t_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/timetables`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async allocationPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/allocation/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async allocation({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/allocation`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            e_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async generationPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: `/app/academic/timetable-groups/` + n.uuid + `/generation/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  n_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/timetable/groups`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var r_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/book-lists`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  i_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/certificate-templates`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  a_ = B(),
  o_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/certificates`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async cancel({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/cancel`,
          method: `POST`,
        })
          .then((e) => {
            a_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  s_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/academic/id-card-templates`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var c_ = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      department: yg,
      departmentIncharge: xg,
      programType: Sg,
      program: wg,
      programIncharge: Eg,
      session: Dg,
      period: kg,
      division: jg,
      divisionIncharge: Ng,
      course: Fg,
      courseIncharge: Lg,
      enrollmentSeat: Rg,
      batch: Bg,
      batchIncharge: Hg,
      subject: Jg,
      subjectIncharge: Xg,
      batchSubjectIncharge: Qg,
      classTiming: $g,
      timetable: t_,
      timetableGroup: n_,
      bookList: r_,
      certificateTemplate: i_,
      certificate: o_,
      idCardTemplate: s_,
      idCard: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/academic/id-cards`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
          printPreRequisite({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/pre-requisite`,
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          print({ state: e, commit: t }, n) {
            let r = e.initURL;
            return z({
              url: D(r, n.params),
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  l_ = B(),
  u_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/registrations`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async showGuardians({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/guardians`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async showQualifications({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/qualifications`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async showDocuments({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/documents`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateDetail({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/detail?tab=` + n.form.tab,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      paymentPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/payment/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      actionPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/action/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      skipPayment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/skip-payment`,
          method: `POST`,
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      payment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/payment`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      cancelPayment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/payment/` + n.moduleUuid,
          method: `DELETE`,
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async anonymousPayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/payment/initiate`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      assignFeePreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/assign-fee/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      assignFee({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/assign-fee`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      verify({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/verify`,
          method: `POST`,
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      undoReject({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/undo-reject`,
          method: `POST`,
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      action({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            l_.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async updateBulkAssignTo({ state: e, commit: t }, n) {
        let r = e.initURL + `/assign`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              l_.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkStage({ state: e, commit: t }, n) {
        let r = e.initURL + `/stage`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              l_.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
    },
    getters: {
      ...W,
    },
  },
  d_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/registrations`,
      module: `/documents`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  f_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/registrations`,
      module: `/qualifications`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  p_ = B(),
  m_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/roll-number`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            p_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  h_ = B(),
  g_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/bulk-edit/address`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            h_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  __ = B(),
  v_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/bulk-edit/rte`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            __.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  y_ = B(),
  b_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/photo`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            y_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  x_ = B(),
  S_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/health-record`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      batchWiseRecord({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/` + n.batch + `/record`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            x_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  C_ = B(),
  w_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/subject`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            C_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  T_ = B(),
  E_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/attendance`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            T_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/remove`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            T_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      sendNotification({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/send-notification`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            T_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      migrate({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/migrate`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            T_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  D_ = B(),
  O_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/fee-allocation`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      allocate({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            D_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      allocateFeeConcession({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/fee-concession`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            D_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/remove`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            D_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  k_ = B(),
  A_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/service-allocation`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      allocate({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            k_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/remove`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            k_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  j_ = B(),
  M_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/promotion`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      promote({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            j_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  N_ = B(),
  P_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/edit-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (N_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  F_ = B(),
  I_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/service-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async updateStatus({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (F_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  L_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/leave-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  R_ = B(),
  z_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/transfer-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (R_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  B_ = B(),
  V_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/transfers`,
      subInitURL: `/app/student/transfer/approval-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      approvalRequests({ state: e, commit: t }, n) {
        return Js(e.initURL, n.params)
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      media({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/media`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            B_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getPeriods({ state: e, commit: t }, n) {
        return z({
          url: `/app/academic/periods?all=true&team=` + n.team,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getCourses({ state: e, commit: t }, n) {
        return z({
          url: `/app/academic/courses?all=true&period=` + n.period,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var H_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/transfer/approval-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  U_ = B(),
  W_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/timesheets`,
      subURL: `/app/student/timesheet`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.subURL + `/batch/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      batchWiseStore({ state: e, commit: t }, n) {
        return z({
          url: e.subURL + `/batch`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            U_.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async check({ state: e, commit: t }, n) {
        return z({
          url: e.subURL + `/check`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async clock({ state: e, commit: t }, n) {
        return await z({
          url: e.subURL + `/clock`,
          method: `POST`,
          data: n,
        })
          .then((e) => (U_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async sync({ state: e, commit: t }, n) {
        return await z({
          url: D(e.subURL + `/sync`, n.params),
          method: `POST`,
          data: n,
        })
          .then((e) => (U_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var G_ = () => ({
    initURL: `/app/student/reports`,
    formErrors: {},
  }),
  K_ = {
    namespaced: !0,
    state: G_,
    modules: {},
    mutations: {
      SET_FORM_ERRORS: (e, t = {}) => {
        e.formErrors = t;
      },
      RESET_STATE: (e) => {
        e = G_;
      },
    },
    actions: {
      resetFormErrors({ commit: e }) {
        e(`SET_FORM_ERRORS`);
      },
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.name + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async fetchReport({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/` + n.name, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      resetState({ commit: e }) {
        e(`RESET_STATE`);
      },
    },
    getters: {
      getFormErrors: (e) => e.formErrors,
    },
  },
  q_ = B(),
  J_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/accounts`,
      subUrl: `/app/students`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async makePrimary({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/accounts/` + n.moduleUuid + `/make-primary`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (q_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/accounts/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (q_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Y_ = B(),
  X_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/documents`,
      subUrl: `/app/students`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/documents/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Y_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Z_ = B(),
  Q_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/qualifications`,
      subUrl: `/app/students`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/qualifications/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Z_.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  $_ = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/config/attendance-types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  ev = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/config/houses`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  tv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/student/config/document-types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  nv = B(),
  rv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/guardians`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async makePrimary({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + e.module + `/` + n.moduleUuid + `/make-primary`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (nv.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  iv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/siblings`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  av = B(),
  ov = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/records`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async cancelAdmission({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/admission`,
          method: `DELETE`,
        })
          .then((e) => {
            av.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async cancelPromotion({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/promotion`,
          method: `DELETE`,
        })
          .then((e) => {
            av.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async cancelAlumni({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/alumni`,
          method: `DELETE`,
        })
          .then((e) => {
            av.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async setDefaultPeriod({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/default-period`,
          method: `POST`,
        })
          .then((e) => {
            av.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  sv = B(),
  cv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async fetch({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async list({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/list?type=` + n.type + `&date=` + n.date,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async transportPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/transport-pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      set({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      update({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee`,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      reset({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee`,
          method: `DELETE`,
        })
          .then((e) => {
            sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      lockUnlock({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/lock-unlock`,
          method: `POST`,
          data: {
            action: n.action,
          },
        })
          .then((e) => {
            sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateInstallment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/` + n.moduleUuid,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getStudentFees({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fees`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getSiblingFees({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/sibling-fees`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async setCustomConcession({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/custom-concession`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async setOptionalFee({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/optional-fee`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async setTransportFee({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/transport-fee`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  lv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/custom-fees`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  uv = B(),
  dv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/fee-refunds`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      cancel({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + e.module + `/` + n.moduleUuid + `/cancel`,
          method: `POST`,
        })
          .then((e) => {
            uv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  fv = B(),
  pv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async preRequisite({ state: e, commit: t }, n) {
        let r = n.type || `payment`;
        return z({
          url: e.initURL + `/` + n.uuid + `/payment/pre-requisite?type=` + r,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      makePayment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/payment`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (fv.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      bankTransfer({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/bank-transfer`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      bankTransferAction({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/bank-transfers/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      makeHeadWisePayment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/head-wise-payment`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      makeMultiHeadPayment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/multi-head-wise-payment`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updatePayment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/payment/` + n.moduleUuid,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      cancelPayment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/cancel-payment/` + n.moduleUuid,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async initiatePayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/online-payment/initiate`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async completePayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/online-payment/complete`,
          method: `POST`,
          data: n,
        })
          .then((e) => (fv.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async failPayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/online-payment/fail`,
          method: `POST`,
          data: n,
        })
          .then((e) => (fv.error(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updatePaymentStatus({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/online-payment/` + n.moduleUuid + `/status`,
          method: `POST`,
        })
          .then((e) => {
            fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      refreshSelfPayment({ state: e, commit: t }, n) {
        return z({
          url:
            e.initURL + `/` + n.uuid + `/online-payment/` + n.moduleUuid + `/refresh-self-payment`,
          method: `POST`,
        })
          .then((e) => {
            fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async anonymousPayment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/payment/initiate`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var mv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/wallet/transactions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  hv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/dialogues`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  gv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/accounts`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  _v = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/documents`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  vv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/qualifications`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  yv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      module: `/edit-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  bv = B(),
  xv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/record/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      fetchRecord({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/` + n.uuid + `/record/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      updateRecord({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/record/change`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            bv.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Sv = B(),
  Cv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/students`,
      formErrors: {},
    }),
    modules: {
      registration: u_,
      registrationDocument: d_,
      registrationQualification: f_,
      rollNumber: m_,
      bulkEditAddress: g_,
      bulkEditRte: v_,
      photo: b_,
      healthRecord: S_,
      subject: w_,
      attendance: E_,
      feeAllocation: O_,
      serviceAllocation: A_,
      promotion: M_,
      editRequest: P_,
      serviceRequest: I_,
      leaveRequest: L_,
      transferRequest: z_,
      transfer: V_,
      transferApprovalRequest: H_,
      timesheet: W_,
      report: K_,
      accounts: J_,
      documents: X_,
      qualifications: Q_,
      attendanceType: $_,
      house: ev,
      documentType: tv,
      guardian: rv,
      sibling: iv,
      record: ov,
      fee: cv,
      customFee: lv,
      feeRefund: dv,
      payment: pv,
      walletTransaction: mv,
      dialogue: hv,
      account: gv,
      document: _v,
      qualification: vv,
      profileEditRequest: yv,
      changeRecord: xv,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      getSummary({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/summary`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      getStudentSummary({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/summary`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      summary({ state: e, commit: t }, n) {
        return Js(e.initURL + `/list`, n.params)
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      listAll({ state: e, commit: t }, n) {
        return Js(e.initURL + `/list-all`, n.params)
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      updatePhotoStatus({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/photo/status`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      fetchAttendance({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/attendance`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      fetchExamReport({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/exam-report`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      fetchSubject({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/subject`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      updateElectiveSubjects({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/subject`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      getFeeSummary({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/fee/summary`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async updateBulkTag({ state: e, commit: t }, n) {
        let r = e.initURL + `/tags`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Sv.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateTags({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/tags`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateBulkGroup({ state: e, commit: t }, n) {
        let r = e.initURL + `/groups`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Sv.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkHouse({ state: e, commit: t }, n) {
        let r = e.initURL + `/house`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Sv.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkMentor({ state: e, commit: t }, n) {
        let r = e.initURL + `/mentor`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Sv.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkEnrollmentType({ state: e, commit: t }, n) {
        let r = e.initURL + `/enrollment-type`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Sv.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkEnrollmentStatus({ state: e, commit: t }, n) {
        let r = e.initURL + `/enrollment-status`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Sv.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkBatch({ state: e, commit: t }, n) {
        let r = e.initURL + `/batch`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Sv.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      getIdCardTemplates({ commit: e }) {
        return z({
          url: `/app/academic/id-cards/student-templates`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      async printIdCard({ commit: e }, t) {
        return await z({
          url: D(`/app/academic/id-cards`, t.form),
          method: `GET`,
        })
          .then((e) => e)
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      confirmUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user/confirm`,
          method: `POST`,
          data: {
            email: n.form.email,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      getUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      createUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            Sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateCurrentPeriod({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/period`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Sv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  wv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/payment-methods`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Tv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/fee-groups`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Ev = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/fee-heads`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Dv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/fee-components`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Ov = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/fee-concessions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  kv = B(),
  Av = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/fee-structures`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async printPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: `app/finance/fee-structure/print/pre-requisite`,
          method: `GET`,
          params: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      getOptionalFeeHeads({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/optional-fee-heads`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      allocation({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/allocation`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            kv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      removeAllocation({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/allocations/` + n.moduleUuid,
          method: `DELETE`,
        })
          .then((e) => {
            kv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            kv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      getInstallment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/installments/` + n.moduleUuid,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      addInstallment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/installments`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            kv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateInstallment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/installments/` + n.moduleUuid,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            kv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      deleteInstallment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/installments/` + n.moduleUuid,
          method: `DELETE`,
        })
          .then((e) => {
            kv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  jv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/fee-structure-components`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Mv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/ledger-types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Nv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/ledgers`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Pv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/taxes`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Fv = B(),
  Iv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/transactions`,
      subInitUrl: `/app/finance`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async markDayClosure({ state: e, commit: t }, n) {
        await z({
          url: e.subInitUrl + `/day-closure`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateClearingDate({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/clearing-date`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Fv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var Lv = {
  namespaced: !0,
  state: () => ({
    initURL: `/app/finance/receipts`,
    formErrors: {},
  }),
  modules: {},
  mutations: {
    ...H,
  },
  actions: {
    ...U,
  },
  getters: {
    ...W,
  },
};
B();
var Rv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/finance/day-closures`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async getDateWiseCollection({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/date-wise-collection`,
          method: `POST`,
          data: n,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  zv = B(),
  Bv = () => ({
    initURL: `/app/finance/reports`,
    formErrors: {},
  }),
  Vv = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      paymentMethod: wv,
      feeGroup: Tv,
      feeHead: Ev,
      feeComponent: Dv,
      feeConcession: Ov,
      feeStructure: Av,
      feeStructureComponent: jv,
      ledgerType: Mv,
      ledger: Nv,
      tax: Pv,
      transaction: Iv,
      receipt: Lv,
      dayClosure: Rv,
      report: {
        namespaced: !0,
        state: Bv,
        modules: {},
        mutations: {
          SET_FORM_ERRORS: (e, t = {}) => {
            e.formErrors = t;
          },
          RESET_STATE: (e) => {
            e = Bv;
          },
        },
        actions: {
          resetFormErrors({ commit: e }) {
            e(`SET_FORM_ERRORS`);
          },
          async preRequisite({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/` + n.name + `/pre-requisite`,
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (V(e), e);
              });
          },
          async fetchReport({ state: e, commit: t }, n) {
            return z({
              url: D(e.initURL + `/` + n.name, n.params),
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          async sendFeeReminder({ state: e, commit: t }, n) {
            return z({
              url: D(e.initURL + `/` + n.name, n.params),
              method: `POST`,
              data: n.data,
            })
              .then((e) => {
                zv.success(e.message);
              })
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          resetState({ commit: e }) {
            e(`RESET_STATE`);
          },
        },
        getters: {
          getFormErrors: (e) => e.formErrors,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  Hv = B(),
  Uv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/terms`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Hv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Wv = B(),
  Gv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/grades`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      storeConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Wv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Kv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/assessments`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  qv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/observations`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Jv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/competencies`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Yv = B(),
  Xv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/schedules`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      storeConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      copyToCourse({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/copy`,
          method: `POST`,
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateForm({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/form`,
          method: `PATCH`,
          data: {
            value: n.value,
          },
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unprocessMarksheet({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unprocess`,
          method: `POST`,
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      togglePublishAdmitCard({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/toggle-publish-admit-card`,
          method: `PATCH`,
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      confirmForm({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/form/confirm`,
          method: `POST`,
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      submitForm({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/form`,
          method: `POST`,
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      printExamForm({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/form/print`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      unlockTemporarily({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/unlock-temporarily/`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      unlockRecordTemporarily({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/unlock-temporarily/` + n.recordUuid,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Yv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Zv = B(),
  Qv = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/forms`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async updateStatus({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Zv.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      printExamForm({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/print`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      printAdmitCard({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/print-admit-card`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  $v = B(),
  ey = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/online-exams`,
      module: `/questions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/questions/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            $v.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  ty = B(),
  ny = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/online-exams`,
      module: `/submissions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async getQuestions({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/submissions/` + n.moduleUuid + `/questions`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async evaluate({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/submissions/` + n.moduleUuid + `/evaluate`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            ty.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  ry = B(),
  iy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/online-exams`,
      formErrors: {},
    }),
    modules: {
      question: ey,
      submission: ny,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async getLiveQuestions({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/live-questions`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async startSubmission({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/start`,
          method: `POST`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async submit({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/submit`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (e.message && ry.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async finishSubmission({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/finish-submit`,
          method: `POST`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async status({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            ry.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var ay = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/admit-card`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetchReport({ state: e, commit: t }, n) {
        let r = e.initURL;
        return z({
          url: D(r, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  oy = B(),
  sy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/records`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      updateExamRecord({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            oy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  cy = B(),
  ly = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/mark`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            cy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `DELETE`,
          data: n.form,
        })
          .then((e) => {
            cy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  uy = B(),
  dy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/mark/record`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            uy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `DELETE`,
          data: n.form,
        })
          .then((e) => {
            uy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  fy = B(),
  py = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/observation-mark`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            fy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `DELETE`,
          data: n.form,
        })
          .then((e) => {
            fy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  my = B(),
  hy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/competency-evaluation`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            my.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `DELETE`,
          data: n.form,
        })
          .then((e) => {
            my.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  gy = B(),
  _y = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/comment`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            gy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `DELETE`,
          data: n.form,
        })
          .then((e) => {
            gy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  vy = B(),
  yy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/attendance`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            vy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      remove({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `DELETE`,
          data: n.form,
        })
          .then((e) => {
            vy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var by = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/reports`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.name + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async fetchReport({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/` + n.name, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  xy = B(),
  Sy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exam/marksheet`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      processPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/process/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      printPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/print/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      process({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/process`, n.params),
          method: `GET`,
        })
          .then((e) => (xy.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      print({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/print`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetchReport({ state: e, commit: t }, n) {
        let r = e.initURL;
        return z({
          url: D(r, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Cy = B(),
  wy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/exams`,
      formErrors: {},
    }),
    modules: {
      term: Uv,
      grade: Gv,
      assessment: Kv,
      observation: qv,
      competency: Jv,
      schedule: Xv,
      form: Qv,
      onlineExam: iy,
      admitCard: ay,
      record: sy,
      mark: ly,
      markRecord: dy,
      observationMark: py,
      competencyEvaluation: hy,
      comment: _y,
      attendance: yy,
      report: by,
      marksheet: Sy,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async setupPreRequisite({ commit: e }) {
        return await z({
          url: `/app/exam/setup/pre-requisite`,
          method: `GET`,
        }).catch((t) => {
          throw (e(`SET_FORM_ERRORS`, V(t)), t);
        });
      },
      async setupList({ commit: e }) {
        return await z({
          url: `/app/exam/setup/list`,
          method: `GET`,
        }).catch((t) => {
          throw (e(`SET_FORM_ERRORS`, V(t)), t);
        });
      },
      storeConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Cy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Cy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Ty = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/config/document-types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Ey = B(),
  Dy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/bulk-edit/address`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      fetch({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      store({ state: e, commit: t }, n) {
        return z({
          url: e.initURL,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ey.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Oy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/departments`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  ky = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/designations`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Ay = B(),
  jy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/documents`,
      subUrl: `/app/employees`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/documents/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Ay.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  My = B(),
  Ny = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/accounts`,
      subUrl: `/app/employees`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async makePrimary({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/accounts/` + n.moduleUuid + `/make-primary`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (My.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/accounts/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (My.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Py = B(),
  Fy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/qualifications`,
      subUrl: `/app/employees`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/qualifications/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Py.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Iy = B(),
  Ly = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/experiences`,
      subUrl: `/app/employees`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.subUrl + `/` + n.uuid + `/experiences/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Iy.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Ry = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/leave/types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var zy = {
  namespaced: !0,
  state: () => ({
    initURL: `/app/employee/leave/allocations`,
    formErrors: {},
  }),
  modules: {},
  mutations: {
    ...H,
  },
  actions: {
    ...U,
    async fetchLeaveRequests({ state: e, commit: t }, n) {
      return await z({
        url: e.initURL + `/` + n.uuid + `/leave-requests`,
        method: `GET`,
      })
        .then((e) => e)
        .catch((e) => {
          throw e;
        });
    },
  },
  getters: {
    ...W,
  },
};
B();
var By = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      type: Ry,
      allocation: zy,
      request: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/employee/leave/requests`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
          async status({ state: e, commit: t }, n) {
            return await z({
              url: e.initURL + `/` + n.uuid + `/status`,
              method: `POST`,
              data: n.form,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          async undoStatus({ state: e, commit: t }, n) {
            return await z({
              url: e.initURL + `/` + n.uuid + `/undo`,
              method: `POST`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  Vy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/attendance/types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Hy = B(),
  Uy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/attendance/work-shifts`,
      subURL: `/app/employee/attendance/work-shift`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assignPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.subURL + `/assign/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async fetchEmployee({ state: e, commit: t }, n) {
        return z({
          url: D(e.subURL + `/assign/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async assign({ state: e, commit: t }, n) {
        return await z({
          url: D(e.subURL + `/assign`, n.routeQuery),
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Hy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Wy = B(),
  Gy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/attendance/timesheets`,
      subURL: `/app/employee/attendance/timesheet`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async check({ state: e, commit: t }, n) {
        return z({
          url: e.subURL + `/check`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async clock({ state: e, commit: t }, n) {
        return await z({
          url: e.subURL + `/clock`,
          method: `POST`,
          data: n,
        })
          .then((e) => (Wy.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async sync({ state: e, commit: t }, n) {
        return await z({
          url: D(e.subURL + `/sync`, n.params),
          method: `POST`,
          data: n,
        })
          .then((e) => (Wy.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Ky = B(),
  qy = () => ({
    initURL: `/app/employee/attendance`,
    formErrors: {},
  }),
  Jy = {
    namespaced: !0,
    state: qy,
    modules: {
      type: Vy,
      workShift: Uy,
      timesheet: Gy,
    },
    mutations: {
      SET_FORM_ERRORS: (e, t = {}) => {
        e.formErrors = t;
      },
      RESET_STATE: (e) => {
        e = qy;
      },
    },
    actions: {
      resetFormErrors({ commit: e }) {
        e(`SET_FORM_ERRORS`);
      },
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async listAttendance({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/list`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async fetchEmployee({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async markAttendance({ state: e, commit: t }, n) {
        return await z({
          url: D(e.initURL + `/mark`, n.routeQuery),
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ky.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async fetchProduction({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/production`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async markProduction({ state: e, commit: t }, n) {
        return await z({
          url: D(e.initURL + `/production`, n.routeQuery),
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ky.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      resetState({ commit: e }) {
        e(`RESET_STATE`);
      },
    },
    getters: {
      getFormErrors: (e) => e.formErrors,
    },
  },
  Yy = B(),
  Xy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/payroll/pay-heads`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Yy.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Zy = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/payroll/salary-templates`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Qy = B(),
  $y = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/payroll/salary-structures`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async revise({ state: e, commit: t }, n) {
        return await z({
          url: `${e.initURL}/${n.uuid}/revise`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Qy.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            Qy.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async bulkRevise({ state: e, commit: t }, n) {
        return await z({
          url: `${e.initURL}/action/bulk-revise`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Qy.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  eb = B(),
  tb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/payrolls`,
      formErrors: {},
    }),
    modules: {
      payHead: Xy,
      salaryTemplate: Zy,
      salaryStructure: $y,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async fetchDetail({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/fetch`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async generate({ state: e, commit: t }, n) {
        let r = e.initURL;
        return await z({
          url: D(r, n.routeQuery),
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            eb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async process({ state: e, commit: t }, n) {
        return await z({
          url: D(e.initURL + `/` + n.uuid + `/process`, n.form),
          method: `POST`,
          data: n.form,
        })
          .then((e) => (eb.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async bulkProcess({ state: e, commit: t }, n) {
        return await z({
          url: D(e.initURL + `/process`, n.form),
          method: `POST`,
          data: n.form,
        })
          .then((e) => (eb.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async edit({ state: e, commit: t }, n) {
        return await z({
          url: D(e.initURL + `/` + n.uuid, n.routeQuery),
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            eb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            eb.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  nb = B(),
  rb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employee/edit-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (nb.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  ib = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/records`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  ab = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  ob = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/work-shifts`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  sb = B(),
  cb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/qualifications`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + e.module + `/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (sb.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  };
B();
var lb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/dialogues`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  ub = B(),
  db = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/accounts`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async makePrimary({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + e.module + `/` + n.moduleUuid + `/make-primary`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (ub.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + e.module + `/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (ub.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  fb = B(),
  pb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/documents`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + e.module + `/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (fb.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  mb = B(),
  hb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/experiences`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async action({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + e.module + `/` + n.moduleUuid + `/action`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (mb.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  gb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      module: `/edit-requests`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  _b = B(),
  vb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/employees`,
      formErrors: {},
    }),
    modules: {
      documentType: Ty,
      bulkEditAddress: Dy,
      department: Oy,
      designation: ky,
      documents: jy,
      accounts: Ny,
      qualifications: Fy,
      experiences: Ly,
      leave: By,
      attendance: Jy,
      payroll: tb,
      editRequest: rb,
      record: ib,
      incharge: ab,
      workShift: ob,
      qualification: cb,
      dialogue: lb,
      account: db,
      document: pb,
      experience: hb,
      profileEditRequest: gb,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      summary({ state: e, commit: t }, n) {
        return Js(e.initURL + `/list`, n.params)
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      confirmUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user/confirm`,
          method: `POST`,
          data: {
            email: n.form.email,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      getUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      createUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            _b.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            _b.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateCurrentPeriod({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/period`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            _b.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateBulkTag({ state: e, commit: t }, n) {
        let r = e.initURL + `/tags`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              _b.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateTags({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/tags`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            _b.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateBulkGroup({ state: e, commit: t }, n) {
        let r = e.initURL + `/groups`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              _b.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      getIdCardTemplates({ commit: e }) {
        return z({
          url: `/app/academic/id-cards/employee-templates`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
      async printIdCard({ commit: e }, t) {
        return await z({
          url: D(`/app/academic/id-cards`, t.form),
          method: `GET`,
        })
          .then((e) => e)
          .catch((t) => {
            throw (e(`SET_FORM_ERRORS`, V(t)), t);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  yb = B(),
  bb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/attendance`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      fetchQrCode({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/qr-code`,
          method: `POST`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      markAttendance({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/mark`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (yb.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  xb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/resource/book-lists`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var Sb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/resource/diaries`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async preview({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/preview`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async viewLogs({ state: e, commit: t }, n) {
        let r = e.initURL + `/` + n.uuid + `/view-logs`;
        return (
          n.params && (r = D(r, n.params)),
          await z({
            url: r,
            method: `GET`,
          })
            .then((e) => e)
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            })
        );
      },
    },
    getters: {
      ...W,
    },
  },
  Cb = B(),
  wb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/resource/assignments`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async getSubmissions({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/submissions`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async submitAssignment({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/submissions`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Cb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async cancelSubmission({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/submissions/` + n.moduleUuid + `/cancel`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Cb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async evaluateAssignment({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/evaluate`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Cb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async viewLogs({ state: e, commit: t }, n) {
        let r = e.initURL + `/` + n.uuid + `/view-logs`;
        return (
          n.params && (r = D(r, n.params)),
          await z({
            url: r,
            method: `GET`,
          })
            .then((e) => e)
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            })
        );
      },
    },
    getters: {
      ...W,
    },
  },
  Tb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/resource/online-classes`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Eb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/resource/lesson-plans`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Db = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/resource/syllabuses`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Ob = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/resource/learning-materials`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async viewLogs({ state: e, commit: t }, n) {
        let r = e.initURL + `/` + n.uuid + `/view-logs`;
        return (
          n.params && (r = D(r, n.params)),
          await z({
            url: r,
            method: `GET`,
          })
            .then((e) => e)
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            })
        );
      },
    },
    getters: {
      ...W,
    },
  },
  kb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/resource/downloads`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var Ab = () => ({
    initURL: `/app/resource/reports`,
    formErrors: {},
  }),
  jb = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      bookList: xb,
      diary: Sb,
      assignment: wb,
      onlineClass: Tb,
      lessonPlan: Eb,
      syllabus: Db,
      learningMaterial: Ob,
      download: kb,
      report: {
        namespaced: !0,
        state: Ab,
        modules: {},
        mutations: {
          SET_FORM_ERRORS: (e, t = {}) => {
            e.formErrors = t;
          },
          RESET_STATE: (e) => {
            e = Ab;
          },
        },
        actions: {
          resetFormErrors({ commit: e }) {
            e(`SET_FORM_ERRORS`);
          },
          async preRequisite({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/` + n.name + `/pre-requisite`,
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (V(e), e);
              });
          },
          async fetchReport({ state: e, commit: t }, n) {
            return z({
              url: D(e.initURL + `/` + n.name, n.params),
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          resetState({ commit: e }) {
            e(`RESET_STATE`);
          },
        },
        getters: {
          getFormErrors: (e) => e.formErrors,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  Mb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/stoppages`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Nb = B(),
  Pb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/routes`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async addStudent({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/students`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Nb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async addEmployee({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/employees`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Nb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async removePassenger({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/passengers/` + n.moduleUuid,
          method: `DELETE`,
        })
          .then((e) => {
            Nb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Fb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/circles`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Ib = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/fees`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Lb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/vehicle/config/document-types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Rb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/vehicle/config/expense-types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  zb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/vehicle/incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Bb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/vehicle/documents`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Vb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/transport/vehicle/trip-records`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var Hb = {
  namespaced: !0,
  state: () => ({
    initURL: `/app/transport/vehicles`,
    formErrors: {},
  }),
  modules: {
    documentType: Lb,
    expenseType: Rb,
    incharge: zb,
    document: Bb,
    tripRecord: Vb,
    fuelRecord: {
      namespaced: !0,
      state: () => ({
        initURL: `/app/transport/vehicle/fuel-records`,
        formErrors: {},
      }),
      modules: {},
      mutations: {
        ...H,
      },
      actions: {
        ...U,
        async getPreviousLog({ state: e, commit: t }, n) {
          return await z({
            url: e.initURL + `/previous-log`,
            method: `POST`,
            data: n,
          })
            .then((e) => e)
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            });
        },
      },
      getters: {
        ...W,
      },
    },
    serviceRecord: {
      namespaced: !0,
      state: () => ({
        initURL: `/app/transport/vehicle/service-records`,
        formErrors: {},
      }),
      modules: {},
      mutations: {
        ...H,
      },
      actions: {
        ...U,
      },
      getters: {
        ...W,
      },
    },
    expenseRecord: {
      namespaced: !0,
      state: () => ({
        initURL: `/app/transport/vehicle/expense-records`,
        formErrors: {},
      }),
      modules: {},
      mutations: {
        ...H,
      },
      actions: {
        ...U,
      },
      getters: {
        ...W,
      },
    },
    caseRecord: {
      namespaced: !0,
      state: () => ({
        initURL: `/app/transport/vehicle/case-records`,
        formErrors: {},
      }),
      modules: {},
      mutations: {
        ...H,
      },
      actions: {
        ...U,
      },
      getters: {
        ...W,
      },
    },
  },
  mutations: {
    ...H,
  },
  actions: {
    ...U,
  },
  getters: {
    ...W,
  },
};
B();
var Ub = () => ({
    initURL: `/app/transport/reports`,
    formErrors: {},
  }),
  Wb = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      stoppage: Mb,
      route: Pb,
      circle: Fb,
      fee: Ib,
      vehicle: Hb,
      report: {
        namespaced: !0,
        state: Ub,
        modules: {},
        mutations: {
          SET_FORM_ERRORS: (e, t = {}) => {
            e.formErrors = t;
          },
          RESET_STATE: (e) => {
            e = Ub;
          },
        },
        actions: {
          resetFormErrors({ commit: e }) {
            e(`SET_FORM_ERRORS`);
          },
          async preRequisite({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/` + n.name + `/pre-requisite`,
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (V(e), e);
              });
          },
          async fetchReport({ state: e, commit: t }, n) {
            return z({
              url: D(e.initURL + `/` + n.name, n.params),
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          resetState({ commit: e }) {
            e(`RESET_STATE`);
          },
        },
        getters: {
          getFormErrors: (e) => e.formErrors,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  Gb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/calendar/holidays`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Kb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/calendar/celebrations`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var qb = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      holiday: Gb,
      celebration: Kb,
      event: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/calendar/events`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
          async pin({ state: e, commit: t }, n) {
            await z({
              url: e.initURL + `/` + n.uuid + `/pin`,
              method: `POST`,
            })
              .then((e) => {})
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          async unpin({ state: e, commit: t }, n) {
            await z({
              url: e.initURL + `/` + n.uuid + `/unpin`,
              method: `POST`,
            })
              .then((e) => {})
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  Jb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/incharges`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var Yb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/vendors`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async fetchStatement({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/` + n.uuid + `/statement`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Xb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-categories`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Zb = B(),
  Qb = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-items`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async recalculateQuantity({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/quantity`,
          method: `POST`,
        })
          .then((e) => {
            Zb.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateBulkTag({ state: e, commit: t }, n) {
        let r = e.initURL + `/tags`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Zb.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
    },
    getters: {
      ...W,
    },
  };
B();
var $b = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-items-with-copies`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  ex = B(),
  tx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-item/copies`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async updateBulkCondition({ state: e, commit: t }, n) {
        let r = e.initURL + `/condition`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              ex.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkStatus({ state: e, commit: t }, n) {
        let r = e.initURL + `/status`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              ex.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkTag({ state: e, commit: t }, n) {
        let r = e.initURL + `/tags`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              ex.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
    },
    getters: {
      ...W,
    },
  };
B();
var nx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-item/labels`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      print({ state: e, commit: t }, n) {
        let r = e.initURL;
        return z({
          url: D(r, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  rx = B(),
  ix = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-bundles`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      storeConfig({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/config`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            rx.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  ax = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-requisitions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  ox = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-purchases`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  sx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-returns`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  cx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-transfers`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  lx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventory/stock-adjustments`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var ux = () => ({
    initURL: `/app/inventory/reports`,
    formErrors: {},
  }),
  dx = {
    namespaced: !0,
    state: ux,
    modules: {},
    mutations: {
      SET_FORM_ERRORS: (e, t = {}) => {
        e.formErrors = t;
      },
      RESET_STATE: (e) => {
        e = ux;
      },
    },
    actions: {
      resetFormErrors({ commit: e }) {
        e(`SET_FORM_ERRORS`);
      },
      async preRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.name + `/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async fetchReport({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/` + n.name, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      resetState({ commit: e }) {
        e(`RESET_STATE`);
      },
    },
    getters: {
      getFormErrors: (e) => e.formErrors,
    },
  };
B();
var fx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/inventories`,
      formErrors: {},
    }),
    modules: {
      incharge: Jb,
      vendor: Yb,
      stockCategory: Xb,
      stockItem: Qb,
      stockItemCopy: tx,
      stockItemWithCopy: $b,
      stockItemLabel: nx,
      stockBundle: ix,
      stockRequisition: ax,
      stockPurchase: ox,
      stockReturn: sx,
      stockTransfer: cx,
      stockAdjustment: lx,
      report: dx,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  px = B(),
  mx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/store/stock-sales`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      cancel({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/cancel`,
          method: `POST`,
        })
          .then((e) => {
            px.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      paymentPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/payment/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      payment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/payment`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            px.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      cancelPayment({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/payment/` + n.moduleUuid,
          method: `DELETE`,
        })
          .then((e) => {
            px.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var hx = {
  namespaced: !0,
  state: () => ({
    initURL: `/app/stores`,
    formErrors: {},
  }),
  modules: {
    stockSale: mx,
  },
  mutations: {
    ...H,
  },
  actions: {
    ...U,
  },
  getters: {
    ...W,
  },
};
B();
var gx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/communication/announcements`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async pin({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/pin`,
          method: `POST`,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unpin({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unpin`,
          method: `POST`,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async toggleShowAsPopup({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/show-as-popup`,
          method: `POST`,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async viewLogs({ state: e, commit: t }, n) {
        let r = e.initURL + `/` + n.uuid + `/view-logs`;
        return (
          n.params && (r = D(r, n.params)),
          await z({
            url: r,
            method: `GET`,
          })
            .then((e) => e)
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            })
        );
      },
    },
    getters: {
      ...W,
    },
  },
  _x = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/communication/emails`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  vx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/communication/sms`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  yx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/communication/whatsapp`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  bx = B(),
  xx = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      announcement: gx,
      email: _x,
      sms: vx,
      whatsapp: yx,
      pushMessage: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/communication/push-messages`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
          async sendTestNotification({ state: e, commit: t }, n) {
            await z({
              url: e.initURL + `/send-test-notification`,
              method: `POST`,
              data: n,
            })
              .then((e) => {
                bx.success(e.message);
              })
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  Sx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/library/books`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Cx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/library/book-additions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  wx = B(),
  Tx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/library/book/copies`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async updateBulkCondition({ state: e, commit: t }, n) {
        let r = e.initURL + `/condition`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              wx.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkStatus({ state: e, commit: t }, n) {
        let r = e.initURL + `/status`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              wx.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkLocation({ state: e, commit: t }, n) {
        let r = e.initURL + `/location`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              wx.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
    },
    getters: {
      ...W,
    },
  };
B();
var Ex = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/library/book/labels`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      print({ state: e, commit: t }, n) {
        let r = e.initURL;
        return z({
          url: D(r, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Dx = B(),
  Ox = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/library/transactions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      actionPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/action-pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async returnBook({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/return`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Dx.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var kx = {
  namespaced: !0,
  state: () => ({
    initURL: `/app/library/book-wise-transactions`,
    formErrors: {},
  }),
  modules: {},
  mutations: {
    ...H,
  },
  actions: {
    ...U,
  },
  getters: {
    ...W,
  },
};
B();
var Ax = () => ({
    initURL: `/app/library/reports`,
    formErrors: {},
  }),
  jx = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      book: Sx,
      bookAddition: Cx,
      bookCopy: Tx,
      bookLabel: Ex,
      transaction: Ox,
      bookWiseTransaction: kx,
      report: {
        namespaced: !0,
        state: Ax,
        modules: {},
        mutations: {
          SET_FORM_ERRORS: (e, t = {}) => {
            e.formErrors = t;
          },
          RESET_STATE: (e) => {
            e = Ax;
          },
        },
        actions: {
          resetFormErrors({ commit: e }) {
            e(`SET_FORM_ERRORS`);
          },
          async preRequisite({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/` + n.name + `/pre-requisite`,
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (V(e), e);
              });
          },
          async fetchReport({ state: e, commit: t }, n) {
            return z({
              url: D(e.initURL + `/` + n.name, n.params),
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          resetState({ commit: e }) {
            e(`RESET_STATE`);
          },
        },
        getters: {
          getFormErrors: (e) => e.formErrors,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  };
B();
var Mx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/approval/types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Nx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/approval/requests`,
      module: `/media`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  Px = B(),
  Fx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/approval/requests`,
      formErrors: {},
    }),
    modules: {
      media: Nx,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async actionPreRequisite({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/action/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async cancel({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/cancel`,
          method: `POST`,
        })
          .then((e) => {
            Px.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async status({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async undoStatus({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/undo`,
          method: `POST`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var Ix = () => ({
    initURL: `/app/approval/reports`,
    formErrors: {},
  }),
  Lx = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      type: Mx,
      request: Fx,
      report: {
        namespaced: !0,
        state: Ix,
        modules: {},
        mutations: {
          SET_FORM_ERRORS: (e, t = {}) => {
            e.formErrors = t;
          },
          RESET_STATE: (e) => {
            e = Ix;
          },
        },
        actions: {
          resetFormErrors({ commit: e }) {
            e(`SET_FORM_ERRORS`);
          },
          async preRequisite({ state: e, commit: t }, n) {
            return z({
              url: e.initURL + `/` + n.name + `/pre-requisite`,
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (V(e), e);
              });
          },
          async fetchReport({ state: e, commit: t }, n) {
            return z({
              url: D(e.initURL + `/` + n.name, n.params),
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          resetState({ commit: e }) {
            e(`RESET_STATE`);
          },
        },
        getters: {
          getFormErrors: (e) => e.formErrors,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  };
B();
var Rx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/tasks/dashboard/`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      resetFormErrors: U.resetFormErrors,
      async getStat({ state: e, commit: t }) {
        return await z({
          url: e.initURL + `stat`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      async getFavorite({ state: e, commit: t }) {
        return await z({
          url: e.initURL + `favorite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      async getChart({ state: e, commit: t }) {
        return await z({
          url: e.initURL + `chart`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
      async getRecord({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `record?type=` + n.type,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw e;
          });
      },
    },
    getters: {},
  },
  zx = B(),
  Bx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/tasks`,
      module: `/checklists`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async toggleStatus({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + e.module + `/` + n.moduleUuid + `/status`,
          method: `POST`,
        })
          .then((e) => {
            zx.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  Vx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/tasks`,
      module: `/members`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  Hx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/tasks`,
      module: `/media`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  Ux = B(),
  Wx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/tasks`,
      module: `/repeat`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
      async updateRepeatation({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/repeat`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Ux.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...$,
    },
  },
  Gx = B(),
  Kx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/tasks`,
      optionURL: `/app/options`,
      formErrors: {},
    }),
    modules: {
      dashboard: Rx,
      checklist: Bx,
      member: Vx,
      media: Hx,
      repeat: Wx,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async updateTags({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/tags`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            Gx.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async status({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            Gx.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async toggleFavorite({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/favorite`,
          method: `POST`,
        })
          .then((e) => {
            Gx.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async addList({ state: e, commit: t }, n) {
        return await z({
          url: e.optionURL + `?type=task_list`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorderList({ state: e, commit: t }, n) {
        await z({
          url: e.optionURL + `/reorder?type=task_list`,
          method: `POST`,
          data: n,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async moveList({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/lists/move`,
          method: `POST`,
          data: n,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorderItems({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n,
        })
          .then((e) => {})
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  qx = B(),
  Jx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/helpdesk/faqs`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      preview({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/preview`, n.params),
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            qx.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  Yx = B(),
  Xx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/helpdesk/tickets`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async assign({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/assign`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Yx.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unassign({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/unassign/` + n.moduleUuid,
          method: `POST`,
        })
          .then((e) => (Yx.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async addMessage({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/messages`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (Yx.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async removeMessage({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/messages/` + n.moduleUuid,
          method: `POST`,
        })
          .then((e) => (Yx.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            Yx.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      async updateBulkAssignTo({ state: e, commit: t }, n) {
        let r = e.initURL + `/assign`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Yx.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkCategory({ state: e, commit: t }, n) {
        let r = e.initURL + `/category`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Yx.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
      async updateBulkPriority({ state: e, commit: t }, n) {
        let r = e.initURL + `/priority`;
        ((r = D(r, n.routeQuery)),
          await z({
            url: r,
            method: `POST`,
            data: n.form,
          })
            .then((e) => {
              Yx.success(e.message);
            })
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            }));
      },
    },
    getters: {
      ...W,
    },
  };
B();
var Zx = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/helpdesks`,
      formErrors: {},
    }),
    modules: {
      faq: Jx,
      ticket: Xx,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  Qx = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      incident: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/discipline/incidents`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  };
B();
var $x = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/galleries`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  eS = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      menuItem: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/mess/menu-items`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
      meal: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/mess/meals`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
      mealLog: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/mess/meal-logs`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  tS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/activity/trips`,
      module: `/media`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  };
B();
var nS = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      trip: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/activity/trips`,
          formErrors: {},
        }),
        modules: {
          media: tS,
          participant: {
            namespaced: !0,
            state: () => ({
              initURL: `/app/activity/trips`,
              module: `/participants`,
              formErrors: {},
            }),
            modules: {},
            mutations: {
              ...Z,
            },
            actions: {
              ...Q,
            },
            getters: {
              ...$,
            },
          },
        },
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  rS = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      block: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/hostel/blocks`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
      blockIncharge: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/hostel/block-incharges`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
      floor: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/hostel/floors`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
      room: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/hostel/rooms`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
      roomAllocation: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/hostel/room-allocations`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  iS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/forms`,
      module: `/submissions`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...Z,
    },
    actions: {
      ...Q,
    },
    getters: {
      ...$,
    },
  },
  aS = B(),
  oS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/forms`,
      formErrors: {},
    }),
    modules: {
      submission: iS,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async updateStatus({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/status`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            aS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async detail({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/detail`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async submit({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/` + n.uuid + `/submit`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            aS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  sS = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      building: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/asset/buildings`,
          formErrors: {},
        }),
        modules: {
          block: {
            namespaced: !0,
            state: () => ({
              initURL: `/app/asset/building/blocks`,
              formErrors: {},
            }),
            modules: {},
            mutations: {
              ...H,
            },
            actions: {
              ...U,
            },
            getters: {
              ...W,
            },
          },
          floor: {
            namespaced: !0,
            state: () => ({
              initURL: `/app/asset/building/floors`,
              formErrors: {},
            }),
            modules: {},
            mutations: {
              ...H,
            },
            actions: {
              ...U,
            },
            getters: {
              ...W,
            },
          },
          room: {
            namespaced: !0,
            state: () => ({
              initURL: `/app/asset/building/rooms`,
              formErrors: {},
            }),
            modules: {},
            mutations: {
              ...H,
            },
            actions: {
              ...U,
            },
            getters: {
              ...W,
            },
          },
        },
        mutations: {
          ...H,
        },
        actions: {
          ...U,
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  cS = B(),
  lS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/site/pages`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async getPageView({ state: e, commit: t }, n) {
        return await z({
          url: `/app/pages/` + n.slug,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateMeta({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/meta`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            cS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateBlocks({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/blocks`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            cS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateSlider({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/slider`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            cS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateCTA({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/cta`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            cS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  uS = B(),
  dS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/site/menus`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            uS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async reorderSubMenu({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder-sub-menu`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            uS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  fS = B(),
  pS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/site/blocks`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async reorder({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/reorder`,
          method: `POST`,
          data: n.data,
        })
          .then((e) => {
            fS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var mS = {
    namespaced: !0,
    state: () => ({}),
    modules: {
      page: lS,
      menu: dS,
      block: pS,
      post: {
        namespaced: !0,
        state: () => ({
          initURL: `/app/site/posts`,
          formErrors: {},
        }),
        modules: {},
        mutations: {
          ...H,
        },
        actions: {
          async list({ state: e, commit: t }, n) {
            return await z({
              url: D(e.initURL, n.params),
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
          async get({ state: e, commit: t }, n) {
            return await z({
              url: e.initURL + `/` + n.uuid,
              method: `GET`,
            })
              .then((e) => e)
              .catch((e) => {
                throw (t(`SET_FORM_ERRORS`, V(e)), e);
              });
          },
        },
        getters: {
          ...W,
        },
      },
    },
    mutations: {},
    actions: {},
    getters: {},
  },
  hS = B(),
  gS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/blogs`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async updateMeta({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/meta`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            hS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async archive({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/archive`,
          method: `POST`,
        })
          .then((e) => {
            hS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unarchive({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unarchive`,
          method: `POST`,
        })
          .then((e) => {
            hS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async pin({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/pin`,
          method: `POST`,
        })
          .then((e) => {
            hS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unpin({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unpin`,
          method: `POST`,
        })
          .then((e) => {
            hS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      archiveBlogs({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/archive`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            hS.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      unarchiveBlogs({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/unarchive`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            hS.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            hS.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  _S = B(),
  vS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/news`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      async updateMeta({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/meta`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            _S.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async archive({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/archive`,
          method: `POST`,
        })
          .then((e) => {
            _S.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unarchive({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unarchive`,
          method: `POST`,
        })
          .then((e) => {
            _S.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async pin({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/pin`,
          method: `POST`,
        })
          .then((e) => {
            _S.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async unpin({ state: e, commit: t }, n) {
        await z({
          url: e.initURL + `/` + n.uuid + `/unpin`,
          method: `POST`,
        })
          .then((e) => {
            _S.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      archiveBlogs({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/archive`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            _S.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      unarchiveBlogs({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/unarchive`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            _S.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
      deleteItems({ state: e, commit: t }, n) {
        return z({
          url: D(e.initURL + `/delete`, n.params),
          method: `POST`,
          data: {
            uuids: n.uuids,
            global: n.global,
          },
        })
          .then((e) => {
            _S.success(e.message);
          })
          .catch((e) => {
            throw (V(e), e);
          });
      },
    },
    getters: {
      ...W,
    },
  };
B();
var yS = {
  namespaced: !0,
  state: () => ({
    initURL: `/app/recruitment/vacancies`,
    formErrors: {},
  }),
  modules: {},
  mutations: {
    ...H,
  },
  actions: {
    ...U,
  },
  getters: {
    ...W,
  },
};
B();
var bS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/recruitment/applications`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  xS = B(),
  SS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/job`,
      formErrors: {},
    }),
    modules: {
      vacancy: yS,
      application: bS,
    },
    mutations: {
      ...H,
    },
    actions: {
      async vacancyPreRequisite({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/vacancies/pre-requisite`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getVacancies({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/vacancies`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async getVacancy({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/vacancies/` + n.slug,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async validateApplication({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/vacancies/` + n.slug + `/applications?option=` + n.option,
          method: `POST`,
          data: n.form,
        })
          .then((e) => !0)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async finishApplication({ state: e, commit: t }, n) {
        return await z({
          url: e.initURL + `/vacancies/` + n.slug + `/applications`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => (xS.success(e.message), e))
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  CS = B(),
  wS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/guardians`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      confirmUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user/confirm`,
          method: `POST`,
          data: {
            email: n.form.email,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      getUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      createUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            CS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            CS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      async updateCurrentPeriod({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/period`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            CS.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  TS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/contact/config/document-types`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  },
  ES = B(),
  DS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/contacts`,
      formErrors: {},
    }),
    modules: {
      documentType: TS,
    },
    mutations: {
      ...H,
    },
    actions: {
      ...U,
      confirmUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user/confirm`,
          method: `POST`,
          data: {
            email: n.form.email,
          },
        })
          .then((e) => e)
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      getUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `GET`,
        })
          .then((e) => e)
          .catch((e) => {
            throw (V(e), e);
          });
      },
      createUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `POST`,
          data: n.form,
        })
          .then((e) => {
            ES.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
      updateUser({ state: e, commit: t }, n) {
        return z({
          url: e.initURL + `/` + n.uuid + `/user`,
          method: `PATCH`,
          data: n.form,
        })
          .then((e) => {
            ES.success(e.message);
          })
          .catch((e) => {
            throw (t(`SET_FORM_ERRORS`, V(e)), e);
          });
      },
    },
    getters: {
      ...W,
    },
  },
  OS = {
    namespaced: !0,
    state: () => ({
      initURL: `/app/devices`,
      formErrors: {},
    }),
    modules: {},
    mutations: {
      ...H,
    },
    actions: {
      ...U,
    },
    getters: {
      ...W,
    },
  };
B();
var kS = oe({
  modules: {
    setup: Ll,
    navigation: Rm,
    config: Ym,
    layout: Zm,
    dashboard: $m,
    image: th,
    auth: dh,
    user: hh,
    chat: Th,
    customField: Eh,
    utility: kh,
    option: jh,
    tag: Mh,
    comment: Ph,
    note: Lh,
    notification: Rh,
    reminder: zh,
    general: Bh,
    moduleImport: Hh,
    support: Uh,
    subscription: Wh,
    onlineEnquiry: Kh,
    onlineRegistration: Jh,
    guestPayment: Qh,
    guestVerification: eg,
    guestStudentPhoto: ng,
    transferCertificate: rg,
    organization: gh,
    team: Ch,
    reception: _g,
    academic: c_,
    student: Cv,
    finance: Vv,
    exam: wy,
    employee: vb,
    attendanceAssistant: bb,
    resource: jb,
    transport: Wb,
    calendar: qb,
    inventory: fx,
    store: hx,
    communication: xx,
    library: jx,
    approval: Lx,
    task: Kx,
    helpdesk: Zx,
    discipline: Qx,
    gallery: $x,
    mess: eS,
    activity: nS,
    hostel: rS,
    form: oS,
    asset: sS,
    site: mS,
    blog: gS,
    news: vS,
    recruitment: SS,
    guardian: wS,
    contact: DS,
    device: OS,
    post: {
      namespaced: !0,
      state: () => ({
        initURL: `/app/posts`,
        formErrors: {},
      }),
      modules: {},
      mutations: {
        ...H,
      },
      actions: {
        ...U,
        async pin({ state: e, commit: t }, n) {
          await z({
            url: e.initURL + `/` + n.uuid + `/pin`,
            method: `POST`,
          })
            .then((e) => {})
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            });
        },
        async unpin({ state: e, commit: t }, n) {
          await z({
            url: e.initURL + `/` + n.uuid + `/unpin`,
            method: `POST`,
          })
            .then((e) => {})
            .catch((e) => {
              throw (t(`SET_FORM_ERRORS`, V(e)), e);
            });
        },
      },
      getters: {
        ...W,
      },
    },
  },
  state: () => ({}),
  mutations: {},
  actions: {},
  getters: {},
});
export {
  Fs as _,
  Yl as a,
  Ol as c,
  B as d,
  qs as f,
  Bs as g,
  Ls as h,
  Nm as i,
  V as l,
  Js as m,
  wh as n,
  K as o,
  z as p,
  Pm as r,
  G as s,
  kS as t,
  Dl as u,
  Ei as v,
};
